/**
 * Created by calhosh on 4/14/2017.
 * English resource file
 */
import {
	Entity,
	GALinkStatus,
	confidentialityTypes,
	currencyType,
	gaRegion,
	gaRoleTypes,
	gaScopeType,
	notesFilter,
	pointOfContactTypes,
	KnowledgeSectionIds,
	sendInstructionsSwitcherIds,
	accountsFilter,
	scotsFilter,
	rejectionType,
	TaskTypeEnum,
	createMisstatementAccountGroupOptionResourceMapping,
	createMisstatementNatureOptionResourceMapping,
	createGuidedWorkFlowValidationTypeResourceMapping,
	createISA315ITFlowValidationTypeResourceMapping,
	ITProcessType,
	riskTypeFilters
} from '../util/uiconstants';


// These lables are only used for server side print.
export const printLabels = {
	//<GilasRequest>:
	HasEstimateLabel: 'Has estimate?',
	NoAnswerPlaceHolder: 'No response provided',
	EstimateEmptyScotsLabel: 'No SCOTs related to estimate',
	RisksRelevantLabel: 'Applies to Estimate?',
	ITAppControlLabel: 'IT App Control',
	ControlRelatedITAppsLabel: 'Control Related IT Apps',
	RelatedITApplicationLabel: 'Related IT Application',
	NoAssociatedItApplicationPlaceholder: 'No related applications',
	NoRelatedSCOTOrControlLabel: 'No related SCOT or Controls. Edit Associations',
	ITProcessesEmptyPlaceholder: 'No IT processes exist for this IT application',
	ITProcessesCount: 'Count of IT Processes',
	ITApplicationsCount: 'Count of IT Applications',
	TaskCountLabel: 'Task Count',
	ITProcessEmptyTaskPlaceholder: 'Atleast one UDP must be related to the IT Process, Create a new UDP or relate and existing UDP',
	AnalysisPeriodBalance: 'Analysis date balance',
	AnalysisPeriodDate: 'Analysis date',
	ComparativePeriodBalancePercentage: 'Comparative date balance %',
	ComparativePeriodDate: 'Comparative date',
	// Scot body
	noAccountsDisclosureCreated: 'No Significant accounts or disclosures have been created',
	notSelected: 'Not selected',
	//</GilasRequest>

	//<SuperKingsRequest>
	EstimateEmptySOLabel: 'No SOs related to estimate',
	EstimateEmptyITAppsLabel: 'No technologies related to estimate',
	EntitySpecificROMMs: 'Entity-specific ROMMs',
	NoROMMRelatedToEstimate: 'No entity-specific ROMMs related to estimate',
	//</SuperKingsRequest>

	controlDesignEffectiveness_0_description: 'Not selected',
	controlDesignEffectiveness_1_description: 'Effective',
	controlDesignEffectiveness_2_description: 'Ineffective',
	controlType_0_controlTypeName: '',
	controlType_0_shortName: 'Not Selected',
	controlType_1_controlTypeName: 'IT Application Control',
	controlType_1_shortName: 'Application',
	controlType_2_controlTypeName: 'IT Dependent Manual Control',
	controlType_2_shortName: 'ITDM',
	controlType_3_controlTypeName: 'Manual Prevent',
	controlType_3_shortName: 'Manual prevent',
	controlType_4_controlTypeName: 'Manual Detect',
	controlType_4_shortName: 'Manual detect',
	strategyType_0_strategyTypeName: 'Not selected',
	strategyType_1_strategyTypeName: 'Controls',
	strategyType_2_strategyTypeName: 'Substantive',
	strategyType_3_strategyTypeName: 'Rely',
	strategyType_4_strategyTypeName: 'Not Rely',
	aggregateITEvaluationType_0_aggregateITEvaluationTypeName: 'Not Selected',
	aggregateITEvaluationType_1_aggregateITEvaluationTypeName: 'Support',
	aggregateITEvaluationType_2_aggregateITEvaluationTypeName: 'Not Support',
	aggregateITEvaluationType_3_aggregateITEvaluationTypeName: 'FS & ICFR Support',
	aggregateITEvaluationType_4_aggregateITEvaluationTypeName: 'FS Only Support',
	itAppTypes_0_label: 'IT App',
	itAppTypes_1_label: 'SO',
	documentsAssociated: 'Documents associated',
	referenceITRisk: 'Reference IT risk',
	reference: 'Reference',
	noReferenceITGCsMitigates: 'No reference ITGC mitigates this IT risk.',
	noITGCsMitigates: 'No ITGC mitigates this IT risk.',
	noResultsFound: 'No results found.',
	potentialROMMs: 'Potential ROMMs',

	// SOCD Labels
	socd_pcaobExportAll: 'Export All',
	socd_managementTabLabel: 'Management',
	socd_tcwgTabLabel: 'TCWG',
	socd_summaryOfControlDeficiencies: 'Summary of control deficiencies',
	socd_engagementName: 'Engagement name',
	socd_clientYearendDate: 'Client year-end date:',
	socd_id: 'ID',
	socd_reference: 'Deficiency name',
	socd_referenceTag: '[Reference]',
	socd_description: 'Deficiency description',
	socd_type: 'Deficiency type',
	socd_severity: 'Deficiency severity',
	socd_deficiencyTypeId_1: 'Operation',
	socd_deficiencyTypeId_2: 'Design',
	socd_deficiencyTypeId_3: 'Design and operation',
	socd_deficiencyTypeId_4: 'Uncategorized',
	socd_deficiencyMagnitudeId_1: 'Control deficiency',
	socd_deficiencyMagnitudeId_2: 'Significant deficiency',
	socd_deficiencyMagnitudeId_3: 'Material weakness',
	socd_deficiencyMagnitudeId_4: 'Uncategorized',
	socd_deficiencyMagnitudeId_5: 'Immaterial',
	socd_relatedEntity: 'Related entity',
	socd_relatedComponent: 'Related component',
	socd_otherConsiderations: 'Other considerations',
	socd_otherConsiderationsOption_1: 'Indicators of material weakness present and consultation required',
	socd_otherConsiderationsOption_2: 'Material weakness or significant deficiency requiring interim communication identified',
	socd_otherConsiderationsOption_3: 'IT risks marked not relevant',
	socd_otherConsiderationsOption_4: 'Control(s) identified that were marked not impacted by this deficiency',
	socd_controlInEYCanvas: 'Control Category(required): ',
	socd_controlType: 'Control type',
	socd_itgc: 'ITGC',
	socd_controlType_1: 'ITAC',
	socd_controlType_1_itac: 'IT application control',
	socd_controlType_2: 'ITDM',
	socd_controlType_2_itdm: 'IT dependent manual control',
	socd_controlType_3: 'Manual prevent',
	socd_controlType_4: 'Manual detect',
	socd_controlType_5: 'Management review control',
	socd_controlDescription: 'Control description',
	socd_controlFrequency: 'Control frequency',
	socd_controlFrequencyType_1: 'Many times per day',
	socd_controlFrequencyType_2: 'Daily',
	socd_controlFrequencyType_3: 'Weekly',
	socd_controlFrequencyType_4: 'Monthly',
	socd_controlFrequencyType_5: 'Quarterly',
	socd_controlFrequencyType_6: 'Annually',
	socd_controlFrequencyType_7: 'ITAC',
	socd_controlFrequencyType_8: 'Other',
	socd_relatedSADiscAssert: 'Related significant account(s) or disclosure(s) & assertion(s)',
	socd_relatedAccRomm: 'Related accounts and ROMMs',
	socd_yes: 'Yes',
	socd_no: 'No',
	socd_causedByITGenControlDeficiency: 'Caused by IT general control deficiency?',
	socd_relatedTechnologies: 'Related technologies',
	socd_relatedTechnologiesITRisks: 'Related IT risks and technologies',
	socd_causedBySODeficiency: 'Caused by service organization deficiency?',
	socd_relatedServiceOrg: 'Related service organizations',
	socd_priorYearOrRecurring: 'Prior year or recurring',
	socd_internalControlComponents: 'Internal control components',
	socd_unCompensatedROMMs: 'Uncompensated ROMMs',
	socd_unMitigatedItRisks: 'Unmitigated IT risks',
	socd_remediationStatus: 'Remediated',
	socd_remediationDate: 'Remediation date',
	socd_maximumAmountOfPotentialMisstatement: 'Evaluation of magnitude and likelihood of potential misstatement',
	socd_financialStatementImpact: 'Effect on financial statement audit procedures',
	socd_relatedChildDeficiency: 'Deficiencies caused by this deficiency',
	socd_tags: 'Tags',
	socd_controlCategory: 'Control category',
	socd_control: 'Control',
	socd_itGeneralControl: 'IT general control',
	socd_recurring: 'Recurring?',
	socd_causedByAnotherDeficiency: 'Caused by another deficiency?',
	socd_relatedParentDeficiency: 'Related parent deficiency',
	socd_compensatingControls: 'Compensating controls',
	socd_parentsDeficienciesRemediated: 'Are all deficiencies that caused this deficiency remediated?',
	socd_compensatingControlExplanation: 'Compensating control explanation',
	socd_deficiencyClassType_1: 'Control environment',
	socd_deficiencyClassType_2: 'Risk assessment process',
	socd_deficiencyClassType_3: 'Control activities',
	socd_deficiencyClassType_4: 'Information and communication',
	socd_deficiencyClassType_5: 'Monitoring',
	socd_rationaleForImmaterialDeficiencySeverity: 'Evaluation of magnitude and likelihood of potential misstatement',
	socd_relatedGroupComponent: 'Related group component',
	socd_relatedAccountsAssertionsAndRomms: 'Related accounts, assertions, and ROMMs',
	socd_deficienciesWhichCausedThisDeficiency: 'Deficiencies that caused this deficiency',
	socd_not_applicable: 'Not applicable',
	socd_deficiencyRelatedTo: 'Deficiency related to',
	socd_businessProcess: 'Business process',
	socd_itProcess: 'IT process',
	socd_conclusion: 'Conclusion',
	socd_compensatingControlsAssociatedToAffectedRomms: 'Compensating controls associated to affected ROMMs',
	socd_relatedInformationTechnologies: 'Related information technologies',
	socd_relatedAccountsAndAssertions: 'Related accounts and assertions',
	socd_multiEntityRelatedEntity: 'Multi-entity: Related entity',
	socd_otherCompensatingControls: 'Other compensating controls',
	socd_compensated: 'Compensated',
	socd_changeToCRA: 'Change to CRA',
	socd_cosoPrinciplesHeader: 'COSO Principles',
	socd_cosoPrinciple_1: '1 - Demonstrate commitment to integrity and ethical values',
	socd_cosoPrinciple_2: '2 - Ensure that board exercises oversight responsibility',
	socd_cosoPrinciple_3: '3 - Establish structures, reporting lines, authorities and responsibilities',
	socd_cosoPrinciple_4: '4 - Demonstrate commitment to a competent workforce',
	socd_cosoPrinciple_5: '5 - Hold people accountable',
	socd_cosoPrinciple_6: '6 - Specify appropriate objectives',
	socd_cosoPrinciple_7: '7 - Identify and analyze risks',
	socd_cosoPrinciple_8: '8 - Evaluate fraud risks',
	socd_cosoPrinciple_9: '9 - Identify and analyze changes that could significantly affect internal controls',
	socd_cosoPrinciple_10: '10 - Select and develop control activities that mitigate risks',
	socd_cosoPrinciple_11: '11 - Select and develop technology controls',
	socd_cosoPrinciple_12: '12 - Deploy control activities through policies and procedures',
	socd_cosoPrinciple_13: '13 - Use relevant, quality information to support the internal control function',
	socd_cosoPrinciple_14: '14 - Communicate internal control information internally',
	socd_cosoPrinciple_15: '15 - Communicate internal control information externally',
	socd_cosoPrinciple_16: '16 - Perform ongoing or periodic evaluations of internal controls (or a combination of the two)',
	socd_cosoPrinciple_17: '17 - Communicate internal control deficiencies',
	socd_descriptionOfMagnitude: 'Description of magnitude and likelihood of potential misstatement',
	socd_evaluationOfMagnitude: 'Evaluation of magnitude and likelihood of potential misstatement',

	// SAD Labels
	sad_iSBSTabLabel: 'All - IS and BS',
	sad_cashFlowTabLabel: 'All - Cash Flow',
	sad_summaryOfAuditDifferences: 'Summary of audit differences',
	sad_incomeStatementAndBalanceSheet: 'All - Income, other comprehensive income, or balance sheet misstatements',
	sad_clientYearendDate: 'Client year-end date',
	sad_misstatementIndex: 'Misstatement index',
	sad_description: 'Misstatement description',
	sad_entity: 'Reporting entity',
	sad_component: 'Identified by',
	sad_period: 'Period',
	sad_periodTypeId_1: 'Current period',
	sad_periodTypeId_2: 'Prior period',
	sad_periodTypeId_3: 'Second comparative period',
	sad_status: 'Misstatement period',
	sad_correctedUncorrected: 'Status',
	sad_corrected: 'Corrected',
	sad_uncorrected: 'Uncorrected',
	sad_type: 'Type',
	sad_misstatementType_1: 'Factual',
	sad_misstatementType_2: 'Projected',
	sad_misstatementType_3: 'Judgmental',
	sad_misstatementType_4: 'Reclassification',
	sad_misstatementType_6: 'Manual Top-Up Adjustment',
	sad_currency: 'Currency',
	sad_currencies: 'Currencies',
	sad_relatedPriorPeriodMisstatement: 'Related prior period misstatement',
	sad_netEffectOn: 'Net effect on',
	sad_category: 'Category',
	sad_category_1: 'Misstatements that have an effect on income or OCI',
	sad_category_2: 'Misstatements that do not affect income or OCI',
	sad_supportingWorkpapers: 'Supporting evidence',
	sad_relatedAccounts: 'Related accounts',
	sad_controlDeficiency: 'Control deficiency',
	sad_yes: 'Yes',
	sad_no: 'No',
	sad_relatedDeficiencies: 'Related deficiencies',
	sad_controlDeficiencyRationale: 'Control deficiency rationale',
	sad_clearlyTrivialDecision: 'Clearly trivial decision',
	sad_excludeFromCommunication: 'Communication decision',
	sad_rationaleForCommunicationDecision: 'Rationale for decision',
	sad_accountGroup: 'Financial statement subtotal',
	sad_financialStatementAccountGroup: 'Financial statement subtotal',
	sad_turnaroundLegend: '1- Turnaround effect of uncorrected prior period misstatements on current period income.',
	sad_financialStatementType_2: 'Current assets',
	sad_financialStatementType_3: 'Noncurrent assets',
	sad_financialStatementType_5: 'Current liabilities',
	sad_financialStatementType_6: 'Noncurrent liabilities',
	sad_financialStatementType_7: 'Equity',
	sad_financialStatementType_11: 'Other comprehensive income',
	sad_financialStatementType_20: 'Pretax income',
	sad_financialStatementType_21: 'Income tax',
	sad_financialStatementLineItem: 'Financial statement line item',
	sad_statementOfCashFlowsLineItem: 'Statement of cash flows line item',
	sad_operating: 'Operating',
	sad_investing: 'Investing',
	sad_financing: 'Financing',
	sad_debit: 'Debit',
	sad_credit: 'Credit',
	sad_taxable: 'Taxable',
	sad_taxEffect: 'Tax effect',
	sad_turnaroundDebit: 'Turnaround debit',
	sad_turnaroundCredit: 'Turnaround credit',
	sad_turnaround: 'Turnaround?',
	sad_disclosureTabLabel: 'All - Disclosure',
	sad_detailsOfMisstatement: 'Disclosure misstatement details and authoritative guidance reference',
	sad_misstatement: 'Misstatement',
	sad_entityComponentIdentifier: 'Entity/Component Identifier',
	sad_effectOnIncome: 'Gross current period effect on income',
	sad_incomplete: 'Incomplete',
	sad_amount: 'Amount',
	sad_engagementName: 'Engagement name',
	sad_entityName: 'Entity name',
	sad_entityNames: 'Entity names',
	sad_periodEndDate: 'Period end date',
	sad_taxRate: 'Tax rate',
	sad_taxRates: 'Tax rates',
	sad_workpaper: 'Workpaper',
	sad_misstatementsWithEffectOnIncome: 'Misstatements that have an effect on income or OCI',
	sad_misstatementsThatDoNotAffectIncome: 'Misstatements that do not have an effect on income or OCI',
	sad_cashFlowMisstatements: 'Cash flow misstatements',
	sad_disclosureMisstatements: 'Disclosure misstatements',
	sad_uncorrectedMisstatements: 'Uncorrected misstatements',
	sad_correctedMisstatements: 'Corrected misstatements',
	sad_uncorrectedMisstatementsFooter: '1- Uncorrected misstatements or matters underlying those uncorrected misstatements could potentially cause future-period financial statements to be materially misstated, even if we have concluded that the uncorrected misstatements are immaterial to the financial statements under audit.',
	sad_misstatementStatusType_1: 'Current period - New',
	sad_misstatementStatusType_2: 'Current period - Recurring',
	sad_misstatementStatusType_3: 'Prior period - New',
	sad_misstatementStatusType_5: 'Prior period - Updated',
	sad_misstatementStatusType_4: 'Prior period - Rolled forward',
	sad_evaluationRationale: 'Disclosure misstatement details and authoritative guidance reference',
	sad_misstatementIncomplete: 'The misstatement entry is incomplete.',
	sad_noMisstatementsIdentified: 'No misstatements identified.',
	sad_aggregateEffects: 'Aggregate effects',
	sad_accumulatedEffect: 'Aggregate effect of uncorrected misstatements',
	sad_uncorrectedMisstatementEffect: 'Effect of uncorrected misstatements',
	sad_incomeStatement: 'Income statement',
	sad_financialStatementAmount: 'Financial statement amount',
	sad_beforeTurnaround: 'Before turnaround',
	sad_afterTurnaround: 'After turnaround',
	sad_debitCredit: 'Debit / (Credit)',
	sad_increaseDecrease: 'Increase / (Decrease)',
	sad_profitBeforeTax: 'Pretax income',
	sad_taxEffectOfMisstatements: 'Tax effect of misstatements',
	sad_misstatementsInIncomeTax: 'Misstatements in income tax',
	sad_profitAfterTax: 'Net income',
	sad_otherComprehensiveIncome: 'Other comprehensive income',
	sad_balanceSheet: 'Balance sheet',
	sad_currentAssets: 'Current assets',
	sad_nonCurrentAssets: 'Noncurrent assets',
	sad_currentLiabilities: 'Current liabilities',
	sad_nonCurrentLiabilities: 'Noncurrent liabilities',
	sad_equity: 'Equity',
	sad_statementOfCashFlows: 'Statement of cash flows',
	sad_turnaroundFooter: '1 - Turnaround describes the effect of uncorrected prior period misstatements on current period income.',
	sad_notSelected: 'Not selected',
	sad_primaryTeam: 'Primary team',
	sad_notApplicable: 'Not applicable',
	sad_priorPeriodTurnaroundLabel: 'Turnaround effect of prior period misstatement on current period income',
	sad_incomeEffect: 'Income effect',
	sad_incomeEffectBefore: 'Income effect before turnaround',
	sad_incomeEffectAfter: 'Income effect after turnaround',
	sad_yesCommunicate: 'Yes - communicate',
	sad_noCommunicate: 'No - exclude from communication',
	sad_totalIncomeTax: 'Total income tax',

	// Body 243 - Identify procedures responsive to risk
	accountName: 'Account Name',
	noAccountsAssociated: 'No accounts associated',
	isEstimateAccount: 'Is estimate account',
	assertionsRelevantForROMM: 'Assertions relevant for the ROMM',
	noResponsiveProceduresAssociated: 'No responsive procedures associated',
	noROMMsAvailable: 'No ROMMs available',

	// Body 244 - Design PSPs and OSPs
	relevantAssertions: 'Relevant assertions',
	relatedROMMs: 'Related ROMMs',
	assertions: 'Assertions',
	risk: 'Risk',
	riskType: 'Risk Type',
	rationale: 'Rationale',
	noSubstantiveProceduresAvailable: 'No substantive procedures available',
	psp: 'PSP',
	osp: 'OSP',
	accountNamePrint: 'Account name',
	isHigherRiskPrint: 'Is higher risk',
	riskNamePrint: 'Risk Name',
	flowchartStepColumnOption_1: 'Initiation',
	flowchartStepColumnOption_2: 'Recording',
	flowchartStepColumnOption_3: 'Processing',
	flowchartStepColumnOption_4: 'Reporting',
	flowchartStepColumnOption_5: 'Preparation of TB',
	flowchartStepColumnOption_6: 'Preparation of Journal entries',
	flowchartStepColumnOption_7: 'Preparation of Financial statements',
	//235 from Body
	noRelatedSO: 'No related service organizations.',
	comparativeDateBalance: 'Comparative date balance',
	noRelatedControls: 'No related controls',
	deficiencyName: 'Deficiency title',
	deficiencyDescription: 'Description',
	design: 'Design',
	operation: 'Operation',
	noRelatedEntities: 'No related entities',
	entities: 'Entities',
	components: 'Components',
	groupScope: 'Group scope',
	noRelatedCmponents: 'No related components',
	noRelatedDeficiencies: 'No related deficiencies',
	parentDeficiencyName: 'Parent deficiency name',
	childDeficiencyName: 'Child deficiency name',
	noRelatedAccountsAssertionsAndRisks: 'No related accounts, assertions and risks',
	referenceOnly: 'Reference only',
	yes: 'Yes',
	no: 'No',
	gaScopes_1: 'Full',
	gaScopes_2: 'Specific',
	gaScopes_3: 'Specified procedures',
	gaScopes_4: 'Review',
	gaScopes_5: 'Primary team',
	deficiency: 'Deficiency',
	category: 'Category',
	type: 'Type',
	recurring: 'Recurring',
	remediationStatus: 'Remediation status',
	remediationDate: 'Remediation date',
	description: 'Description',
	businessProcess: 'Business process',
	itProcess: 'IT process',
	deficiencyType_1: 'Operation',
	deficiencyType_2: 'Design',
	deficiencyType_3: 'Design and operation',
	deficiencyType_4: 'Uncategorized',
	remediated: 'Remediated',
	unremediated: 'Unremediated'
};

export const technologyTypeFilter = {
	firstLevelLabel: 'Technology type',
	secondLevelOptionsLabels: [
		{ value: 'applicationOrTool', label: 'Application/Tool' },
		{ value: 'database', label: 'Database' },
		{ value: 'operatingSystem', label: 'Operating system' },
		{ value: 'network', label: 'Network' }
	],
};

export const directlySupportsFilter = {
	firstLevelLabel: 'Directly supports',
	secondLevelOptionsLabels: [
		{ value: 'financialReporting', label: 'Financial reporting' },
		{ value: 'itEnvironment', label: 'IT environment' }
	]
};

export const labels = {
	relatedAccountsAndRomms: 'Related accounts and ROMMs',
	blockerBodyWarningText: 'An action is required',
	editModalDescription: `Edit the ITGC details below and select '<b>{0}</b>' to finish.`,
	editModalTitle: 'Edit ITGC',
	craViewDetailModalTitle: 'View changes',
	craSelectLabel: 'Select a comparative period and then click an account to view the details.',
	noRelatedRiskLabel: 'No related ROMMs',
	addEvidenceBtn: 'Add evidence',
	relateEvidence: 'Relate evidence',
	newEvidence: 'New evidence',
	relateAccount: 'Relate account',
	relatePriorPeriodMisstatement: 'Relate prior period misstatement',
	multipleDocuments: 'Multiple Documents',
	invalidEngagementId: 'Engagement ID is invalid. Refresh the page and try again. Contact the Help Desk if the error persists.',
	newComponent: 'new component',
	workingOffline: 'Working Offline',
	syncInProgress: 'Sync in progress',
	prepareOffline: 'Preparing data for offline',
	connectionAvailable: 'Connection available',
	training: 'Training',
	clickForOptions: 'Click for more options',
	navReviewNotes: 'Review notes',
	navHeaderManageTeam: 'Manage team',
	navManageGroup: 'Manage group',
	manageObjects: 'Manage objects',
	manageControls: 'Manage controls',
	referenceOnlyControlEntityName: 'reference control',
	manageReferenceOnlyControls: 'Manage reference controls from other engagements',
	createReferenceOnlyControls: 'New reference control',
	editReferenceOnlyControls: 'Edit reference control',
	manageReferenceOnlyROMM: 'Manage reference risks of material misstatement',
    createReferenceOnlyROMM: 'New reference ROMM',
	createNewReferenceOnlyROMM: 'New reference risk of material misstatement',
	editReferenceOnlyROMM: 'Edit reference risk of material misstatement',
	referenceOnlyRiskEntityName: 'reference risk of material misstatement',
	placeholderTextNoCreateReferenceROMM: 'Edit and delete existing reference ROMMs below.',
	manageDeficiencies: 'Manage deficiencies',
	relateAccountsAndAssertions: 'Relate accounts and assertions',
	showValidations: 'Show validations',
	entityNewControlLabel: 'New control',
	entityRelateControlLabel: 'Relate controls',
	entityEditControlLabel: 'Edit control',
	navCRASummary: 'CRA summary',
	navAuditPlan: 'Audit plan',
	navWorkPlan: 'Work plan',
	navSEM: 'Substantive evaluation matrix',
	navFindings: 'Findings',
	navDeficiencies: 'Deficiencies',
	navContentUpdates: 'Content update',
	navCanvasFormUpdates: 'Canvas form updates',
	navCopyHub: 'Copy hub',
	navCopyHubNew: 'Copy hub NEW',
	navArchiveChecklist: 'Archive checklist',
	navExportHub: 'Export hub',
	navReporting: 'Reporting',
	navHelp: 'General help',
	validationNavHelp: 'Validation help',
	leaveUsFeedback: 'Leave us feedback',
	navDashboard: 'Dashboard',
	tasksPage: 'Tasks',
	documentsPage: 'Documents',
	collaborationPage: 'Collaboration',
	automationPage: 'Automation',
	documentHelperConnectionIssue:
		'An issue has been detected with EY Canvas Document Helper. Click <a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">here</a> for instructions of how to resolve this issue.',
	noContentAvailable: 'No content available',
	noSectionsAvailable: 'No sections available',
	noInformationAvailable: 'No information available',
	collapse: 'Collapse',
	expand: 'Expand',
	duplicate: 'Duplicate',
	duplicateSection: 'Duplicate section',
	duplicateSectionHeader: 'Are you sure that you want to duplicate the selected section?',
	deleteSection: 'Delete section',
	deleteSectionHeader: 'Are you sure you want to delete the selected section?',
	deleteHeader: 'Delete header',
	deleteHeaderTitle: 'Are you sure that you want to delete the selected header?',
	confirmLabel: 'Confirm',
	custom: 'Custom',
	selectHeader: 'Select Header',
	selectSection: 'Select Section',
	noResultsFound: 'No results found',
	noMisstatementResultsFound: 'No misstatements identified',
	SADNoMisstatementFoundOnTabChange: 'No misstatements found',
	ALL: 'All',
	scot: 'SCOT',
	scotTypes: 'SCOT type',
	frequency: 'Frequency',
	SelectFrequency: 'Select Frequency',
	SelectControlType: 'Select Control Type',
	itBadge: 'IT',
	soBadge: 'SO',
	noRecordsAvailable: 'No records available',
	noIncompleteResponseSummaryView: 'No incomplete responses',
	incomplete: 'Incomplete',
	noUnresolvedCommentsSummaryView: 'No unresolved comments',
	edit: 'Edit',
	editForm: 'Edit form',
	delete: 'Delete',
	remove: 'Remove',
	noBodies: 'No bodies available',
	relateDocuments: 'Relate documents',
	relatedDocuments: 'Related documents',
	deleteBody: 'Delete body',
	bodyDescription: 'Are you sure you want to delete the selected body?',
	description: 'Description',
	maxLengthForEditResponse: 'Body text exceeds maximum allowed length',
	maxLengthForEditResponseWithCount:
		'Response contains {#} characters which exceeds the maximum of {##} characters.  Adjust the answer by reducing text or formatting and try again.  If the issue persists, contact the Help Desk.',
	saveResponse:
		'Discarding the changes will not save any edits made to the response text. Closed or deleted comments will remain highlighted. Please confirm if you want to discard all changes.',
	discardChangesModalText: 'Discard changes',
	seeBodyDescriptionText: 'See description',
	hideBodyDescriptionText: 'Hide description',
	showBodyDescriptionText: 'Show description',
	okLabel: 'Ok',
	addButtonLabel: 'Add',
	addEvidence: 'Add evidence',
	addTemporaryFiles: 'Add temporary files',
	notemporaryDocs: 'No temporary files available',
	relateFiles: 'Relate files',
	uploadFiles: 'Upload files',
	cancelButtonLabel: 'Cancel',
	clickEditResponseToContinue: 'Click edit icon to continue',
	editResponse: 'Edit response',
	save: 'Save',
	numericValuePlaceholder: 'Enter amount',
	saveLabel: 'Save',
	cancelLabel: 'Cancel',
	closeLabel: 'Close',
	editText: 'Edit',
	select: 'Select',
	selectScot: 'Select SCOTs',
	clearHoverText: 'Clear',
	optional: '(optional)',
	nodocumentsAdded: 'No documents available',
	errorBanner: '{0} Error(s)',
	NetworkErrorMessage: 'The application network is experiencing an error. Refresh the page and try again later. Contact the Help Desk if the error persists.',
	of: 'of',
	characters: 'characters',
	show: 'Show:',
	views: 'View:',
	primaryRelated: 'Primary related Canvas forms',
	secondaryRelated: 'Secondary related Canvas forms',
	singleLineValuePlaceholder: 'Enter text',
	paceInputPlaceholder: 'PACE ID',
	multiLineValuePlaceholder: 'Enter text',
	riskFactorDescribe: 'Describe',
	riskFactorLabel: 'Relevant event and condition / risk of misstatement',
	riskFactorEmptyWarning: 'Event and condition / risk of misstatement missing description',
	riskFactorNoDescription: 'Create new or select existing relevant event and condition / risk of misstatement',
	fraudRiskTagMessage:
		'This relevant event and condition / risk of misstatement always gives rise to a fraud risk or, if applicable, should be designated as not a risk of material misstatement',
	significantRiskTagMessage:
		'This relevant event and condition / risk of misstatement always gives rise to a significant risk, fraud risk or, if applicable, should be designated as not a risk of material misstatement',

	on: 'on',
	sliderDeSelectMessage: 'Drag the circle to assign a value',
	yearPlaceholder: 'YYYY',
	dayPlaceholder: 'DD',
	monthPlaceholder: 'MM',
	amLabel: 'AM',
	pmLabel: 'PM',
	relatedEntities: 'Related entities',
	relatedEntity: 'Related entity',
	noControlsAreAvailable: 'No controls available',
	noSCOTsAvailable: 'No SCOTs available',
	noEstimatesAvailable: 'No Estimates available',
	noITProcessAvailable: 'No IT processes available',
	eyServiceGateway: 'EY Service Gateway',
	eyAutomation: 'EY Automation',
	eyserviceGatewayAutomation: 'EY Service Gateway & Automation',
	creating: 'Creating...',
	cannotCreateUdp: 'Cannot create UDP. Time Phase cannot be empty',
	relateModalGenericErrorMessage: 'This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	psp: 'PSP',
	rejectionRationale: 'Rejection rationale',
	rejectedPSPs: 'Rejected PSPs',

	relatedTechnologyLabel: 'Related technology',

	// 440GL
	rrdReminderTitle: 'Review and Approval Summary reminder',
	rrdReminderMessage: 'The Report Release Date is {rrdDescription}. Remember to sign the Review and Approval Summary {rrdPendingDays}.',
	rrdReminderPendingDays: 'in {0} day(s)',

	//Create or Associate risks
	createAssociateRisksLabel: 'Create new or associate ROMMs',
	createNewRommLabel: 'New ROMM',
	relateExistingRommsLabel: 'Relate ROMMs',
	relatedRiskIsMissingWarning: 'Related ROMM is missing',
	associateRiskDescription: 'Select one or more ROMMs to associate or create a new ROMM.',
	createNewRiskLabel: 'New ROMM',
	noRiskIdentifiedLabel: 'No ROMMs identified',
	noAssociateStandardRiskLabel: 'No ROMMs identified',

	// GuidanceModal
	eyAtlasLink: 'EY Atlas',
	guidanceHeaderMessage: 'This module contains',
	guidanceModalHeader: 'Guidance',
	guidanceModalLabelText: 'Entry',
	guidanceFooter: 'for more information.',
	guidanceSeveralEntriesText: 'several entries:',
	guidanceVisitText: 'Visit',
	guidanceClickText: 'Click',
	guidanceHereText: 'here',
	guidanceFooterText: 'for more information.',
	analyticsInconsistencies:
		'When reviewing analytics, consider if there are changes or activity that is inconsistent with our expectations. These situations may be indicative of new ROMMs, separate classes of transactions, changes to SCOTs, or risks of management override.',
	analyticsInconsistenciesOSJE:
		'OSJE depicts the double-entry accounting for the selected account being analyzed. We look for new or unusual account pairings.',
	analyticsInconsistenciesActivityBySource:
		'Activity by source depicts the gross monthly activity and related sources for the selected account. We focus on unusual activity or changes in sources or volume of activity to a source.',
	analyticsInconsistenciesPreparerAnalysis:
		'Preparer analysis summarizes the period over period gross activity recorded by preparers for the selected account. We focus on changes to preparers or activity to accounts outside their role.',
	analyticsInconsistenciesAccountMetrics: 'Account metrics summarizes key information about the account which assists in account designation.',
	analyticsLoadingIsInProgress: 'The requested analytic is still being loaded. The tab will be accessible once that completes.',

	aboutDescriptioin: 'Edit the GAM layers, standards, or language.  Edits will trigger a content update.',
	aboutContentDescription: 'Edit the content layers, standards, language, or content driving entity. Edits will trigger a content update.',
	about: 'About',
	formType: 'Form type',
	gamLayer: 'GAM layers',
	contentLayer: 'Content layers',
	standard: 'Standard',
	language: 'Language',
	createdBy: 'Created by',
	createdOn: 'Created on',
	contentLastUpdatedBy: 'Content last updated by',
	contentLastUpdatedOn: 'Content last updated on',
	notModified: 'Not modified',

	rolesInsufficientTooltip: 'Insufficient roles to edit content. Work with an engagement administrator to get sufficient rights.',
	insufficientRolePermissionsError: 'Insufficient role permissions. Contact administrator and try again.',
	knowledgeFormToolTip: "Knowledge delivered documents cannot be updated. Update the Engagement Profile to change this form's profile.",
	selectTeamMember: 'Name or email',

	// SeeMore component
	showMore: 'Show more',
	showLess: 'Show less',
	showMoreEllipsis: 'Show more...',
	showLessEllipsis: 'Show less...',

	relatedITapplicationSOs: 'Related IT applications/SOs',
	aggregateITevaluations: 'Aggregate IT Evaluations',
	controlLowerRisk: 'Control is lower risk',
	relatedITApplication: 'Related IT applications',
	relatedITSO: 'Related SOs',
	noITApplicationUsed: 'No IT application used',

	//Account Control Table Column Header Labels
	controlTotal: 'Total',
	controlGroupLabel: 'Control',
	design: 'Design',
	operating: 'Operating',
	ineffectiveGroupLabel: 'Ineffective',
	designConclusion: 'Design conclusion',
	operatingConclusion: 'Operating conclusion',
	effectiveLabel: 'Effective',
	ineffectiveLabel: 'Ineffective',
	noExceptionsLabel: 'No exceptions',
	exceptionsLabel: 'Exceptions',
	conclusionLabel: 'Conclusion',
	notApplicableLabel: 'Not applicable',
	notSelectedLabel: 'Not selected',
	notTested: 'Not tested',

	notSel: 'NOT SELECTED',
	internal: 'Internal',
	external: 'External',
	notSelected: printLabels.notSelected,
	noOptionSelected: 'Not selected',
	tod: 'TOD',
	sap: 'SAP',
	int: 'INT',
	ext: 'EXT',
	toc: 'TOC',
	udp: 'UDP',
	placeholderForSearch: 'Search',
	source: 'Source',
	nature: 'Nature',
	testOfDetail: 'Test of details',
	testOfControl: 'Test of control',
	substantiveAnalyticalProcedure: 'Substantive analytical procedure',
	expandScot: '1. Expand a SCOT',
	selectWCGWToDisplayTheResponsiveTask: '2. Select the risk of material misstatement to display the responsive tasks',
	tasksWithNoRelatedWCGW: 'Tasks with no related risk of material misstatement',
	noTasksAvailable: 'No available tasks',
	noWCGWAvailableForTask: 'No ROMM available',
	noSubstantiveTasksAvailable: 'No related substantive tasks',
	selectAssertionToRelateWCGW: 'Select Assertion to relate ROMM to WCGW',
	significantAccounts: 'Significant Accounts',
	riskName: 'ROMM: ',
	accountName: 'Account: ',
	control: 'Control',
	controls: 'Controls',
	technologyCount: 'Technologies',
	noScotsFound: 'No related Scots',
	knowledgeScotWarning:
		'Based on the ROMMs related to this account or disclosure, the following standard SCOTs are required. You can import a new SCOT from Knowledge or relate an existing standard SCOT from this engagement.',
	requiredScots: 'Required standard SCOTs',
	knowledgeScotRelateInformation:
		'This standard SCOT has already been imported to this engagement. You may select a SCOT below to relate it to this account or disclosure or you may import a new SCOT.',
	importRelateDisabledMessage: 'Import or relate the required SCOTs before creating or relating other SCOTs',
	genericErrorMessage: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	previouslyImported: 'Previously imported',
	relatedwcgw: 'Related WCGWs',
	relatedRisks: 'Related ROMMs: ',
	boltIconTitle: 'Related ROMM',
	boltOutlineIconTitle: 'Potential ROMM',
	relatedITApp: 'Related IT App/SO',
	instructions: 'Instructions:',
	expandRisk: '1. Expand a ROMM',
	selectAssertion: '2. Select an assertion',
	identifyRelatedWCGW: '3. Identify that WCGW related to the ROMM',
	clickAccount: '1. Click on an account',
	selectWCGW: '2. Select a WCGW',
	identifyRelatedTask: '3. Identify the tasks that respond to the WCGW',
	information: 'Information',
	requiredAssertions: 'Required assertions',
	wcgwWithoutTasks: 'WCGW without tasks',
	rommAssociatedWNotRelyAssertion:
		'ROMM is associated to an Assertion with Control Risk of Not Rely or an Assertion with Inherent Risk of Higher where the Account has an estimate',
	hasRiskAssociated: 'ROMM Associated',
	clearSelections: 'Deselect All',
	romm: 'ROMM',
	riskOfMaterialMisstatementsWithoutRelatedTask: 'Risk of material misstatements without related task',
	selectOneOrMoreTasksToSeeTheRelatedROMM: 'Select one or more tasks to see the related ROMM',
	invalidRelatedEntity: 'Related account cannot be found. Refresh the page and try again. Contact the Help Desk if the issue persists.',
	noResultsAvailable: 'No results found',
	selectAccounts: 'Select accounts',
	riskOfMaterialMisstatement: 'Risk of material misstatement',
	AccountConclusion: 'Account Conclusion',
	CanvasForm: 'Canvas Form',
	IndependenceForm: 'Independence Form',
	Profile: 'Profile',
	AccountDetails: 'Details',
	Conclusions: 'Conclusions',
	accountDetailsTab: 'details',
	conclusionsTab: 'conclusions',
	formsNoContentText: 'No content available.',
	formsDocumentNoRelatedObjects: 'No objects related to the document',
	formsNoRelatedObjects: 'No related objects',
	formsBodyHeaderControl: 'Controls',
	formsBodyDesignEffectiveness: 'Design effectiveness',
	formsScotsAndWcgws: 'SCOTs & WCGWs',
	wcgWAndRelatedControls: 'WCGWs and related Controls',
	controlAndRelatedItSO: 'Controls and related Technology/ SOs',
	type: 'Type',
	approch: 'Approach',
	testingApproach: 'Testing approach',
	controlOpertaingEffectiveness: 'Operating effectiveness',
	iTAppSO: 'IT App/SO',
	iTProcess: 'IT process',
	iTControl: 'IT Control',
	iTRisk: 'IT risks',
	aggregateITEvaluation: 'Aggregate IT evaluation',
	relatedCanvasForm: 'Related Canvas Form',
	relatedSections: 'Related sections',
	validations: 'Validations',
	profileV2Validation: 'Changes not submitted',
	profileV2ValidationModalDescription:
		'Changes have been made that would result in a content update, but have not been submitted. If the changes are intentional close this modal and submit the new profile answers. If the changes are not intentional, review the Changes view and manually revert the answers back to previous selections.',
	profileV2ValidationCount: '1',
	itProcessWithoutRelatedTechnology: 'IT process without related technology',
	reviewNote: 'Review notes',
	editAssociations: 'Edit Associations',
	editAssociationsLower: 'edit associations',
	riskWCGW: 'ROMM:WCGW relationship',
	wcgwTask: 'WCGW:Task relationship',
	noAssertionFound: 'No assertions have been associated. Click {here} to associate assertions',
	limitedRiskAccountIdentifier: 'Limited risk account',
	insignificantAccountIdentifier: 'Insignificant account',
	noWCGWFound: 'There are no WCGWs related to this ROMM. Click on Edit Associations to relate one or more WCGWs.',
	noRelatedWCGWs: 'No related WCGWs',
	noWCGWAvailable: 'No ROMM available for the selected assertion(s)',
	expandCollapse: 'Click here to expand/collapse',
	requiredAssertionsInfo: 'Show only assertions with a control risk assessment of not rely and assertions related to higher risk estimates',
	wCGWwithoutTasksInfo:
		'Show only WCGWs related to an assertion with a control risk assessment of not rely and assertions related to higher risk estimates, that do not have any responsive substantive tasks associated',
	noBuildStepsAvailable: 'No build steps available to be presented.',
	risk: 'ROMMs',
	wcgw: 'WCGW',
	riskWcgw: 'ROMM: WCGW',
	wcgwTasks: 'WCGW: Task',
	riskWcgwLabel: 'Relate ROMM to WCGW',
	wcgwTasksLabel: 'Relate WCGW to Task',
	noRiskTypes: 'No ROMM types found',
	saveRisk: 'Save',
	noRisksFound: 'No ROMMs found',
	searchROMMs: 'Search ROMMs',
	selectRiskForAccountsAndProcedures: 'Select a significant, fraud or higher risk to view the related accounts and procedures',
	designROMMResponse: 'Design ROMM response',
	haveBeenIdentified: 'have been identified',
	noAccountsFound: 'No records found',
	noResponseAvailable: 'No response available',
	noResponseAvailableForAttributes: 'No response available. Attributes',
	noDocumentsAvailable: 'No documents available',
	noValue: 'No value',
	showValidation: 'Validations',
	noTasksAssociated: 'No tasks associated',
	noAccountsIdentified: 'No accounts have been identified',
	noAssertionsIdentified: 'No Assertions have been identified',
	noWcgwsIdentified: 'No WCGW have been identified',
	pastingImagesNotAllowed: 'Pasting of images is not allowed. If images are required upload them as evidence and refer to them.',
	incompleteResponse: 'Incomplete responses',
	unresolvedComments: 'Unresolved comments',
	inconsistentForms: 'Inconsistent forms',
	limitedRiskAccount: 'Limited risk account',
	inherentRiskAssessment: 'Inherent risk assessment',
	task: 'Task',
	tasks: 'tasks',
	taskLabel: 'task',
	selected: 'selected',
	displaytoc: 'Display TOC',
	workingoffline: 'Working Offline',
	syncinprogress: 'Sync in progress',
	prepareoffline: 'Preparing data for offline',
	connectionavilable: 'Connection available',
	softwareUpdate: 'Software updates',
	updateLater: 'Update later',
	updateNow: 'Update now',
	updateMsg: 'Software updates are available for EY Canvas. Select Update Now to download and install the updates. The page will be refreshed.',
	searchPlaceholder: 'Search',
	filter: 'Filter',
	leftNavSearchPlaceholder: 'Search headers and sections',
	back: 'Back',
	updateAvailable: 'Update available',
	contentUpdateAvailableTooltip: "Content update available. Click here to navigate to the 'Canvas form updates' screen to initiate an update.",
	moreMenu: 'More Menu',
	signoffPreparer: 'Sign-off as preparer',
	signoffReviewer: 'Sign-off as reviewer',
	pagingShowtext: 'Show',
	searchDocuments: 'Search documents',
	noRelatedDocuments: 'No related documents',
	noRelatedObjects: 'No related objects',
	documentName: 'Document name',
	formDetails: 'Form details',
	questionsAndResponses: 'Questions and responses',
	details: 'Details',
	trackChanges: 'Track changes',
	goToTrackChanges: 'Go to Track Changes',
	attributes: 'Attributes',
	relatedActions: 'Related actions',
	createCustom: 'Create custom',
	createCustomButtonLabel: 'Create custom header, section, or body',
	overwriteForm: 'Overwrite form',
	decimalNaN: 'NaN - Not a number',
	noRelatedObjectsApplicable: 'Objects are not required to be associated to this Canvas Form',
	objects: 'Objects',
	objectName: 'Object name',
	addCustomDescription: 'Select the content type to be added to this Canvas Form, input details, and click save',
	headerTitle: 'Header title',
	sectionTitle: 'Section title (mandatory)',
	aresSectionTitle: 'Section title',
	customLabel: 'Custom label (optional)',
	customBodyDescription: 'Body description',
	header: 'Header',
	section: 'Section',
	body: 'Body',
	requiredWCGW: 'Required',
	headerTitleRequired: 'Header title required.',
	bodyDescriptionRequired: 'Body description is required.',
	bodySectionRequired: 'Section is required.',
	bodyHeaderRequired: 'Header is required.',
	sectionTitleRequired: 'Section title is required.',
	headerRequiredMessage: 'Header is required.',
	enterDecimalAmount: 'Enter decimal amount',
	enterPercentage: 'Enter percentage',
	completeRiskFactorAssessment: 'Complete assessment of identified events and conditions.',
	noScotsEstimatesIdentified: 'No SCOTs or estimates have been identified',
	// Track changes
	trackChangesResponseLabel: 'Track change version response',
	trackChangesVersionLabel: 'Track changes version',
	noResponseIdentified: 'No response identified',

	// Compare responses
	compareResponsesLabel: 'Compare responses',
	compareResponsesTitle: 'Compare entity responses',
	compareResponseNoDataPlaceholder: 'No data available, since the engagement has only one document of the same type.',
	labelFor: 'for',
	questions: 'Questions',
	answers: 'Answers',
	countOfResponses: 'Count of responses',
	openNotes: 'Open notes',
	clearedNotes: 'Cleared notes',
	click: 'Click',
	clickToViewAnswer: 'to view answer',
	clickToViewQuestionAnswer: 'to view question and answer',
	selectDocuments: 'Select documents',
	selectedDocumentsCount: '{0} documents selected',
	selectedDocumentCount: '{0} document selected',
	associatedDocuments: 'Related documents',
	noAnswerProvided: 'No answer provided',

	//Individual Account Attributes
	individualAccountAttributes: 'Individual account attributes',
	individualAccountAttributesName: 'Attribute name',
	individualAccountAttributesIsSelected: 'Is selected?',
	individualAccountAttributesRomms: 'ROMMs',
	individualAccountAttributesRiskName: 'ROMM name',
	individualAccountAttributesAssertion: 'Assertion',
	individualAccountAttributesNoData: 'Account attributes not available for this document',

	//Standard ROMM Listing
	standardRommListing: 'Standard ROMM listing',
	standardRommListingRisksNotAvailable: 'ROMMs are not available for this document',
	standardRommListingAccepted: 'Standard ROMMs',
	standardRommListingAllRisksRejected: 'All ROMMs have been rejected',
	standardRommListingRelevantAssertions: 'Relevant assertions',
	standardRommListingRejected: 'Standard ROMMs that are not ROMMs in this engagement',
	standardRommListingPreRejected: 'Standard risks of misstatements that are not ROMMs in this engagement',
	standardRommListingCategory: 'Rationale',
	standardRommListingRationale: 'Rationale',
	standardRommListingAdditionalContext: 'Entity- specific context',
	additionalEntitySpecificContext: 'Click {here} to add additional entity specific context',
	entitySpecificContext: 'Entity specific context',
	addAdditionalContextTitle: 'Add additional context',
	editAdditionalContextTitle: 'Edit additional context',
	entitySpecificContextRequired: 'Entity-specific context (required)',
	entitySpecificInformation: 'Entity specific information',

	// Workspace Engagement
	thisEngagement: 'This engagement',
	documentLocation: 'Document location',
	otherEngagementsInWorkspace: 'Other engagements in the workspace',
	added: 'Added',
	shared: 'Shared',
	documentIneligibleForSharingMessage: 'Confidential documents are not eligible to be shared.',
	fitDocumentCannotbeSelected: 'FIT documents cannot be shared between engagements.',

	//Helix Configuration
	helixConfigurationTitle: 'Integrate EY Helix data',
	helixConfigurationPageDescription:
		'Validate linked EY Helix project and import data to EY Canvas. If you have changed any EY Helix settings below or made changes to your EY Helix data after you have imported the data, you will have to re-import the data for the update to be made.',
	linkedEYHelixProjects: 'Linked EY Helix projects:',
	client: 'Client:',
	engagement: 'Engagement:',
	analysisDate: 'Analysis date:',
	eyHelixProjects: 'EY Helix projects',
	noPrimaryEYHelixproject: 'No primary EY Helix project has been identified.',
	here: 'here',
	identifyEyHelixProjects: 'to identify an EY Helix project and start the work flow.',
	eyHelix: 'EY Helix',
	primary: 'Primary',
	helixSettingsDescription: 'Click Edit to select the settings that will be applied when loading EY Helix Analyzers.',
	editButton: 'Edit',
	helixSettingsModalTitle: 'EY Helix Settings',
	currencyType: 'Currency type',
	currencyTypeError: 'Currency type could not be retrieved from EY Helix. Confirm data is set up correctly in EY Helix and try again.',
	shortNumberFormat: 'Short number format',
	shortNumberFormatFooter: 'Rounding to be applied to numerical values displayed in EY Helix tables.',
	eyHelixAnalyzerFilterMetadataError: 'Could not connect to EY Helix. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	functional: 'Functional',
	reporting: 'Reporting',
	currencyCode: 'Currency code',
	businessUnit: 'Business unit',
	roundingNumberFormat: 'Rounding number format',
	eyHelixProjectChangedLine1: 'Linked EY Helix project has been changed since the last time EY Helix settings were saved.',
	eyHelixProjectChangedLine2: 'Click Edit to update settings before data can be imported or re-imported from EY Helix.',
	helixSettingsTimeline: 'EY Helix settings',
	helixMapEntitiesToBU: 'Map Entities to Business Units',
	helixNumberOfMapEntities: 'Number of mapped Business Units',
	importEYHelixDataTimeline: 'Import EY Helix data',
	mapAccountsHelixTimeline: 'Map accounts',
	setEYHelixSettings:
		"Edit your EY Helix settings below. Once saved and data is imported, the selected comparative date 1 and comparative date 2 dates will be used as comparisons against the designated analysis date in the OAR activity. To compare against only one comparative date, select 'None' in the comparative 2 date selection.",
	eyHelixDataHasChangedLine1: 'Data has changed since the last time settings were saved. Make new selections below and click',
	eyHelixDataHasChangedLine2: 'to update EY Helix settings.',
	all: 'All',
	multiple: 'Multiple',
	notApplicableAbbreviation: 'N/A',
	importEyHelixData: 'Import EY Helix data',
	editScreenshot: 'Edit',
	deleteNote: 'Delete',
	removeAnnotation: 'Remove annotation',
	addAnnotation: 'Add annotation',
	addingBoundingBox: 'Select an area on the screenshot to annotate, confirm the annotation, and click the checkmark to save. ',
	cancelBoundingBox: 'Cancel',
	deleteScreenshot: 'Delete screenshot',
	openInFullscreen: 'Open in fullscreen',
	helixURLErrorMessage1: 'The configuration for the mapped EY Helix project is incomplete.',
	helixURLErrorMessage2: 'Please go to {0} page to update.',
	helixIsNotEnabledMessage: 'EY Helix is not enabled for your engagement.',
	helixSetup: 'EY Helix setup',
	openAnalysisInHelix: 'Open analysis in EY Helix',
	helixInvaliddate: 'Invalid date. Select a date prior to the analysis date.',
	helixcomparativedateoptional: 'EY Helix comparative date 2 (optional)',
	helixpriorperioddate: 'EY Helix comparative date 1',
	helixanalysisperiod: 'EY Helix analysis date',
	helixfiscalDropDownLabel: 'Period {0} - {1}',

	helixSettingsEditButtonTitle: 'Edit',
	helixImportDataEditButtonTitle: 'Import',
	helixImportInsufficientPermissionsMessage:
		'Insufficient permissions to perform Helix data Import. Contact your engagement administrator and request permssion to initiate a Helix data import.',
	helixImportNotAllowed: 'Engagement profile does not permit the import of Helix data',
	helixDeleteImportInsufficientPermissionsMessage:
		'Insufficient permissions to delete the EY Helix data Import. Contact your engagement administrator and request permission to delete the EY Helix data.',
	helixModalTitle: 'Helix modal',

	EYAccountMappingStepLabel: 'Manage account mapping',

	EYAccountMappingOptional: 'Optional',
	EYAccountMappingStepTitleSettingsCompleted: 'Perform EY account mapping',
	EYAccountMappingStepTitleSettingsIncomplete: 'Complete EY Helix settings to access the EY Helix Mapping Module',
	EYAccountMappingInstructions: 'Map client accounts to EY accounts and process changes. Once processing completes, import the data below.',
	manageAccountMappingButtonLabel: 'Manage account mapping',

	// Deficiency Modal
	createNewDeficiency: 'Create {newCaps} or {relateCaps} deficiency',
	newCaps: 'new',
	editDeficiency: 'Edit deficiency',
	unrelateDeficiency: 'Unrelate deficiency',
	relateCaps: 'relate',

	//EY Helix Setup Card
	EYHelixSetupTitle: 'EY Helix',
	EYHelixSetupSubTitle: 'Configure and import data to EY Canvas',
	LastImported: 'Last imported',
	EYHelixSettings: 'EY Helix connections',
	NoEYHelixProjectLinkedLabel1: 'This engagement is not linked to a Primary EY Helix project. Please visit the',
	NoEYHelixProjectLinkedLabel2: 'page to establish the link.',
	NoEYHelixProjectLinkedHperlink: 'EY Helix Projects',
	NoDataImportedLabel: 'Data has not been imported from EY Helix. Click EY Helix setup to initiate the process.',
	noHelixConnections: "Click 'EY Helix connections' to create a connection.",
	helixConnectionExists: 'connection exists',
	helixConnectionsExist: 'connections exist',
	helixTrialBalanceImported: 'Scope & strategy trial balance imported',
	helixTrialBalancesImported: 'Scope & strategy trial balances imported',
	helixNoTrialBalanceImported: "Click 'EY Helix connections' to import a Scope & strategy trial balance.",

	// EY Helix - Map Accounts
	mapAccountsHelixCanvas: 'Click Edit to Map EY Canvas accounts to accounts imported from EY Helix',
	mapAccountsHelixCanvasSubtitle:
		'Drag and drop each EY Helix account to map to an EY Canvas account. Click Manage accounts to create or edit EY Canvas accounts.',
	mapAccountsHelixHeaderLabel: 'EY Helix accounts',
	mapAccountsCanvasHeaderLabel: 'EY Canvas accounts',
	mapAccountsConnectedLabel: 'Accounts connected',
	mapAccountsShowMappedLabel: 'Show mapped accounts',
	mapAccountsHideMappedLabel: 'Hide mapped accounts',
	mapAccountsManageLabel: 'Manage accounts',
	mapCraViewDetailsLabel: 'View changes',
	mapAccountsAndDisclosuresManageLabel: 'Manage accounts and disclosures',
	mapAccountsNoCanvasAccounts: 'No accounts have been identified.',
	mapAccountsNoCanvasAccountsClick: 'Click ',
	mapAccountsNoCanvasAccountGetStarted: ' to get started.',
	mapAccountsRemoveAccount: 'Remove',
	mapAccountsReImportHelixAccounts: 'Data import from EY Helix was not successful. Please re-import the data and try again.',
	mapAccountsReImportHelixAccountsHelpDesk: 'If the issue persists, contact the Help Desk',
	mapAccountsNoHelixAccountHasBeenImported: 'No EY Helix accounts have been imported.',
	mapAccountsNoHelixAccountHasBeenImportedCheckData: 'Check data in EY Helix and try again.',

	//Helix Analyzer
	accountNotRelatedToDocumentOnPhaseTwo: 'No account related to this document',

	// Materiality
	materialityNotAvailableForEntity: 'Materiality is not available for the selected entity',
	materialityBasisLabel: 'Measurement basis',
	currencyLabel: 'Currency',
	taxRateLabel: 'Tax rate',
	SAD: 'SAD nominal amount',
	revisedMateriality: 'Revised materiality',
	deleteMaterialityTitle: 'Delete materiality',
	deleteMaterialityDescription: 'Are you sure you want to delete the materiality. This action cannot be undone.',
	revisedAmountRequired: 'Please complete all required fields to save',
	teExceedsPmError: 'TE amount must not exceed PM amount',
	sadExceedsTeError: 'SAD amount must not exceed TE amount',
	//PM TE SAD Widget
	materialityWidgetLabel: 'PM/TE/SAD',
	deleteRevisedMateriality: 'Clear revised materiality values',
	changeRevisedMateriality: 'Click edit to change revised materiality',

	// TE labels
	planningmateriality: 'Planning Materiality',
	requiredTePercentage: 'Required TE',
	suggestedtepercentage: 'Suggested TE',
	currentperiodte: 'Current Period TE',
	priorperiodte: 'Prior Period TE',
	pmPriorPeriod: 'Prior Period PM',
	tepercentage: 'TE percentage',
	teamount: 'TE amount',
	teLabel: 'Tolerable error',
	sugestedSAD: 'Suggested SAD percentage:',
	priorSAD: 'Prior period SAD',
	currentPeriodSAD: 'Current period SAD',
	sadPercentage: 'SAD percentage',
	sadAmount: 'SAD nominal amount',
	rationaleLabel: 'Rationale',
	suggestedTEPercentageInfo:
		'If a different percentage is selected based on engagement specific factors, you will be prompted to document those factors below.',
	rationaleTEDescription: 'Enter rationale for TE as a percentage of PM in consideration of attributes selected above.',
	teAmmountInvalid: 'Enter a valid amount, or select 50% or 75%',
	highRiskTEAmmountInvalid: 'Enter a valid amount, or select 50%',
	highRiskTERequired: 'Based on the responses to the considerations above, the TE percentage identified is required and cannot be changed.',

	//for SAD final balances modal
	sadFinalBalancesLabel: 'SAD final balances',
	sadFinalBalancesDescription: 'Input the tax rate, currency and final financial statement amounts below and select <b class=\'motif-body1-default-bold\'>\'Save and close\'</b> to finish.',
	sadFinalBalTaxRateLabel: 'Tax rate',
	sadFinalBalTaxRatePlaceholder: 'Tax rate',
	sadFinalBalTaxRateTooltip: 'Enter the current year marginal tax rate.  This rate will be used to calculate the tax effect of misstatements.',
	sadFinalBalCurrencyLabel: 'Currency',
	sadFinalBalCurrencyPlaceholder: 'Currency',
	sadFinalBalCurrencyTooltip: 'Provide the reporting currency code for the entity.',

	// EY Helix Map Entities to Business Units Modal
	mapEntitiesModalTitle: 'Manage Entities',
	mapEntitiesModalLeyendDescription: 'Manage the mapping between EY Canvas Entities and Business Units from the EY Helix project below.',
	mapEntitiesModalLeyendNote:
		'Note: A Business Unit can be associated to one or multiple EY Canvas Entities. Once saved and data is imported, the data associated to the Business Units in EY Helix will show as mapped to related EY Canvas Entities.',
	mapEntitiesModalEntityCodeLabel: 'Entity code',
	mapEntitiesModalEmptyEntitiesList: 'No entities have been created.',
	mapEntitiesRelatedBusinessUnitDropdownPlaceholder: 'Related Business Unit',
	mapEntitiesSelectedBusinessUnitsCount: '{0} Business Units selected',

	//AdjustedBasis
	enterAmount: 'Enter amount',
	basisAmount: 'Basis amount',
	lowEndOfRange: 'Low end of range',
	highEndOfRange: 'High end of range',
	suggestedRange:
		'Based on the above factors, use of a percentage towards the {0} of the range {1} to {2} may be appropriate. If an amount is selected outside of this range based on engagement specific factors, you will be prompted to document those factors below.',
	suggestedRangeLowPMBracket:
		'Based on the above factors, a percentage of {0} may be appropriate. If an amount is selected outside of this percentage based on engagement specific factors, you will be prompted to document those factors.',
	middle: 'middle',
	lowerEnd: 'lower end',
	higherEnd: 'higher end',
	lowEnd: 'low end',
	priorPeriodPm: 'Prior period PM:',
	suggestedRangeSummary: 'Suggested range',
	loadingMateriality: 'Loading materiality...',
	pmBasisPercentage: 'PM basis percentage',
	pmAmount: 'PM amount',
	currentPmAmount: 'Current period PM amount',
	pmAmountPlaceholder: 'Enter PM amount',
	currentPeriodPm: 'Current period PM:',
	enterRationale: 'Enter rationale',
	rationaleDescription: 'Enter rationale for PM basis percentage in consideration of attributes selected above',
	pmValidationMessage: 'Planning materiality cannot exceed the higher end of the range',
	sadValidationMessage: 'Nominal amount cannot exceed the higher end of the range.',
	sadRationaleDiscription: 'Enter rationale for SAD percentage in consideration of attributes selected above',
	nopriorperiodDocs: 'No prior period documents available',
	addPriorPeriodEvidence: 'Add prior period evidence',
	addToEvidenceLabel: 'Add to evidence',
	moveToEvidenceLabel: 'Move to evidence',
	addToEvidenceModalDescription: 'Create a new name or keep the existing name for the selected document.',
	GoToSource: 'Go to source',
	//ITRiskITControls
	createNewITGC: 'New ITGC',
	relateITGC: 'Relate ITGCs',
	createNewITSP: 'New ITSP',
	relateITSP: ' Relate ITSP',
	noITGC: 'no ITGCs',
	itRiskForITGCITSP: 'IT risk name (required)',
	createITGCModalDescription: `Enter the ITGC details below and select '<b>{0}</b>' to finish. To create another ITGC, select '<b>{1}</b>'.`,
	createITSPModalDescription: `Enter the ITSP details below and select '<b>{0}</b>' to finish. To create another ITSP, select '<b>{1}</b>'.`,
	supportingTechnologies: 'Tool(s) that performs the automated portion of the ITGC',
	relateSupportingTechnologies: 'Relate supporting technologies',
	noRelatedsuppotingTechnology: 'No related supporting technology',
	editITGCModalDescription: 'Edit the ITGC details below and select \'Save\' to finish.',
	editITSPModalDescription: 'Edit the ITSP details below and select \'Save\' to finish.',
	frsr: 'FR/SR',
	substantiveAloneNotSufficient: 'Substantive alone is not sufficient',
	journalEntry: 'Journal entry considerations',
	relatedparty: 'Related party transactions',
	significantunusaltransactions: 'Significant unusual transactions',
	controlDesignEffectiveness: {
		[0]: { description: printLabels.controlDesignEffectiveness_0_description },
		[1]: { description: printLabels.controlDesignEffectiveness_1_description },
		[2]: { description: printLabels.controlDesignEffectiveness_2_description }
	},
	controlOperationEffectiveness: {
		[0]: { description: 'Not selected' },
		[1]: { description: 'Effective' },
		[2]: { description: 'Ineffective' }
	},
	controlTesting: {
		[0]: { description: 'Not selected' },
		[1]: { description: 'Yes' },
		[2]: { description: 'No' }
	},
	itAppTypes: {
		[0]: { label: printLabels.itAppTypes_0_label },
		[1]: { label: printLabels.itAppTypes_1_label }
	},
	controlType: {
		[0]: { controlTypeName: printLabels.controlType_0_controlTypeName, shortName: printLabels.controlType_0_shortName },
		[1]: { controlTypeName: printLabels.controlType_1_controlTypeName, shortName: printLabels.controlType_1_shortName },
		[2]: { controlTypeName: printLabels.controlType_2_controlTypeName, shortName: printLabels.controlType_2_shortName },
		[3]: { controlTypeName: printLabels.controlType_3_controlTypeName, shortName: printLabels.controlType_3_shortName },
		[4]: { controlTypeName: printLabels.controlType_4_controlTypeName, shortName: printLabels.controlType_4_shortName }
	},
	controlTypeEnumLabel: {
		[0]: { controlTypeName: 'Not selected' },
		[1]: { controlTypeName: 'IT Application Control' },
		[2]: { controlTypeName: 'IT Dependent Manual Control' },
		[3]: { controlTypeName: 'Manual Prevent' },
		[4]: { controlTypeName: 'Manual Detect' }
	},
	controlFrequencyType: {
		[0]: { controlFrequencyTypeName: 'Not selected' },
		[1]: { controlFrequencyTypeName: 'Many times per day' },
		[2]: { controlFrequencyTypeName: 'Daily' },
		[3]: { controlFrequencyTypeName: 'Weekly' },
		[4]: { controlFrequencyTypeName: 'Monthly' },
		[5]: { controlFrequencyTypeName: 'Quarterly' },
		[6]: { controlFrequencyTypeName: 'Annually' },
		[7]: { controlFrequencyTypeName: 'IT Application Control' },
		[8]: { controlFrequencyTypeName: 'Other' }
	},
	strategyType: {
		[0]: { strategyTypeName: printLabels.strategyType_0_strategyTypeName },
		[1]: { strategyTypeName: printLabels.strategyType_1_strategyTypeName },
		[2]: { strategyTypeName: printLabels.strategyType_2_strategyTypeName },
		[3]: { strategyTypeName: printLabels.strategyType_3_strategyTypeName },
		[4]: { strategyTypeName: printLabels.strategyType_4_strategyTypeName }
	},
	aggregateITEvaluationType: {
		[0]: { aggregateITEvaluationTypeName: printLabels.aggregateITEvaluationType_0_aggregateITEvaluationTypeName },
		[1]: { aggregateITEvaluationTypeName: printLabels.aggregateITEvaluationType_1_aggregateITEvaluationTypeName },
		[2]: { aggregateITEvaluationTypeName: printLabels.aggregateITEvaluationType_2_aggregateITEvaluationTypeName },
		[3]: { aggregateITEvaluationTypeName: printLabels.aggregateITEvaluationType_3_aggregateITEvaluationTypeName },
		[4]: { aggregateITEvaluationTypeName: printLabels.aggregateITEvaluationType_4_aggregateITEvaluationTypeName }
	},

	sampleItemFilterLabels: {
		filterTypeOfTags: 'Tags',
		noFiltersAvailable: 'No filters available',
		filterToolTip: 'Filter',
		clearAll: 'Clear all',
		showMore: 'more',
		filters: 'Filters',
		noResults: 'No results found'
	},

	accountFilterLabels: {
		clearHoverText: 'Clear',
		clearAll: 'Clear all',
		controlDeficiency: 'Control deficiency',
		filtersLabel: 'Filters',
		filterToolTip: 'Filter',
		designConclusion: 'Design effectiveness',
		operatingConclusion: 'Operating effectiveness',
		noResultFound: 'No results found',
		labelYes: 'Yes',
		labelNo: 'No'
	},

	itgcFilterLabels: {
		itRiskWithNoITGC: 'IT risks not mitigated by ITGCs',
		technologyType: technologyTypeFilter.firstLevelLabel,
		technologyTypeOptions: technologyTypeFilter.secondLevelOptionsLabels,
		directlySupports: directlySupportsFilter.firstLevelLabel,
		directlySupportsOptions: directlySupportsFilter.secondLevelOptionsLabels
	},

	itspFilterLabels: {
		itRiskNeedAttention: 'IT risk requiring attention',
		itRiskWithITSP: 'IT risk with related ITSP',
		technologyType: technologyTypeFilter.firstLevelLabel,
		technologyTypeOptions: technologyTypeFilter.secondLevelOptionsLabels,
		directlySupports: directlySupportsFilter.firstLevelLabel,
		directlySupportsOptions: directlySupportsFilter.secondLevelOptionsLabels
	},

	socdOnboardITFilterLabels: {
		itRiskFromOtherEngagements: 'Reference IT risks',
		itGCsFromOtherEngagements: 'Reference ITGCs',
		itRiskWithNoITGC: 'IT risks not mitigated by ITGCs',
		technologyType: technologyTypeFilter.firstLevelLabel,
		technologyTypeOptions: technologyTypeFilter.secondLevelOptionsLabels,
		directlySupports: directlySupportsFilter.firstLevelLabel,
		directlySupportsOptions: directlySupportsFilter.secondLevelOptionsLabels
	},

	stratergyTypeLabels: {
		[0]: { label: 'Not Selected' },
		[1]: { label: 'In scope' },
		[2]: { label: 'Out of scope' }
	},
	noChangeReasonCommentAvailable: 'Click edit reason from the document cog wheel options to enter the reason for change.',
	changeReasonModalTitle: 'Edit reason for change',
	changeReasonModalText:
		'Select the reason for the change(s) made to the document after the report date. If multiple administrative changes have been made, select the most significant change from the drop-down below. If both administrative changes and non-administrative changes have been made, select non-administrative below.',
	changeReasonUploadModalTitle: 'Reason for document upload',
	changeReasonUploadModalText:
		'Select the reason for the change(s) made to the document after the report date. If multiple administrative changes have been made, select the most significant change from the drop-down below. If both administrative changes and non-administrative changes have been made, select non-administrative below.',
	changeReasonModalComboPlaceholder: 'Select',
	changeReasonModalAnnotationText:
		'Document the circumstances encountered and the reasons for adding the information; new or additional audit procedures performed, audit evidence obtained and conclusions reached, and the effect on our auditor’s report.',
	changeReasonUploadModalAnnotationText:
		'Document the circumstances encountered and the reasons for adding the information; new or additional audit procedures performed, audit evidence obtained and conclusions reached, and the effect on our auditor’s report.',
	changeReasonModalAnnotationPlaceHolder: 'Enter reason for change',
	changeReasonModalChangeReasonRequired: 'Change reason to save',
	reasonColumnTitle: 'Reason',
	linked: 'Linked',
	linkStatusOwned: 'Owned by this engagement',
	linkStatusLinked: 'Linked into this engagement',
	shareStatusShared: 'Shared into this engagement',
	lastModifiedBy: 'Last modified by',
	fileSize: '| {1} KB',
	openedLabelText: 'Opened ',
	currentlyBeingModifiedBy: 'Currently being modified by',
	OpenGuidedWorkflowDocument: 'Open this document through the EY Canvas FIT enablement',
	submitProfile: 'Submit Profile',
	submitProfileFit: 'Submit profile',
	contentUpdateUnAuthorizedTooltipMessage:
		'Insufficient permissions to perform content update. Contact your engagement administrator and request permission to initiate a content update.',
	submitProfileValidationErrorMessage:
		'Profile can only be submitted when all questions have been answered. Filter for incomplete questions, complete them, and submit again. If the issue persists, contact the Help Desk.',
	pickADate: 'Select a date',
	remediationDate: 'Remediation date',
	startDate: 'Start date',

	/* Sign Offs */
	preparerHoverText: 'Sign-off as preparer',
	reviewerHoverText: 'Sign-off as reviewer',
	preparerTitle: 'Preparer sign-offs',
	reviewerTitle: 'Reviewer sign-offs',
	deleteHoverText: 'Remove sign-off',
	preparer: 'Preparer',
	reviewer: 'Reviewer',
	preparerLabel: 'P',
	reviewerLabel: 'R',
	noSignOffsAvailable: 'No sign-offs available',
	none: 'None',
	partnerInChargeLabel: 'PIC',
	eqrLabel: 'EQR',
	documentSignoffRequiredLabel: 'Sign-offs required from:',

	relatedDocumentsTitle: 'Related documents',
	relatedTasksCount: '{0} Related tasks',
	relatedTasksTitle: 'Related tasks',
	relateTemporaryFiles: 'Relate temporary files',
	bodyRelatedDocumentsTitle: 'Documents associated to a body',
	relatedObjectsTitle: 'Related objects',
	relateDocumentsTitle: 'Manage related documents',
	relateDocumentsToBodyTitle: 'Add Evidence',
	relateDocumentsDesc: 'Select documents to be associated to the Canvas Form',
	relateDocumentsToBodyDesc: 'Relate a document from this engagement or from another engagement in this workspace',
	relateDocumentsToTheBody: 'Relate a document from this engagement.',
	priorPeriodEvidencesToTheBody: 'Prior period evidences related to the body',
	relatedDocunentEngdisabed: 'Document is not shared with this engagement',
	showOnlyRelatedDocuments: 'Show only related documents',
	manageDocuments: 'Manage Documents',
	documentCount: '{0} document',
	documentsCount: '{0} documents',
	relateDocumentsSearchPlaceholder: 'Search documents',
	overwriteFormDesc:
		'Select a form to overwrite the responses with the data from the current Canvas form. Note the current Canvas form will be moved to Temporary Files.',
	searchFormPlaceholder: 'Search form',
	overwriteLabel: 'Overwrite',
	confirmOverwriteLabel: 'Confirm overwrite',
	confirmOverwriteDesc:
		"Are you sure that you want to copy the content of the '{0}' form to the '{1}' form? Responses will be overwritten in the '{2}' form, but related evidence and objects will not. Applicable related evidence and objects should be re-associated to the '{3}' form after the overwrite has been completed. '{4}' form will retain its existing profiling/GAM layers, therefore, if that profiling is different from '{5}' form, please review and clean up the copied content. \n Do not close the browser or navigate away while the overwrite process is in progress. After the overwrite process has completed, the '{6}' form will be moved to Temporary files and you will be navigated to the '{7}' form. This action cannot be undone.",
	formSelectionRequired: 'Select a form to override.',

	open: 'Open',
	startCoeditMode: 'Start multi-user editing',
	endCoeditMode: 'End multi-user editing',
	openReadOnly: 'Open read-only',
	copyLink: 'Copy link',
	rename: 'Rename',
	viewHistory: 'View history',
	documentOpenModelLabel: 'Document currently being modified',
	modelUserOpenedTheDocumentText: 'This user opened the document ',
	modelDocumentOpenedText: 'This document is currently being modified by ',
	modelOpenedDocumentConflictText:
		'Opening the document could cause conflicts, so we recommend opening as read-only. If you would like to become the editor of this document, then ',
	clickHereEnabledText: 'click here.',
	documentOptions: 'Document Options',
	accountDetails: 'Account details',

	// DAAS labels
	coEditModeIsEnding: 'Multi-user editing is ending',
	coEditMode: 'Multi-user editing',
	checkInInProgressMessage: 'Check-in in progress. It may take up to 20 minutes for the document to be checked in. Please refresh for updates',
	checkInInErrorLabel: 'Check-in failed',
	checkOutInProgressMessage: 'Check-out in progress. It may take up to 20 minutes for the document to be checked out. Please refresh for updates',
	checkOutInProgressLabel: 'Check-out in progress.',
	checkInInProgressLabel: 'Check-in in progress',
	checkOutInErrorLabel: 'Check-out failed.',
	daasErrorMessage: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk',
	coEditModeIsStarting: 'Multi-user editing is starting',
	daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again.',
	beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} ',
	beingEditedInCoeditModeOn: 'on {0}.',
	beingEditedInCoeditModeError: 'Being edited in multi-user edit',
	coEditModeAutomaticallyEnds: 'Document is in multi-user edit mode, which will automatically end in {0} days.',
	coEditModeAutomaticallyEndsToday: 'Document is in multi-user edit mode, which will end today.',
	daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again.',
	documentCurrentlyBeingModifiedTitle: 'Document currently being modified',
	documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document',
	documentCurrentlyBeingModifiedBody:
		'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
	documentEndMultiUserEditingTitle: '​End multi-user editing',
	documentEndMultiUserEditingHeader:
		'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
	documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
	startMultiuserEditing: 'Start',
	close: 'Close',

	/* Engagement Comments */
	clear: 'Clear',
	reOpen: 'Re-open',
	reply: 'Add reply',
	replyLabel: 'Reply',
	unselectComment: 'Unselect comment',
	commentText: 'Enter text',
	replyText: 'Reply text',
	openStatus: 'Open',
	clearedStatus: 'Cleared',
	closedStatus: 'Closed',
	chartCommentsTitle: 'Review notes',
	showComments: 'Show comments',
	noRecordsFound: 'No records found',
	noCommentsFound: 'Leave a comment by using the inputs below. Assign the comment to a user and specify priority and due date.',
	newComment: 'Add comment',
	addNoteTitle: 'Add note',
	editComment: 'Edit comment',
	newReply: 'Add reply',
	editReply: 'Edit reply',
	commentTextRequired: 'Comment text required',
	replyTextRequired: 'Reply text required',
	myComments: 'My comments',
	assignTo: 'Assign to',
	theCommentMustBeAssigned: 'Assigned to required',
	priorityRequired: 'Priority required',
	dueDateRequired: 'Due date required',
	assignedTo: 'Assigned to',
	allComments: 'All comments',
	assignedToMe: 'Assigned to me',
	unassigned: 'Unassigned',
	draggableCommentsPlaceholder: 'Enter text to add a new comment',
	draggableNotesPlaceholder: 'Enter text to add a new note',
	enterReply: 'Enter reply',
	dueDate: 'Due date',
	commentsAmmount: '{count} comments',
	singleCommentAmmount: '{count} comment',
	eyInternal: 'EY',
	noneAvailable: 'None available',
	inlineEditorOpenWarning: 'Please close the current editor before opening notes in another section.',
	editBodyNotAllowedWhenInlineEditorIsOpen: 'Please close the open editor before editing the custom body.',
	deleteBodyNotAllowedWhenInlineEditorIsOpen: 'Please close the open editor before deleting the custom body.',
	navHelixProjects: 'EY Helix connections',
	evidence: 'Evidence',
	priorPeriod: 'Prior period',
	temporaryFiles: 'Temporary files',
	priorPeriodEvidence: 'Prior period evidence',
	closed: 'All assignments closed',

	/*Delete*/
	deleteFileTitle: 'Delete document',
	deleteFileCloseBtnTitle: 'Cancel',
	deleteFileConfirmBtnTitle: 'Delete',
	deleteFileCloseTitle: 'Close',
	deleteFileModalMessage: 'Are you sure that you want to delete the selected document?',
	/*Rename*/
	editCanvasformObjects: 'Edit the attributes and click <b>Save</b>.',
	renameFileModalMessage: 'Rename the document and click Save.',
	renameScreenshotModalMessage: 'Rename the screenshot and click Confirm.',
	renameFileTitle: 'Rename document',
	fileNameRequired: 'File name is required',
	invalidCharacters: 'File name cannot include: */:<>\\?|"',
	existingFileName: 'File name is not unique. Refresh the page or rename the file to remove this message.',
	maxLengthExceeded: 'The document name cannot exceed 115 characters.',

	STEntityProfileBannerMessage:
		'Changes have been made to one or more of the entity profiles that will result in content updates. Navigate back to the Profile entities page and click "Import content" to receive the new content applicable to the entity\'s profile or revert the answers to a previous state.',
	independenceValidationForOwnForm:
		'Changes have been made to the Independence responses, but have not been submitted. If the changes are intentional, ensure that the responses are submitted. If the changes are not intentional, review the Changes view and manually revert the answers back to previous selections.',
	independenceValidationForOthersForm:
		'Changes have been made to the Independence responses, but have not been submitted by the team member. Ensure that the team member reviews the changes and submits the same if they were intentional.',
	insufficientRightsForIndependenceSubmission:
		'Insufficient permissions to edit content. Contact your engagement administrator and request permission to edit content.',
	submitIndependenceProfileV2Message:
		'Please review the profile and confirm that the responses are accurate. If it is, please provide sign-offs and continue onto the engagement.',
	submitIndependenceProfileV2EditMessage:
		'No changes have been made to the profile that would result in engagement content changing. Use the Engagement content update page to perform a content update if necessary.',
	insufficientRightsForProfileV2Submission:
		'Insufficient permissions to edit the profile. Contact your engagement administrator and request permission to edit the profile.',
	returnToDashboard: 'Return to Dashboard',
	returnToDashboardFit: 'Return to dashboard',
	profileV2ChangeNotSubmittedBannerMessage:
		'Changes have been made to the Profile that will result in content updates. Submit the Profile to receive the new content or revert the answers to the previous state.',
	independenceChangeNotSubmittedBannerMessage:
		'Changes have been made to the independence form that need to be re-submitted.  Submit the independence form or deactivate this user to clear the validation.',
	multiEntityIndividualProfileBannerMessage:
		'Insufficient permissions to edit the profile. Contact your engagement administrator and request permission to edit the profile.',
	objectMissingBannerMessage:
		'<span class="headingText">Form is missing valid {0} association</span></br> This form requires {0} association. Select Edit objects to associate the {0} to this form.',
	objectMissingBannerOnTargetEngagementMessage:
		'<span class="headingText">Form is missing valid {0} association</span></br> This form requires {0} to be associated to the form. Navigate to the original engagement to make the association.',
	scotStrategy: 'SCOT strategy',
	wcgwStrategy: 'WCGW strategy',
	itProcessStrategy: 'IT process strategy',

	/*Edit Wcgw*/
	editWcgw: 'Edit WCGW',
	viewWcgw: 'View WCGW',
	editScot: 'Edit SCOT',
	viewScot: 'View SCOT',
	showIncomplete: 'Show incomplete',
	forms: 'Forms',
	form: 'Form',
	comments: 'Notes',
	commentsRequireYourAttention: 'Comment(s) require your attention',
	commentsAuthoredByYouStillOpen: 'Comment(s) authored by you are still open',
	commentsClearedForYourReview: 'Comment(s) cleared for your review',
	changes: 'Changes',
	editHeader: 'Edit header',
	editSection: 'Edit section',
	editBody: 'Edit body',
	editSectionDescription: "Edit the details for the section and click 'Save'.",
	editHeaderDescription: "Edit the details for the header and click 'Save'.",
	editBodyDescription: "Edit the details for the body and click 'Save'.",
	manageObject: 'Manage Object',
	relatedObjects: 'Related objects',
	taskCountSingular: 'task',
	taskCountPlural: 'tasks',

	/* Manage body objects */
	bro_manage_WCGWTask_title: 'Relate WCGWs',
	bro_manage_WCGWTask_instructions: 'Manage the WCGWs that are applicable',
	bro_manage_WCGWTask_noDataLabel: 'No results found',

	/*Add/Edit ITGC*/
	addITGC: 'Add ITGC',
	addNewITGC: 'Add new ITGC',
	addExistingITGC: 'Add existing ITGC',
	addITGCDescription: 'Enter the ITGC description.',
	itControlNameRequired: 'ITGC Name is required',
	frequencyRequired: 'Frequency is required',
	frequencyITGC: 'Select frequency',
	nameITGC: 'ITGC name (required)',
	iTProcesslabel: 'IT process',
	editITGC: 'Edit ITGC',
	editITSP: 'Edit ITSP',
	editITGCDescription: 'Edit the ITGC and its associated attributes',
	editITSPDescription: 'Edit the ITSP and its associated attributes',
	viewITGC: 'View ITGC',
	viewITSP: 'View ITSP',
	itgcTaskDescription:
		'Perform our designed tests of ITGCs to obtain sufficient appropriate audit evidence of their operating effectiveness throughout the period of reliance.',
	/**
	 * Add Edit ITGC
	 */
	addITSPDescription: 'Enter the ITSP description.',
	selectITRisk: 'Select IT risk (required)',
	itRiskRequired: 'IT risk (required)',
	itspNameRequired: 'ITSP name (required)',
	itspTaskDescription:
		'Customize this task description to design the nature, timing and extent of IT-substantive procedures to obtain sufficient appropriate audit evidence that the IT risks are addressed effectively throughout the period of reliance.<br />When the IT-substantive procedure is performed as of an interim date, design and perform procedures to obtain additional evidence that the IT risks are addressed for the period covered by our interim procedures through period-end.<br />We conclude on the results of our IT-substantive procedures.',
	itspRequired: 'ITSP Name is required',
	selectTestingStrategy:
		'Design the nature, timing and extent of our tests of controls to obtain sufficient appropriate audit evidence that the control operates effectively as designed throughout the period of reliance to prevent or detect and correct material misstatements at the assertion level. <br /> Conclude on the operating effectiveness of controls, by evaluating the results of our tests of controls including when we extended our sample size and performed tests of compensating controls.',
	itControlNameTest: 'Test {0}',

	/*Edit ITControl*/
	editITControl: 'Edit ITGC/ITSP',
	viewITControl: 'View ITGC/ITSP',

	/*Add/Edit ITRisk*/
	editITRisk: 'Edit IT risk',
	editITRiskDescription: 'Edit the IT risk',
	viewITRisk: 'View IT risk',
	addITRisk: 'Add IT risk',
	addITRiskDescription: 'Enter the IT risk description',
	selectITProcess: 'Select IT process (required)',
	itRiskName: 'IT risk',
	itRiskNameRequired: 'IT risk (required)',
	riskNameRequired: 'IT risk is required',
	processIdRequired: 'IT process is required',
	itProcessRequired: 'IT process (required)',
	hasNoITGC: 'There are no ITGCs that address the IT risk',

	/*Edit Risk*/
	editRisk: 'Edit ROMM',
	viewRisk: 'View ROMM',

	/*Edit Control*/
	editControl: 'Edit control',
	viewControl: 'View control',
	scotRelatedControls: 'Controls related to ',
	applicationControl: 'Application control',
	iTDependentManualControl: 'IT dependent manual control',
	noAapplicationControlAvailable: 'No application controls',
	noITDependentManualControlAvailable: 'No ITDM controls',
	isIPEManuallyTested: 'The automated portion of this ITDM control is only the use of system-generated report(s) that are tested substantively',

	/*Edit ITProcess*/
	editITSOProcess: 'Edit IT/SO process',
	viewITSOProcess: 'View IT/SO process',

	/*Edit ITApplication*/
	viewITAppSO: 'View IT App/SO',
	editITAppSO: 'Edit IT App/SO',
	strategy: 'Strategy',
	nameRequired: 'Name required',
	name: 'Name',

	/*Snap shot*/
	currentVersion: 'Current version',
	compareVersion: 'Select a version to compare',
	comparative: 'Comparative',
	snapshotVersionNotAvailable: 'No versions available for comparison',
	snapshots: 'Snapshots',
	sharedFormWarning:
		'This is a shared Canvas Form. The objects and evidence exists in the original engagement and will not be added to this engagement upon unlink. See <a style="color: #467cbe" href="https://live.atlas.ey.com/#library/104/p/SL33184174-396647/C_33404446/C_38129691" target="_blank">enablement here</a> for further details.',
	fullView: 'Full View',
	defaultView: 'Default View',
	print: 'Print',
	version: 'Version',
	navigationUnavailable: "Navigation is unavailable in Track changes & Attributes view. View 'Questions and responses' to enable navigation again.",
	snapshotUpdate: 'Updated',
	snapshotNew: 'New',
	snapshotAdjusted: 'Adjusted',
	snapshotRemoved: 'Removed',
	snapshotDeleted: 'Deleted',
	snapshotUnchanged: 'Unchanged',
	snapshotRollforward: 'Created at time of Roll-Forward',
	snapshotRestore: 'Created at time of Restore',
	snapshotCopy: 'Created at time of Copy',
	snapshotCopyAsterisked: 'Created at time of Copy*',
	/*Special Body*/
	priorPeriodAmount: 'Prior period amount',

	// Helix special body:
	helixScreenshotListLoading: 'Loading screenshots...',
	helixScreenshotLoading: 'Loading screenshot image...',
	helixScreenshotDeleting: 'Deleting screenshot...',
	helixNotesLoading: 'Loading tickmarks...',
	helixNotesBoundingBoxShow: 'Show annotations',
	helixNotesBoundingBoxHide: 'Hide annotations',
	helixNoteReferenceNumber: '#',
	helixNoteReferenceNumberPlaceholder: 'Enter reference number',
	helixNoteText: 'Note',
	helixNoteTextPlaceholder: 'Enter tickmark text',
	helixNoteAnnotate: 'Annotate',
	helixNoteAnnotateMessage: 'Select an area on the screenshot to annotate, confirm the annotation, and click the checkmark to save.',
	helixRemoveAnnotation: 'Delete annotation',

	/* User lookup body */
	userLookupInstructionalText: 'Enter name or email and press enter to see results.',
	userLookupShortInstructionalText: 'Enter name or email and press enter',

	/*Guidance*/
	guidance: 'Guidance',
	noIncompleteBodies: 'Select a Header or Section from the navigation menu to view content',
	noUnresolvedComments: 'Select a Header or Section from the navigation menu to view content',
	addComment: 'Add comment',

	/*Independence*/
	otherFormIndependenceMessage:
		'The content of this independence form has been updated, and the user has not logged in again since that happened. As a result certain responses may be incomplete. The prior independence status has been retained for reference.',
	override: 'Override',
	grantAccess: 'Grant access',
	denyAccess: 'Deny access',
	overrideSmall: 'override',
	grantAccessSmall: 'granting access',
	denyAccessSmall: 'denying access',
	status: 'Status',
	undefined: 'Undefined',
	incomplete: 'Incomplete',
	noMattersIdentified: 'No Matters Identified',
	matterIdentifiedPendingAction: 'Matter Identified - Pending Action',
	matterResolvedDeniedAccess: 'Matter Resolved - Denied Access',
	matterResolvedGrantedAccess: 'Matter Resolved - Granted Access',
	notApplicable: 'Not applicable',
	restored: 'Restored',
	overridden: 'Overridden',
	priorNoMattersIdentified: 'Prior - No Matters Identified',
	priorMatterIdentifiedPendingAction: 'Prior - Matter Identified - Pending Action',
	priorMatterResolvedGrantedAccess: 'Prior - Matter Resolved - Granted Access',
	priorMatterResolvedDeniedAccess: 'Prior - Matter Resolved - Denied Access',
	byOn: 'by {0} on',
	byLabel: 'by',
	onLabel: 'on',
	modifiedBy: 'Modified by',
	reason: 'Reason',
	submit: 'Submit',
	submitTemplate: 'Submit template',
	independenceHoverText: 'Your role must be Partner in Charge; Engagement Partner; or Executive Director to grant, deny or override access for this user.',
	enterRationaleText: 'Enter rationale for',
	enterRationalePlaceholderText: 'Enter rationale text',
	requiredRationaleText: 'Rationale (required)',
	rationaleTextRequired: 'Rationale is required',
	sharedExternalWarning:
		'This form is shared via Canvas Client Portal and accessible by external team members. Only enter responses and comments that should be shared with external team members.',
	independenceViewTemplateMessage:
		"This form serves as a template for each team member's individual independence inquiry. <br /> When completing the independence inquiry, there are several questions that relate to the independence requirements applicable to the entity under audit for which each team member must provide a response. Select the appropriate responses to these questions. Responses will be synchronized to each team member's individual independence inquiry. If a team member has selected a different response, they will have to reconfirm their independence when they re-enter the engagement. If they do not re-enter the engagement, then their previous independence status and responses will be preserved. <br /> Only authorized users can make changes to the independence template.  Speak to an engagement administrator.  Any changes made must be submitted, even if they are manually undone prior to archive.",

	/**
	 * FORM OBJECTS: SCOT-WCGW-CONTROL
	 */
	fo_instructionalText: 'Select the objects that the Canvas Form is documenting',
	fsro_instructionalText: 'Manage the objects related to this Section',
	relObj_title_risk: 'ROMMs',
	relObj_title_riskType: 'ROMM type',
	fo_showOnlyRelated: 'Show only related objects',
	scotsCount: '{0} SCOTs',
	wcgwsCount: '{0} WCGWs',
	itsoCount: '{0} IT applications / service organization',
	controlsCount: '{0} Controls',
	itControlsCount: '{0} IT Controls',
	itGcCount: '{0} ITGCs',
	itSpCount: '{0} ITSPs',
	itProcessesCount: '{0} IT Processes',
	risksCount: '{0} ROMMs',
	accountsCount: '{0} Accounts',
	stEntitiesCount: '{0} Entities',
	componentsCount: '{0} Components',
	deficiencyCount: '{0} deficiency',
	deficienciesCount: '{0} deficiencies',
	itApplicationsCount: '{0} IT Applications',
	view: 'View',
	searchByScotName: 'Search by SCOT name',
	searchByWcgwName: 'Search by WCGW name',
	searchByITSOAppName: 'Search by IT/SO Application name',
	searchByControlName: 'Search by Control name',
	searchByItControlName: 'Search by IT Control name',
	searchByItProcessName: 'Search by IT process name',
	searchByRiskName: 'Search by ROMM name',
	searchByAccountName: 'Search by Account name',
	searchBySTEntityName: 'Search by Entity name',
	searchByEstimateName: 'Search by estimate name',
	searchByComponentName: 'Search by Component name',
	searchByDeficiencyName: 'Search by Deficiency name',
	relateDeficiencyModalTitle: 'Relate deficiencies',
	relateDeficiencyModalDescription: 'Select one or more deficiencies to relate. To unrelate, deselect the relevant deficiency.',
	relateDeficiencyToITGCModalDescription: 'Select one or more deficiencies to relate to the ITGC. To unrelate from ITGC, deselect the relevant deficiency.',
	deficiencyTitle: 'Deficiency',
	relateTagToDeficiencyModalTitle: 'Relate tags',
	relateTagToDeficiencyModalDescription: 'Select the tags that caused this deficiency.',
	tag: 'tag',
	tagsCounter: '{0} tags',
	relateDeficiencyShowOnlyRelated: 'Show only related',
	showOnlyImpactedControlsLabel: 'Show only deficiencies related to impacted controls',
	relateDeficiencyNoResults: 'No results found',
	searchByItApplicationsName: 'Search by IT Application name',
	noScotsAvailable: 'No Scots are available in this engagement.',
	noRisksAvailable: 'No ROMMs are available in this engagement.',
	noControlsAvailable: 'No controls are available in this engagement.',
	noItControlsAvailable: 'No IT Controls are available in this engagement.',
	noItProcessesAvailable: 'No IT Processes are available in this engagement.',
	noItApplicationsAvailable: 'No IT Applications are available in this engagement.',
	noAccountsAvailableLabel: 'No Accounts are available in this engagement.',
	noDeficienciesAvailableLabel: 'No Deficiencies are available in this engagement.',
	noObjectsRelatedToForm: 'No objects related to this Canvas Form',
	noDocumentControlsAvailable: 'No controls are associated in this document.',
	noDocumentScotsAvailable: 'No SCOTs are associated to this document.',
	noSTEntitiesAvailable: 'No Entities are available in this engagement.',
	noComponentsAvailable: 'No components are available in this engagement.',
	editObjectDescription: 'Edit the association of objects to this form',
	editObjectsLabel: 'Edit objects',
	noITGCsOrITSPsHaveBeenIdentified: 'No ITGCs or ITSPs have been identified',
	noITSPsHaveBeenIdentified: 'No ITSPs have been identified',
	noItProcessIdentified: 'No IT process have been identified',
	noControlsIdentified: 'No controls have been identified',
	noITGCsHaveBeenIdentified: 'No ITGCs have been identified',
	noRelatedRisksIdentified: 'No related significant or fraud risks have been identified',
	noItApplicationsIdentified: 'No IT Applications have been identified',
	noSCOTIdentified: 'No SCOTs have been identified',
	noWCGWIdentified: 'No WCGWs have been identified',
	maxLimitLabel: 'Maximum number of objects have been selected.',
	minLimitLabel: 'Minimum number of objects have been selected.',
	manageGroupComponents: 'Manage group components',
	relatedITAppsTitle: 'IT processes and related IT applications',
	relatedWCGWTasksTitle: 'WCGWs and related tasks',
	noRelatedTasks: 'No related tasks',
	noRelatedWcgw: 'No related WCGWs',
	noRelatedControls: 'No related Controls',
	controlRelatedRisksTitle: 'Controls and related ROMMs',
	sCOTRelatedRisksTitle: 'SCOTs and related ROMMs',
	scotRelatedItApp: 'SCOT related Technology',
	relatedItApps: 'Related IT apps',
	relatedRisksTitle: 'Related ROMMs',
	relatedItRisksItProcessesTitle: 'ITGCs and related IT processes and IT risks',
	testingTitle: 'Testing',
	strategyTitle: 'Strategy',
	yes: 'Yes',
	yesInOtherEngagements: 'Yes*',
	yesInOtherEngagementsLegend: '* Yes, in other engagements',
	yesInOtherEngagementsLabel: '*Yes, in other engagements',
	no: 'No',
	noRelatedRisks: 'No related significant or fraud risks',
	closeAllComments: 'Close all comments',
	closeComments: 'Close comments',
	closeCommentsDescription: 'All open and cleared comments will be closed. Are you sure that you want to close all of the comments for this {0}?',
	addCanvasFormDigital: 'Digital',
	addCanvasFormCore: 'Core',
	addCanvasFormNonComplex: 'Non-Complex',
	addCanvasFormComplex: 'Complex',
	addCanvasFormListed: 'Listed',
	addCanvasFormGroupAudit: 'Group audit',
	addCanvasFormPCAOBFS: 'PCAOB-FS',
	addCanvasFormPCAOBIA: 'PCAOB-IA',
	addCanvasFormGroup: 'Group',
	addCanvasFormIsSmall: 'Small',
	addCanvasFormIsStandard: 'Standard',
	addCanvasFormIsComplex: 'Complex',
	addCanvasFormIsPubliclyTraded: 'PTE',
	addCanvasFormIsPublicInterestEntity: 'PIE',
	addCanvasFormIsNotPublicInterestEntity: 'Non-PIE',
	addCanvasFormIsPcaob: 'PCAOB',
	addCanvasFormIsIntegratedAudit: 'Integrated audit',
	addCanvasFormDisableTooltipLabel: 'Form profile is disabled',
	addCanvasFormIsPubliclyTradedTooltipLabel: 'Publicly traded entity',
	addCanvasFormIsPublicInterestEntityTooltipLabel: 'Public interest entity',
	addCanvasFormIsNotPublicInterestEntityTooltipLabel: 'Non-public interest entity',
	addCanvasFormStandards: 'Standards',
	addCanvasFormLanguage: 'Language',
	addCanvasFormNoResultFound: 'No results found',
	addCanvasFormStandardsNotSelectedMessage: 'Standard is a required field',
	addCanvasFormLanguageNotSelectedMessage: 'Language is a required field',
	contributesToHigherRiskTitle: 'Contributes to higher ROMM?',
	isHigherRisk: 'Is higher ROMM',
	contributesToHigherRisk: 'Contributes to higher inherent risk',

	/* Confidentiality */
	confidentialityPlaceholder: 'Select confidentiality',
	confidentiality: 'Confidentiality',
	confidentialityTitle: 'Document confidentiality',
	confidentialityText:
		'Set the level of access required for this document to be opened. Access levels are set by Engagement Administrators in the Manage Team page. If confidentiality has already been set for this document, only those that can open the document can change it.',
	confidentialityNotOpenable:
		'Document cannot be opened because your engagement rights are insufficient. Access levels are set by Engagement Administrators in Manage Team.',
	confidentialityTargetNotOpenable: 'Confidential documents can only be opened from the source engagement.',
	backToCCP: 'Back to EY Canvas Client Portal',
	guidanceMessageBackToCCP: 'After filling this form, go back to EY Canvas Client Portal and submit the request to EY.',
	noProfileInformationFound: 'No profile information found. Refresh the page and try again. If the issue persists contact the Help Desk.',
	confirmUpdate: 'Confirm update',
	keepVersion: 'Keep this version',
	conflictDescription: '{0} has edited this text {1} since it was opened. Select the version that should be retained.',
	currentConflictVersion: 'Current version',
	serverConflictVersion: 'Server version',
	conflictShowChanges: 'Show track changes',
	sectionViewTrackChangesDropdownPlaceholder: 'Select version',
	verifyingIndependence: 'Verifying independence status, please wait.',
	creatingIndependenceForm: 'Creating independence form.',
	meCallFailed: 'Failed to retrieve user information. Please refresh the page and try again. If the issue persists, please contact Help Desk.',
	getUserByIdFailed: 'Failed to retrieve user independence status. Please refresh the page and try again. If the issue persists, please contact Help Desk.',
	independenceFormCreationFailed:
		'Failed to create user independence form. Please refresh the page and try again. If the issue persists, please contact Help Desk.',
	gettingProfile: 'Getting profile information, please wait.',
	invalidDocumentId: 'Document Id is invalid. Refresh the page and try again. Contact the Help Desk if the error persists.',
	returnToEditMode: 'Return to edit mode',
	saveAndCloseButtonTitle: 'Save & close',
	formCreationFailed: 'Failed to create form. Please refresh the page and try again. If the issue persists, contact Help Desk.',

	/*Sign-off requirements*/
	signOffRequirements: 'Sign-off requirements',
	signoffRequirementsModalTitle: 'Sign-off requirements',
	signoffRequirementsModalDescription1: "Adjust this document's executive sign-off requirements below.",
	signoffRequirementsModalDescription2: 'Some sign-off requirements cannot be adjusted because they are required by EY Canvas.',
	signoffRequirementsModalSaveLabel: 'Save',
	signoffRequirementsModalCancelLabel: 'Cancel',
	signoffRequirementsModalCloseLabel: 'Close',
	signoffRequirementsModalPICLabel: 'PIC',
	signoffRequirementsModalEQRLabel: 'EQR',

	/*<Ares>*/
	/* View changes */
	viewChanges: 'View changes',
	viewChangesModalTitle: 'View changes',
	documentModificationAlert: 'This activity was last modified by ',
	dismiss: 'Dismiss',

	/*Task List*/
	aresPageTitle: 'EY Canvas FIT enablement',
	aresPageSubtitle: 'Complete the steps below with the requested information about your audit.',
	summary: 'Summary',
	aresNoDocumentFound: 'No other information available for the selected activity',
	taskSubTitleNoValue: 'No description available',
	mainActivities: 'Main activities',
	unmarkComplete: 'Unmark Complete',
	markCompleteTitleTip: 'Mark complete',
	disableMarkCompleteTitleTip: 'Ensure that all related documents are signed off by at least one preparer and one reviewer to mark this activity complete',
	/*Activity Summary*/
	activitySummary: 'Activity Summary',
	selectedAnswers: 'Selected answers',
	allAnswers: 'All answers',
	incompleteResponses: 'Incomplete responses',
	previous: 'Previous',
	next: 'Next',
	viewAsLabel: 'View as',
	rolePreparerLabel: 'Preparer',
	roleDetailedReviewerLabel: 'Detailed Reviewer',
	roleGeneralReviewerLabel: 'General Reviewer',
	roleEQRLabel: 'EQR',
	/*Simple Helix*/
	helixPlaceholder: 'Guidance type 7 with guidanceurl is required for helix screenshots.',
	noNotesAvailable: 'No tickmarks created',
	addScreenshot: 'Add screenshot',
	replaceScreenshot: 'Replace screenshot',
	replaceFrameDescription: `Review the below analytic and click on 'Replace' to replace the existing screenshot.`,
	addNote: 'Add tickmark',
	notes: 'Tickmarks',
	noScreenshotsAvailable: 'Click {viewDataAnalytic} to get started',
	viewDataAnalytic: 'View data analytic',
	/* Delete modal Helix screenshot*/
	modalTitle: 'Delete screenshot',
	sureDeleteBeforeName: 'Do you want to delete the screenshot?',
	sureDeleteAfterName: 'On deletion of the screenshot, all associated tickmarks will also be deleted and this action cannot be undone.',

	/*uploadDocument body type */
	relateExistingDocuments: 'Relate existing documents',
	fromEngagementOr: 'from this/other engagement(s) or',
	browse: 'browse',
	toUpload: 'to upload',
	signoffs: 'Sign-offs',
	addDocument: 'Add documents',
	uploadDocument: 'Upload document',
	relateDocument: 'Relate existing documents',
	generateAccountRiskAssessmentPackage: 'Generate group ALRA',
	relateDocumentsToBodyAresTitle: 'Relate documents',
	discardLabel: 'Discard',
	uploadDocumentLabel: 'Upload Document',
	confirm: 'Confirm',
	duplicateDocumentHeader: 'One or more documents with the same name already exist in this engagement (either as Evidence or Temporary files).',
	duplicateDocumentInstruction:
		'Select ‘Overwrite’ to upload the document and replace the existing file or ‘Discard’ to cancel. If this existing file is in Evidence, then the document will be uploaded to Evidence. If the existing file is in Temporary files, then the document will be uploaded to Temporary files.',
	maxUploadFilesError: 'System can upload a maximum of 10 documents at the same time',
	/*</Ares>*/
	noTaskRelatedToThisDocument: 'No task related to this document',
	uncheckTrackChangesToSave: 'Unselect the track changes option to save',
	reviewRoleCloseCommentsTitle: 'Unresolved comments',
	reviewRoleCloseCommentsDesc: 'There are unresolved comments to be addressed. Use the filter to easily identify unresolved comments.',
	closeEditorToEnableUnresolvedComments: 'Close the editor to enable "Unresolved comments" validation link',

	/*Document Upload - PIC/EQR Required Body type*/
	requirementDetails: 'Requirement details',

	//Risk Factors
	riskFactor: 'Relevant event and condition / risk of misstatement',
	manageRisk: 'Manage ROMMs',
	noRiskFactors: 'No relevant events and conditions / risks of misstatement have been identified',
	relateRiskFactorsToRisks: 'Determine the significance of events and conditions',
	riskType: 'ROMM type',
	relateToRisk: 'Relate to ROMM',
	noRisksIdentified: 'No ROMMs identified',
	notDefined: 'Not defined',
	selectValidRiskType: 'Please select valid ROMM type',
	newRisk: 'Add new ROMM',
	notAROMM: 'Not a Risk of material misstatement',
	describeRationale: 'Describe rationale',
	noRisksIdentifiedForTheSpecificRiskType: 'No {0}s have been identified',
	addAnAccount: 'Associate additional account',
	selectAnAccount: 'Select an account',
	noAccountsHaveBeenIdentified: 'No accounts have been identified',
	accountSelected: 'Account selected',
	accountsSelected: 'Accounts selected',
	statementType: 'Statement Type',
	selectAssertions: 'Select one or more assertions',
	noAssertionsIdentifiedForAccount: 'No assertions have been identified for this account',
	relatedAssertions: 'Related assertions',
	editAccount: 'Edit account & disclosure',
	addNewDescription: 'Add new description',
	editRiskFactorDescription: 'Edit description',
	enterRiskFactorDescription: 'Enter description for the relevant event and condition / risk of misstatement',
	riskFactorDescriptionRequired: 'Relevant event and condition / risk of misstatement description required',
	riskFactorDescription: 'Relevant event and condition / risk of misstatement description',
	createNewAccount: 'Create new account',
	createAccountLabel: 'Successfully created the account {0}',
	updateAccountLabel: 'Successfully saved edits to the account {0}',
	deleteAccountLabel: ' has been successfully deleted',
	significanceLabel: 'Significance',
	provideRationale: 'Please provide a rationale in order to save your selection',
	clearRiskSignificance: 'Clear ROMM Significance and Description',
	clearSignificance: 'Clear significance and description',
	relateResponsiveProcedure: 'Relate responsive procedure',
	risksBeingRespondedToByComponentTeam: 'ROMMs are being responded to by component team(s)',
	invalidAccountIndexTitle: 'Account with invalid Account index',
	invalidAccountIndexDescription: 'The account must have at least one valid Account index. Select \'Edit account & disclosure\' to review and update the account.',
	noAccountIndexesAssociated: 'No account indexes associated',
	// Account Summary
	unavailable: 'Unavailable',
	notAvailable: 'Not available',
	fraudRisk: 'Fraud Risk',
	significantRisk: 'Significant Risk',
	significantRiskIndicator: 'S',
	fraudRiskIndicator: 'F',
	inherentRisk: 'ROMM',
	inherentRiskIndicator: 'ROMM',
	prioryearbalance: 'Prior period balance:',
	accounts: 'Accounts',
	accountsOther: 'Account - Other',
	accountsSignDis: 'Significant disclosure',
	xMateriality: 'Multiples of PM',
	xTEMateriality: 'x TE',
	estimateAssociated: 'Estimate associated',
	accountIndex: 'Account indexes',
	accountWithInvalidAccountIndex: 'No account indexes associated',
	additionalAccountIndexes: 'Additional account indexes',
	designation: 'Designation',
	noAccountshasbeenIdentified: 'No accounts has been identified.',
	noAccountsOtherhasbeenIdentified: 'No other accounts identified.',
	noAccountsSigfhasbeenIdentified: 'No significant disclosures identified.',
	addOtherAccounts: 'Add account - Other',
	addSignificantDisclosure: 'Add significant disclosure',
	pydesignation: 'Prior designation:',
	notapplicable: 'N/A',
	noApplicable: 'Not applicable',
	changeDesignationMessage: 'You are about to change the designation of the account',
	changeDesignationTitle: 'Change account designation',
	continue: 'Continue',
	currentYearBalance: 'Current period',
	currentPeriodBalance: 'Current Period',
	priorYear: 'Prior year',
	priorYearDesignation: 'Prior period designation',
	priorYearEstimation: 'Prior period estimation',
	priorPeriodChange: '% change',
	analytics: 'Analytics',
	notROMMHeader: 'Not a Risk of material misstatement',
	manageEyCanvasAccounts: 'Manage EY Canvas accounts',
	manageAccountMapping: 'Manage account mapping',
	manageAccountMappingCloseButton: 'Use the button at the bottom of the page to close.',
	manageAccountMappingToasterMessage: 'Could not connect to EY Helix. Refresh the page and try again. If the issue persists, contact the Help desk.',
	inherentRiskTypeChangeMessage:
		'By changing account assertion(s) from relevant to not relevant, certain associations in EY Canvas, including Standard ROMMs, will be removed and PSPs will be demoted to OSPs. Click "Confirm" if you would like to proceed. Click "Cancel" to return without changes.',
	entitySpecificRisk: 'Entity specific risk',
	sourcedFromSCOT: 'Sourced from SCOT',
	analyticsIconDisabled: 'EY Helix is not enabled for your engagement.',
	//Estimate
	estimatesTitle: 'Estimates',
	relatedAccount: 'Related Accounts',
	relatedAccounts: 'Related accounts',
	relatedAccountForSAD: 'Related account',
	misstatementStatusForSAD: 'Misstatement period',
	misstatementTypeForSAD: 'Misstatement type',
	currentBalance: 'Current Balance',
	priorBalance: 'Prior Balance',
	unrelateEstimates: 'unrelated estimate account',
	manageEstimates: 'Manage estimates',
	noEstimatesCreated: 'No estimates have been created.',
	createEstimates: 'Create estimate',
	estimateStarted: 'to get started',
	createEstimateDocument: 'Create estimation documentation',
	noEstimatesFound: 'No estimates have been identified',
	relateEstimateLink: 'Relate estimates',
	estimateLabel: 'Estimate',

	//Journal Source
	noJournalEntrySourcesAreAvailable: 'No journal entry sources are available.',
	jeSourceName: 'JE source',
	jeSourceNameTooltip: 'JE source',
	changeInUse: 'Change in use',
	grossValue: 'Gross value of related transactions',
	relatedTransactions: 'Number of related transactions',
	relevantTransactions: 'Relevant to significant class of transactions',
	expandAll: 'Expand all',
	collapseAll: 'Collapse all',
	descriptionLabel: 'Provide a brief description of the purpose of this source',
	jeSourceTypesLabel: 'Are the journal entries recorded through this source, system generated or manual?',
	journalEntries: 'Is this source used to record non-standard journal entries (i.e. non-recurring, unusual transactions or adjustments)?',
	identifySCOTsLabel: 'Identify the SCOTs associated to the JE source (select all that apply)',
	systemGeneratedLabel: 'System generated',
	manualLabel: 'Manual',
	bothLabel: 'Both',
	accountEstimateLabel: 'Est',
	addSCOTLabel: 'Add SCOT',
	newSCOTLabel: 'New SCOT',
	relateSCOTLabel: 'Relate SCOTs',
	relateSCOTsLabel: 'Relate SCOTs',
	relateAnEstimateLabel: 'Relate an estimate',
	relateExistingLabel: 'Relate existing',
	importNew: 'Import new',
	addSCOTModalDescription: 'You can create SCOTs. Changes will be applied once saved.',
	scotnameRequired: 'SCOT name is required.',
	scotCategoryRequired: 'SCOT category is required.',
	estimateRequired: 'Estimate is required.',
	jeSourcesLabel: 'JE sources',
	jeSourcesToSCOTs: 'JE sources to SCOTs',
	scotsToSignificantAccounts: 'SCOTs to significant accounts',

	//Modal common labels.
	modalCloseTitle: 'Close',
	modalConfirmButton: 'Save changes',
	modalCancelTitle: 'Cancel',
	modalSave: 'Save',
	modalSaveAndClose: 'Save and close',
	modalSaveAndAdd: 'Save and add',
	modalSaveAndCreateAnother: 'Save and create another',
	editing: 'editing',
	deleting: 'deleting',

	//Add & Manage Risks
	addNewRiskModalTitle: 'Add new ROMM',
	manageRisksListModalTitle: 'Manage ROMMs',
	riskInfoMessage: 'Changes will be applied once saved.',
	risksListInstructionalText: 'You can edit and delete existing ROMMs. You can also add a new one, if needed.',
	risksListEmptyArray: 'No ROMMs available. Add new ROMM to get started',
	addNewRiskButtonLabel: 'Add new ROMM',
	labelRiskName: 'ROMM name',
	riskDescriptionLabel: 'ROMM description',
	selectRiskType: 'ROMM type',
	requiredRiskName: 'ROMM name is required',
	requiredRiskType: 'ROMM type is required',
	deleteRiskTrashLabel: 'Delete ROMM',
	undoDeleteRiskTrashLabel: 'Undo delete',
	notARommLabel: 'No risk of material misstatement',
	identifiedRiskFactors: 'Identified events/conditions/risks of misstatement, risks of material misstatement, significant risks, and fraud risks.',
	noneIdentified: 'None identified',
	countUnassociatedRisk:
		"Events/conditions/risks of misstatement are unrelated/not marked as 'Not a risk of material misstatement/Risk of material misstatement'.",

	// Bar Chart / Account Summary
	accountsTotal: '{0} accounts total',
	accountSummary: 'Account summary',
	allAccounts: 'All accounts',
	significantAccountsBarChart: 'Significant accounts',
	limitedAccounts: 'Limited risk accounts',
	insignificantAccounts: 'Insignificant accounts',
	noAccountsHasBeenIdentifiedBarChart: 'No {0} have been identified.',
	selectedTotalAccountsCounter: '{0}/{1} accounts',
	identifyInsignificantAccounts: 'Identify insignificant accounts',
	identifySignificantAccounts: 'Identify significant accounts',
	identifyLimitedAccounts: 'Identify limited risk accounts',
	preInsigniAccounts: 'Previously insignificant account that is no longer less than TE in the current period.',
	nonDesignatedInsignificant: 'This account cannot be designated as Insignificant. Click the designation drop down to change the designation for this account.',
	tolerableError: 'Tolerable error is not available. Update materiality and try again.',
	documentContainerLabel: 'Document',
	clickcreateformtogenerate: 'Click {0} to generate Limited risk account documentation.',
	createform: 'Create form',
	createLimitedRiskAccountDocumentation: 'Create Limited risk account documentation',
	limitedAccountDocumentName: 'Limited risk account documentation',

	//Modal Confirm Switch account
	modalSwitchTitle: 'Unsaved changes',
	modalConfirmSwitch: 'Confirm',
	modalConfirmSwitchDescription: 'The changes are not saved and will be lost if you decide to continue. Do you want to continue?',

	//Modal Edit Account
	manageAccountsModalTitle: 'Manage EY Canvas accounts',
	editAccountLinkLabel: 'Edit account',
	editAccountInstructionalText: 'You can edit or delete existing EY Canvas accounts, or create new ones. Changes will be applied once saved.',
	selectAnAccountLabel: 'Select account',
	accountsandDisclosuresLabel: 'Accounts and disclosures',
	accountNameLabel: 'Account',
	accountLabel: 'Account',
	accountDesignationLabel: 'Account designation',
	accountStatementTypeLabel: 'Statement type',
	accountRelatedAssertionsLabel: 'Related assertions',
	accountHasEstimateLabel: 'Is the account impacted by estimation?',
	requiredAccountName: 'Account name is required',
	requiredAccountDesignation: 'Account designation is required',
	requiredStatementType: 'Statement type is required',
	requiredRelatedAssertions: 'Select an assertion',
	pspIndexDropdownLabel: 'Select PSP index',
	removePSPIndexLabel: 'Remove account and disclosure index',
	addPSPIndexLink: 'Add PSP index',
	pspIsRequired: 'PSP index is required',

	//Delete account modal
	deleteAccount: 'Delete account',
	deleteAccountModalMessage: 'Are you sure that you want to delete the selected account?',
	cannotBeUndone: 'This cannot be undone.',
	guidedWorkflow: 'EY Canvas FIT enablement',
	scotSummary: 'SCOT summary',
	scopeAndStrategy: 'Scope & strategy',
	ToggleSwitch: {
		Inquire: 'Inquire',
		Completed: 'Completed',
		isOn: 'Yes',
		isOff: 'No'
	},
	navExecution: 'Execution',
	navCanvasEconomics: 'EY Canvas Economics',
	navOversight: 'EY Canvas Oversight',
	navConclusion: 'Conclusion',
	navTeamMemberIndependence: 'Team member independence',
	navGroupAudit: 'Group management',
	navGroupActivityFeed: 'Group activity feed',
	navPrimaryStatus: 'Primary status',
	navComponentStatus: 'Component status',
	navGroupStatus: 'Group status',
	navEngagementManagement: 'Engagement management',
	navProfile: 'Profile',
	navItSummary: 'IT summary',
	nav440GL: 'Changes after report date',
	navGroupStructureSummary: 'Group structure',
	navGroupInstructionSummary: 'Group instructions',
	navGroupInvolvement: 'Group involvement',
	navNotApplicable: 'Not applicable',
	cropScreenshot: 'Crop screenshot',
	cropScreenshotModalDescription:
		'Crop the screenshot to only include relevant portions.  Cropping will remove existing annotations,  the tickmarks will be retained and can be annotated again.  Cropping cannot be undone.',
	crop: 'Crop',
	replace: 'Replace',
	nameTheScreenshot: 'Screenshot name',
	nameLabel: 'Name',
	takeScreenshot: 'Add screenshot',
	measurementBasis: 'Measurement basis',
	MeasurementBasisMessage:
		'Based on the underlying EY Helix data mapping, it appears the measurement basis selected is not in the expected position (e.g., pretax income in a debit position). Consider whether:',
	measurementBasisProjectMappedCorrectly: 'The data in the EY Helix project is mapped correctly,',
	measurementBasisAppropriateValue: 'A different measurement basis may be appropriate, or',
	measurementBasisAdjustValue: 'It may be appropriate to adjust the measurement basis value as provided below',
	basisValueFromHelix: 'Trial balance value',
	rationaleDeterminationLabel: 'Rationale for how this amount was determined',
	loginInstructions: 'log in and follow the instructions to set up your account.',
	gotoText: 'Go to,',
	asOfDate: 'As of date',
	annualizedBasisValue: 'Annualized basis value',
	basisValue: 'Basis value',
	isAnnualizedAmountRepresentative: 'Is the annualized basis value representative of the amount expected to be reported as of the period end?',
	isAnnualizedAmountRepresentativeForAssetsOrEquity: 'Is the value representative of the amount expected to be reported at the audit period end?',
	enterExpectedFinancialPerioadAmount: 'Enter expected amount at audit period end',
	enterRationaleAmountDetermined: 'Enter rationale for how this amount was determined',
	printNotAvailable: '{0} has no content and therefore no information is shown',
	canvasFormPrintNotAvailable: 'Canvas Form Print is not currently available. Please try again or contact the Help Desk if the error persists.',
	contentDeliveryInProgress: 'Content delivery in progress. It may take up to {0} seconds for the content to refresh',
	saving: 'Saving...',
	removing: 'Removing..',
	activitySummaryTitle: 'Activity summary',
	currentLabel: 'Current',
	backToAccounts: 'Back to accounts',
	noChangesToDisplay: 'No changes to display',
	PMLabel: 'PM',
	planningMaterialityLabel: 'Planning materiality',
	TELabel: 'TE',
	tolerableErrorLabel: 'Tolerable error',
	SADLabel: 'SAD nominal amount',
	SADNominalAmountLabel: 'SAD nominal amount',
	UMTLabel: 'UMT',
	PriorLabel: 'Prior',
	editRichText: 'Edit text',
	noTypeTwoResponseAvailable: 'No response available. <br /> Click {clickHere} to respond.',
	clickHere: 'here',
	helixNavigationTitle: 'Go to EY Helix Configuration page to link or configure an EY Helix project',
	helixNavigationLink: 'Go to EY Helix',
	measurementBasisValue: 'Measurement basis value',
	inlineSaveUnsavedChanges: 'There are unsaved changes, do you want to continue?',
	rationaleIncomplete: 'Rationale incomplete',
	projectMismatchDisplayMessageOnDataImport:
		'Your primary EY Helix project has been changed. Please confirm EY Helix Settings and import data from the new project.',
	importSuccess: 'EY Helix data successfully imported.',
	importHelix: 'Click Import to import general ledger data from EY Helix.',
	importLabel: 'Import',
	reImportLabel: 'Re-import',
	lastImportedBy: 'Last imported by',
	lastImportedOn: 'Last imported on',
	dataImportedFromProjec: 'Data imported from project',
	reImportConfirmationTitle: 'Re-importing data from EY Helix',
	reImportConfirmationMessagePart1:
		'Re-importing data from EY Helix will change existing data or add new data within relevant activities and this cannot be undone.',
	reImportConfirmationMessagePart2:
		'For more information and a summary of how the re-import data process affects EY Canvas FIT enablement, please refer to EY Atlas.',
	defineRisksTitle: 'Define ROMMs',
	assessAndDefineRisksTitle: 'Assess and define ROMMs',
	identifiedRiskFactorsTitle: 'Identified events/conditions and related ROMMs:',
	descriptionIncompleteLabel: 'Description incomplete',
	noRiskHasBeenRelatedMsg: 'No ROMM has been related',
	rationaleIncompleteMsg: 'Rationale incomplete',
	loading: 'Loading...',
	importInProgressLabel: 'Import in progress. This could take several minutes. Please refresh the page to see updated status.',
	importInProgressMessage: 'Helix data import in progress. Refresh the page to see import status.',
	importHelixProjectError:
		'An error occurred importing data from EY Helix. Check that the status of the EY Helix project is showing as Analytics available, refresh the page, and click Import or Re-import again. If the issue persists contact the Help Desk.',
	importDeletionConfirmationMsg:
		'Are you sure you want to delete the import of EY Helix data? Delete import will delete existing data within relevant activities and this cannot be undone.',
	deletePreviousImport: 'Delete EY Helix import',
	//Assess Risks - Summary Page
	assessRisksAccordionLabel: 'Associate ROMMs',
	assessRisksNoItemsFound: 'No ROMMs have been identified',
	assessRiskAccountsAndRelatedAssertions: 'Accounts and related assertions',
	assessRiskNoAccountsLinked: 'No account associated',
	accountRiskAssessmentSummary: 'Accounts and disclosures',
	significantAccountRiskAssessmentSummary: 'Significant accounts and disclosures',
	// Flow chart
	flowchartTitle: 'Flowchart',
	launchFlowchart: 'Launch Flowchart',
	clickherelink: 'Click here',
	orderToCashPlacement: 'Order to cash placement',
	orderToCashPlacementMessage:
		'the Program Dept. negotiates agrements with new customers and negotiates renewing contracts and/or modifying contracts with exting customers. A contract holds details such as: pricing, terms and warranties',
	saveFlowChart: 'Save',
	newstep: 'New step',
	zoomIn: 'Zoom in',
	zoomOut: 'Zoom out',
	resetZoom: 'Reset zoom',
	toogleInteractivity: 'Lock/unlock for editing',
	fitView: 'Fit view',
	numberOfSteps: 'Number of steps',
	flowchartSuccessfullyCreated: 'Flowchart successfully created.',
	flowchartLinkedEvidenceMessage:
		'This flowchart has been created in another engagement.  Access to the flowchart in this engagement will be removed when the evidence is unlinke.',
	flowchartSmartEvidenceSourceIdNullMessage: 'No SCOT available.',
	noTaskDocumentAvailableFlowchart: 'This document is a temporary file.  Please relate to a task as evidence to access the flowchart details',
	NoFlowchartCreatedForGuest: 'No flowchart created',
	// Control Attributes
	controlAttributes: 'Control attributes',
	noControlAttributes: 'No control available',
	flowchartStepMoremenu: 'More menu',
	movestep: 'Move process step',
	flowchartNotes: 'Notes',
	createControlAttributes: 'No control attributes available.<br />Click {clickHere} to create a new control attribute.',
	createNewControlAttribute: 'New attribute',
	editControlAttribute: 'Edit attribute',
	createControlAtttributeInstructions:
		"Enter attribute details below and select <b>'Save and close'</b> to finish. To create another attribute, select <b>'Save and create another'.</b> Attributes will be sorted based on attribute index.",
	editControlAttributeInstructions: "Edit the attribute details below and select <b>'Save'</b> to finish.  Attributes will be sorted based on attribute index.",
	editAttributeButtonLabel: 'Edit attribute',
	deleteAttributeButtonLabel: 'Delete attribute',
	deleteControlAttributeInstructions: 'Are you sure that you want to delete the selected attribute? This action cannot be undone.',
	// Control Attributes Form
	requiredAttributeIndexLabel: 'Attribute index (required)',
	requiredAttributeDescriptionLabel: 'Attribute description (required)',
	errorMessageAttributeIndexRequired: 'Required',
	errorMessageAttributeDescriptionRequired: 'Required',
	errorMessageAttributeDescriptionMaxLength:
		'Response contains {#} characters which exceeds the maximum of {##} characters.  Adjust the description by reducing text or formatting and try again.  If the issue persists, contact the Help Desk.',
	errorMessageAttributeTestingTypesRequired: 'Required',
	proceduresLabel: 'Procedures to be performed',
	modalRequiredProceduresLabel: 'Procedures to be performed (required)',
	attributeTestingTypesLabel: {
		inquiry: 'Inquiry',
		observation: 'Observation',
		inspection: 'Inspection',
		reperformance: 'Reperformance/recalculation'
	},

	/*CRA Badge*/
	ir: 'IR',
	cr: 'CR',
	cra: 'CRA',
	incompleteCra: 'Incomplete CRA',

	//Progess bar labels
	savingProgress: 'Saving...',
	discardChangesLabel: 'Discard changes',
	removeFromBody: 'Remove from body',
	uploading: 'Uploading...',
	uploadComplete: 'Upload Complete',
	downloadComplete: 'Download Complete',
	processing: 'Processing...',

	/* ISA BODIES */
	/* Common */
	deleteEntityConfirmation: 'Are you sure you want to delete <b>{0}</b>? This action cannot be undone.',
	/* ITAPP-SCOT */
	searchScot: 'Search SCOT',
	addITApp: 'Add IT application',
	relatedItApp: 'Related IT Apps',
	itApplicationHeader: 'IT applications',
	scotNoDataPlaceholder: 'No information available',
	noScotsOrControlsPlaceholder: 'No related SCOTs or controls; {noScotsOrControlsPlaceholderEditAssoc}.',
	noScotsOrControlsPlaceholderEditAssoc: 'edit associations',
	noScotsOrControlsPlaceholderTarget: 'No related SCOTs or Controls.',
	scotHeader: 'SCOTs',
	controlsHeader: 'Controls',
	controlsApplicationHeader: 'Application',
	controlsITDMHeader: 'ITDM',
	itAppScotNoDataPlaceholderLabel: 'No IT applications have been added.',
	itAppScotNoDataPlaceholder: 'No IT applications have been added.<br /> To start, click on {itAppScotNoDataPlaceholderAddItApp}',
	itAppScotNoDataPlaceholderAddItApp: 'Add IT application',
	editItAppOption: 'Edit IT application',
	removeItAppOption: 'Delete IT application',
	viewItAppOption: 'View IT application',
	editScotsISA: 'Edit SCOT',
	viewScotISA: 'View SCOT',
	viewControlISA: 'View controls',
	scotAndRelatedControls: 'SCOTs and controls',
	otherControls: 'Other controls',
	controlTypeLabel: 'Control type',

	/*SCOT-ITAPP*/
	addOrRelateItAppPlaceholder: '{identifyRelatedItApps} or document that the {documentScotHasNoItApps}.',
	identifyRelatedItApps: 'Identify related IT applications',
	documentScotHasNoItApps: 'SCOT has no related IT applications',
	correctScotDocumentationPlaceholder:
		'The SCOT has been designated as not being supported by an IT application. Application and/or a ITDM control(s) have been associated to this SCOT, {correctScotDocumentation}.',
	correctScotDocumentation: 'revisit the designation that no IT applications support this SCOT',
	controlsWithoutRelatedItApps: 'Controls without related IT applications',
	controlsWithRelatedItApps: 'Controls with related IT applications',

	/*IT Planning */
	itPlanningTitle: 'Technologies and related IT scope & strategy tasks',
	itPlanningTask: 'Tasks',

	itApplicationListTitle: 'Technologies and related IT risk assessment tasks',
	itspOSPTaskTitle: 'IT substantive procedures and related tasks',
	manageWalkThroughTaskItControlTitle: 'IT general controls and related tasks',

	/*AddEditITApplication */
	saveAndCreateNewButtonTitle: 'Save & create new',
	instructionalMessage: 'Add IT application and select the related SCOTs. Associate controls related to the IT application, when applicable.',
	ITApplicationNamePlaceholder: 'IT application name (required)',
	scotDropdownPlaceholderText: 'Select SCOTs to be related to the IT application',
	selectScotPlaceholderText: 'Select SCOTs to be related to the IT application',
	selectControlPlaceholderText: 'Select Controls to be related to the IT application',
	noRelatedScotsPlaceholderText: 'No related SCOTs',
	noRelatedControlsPlaceholderText: 'No related Controls',
	CreateSOModelTitle: 'Add service organization',
	CreateSOInstructionalMessage: `Enter the new service organization details below and select '<b>{0}</b>' to finish. To create another service organization, select '<b>{1}</b>'.`, //'Create a new service organization and associate SCOTs and Controls related to it.',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	SONamePlaceholder: 'Service organization name (required)',
	SOSelectScotPlaceholderText: 'Select SCOTs related to the service organization',
	SOSelectControlPlaceholderText: 'Select Controls related to the service organization',
	CreatedSOLabel: 'SO added',
	createdITAppLabel: 'IT application added',
	searchNoResultFoundText: 'No result found',
	searchNoResultsFoundText: 'No results found',
	iTApplicationNameRequired: 'IT application name is required',
	soNameRequired: 'Service organization name is required',
	editITAppDesctiptionLabel: 'Edit the IT application and associated SCOTs and Controls',
	editSODescriptionLabel: `Edit the service organization details below and select <b>'Save'</b> to finish.`,
	viewITApplication: 'View IT application',
	itApplicationName: 'IT application name',
	serviceOrganizationName: 'Service organization name',
	newItApplication: 'New IT application',

	/*Add/Edit ITProcess*/
	itProcessName: 'IT process name',
	addItProcessDescription: 'Create an IT process',
	addItProcess: 'Add IT process',
	itProcessNameRequired: 'IT process name is required',
	editItProcess: 'Edit IT process',
	editItProcessDescription: 'Edit the IT process',
	viewItProcess: 'View IT process',
	taskTitle: 'Understand and document the IT process: {0}',
	taskDescription:
		'Document our understanding of the IT process. Complete the relevant forms and attach evidence of our procedures.',
	newItProcess: 'New IT process',
	noITProcessesFound: 'No IT processes have been identified',

	/* IT Process - Task */
	itProcessSearchPlaceholder: 'Search IT process',
	itProcessHeader: 'IT process',
	itProcessTasksHeader: 'Tasks',
	itProcessTechnologyScopingHeader: 'IT scope & strategy',
	itRiskAssesmentRelatedTaskHeader: 'IT risk assessment',
	itProcessAddUPD: 'Add UDP',
	itProcessEditItProcess: 'Edit IT process',
	itProcessRelateUDP: 'Relate UDP',
	itProcessViewProcess: 'View IT process',
	itProcessNoDataPlaceholder: 'No IT Processes have been added.<br /> To start, click on {addItProcess}.',
	itProcessSourceInstructionalText:
		'At least one UDP must be related to the IT process. {itProcessSourceInstructionalTextCreateUdp} or {itProcessSourceInstructionalTextRelateUdp}',
	itProcessSourceInstructionalTextCreateUdp: 'Create a new UDP',
	itProcessSourceInstructionalTextRelateUdp: 'relate an existing UDP.',
	itProcessTargetInstructionalText: 'No UDP are related to the IT process.',

	/* IT APP IT PROCESSES RELATION*/
	itApplicationHeaderRelate: 'IT applications',
	itProcessesHeaderRelate: 'IT processes',
	itAppNoDataPlaceHolderLabel: 'No IT applications have been identified.',
	itAppNoDataPlaceHolder: 'No IT applications have been identified.<br />{identifyItApp}',
	identifyItApp: 'Identify an IT application.',
	itProcessNoDataPlaceHolderRelationLabel: 'No IT processes have been identified.',
	itProcessNoDataPlaceHolderRelation: 'No IT processes have been identified. <br /> {identifyItProcess}',
	identifyItProcess: 'Identify an IT process.',
	editItApp: 'Edit IT application',
	deleteItApp: 'Delete IT application',
	drag: 'Drag IT process to the related IT applications',
	// editItProcess: 'Edit IT process',
	deleteItProcess: 'Delete IT process',
	unassociatedProcess: '{0} unrelated processes',
	unassociatedItApplications: '{0} unrelated IT applications',
	showOnlyUnrelated: 'Show only unrelated - {0}',
	searchItProcess: 'Search IT process',
	searchItApplication: 'Search IT application',
	itProcessesLabel: 'IT processes',
	itApplicationsLabel: 'IT applications',
	showAllItAplications: 'Show all IT applications',
	showAllItProcesses: 'Show all IT processes',
	relatedToLabel:
		'List of all <span class="child-entity-count">{count}</span> <span class="child-entity-name">{child}</span> related to <span class="parent-entity-object-name">{parent}</span>',

	/* IT Process > IT Risk */
	itProcessItRiskNoDataPlaceholder: 'No IT process has been identified.<br/>{identifyItProcess}',
	itProcessItRiskNoDataPlaceholderTarget: 'No IT processes have been identified.',
	itApplication: 'IT Apps',
	itGC: 'ITGCs',
	addItRiskBtnTitle: 'Add IT risk',
	itProcessItRiskUnrelatedITGC: 'unassociated ITGCs',
	itProcessItRiskUnrelatedITGCUppercase: 'Unassociated ITGCs',
	itProcessItRiskNoRisksNoControlsPlaceholder:
		'There is no requirement to include the IT risks or ITGCs for this IT process because there are no application or ITDM controls with an effective design evaluation related to the IT applications associated to this IT process.',
	itProcessItRiskNoRisksControlsPlaceholder: 'Based on the identified application and ITDM controls, {itRiskIdentify} for this IT process',
	itRiskIdentify: 'IT risks should be identified',
	itProcessItRiskItProcessContentTitle: 'IT risks and ITGCs',
	itProcessItRiskItRiskNoItgcRequiredPlaceholder: 'There are no ITGCs that address the IT risk.',
	itProcessItRiskItRiskItgcRequiredPlaceholder:
		'All identified risks must have at least one ITGC identified or a designation that the IT risk has no ITGCs.<br/>Identify a {newITGC} or {existingITGC} that addresses the IT risk or indicate that there are {noItRisksIdentified} that address the IT risk.',
	noItRisksIdentified: 'no ITGCs',
	newITGC: 'new ITGC',
	existingITGC: 'existing ITGC',
	unrelatedItGCModalMessage: 'Delete unassociated ITGCs that are no longer required.',
	unrelatedItGCModalNoDataPlaceholder: 'No unassociated ITGC',
	removeItRisk: 'Remove IT risk',
	deleteItRiskConfirmation: 'Are you sure you want to remove the IT risk <b>{0}</b>? This action will delete the IT risk and cannot be undone.',
	relateItGcTitle: 'Relate ITGC',
	relateItGcEntityTitle: 'IT risk',
	relateItGcDescription: 'Select the ITGCs that are relevant for the IT risk.',
	relateItGcSearchPlaceholder: 'Search ITGC',
	relateItGcShowSelectedOnlyText: 'Show only related ITGCs',
	relateItGcNoDataPlaceholder: 'No ITGCs available. Create a new ITGC to continue.',
	relateITSPTitle: 'Relate ITSP',
	relateITSPDescription: 'Select one or more ITSPs to relate to the IT risk. To unrelate from IT risk, deselect the relevant ITSP.',
	relateITSPSearchPlaceholder: 'Search by ITSP name',
	relateITSPShowSelectedOnlyText: 'Show only related ITSPs',
	relateITSPNoDataPlaceholder: 'No ITSP available. Create a new ITSP to continue.',

	/* IT Process Task Relationship */
	relateUDP: 'Relate UDP',
	relateUDPDescription: 'Select the UDP tasks that are relevant for the IT process.',
	relateUDPListHeaderItemName: 'Task name',
	relateUDPSearchPlaceholder: 'Search by task name',
	relateUDPNoResultsFoundPlaceholder: 'No results found',
	relateUDPCountLabel: '{0} tasks',
	relateUDPClose: 'Close',
	relateUDPShowOnlyRelatedTasks: 'Show only related tasks',
	relateUDPNoDataFoundPlaceholder: 'No tasks available',
	relateUDPNoDataPlaceHolder: 'No IT process have been identified',

	/* ITGC test strategy */
	itProcessItRiskItGcWithoutDesignEffectiveness: 'ITGCs without design effectiveness',
	searchItGC: 'Search IT process',
	itGCNoDataPlaceHolder: 'No IT process have been identified',
	addItRisks: 'Add IT risks',
	itDMHeader: 'ITDM',
	itAppHeader: 'IT app',
	itTestHeader: 'Test',
	itTestingHeader: 'Testing',
	itgcHeader: 'ITGCs',
	controlsSelectedHeader: 'Controls selected for testing',
	iTRisksAndITGCs: 'IT risks and ITGCs',
	NoITGCForITRiskPlaceholder: 'No ITGCs exist in the IT environment to address this IT risk',
	ITGCsNotIdentifiedRiskNoITGCs: 'ITGCs have not been identified for this risk. {identifyAnITGC} or designate that the {itRiskHasNoITGCs}.',
	identifyAnITGC: 'Identify an ITGC',
	itRiskHasNoITGCs: 'IT risk has no ITGCs',

	/**
	 * IT SO > SCOT
	 */
	searchItSO: 'Search service organization',
	addItSOBtnTitle: 'Add service organization',
	itSoNoDataPlaceHolder: 'No service organizations have been identified.<br/><a>{identifyAnSo}<a/>',
	noItSoDataPlaceHolder: 'No service organizations have been identified.',
	identifyAnSo: 'Identify a service organization',
	soHeader: 'Service Organization',
	editSO: 'Edit service organization',
	deleteSO: 'Delete service organization',
	viewSO: 'View service organization',
	controlRelatedToSO: 'Controls related to SO',

	/**
	 * Manage IT SP
	 */
	addITSP: 'Add ITSP',
	searchPlaceholderManageITSP: 'Search IT process',
	noManageITSPDataPlaceholder: 'No IT process have been identified',
	itRiskColumnHeader: 'IT risks',
	itDesignEffectivenessHeader: 'Design effectiveness',
	itTestingColumnHeader: 'Testing',
	itGCColumnHeader: 'ITGCs',
	itSPColumnHeader: 'ITSPs',
	searchClearButtonTitle: 'Clear',
	itProcessItRiskUnrelatedITSP: ' unassociated ITSPs',
	manageITSPUnrelatedITSPUppercase: 'Unassociated ITSPs',
	unrelatedITSPModalMessage: 'Delete unassociated ITSPs that are no longer required.',
	unrelatedITSPModalNoDataPlaceholder: 'No unassociated ITSP',
	noITGCPlaceholderMessageFragment1: 'All identified risks must have at least one ITGC identified or a designation that the IT risk has no ITGCs:',
	noITGCPlaceholderMessageFragment2: 'Identify a ',
	noITGCPlaceholderMessageFragment3: 'new ITGC ',
	noITGCPlaceholderMessageFragment4: 'or ',
	noITGCPlaceholderMessageFragment5: 'existing ITGC ',
	noITGCPlaceholderMessageFragment6: 'that addresses the IT risk or indicate that there are ',
	noITGCPlaceholderMessageFragment7: 'no ITGCs ',
	noITGCPlaceholderMessageFragment8: 'that address the IT risk',
	addNewITSP: 'Add new ITSP',
	addExistingITSP: 'Add existing ITSP',
	noITSPPlaceholderMessageFragment1:
		'If we have evaluated ITGCs as ineffective or determined there are no ITGCs that exist to address the IT risk, we may be able to perform IT-substantive testing procedures (ITSPs) to obtain reasonable assurance that the IT risk within the IT process associated with the ineffective ITGC was not exploited. ',
	noITSPPlaceholderMessageFragment2: 'Identify a new ITSP',
	noITSPPlaceholderMessageFragment3: 'or',
	noITSPPlaceholderMessageFragment4: 'relate an existing ITSP',
	noITSPPlaceholderMessageFragment5: '.',
	noITGCsExitForITRisk: 'No ITGCs exist for the IT risk.',
	noITSPExitForITRisk: 'No ITSP have been identified for the IT risk.',
	manageITSPItemExpansionMessage: 'IT risks',
	noITGCExists: 'There are no ITGCs that address the IT risk.',
	iTGCName: 'ITGC name',
	itSPName: 'ITSP name',
	operationEffectiveness: 'Operation effectiveness',
	savingLabel: 'Saving',
	deletingLabel: 'Deleting',
	removingLabel: 'Removing',
	itFlowModalDescription: 'Go to the {itSummaryLink} to edit/remove these objects that are no longer applicable for the engagement.',
	itSummaryLink: 'IT Summary screen',
	manageITSPYes: 'Yes',
	manageITSPNo: 'No',

	understandITProcess: 'Understand IT processes',
	activity: 'Activity',
	unsavedPageChangesMessage: 'You have unsaved changes that will be lost if you choose to continue. Are you sure you want to leave this page?',
	unsavedChangesTitle: 'Unsaved changes',
	unsavedChangesLeave: 'Leave this page',
	unsavedChangesStay: 'Stay on this page',

	notificationDownErrorMessage:
		'The Notifications feature is temporarily unavailable. Refresh the page and try again. If this message persists, contact the Help Desk.',
	notificationUpbutSomeLoadingErrorMessage:
		'A technical error has occurred that is preventing the Notifications feature from working. Refresh the page and try again.',
	markCompleteError: 'All documents presented require at least one preparer and one reviewer sign-off.',
	markCompleteDescription: 'All documents must be signed-off by at least one preparer and one reviewer to mark the activity as complete.',
	lessthan: 'Less than',
	openingFitGuidedWorkflowFormError: 'Unable to open EY Canvas FIT enablement form',
	timeTrackerErrorFallBackMessage:
		'The Time Tracking feature is temporarily unavailable. Refresh the page and try again. If this message persists, contact the Help Desk.',
	timeTrackerLoadingFallbackMessage: 'The Time Tracking feature is temporarily unavailable. It will be available shortly.',
	priorPeriodRelateDocument: 'Relate prior period evidence',
	selectedValue: 'Selected value',
	serviceGateway: 'Service Gateway',
	docNameRequired: 'Name cannot be empty',
	docInvalidCharacters: 'Name cannot include: */:<>\\?|"',
	invalidComment:
		'Comment could not be added. If selecting multiple items in a list, only select a single item and try again. If the issue persists, refresh the page and try again or contact the Help Desk.',
	inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|"',

	// FIT Navigation panel
	relatedActivities: 'Related activities',
	backToRelatedActivities: 'Back to related activities',
	backToMainActivities: 'Back to main activities',
	formOptions: 'Form options',
	enableCompactFormView: 'Enable compact form view',
	disableCompactFormView: 'Disable compact form view',

	// FIT Linking
	linkActivity: 'Link responses',
	linkActivityLabel: 'Link responses',
	shareInProgress: 'Linking in progress',
	dropdownPlaceholderLA: 'Select the engagement to link with',
	linkActivityModalInfo:
		'Link this form\'s responses with one or more forms from the same engagement or from another engagement in the same workspace. If the forms selected from the table are not already linked, then the responses in those forms will be overwritten by the current form. If the form selected from the table is already linked, then only one can be selected from the table, and the responses in current form will be overwritten by the already linked form.',
	lastModifiedDate: 'Last modified on',
	activityLinkedSuccessfull: '{0} linked successfully',
	linkedWithAnotherFITActivity: 'This form is linked with another form',
	linkActivityWithAnotherCanvas: 'Link form with another EY Canvas FIT enablement',
	linkActivityModalTitle: 'Link responses',
	showRelationshipsTitle: 'Show relationships',
	linkActivityEngagement: 'Engagement',
	linkedActivityRelationshipsModalTitle: 'Linked response relationships',
	linkedActivityWorkspaceHeading: 'This form is currently linked with the related form(s) in the identified engagement(s) within the same workspace.',
	shareModalContinueLabel: 'Continue',
	selectedActivityInfoLabel: 'in the selected engagement was last modified on:',
	noLinkedActivityInfoLabel: 'This engagement does not have another document of this same type to link with.',
	linkedHoverLabel: 'This form\'s responses are currently linked with another form\'s responses',
	sharedHoverLabel: 'This form is currently being shared with another engagement',
	linkedResponsesBtnTitle: 'Link responses',
	shareEvidenceBtnTitle: 'Share evidence',
	documentsSelected: 'Document(s)',
	goBackBtnTitle: 'Go back',
	continueBtnTitle: 'Continue',
	selectActivityResponsesWarningEarlierTimeLabel:
		"The current form was modified at an earlier time compared to the selected engagement's form. Please consider this before proceeding with linking the form from the table.",
	sourceEngagementLabel: 'Source engagement',
	otherEngagementDropdownLabel: 'Other engagements in this workspace',
	showOnlySelected: 'Show only selected',
	insufficientRoleMessage: 'Insufficient roles to link content. Work with an engagement administrator to obtain sufficient rights.',

	//FIT Copy
	copyLabel: 'Copy',
	copyActivity: 'Copy form',
	copyInProgress: 'Copy in progress',
	fitCopyModalInfo: 'Copy responses from this form to one or more forms from the same engagement or from another engagement in the same workspace.',
	dropdownPlaceholderCA: 'Select the engagement to copy to',
	noCopyActivityInfoLabel: 'This engagement does not have document of this same type to copy to.',
	copyActivityHoverLabel: 'This form is already shared with other forms and cannot be copied into',
	copyActivityWarningEarlierTimeLabel:
		"The current form was modified at an earlier time compared to the selected engagement's form. Please consider this before confirming the copy options.",
	noSelectionToast: 'You must select at least one form to continue with Link responses',

	//Unlink
	unlinkModalTitle: 'Unlink form responses',
	unlinkModalDescription: 'Are you sure that you want to unlink the selected form?',
	unlinkLabel: 'Unlink',
	insufficientPermissionsLabel: 'Insufficient permission',
	unlinkFailMessage: 'Unlink failed. Please refresh and try again. If issue persists, contact the EY Help desk.',
	unlinkSuccessfulMessage: 'Unlink successful',
	unlinkInProgressLabel: 'Unlink in progress',
	unlinkError: 'Unlink error',
	unlinkInProgressInfo:
		'Unlink in progress. This may take up to fifteen minutes. After the unlink is complete, this form will need to be closed and opened again.',

	/** Manage scot modal labels */
	scotName: 'SCOT name',
	scotCategory: 'SCOT category',
	estimate: 'Estimate',
	noScotsAvailablePlaceHolder: 'No SCOT available. Add new SCOT to get started',
	addScotDisableTitle: 'Fill all the details for the SCOT to add a new SCOT',
	deleteScotTrashLabel: 'Delete scot',
	undoDeleteScotTrashLabel: 'Undo delete',
	scotNameValidationMessage: 'SCOT name is required',
	scotCategoryValidationMessage: 'SCOT category is required',
	scotWTTaskDescription:
		'<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period using a combination of risk assessment procedures (e.g., automated techniques, inquiry, observation and inspection) to enable us to identify risks of material misstatement. In addition, for PCAOB audits, we perform these same procedures for SCOTs impacted by higher or lower risk estimates. <br/>We conclude that our documentation accurately describes the critical path of the SCOT and we have identified all appropriate ROMMs, including risks that arise from using IT. <br/><br/> For SCOTs impacted by higher or lower risk estimates, when we use a substantive only strategy, we determine whether our understanding of the SCOT is appropriate based on our substantive procedures.</p>',
	relate: 'Relate',
	unrelate: 'Unrelate',
	related: 'Related',
	relatedSCOTs: 'Related SCOTs',
	thereAreNoSCOTsIdentified: 'There are no SCOTs identified',
	selectSCOTsToBeRelated: 'Select SCOTs to be related',

	//OAR Tables
	OARBalanceSheet: 'Balance sheet',
	OARIncomeStatement: 'Income statement',
	OARCurrentPeriod: 'Analysis date',
	OARAmountChangeFrom: 'Change from',
	OARPercentageChangeFrom: '% change from',
	OARNoDataAvailable: 'No data available. Review the {0} page and import the data to proceed further.',
	OARAnnotationLabel: 'Click to review reason for unexpected changes or lack of expected changes',
	OARAnnotationSelectedIcon: 'Document reason for unexpected changes or lack of expected changes',
	OARAnnotationModalTitle: 'Annotation',
	OARAnnotationModalAddTitle: 'Add annotation',
	OARAnnotationModalEditTitle: 'Edit annotation',
	OARAnnotationModalPlaceholder: 'Document items that appear unusual, unexpected changes or lack of expected changes.',
	OARAnnotationDeleteConfirmTitle: 'Delete',
	OARAnnotationDeleteConfirmMessage: 'Are you sure you want to delete this annotation?',
	OARWithAnnotationLabel: 'Documentation of unexpected changes',
	OARAnnotation: 'Annotation',
	OARAccTypeWithAnnotationCountLabel: '{0} annotations within the account type',
	OARSubAccTypeWithAnnotationCountLabel: '{0} annotations within the account sub-type',
	OARColumnA: 'A',
	OARColumnB: 'B',
	OARColumnC: 'C',
	OARComparativePeriod: 'Comparative date',
	OARComparative1Period: 'Comparative date 1',
	OARComparative2Period: 'Comparative date 2',
	OARExpand: 'Expand account class',
	OARCollapse: 'Collapse account class',
	OARHelixNavigationLink: 'Go to EY Helix for additional information',
	OARPrintNoDataAvailable: 'No data available',
	OARAdjustedBalance: 'Adjusted balance',
	OARLegendLabel: 'Values with * indicate that they include an adjustment. Navigate to Adjustment module for further details.',
	OARAccountType: 'Account type',
	OARAnnotationTitle: 'Annotation',
	OARAnnotationAddAnnotation: 'Add annotation',
	OARAnnotationEditAnnotation: 'Edit annotation',
	noGLAccountAvailable: 'No data available',
	astrixLabel: '*',

	//OAR Helix integration
	helixIntegrationModalDescription: 'This is a text pending to be defined',
	OSJETabText: 'Other side of the journal entry',
	activityAnalysisTabText: 'Activity analysis',
	preparerAnalysisTabText: 'Preparer analysis',
	accountMetricsTabText: 'Account metrics',
	noAnalyticsData: 'No analytics available to display',

	printActivitiesTitle: 'Print Activities',
	printActivitiesModalInfo: 'Please select which activities you would like to include.',
	printActivitiesModalConfirmButton: 'Compile PDF',
	printActivitiesDropdownLabel: 'FIT Activities',
	printActivitiesAll: 'All',
	oarSetupText: 'Go to {0} page to link or configure an EY Helix project',
	helixNotAvailable: 'EY Helix is not available for your engagement.',
	dragDropUploadPlaceholder: 'Drag and drop one or more documents or click <span>{addDocument}</span>',

	noTaskAssociatedToastMessage: 'Since the Canvas form is in Temporary files the added document(s) have also been added to Temporary files',

	// chart labels.
	assets: 'Assets',
	liabilities: 'Liabilities',
	equity: 'Equity',
	revenues: 'Revenues',
	expenses: 'Expenses',
	noAccountsAvailable: 'No accounts available',

	// ALRA
	ALRAFilterByAccount: 'Filter by account',
	ALRANoRecords: 'No results found',
	ALRAAssertions: 'Assertions',
	ALRAInherent: 'Inherent risk factors',
	ALRAHigher: 'Higher risks factors',
	ALRAAccountDisclosure: 'Accounts/Disclosures',
	ALRAType: 'Type',
	ALRAName: 'Name',
	ALRARisks: 'ROMMs',
	ALRAC: 'C',
	ALRAEO: 'E/O',
	ALRAMV: 'M/V',
	ALRARO: 'R&O',
	ALRAPD: 'P&D',
	ALRAR: 'R',
	ALRANoRisksAssociated: 'No ROMM related to this account',
	ALRAAccountsDisclosureName: 'Accounts/Disclosure name',
	ALRAHigherRisk: 'Higher risk',
	ALRAHigherInherentRisk: 'Higher inherent risk',
	ALRAHigherRiskCode: 'H',
	ALRALowerRisk: 'Lower risk',
	ALRALowerInherentRisk: 'Lower inherent risk',
	ALRALowerRiskCode: 'L',
	ALRALimitedRiskAccount: 'The account has been identified as limited risk',
	ALRAInsignificantRiskAccount: 'The account has been identified as insignificant',
	ALRADesignations: 'Designations',
	ALRABalances: 'Balances',
	ALRADesignation: 'Designation',
	ALRAAnalysisPeriod: 'Analysis date',
	ALRAxTE: 'xTE',
	ALRAPercentageChangeFrom: '% change from',
	ALRAPriorPeriodDesignation: 'Prior period designation',
	ALRAPriorPeriodEstimate: 'Prior period estimate',
	ALRAComparativePeriod1: 'Comparative date 1',
	ALRAComparativePeriod2: 'Comparative date 2',
	ALRASelectUpToThreeOptions: 'Select up to 3 options',
	ALRASelectUpToTwoOptions: 'Select up to 2 options',
	ALRAValidations: 'Validations',
	ALRAAccountIndexes: 'Account indexes',
	ALRANoSignOffs: 'No sign-offs',
	ALRAIncompleteInherentRisk: 'Incomplete inherent risk',
	ALRARelatedDocuments: 'Related Documents',
	ALRAGreaterExtent: 'Greater extent',
	ALRALesserExtent: 'Lesser extent',
	ALRARiskRelatedToAssertion: 'ROMM associated',
	ALRAContributesToHigherInherentRisk: 'ROMM associated and contributes to the higher inherent risk',

	// Assess inherent risk
	HigherRiskAssertionWithoutRisksThatContributesToTheHigherInherentRisk:
		"It was indicated that this assertion has a higher inherent risk assessment. As a result, this assertion requires ROMM(s) that contributes to the higher inherent risk assessment. Indicate which ROMM(s) contributes to the higher inherent risk assessment.",

	//MEST - Multi-entity account Execution Type selection listing
	account: 'Account',
	taskByEntity: 'Task by entity',
	bodyInformation: 'You must click Import Content below in order to save any changes.',

	/*user search component*/
	seachInputRequired: 'Search input required',
	nameOrEmail: 'Name or email',
	emailForExternal: 'Email',
	noRecord: 'No results found',
	userSearchPlaceholder: 'Enter name or email and press enter to see results.',
	userSearchPlaceholderForExternal: 'Enter email and press enter to see results.',
	clearAllValues: 'Clear all values',
	inValidEmail: 'Please enter valid email',

	//reactive frame
	maxTabsLocked: 'Maximum allowed tabs reached. Unpin and close one of the tabs to open a new one.',
	openInNewTab: 'Open in new tab',
	unPinTab: 'Unpin tab',
	pinTab: 'Pin tab',
	closeDrawer: 'Close Drawer',
	minimize: 'Minimize',

	accountHeader: 'Accounts',
	sCOTSummaryAccountNoDataLabel:
		'Each SCOT must be related to at least one significant account or disclosure. Select an existing significant account or disclosure to relate to this SCOT',
	sCOTSummaryNoDataLabel: 'No SCOTs have been created',
	scotSearchNoResultsFound: 'No results found',
	scotSummary225TabsName: {
		[0]: { label: 'Show by account' },
		[1]: { label: 'Show by SCOT' }
	},

	// Display Account Balances
	currentPeriodAccountBalance: 'Current period account balance:',
	priorPeriodAccountBalance: 'Prior period account balance:',
	ALRANoResults: 'No results found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	associatedRomsCount: 'Total number of associated ROMMs: {0}',
	notRelevantDisabledTooltip: 'Changes cannot be made to an assertion(s) that has a related entity-specific ROMM, estimate or additional account characteristic.',
	alraMessage: "Account designation response not aligned to designation in 'Edit account & disclosure'",
	estimateCategoryResponseNotAlignedToDesignation: "Estimate category response not aligned to designation in 'Edit estimate'",

	// Analytics Overview
	analyticsOverviewTitle: 'Analytics Overview',
	noSignificantAccountRecords: 'No significant accounts have been created.',
	noSignificantAccountMapped: 'No significant accounts are mapped to the selected entity.',
	noLimitedAccountMapped: 'No limited accounts are mapped to the selected entity.',
	openAnalyticDocumentation: 'Open analytic documentation',
	openLimitedRiskAccountDocumentation: 'Open limited risk account documentation',
	associatedSCOTs: 'Associated SCOTSs: ',
	analysisPeriodLabel: 'Analysis date {0}',
	analysisPeriodChangeLabel: '% change from {0}',
	xTELabel: 'xTE',
	risksLabel: 'ROMMs',
	rommsHeader: 'ROMMs',
	rommNameHeader: 'ROMM Name',
	searchRomms: 'Search ROMMs',
	searchRommsOrControls: 'Search ROMMs or Controls',
	comparativePeriod1: 'Comparative date 1 {0}',
	analysisPeriodTitle: 'Analysis date',
	analysisPeriodChangeTitle: '% change from',
	comparativePeriodTitle: 'Comparative date 1',
	noAccountAvailable: 'No account available',
	controlHeader: 'Controls',
	effectiveHeader: 'Effective',
	theAccountContainsNoROMMs: 'The account contains no ROMMs',

	// Estimates
	titleEstimateCategory: 'Estimate category',
	titleRisks: 'ROMMs',
	voiceNoteNotAvailable: 'Voice note and screen recording is not available in drawer view. Switch to full screen view to use these features.',
	financialStatementType: {
		[1]: { label: 'Asset' },
		[2]: { label: 'Current asset' },
		[3]: { label: 'Non-current asset' },
		[4]: { label: 'Liability' },
		[5]: { label: 'Current liability' },
		[6]: { label: 'Non-current liability' },
		[7]: { label: 'Equity' },
		[8]: { label: 'Revenue' },
		[9]: { label: 'Expense' },
		[10]: { label: 'Non-operating income/(expense)' },
		[11]: { label: 'Other comprehensive income' },
		[12]: { label: 'Other' },
		[13]: { label: 'Account Type' },
		[14]: { label: 'Account Sub-Type' },
		[15]: { label: 'Account Class' },
		[16]: { label: 'Account Sub-Class' },
		[17]: { label: 'Net (Income) / Expense' },
		[20]: { label: 'Pretax (income) / expense' },
		[21]: { label: 'Income tax (benefit) / expense' }
	},
	accountTypes: {
		[1]: { label: 'Significant account' },
		[2]: { label: 'Limited risk account' },
		[3]: { label: 'Insignificant account' },
		[4]: { label: 'Other account' },
		[5]: { label: 'Significant disclosure' }
	},
	financialStatementTypeIds: [
		{
			id: 1,
			label: "Assets"
		},
		{
			id: 4,
			label: "Liabilities"
		},
		{
			id: 7,
			label: "Equity"
		},
		{
			id: 8,
			label: "Revenue"
		},
		{
			id: 9,
			label: "Expenses"
		},
		{
			id: 17,
			label: "Net income"
		}
	],
	noClientDataAvailable: 'No data available',
	analysisPeriod: 'Balance as of Analysis Date',
	comparativePeriod: 'Balance as of Comparative Date',
	perchangeLabel: '% change',
	entityCreateAccountLabel: 'Create account & disclosure',
	insignificantAccount: 'Insignificant account',
	noAccountRecords: 'No accounts have been identified',
	noAccountsForEntity: 'No accounts or disclosures are mapped to the selected entity.',
	knowledgeDrivenAccount: 'Knowledge driven account',
	noLimitedRiskAccountRecords: 'No Limited Risk Accounts available.',
	createAccount: 'Create account',
	createDocument: 'Create document',
	noAccountResults: 'No accounts identified.',
	createGroupInvolvementDocument: 'Create involvement form',
	chooseVersionsToCompare: 'Choose version to compare',
	noTrackChangesOption: 'No track changes versions available',
	trackChangesDefaultMessage: "Select a version from the 'Choose version to compare' drop down to proceed.",
	whichRiskContributeToHigherRisk: 'Which ROMM(s) contribute to the higher inherent risk assessment?',
	noAccountSelectedMessage: 'Please select a significant account or disclosure to view the associated ROMMs and relate controls that mitigate the risk',
	accountsPaneHeader: 'Accounts',

	//multi-entity Entity List
	createMultiEntity: 'New entity',
	editMultiEntity: 'Edit entity',
	noEntitiesAvailableCreateNewLink: 'Click here',
	noEntitiesAvailable: 'No entities have been created. {noEntitiesAvailableCreateNewLink} to get started',
	noEntitiesFound: 'No results found',
	createMultiEntityProfile: 'Create entity profile',
	multiEntityFormNotAvailable: 'Multi-entity individual profile form is not available',
	createEntity: 'Create entity',
	includeEntities: 'The multi-entity listing must include at least one entity. {createEntity} to get started.',
	includeEntitiesMessage: 'The multi-entity listing must include at least one entity',

	//multi-entity table
	multiEntityCode: 'Entity standard index',
	multiEntityName: 'Entity name',
	multiEntityGroup: 'Entity group',
	multiEntityActions: 'Actions',
	relateMultiEntityUngrouped: 'Ungrouped',
	selectAll: 'Select all',
	entitiesSelected: 'entities selected',
	entitySelected: 'entity selected',
	meNoEntitiesAvailable: 'No entities available',
	meSwitchEntities: 'Switch entities',
	meSelectEntity: 'Select entity',
	selectEntity: 'Select entity',
	allEntities: 'All entities',
	noEntitiesIdentified: 'No entities identified',
	noEntitiesWithMisstatements: 'No entities with misstatements',
	contentDeliveryInProcessMessage: 'Content delivery in progress.  It may take up to ten minutes for the content to be delivered.',
	importContent: 'Import content',
	profileSubmit: 'Profile submit',
	importPSPs: 'Import PSPs',
	testOfControls: 'Test of controls',
	relateTOCsToControls: 'Relate TOCs to Control',
	relateUDPsToITProcesses: 'Relate UDP to IT process',
	evaluateDesignOfControls: 'Evaluate design of controls',
	relateEDCsToControls: 'Relate EDC to Control',
	relateUDPToSCOT: 'Relate UDP to SCOT',
	relateUDPToEstimate: 'Relate UDP to estimate',
	relateUDPtoTechnology: 'Relate UDP to technology',
	relateOSPtoITSP: 'Relate OSP to ITSP',
	udps: 'UDPs',
	relateTOCsToITGC: 'Relate TOCs to ITGC',
	relateEDCToITGC: 'Relate EDC to ITGC',
	itgc: 'ITGC',
	relateUDPsToTechnology: 'Relate UDP to technology',
	contentUpdateInsufficienRolesLabel: 'Insufficient roles to update content. Work with an engagement administrator to get sufficient rights.',
	// MEST Switcher
	meEntitySwitcher: 'Entity switcher',
	//Error Boundary
	errorBoundaryMessage: 'An error has occurred. Please refresh the page and try again. If the issue persists, contact the Help Desk.',
	sectionName: 'Section name',
	maxLength: 'Text cannot exceed {number} characters.',
	yearAgo: 'year ago',
	yearsAgo: 'years ago',
	monthAgo: 'month ago',
	monthsAgo: 'months ago',
	weekAgo: 'week ago',
	weeksAgo: 'weeks ago',
	daysAgo: 'days ago',
	dayAgo: 'day ago',
	today: 'Today',
	todayLowercase: 'today',
	yesterday: 'Yesterday',
	approaching: 'approaching',
	associatedToInherentRiskFactor: 'Associated to Inherent risk factor',
	createMissingDocument: 'Create missing document',
	createMissingDocumentBody: "Click 'Confirm' to create the document for the related items currently missing a document.",
	documentCreationSuccessMsg: 'Document creation in progress. Refresh the page for updates.',
	noRisksRelatedToAssertion: 'No ROMM related to this account assertion.',
	noAssertionsRelatedToAccount: 'No assertions related to this account',
	sharing: 'Sharing',
	risksUnrelatedToAccountAssertion: 'ROMMs unrelated to account assertion',
	cantCompleteTask:
		'Documents associated to the related task are missing sign-offs. Open the task, complete the missing documents, and then try Mark Complete again.',
	cantCompleteTasksTitle: 'Unable to mark complete',
	ok: 'OK',
	documentsEngagementLinkLabel: 'Select the form within the engagement to link with:',
	documentsEngagementCopyLabel: 'Select the form within the engagement to copy:',
	lastModifiedon: 'Last modified on',
	newAccountAndDisclosure: 'New account & disclosure',
	newAccountORDisclosure: 'New account or disclosure',
	externalDocuments: 'External documents',
	noExternalDocumentsAvailable: 'No external documents available',
	addExternalDocuments: 'Add external documents',
	relateExternalDocuments: 'Relate external documents',
	helixNotMappedToAccount: 'EY Helix data is not mapped to this account. Please update mapping and re-import data to proceed.',
	trackChangesNotAvailableForSpecialBodyDisplayMessage: 'Tracked changes functionality is not available for the response(s) below.',
	noDocumentRelatedObjectsApplicable: 'Objects are not required to be associated to this guided workflow form',
	helixViewerLoader: 'Loading Helix Viewer...',
	trackChangesViewDefaultMessage:
		'Certain responses do not have track change functionality. This will be indicated with the following message in the underlying activity details: "Tracked changes functionality is not available for the response(s) below."  Accordingly, lack of notification of changes below is not indicative of whether changes have been made.',

	//Relate task modal
	relateTasksTitle: 'Relate tasks',
	relateTaskTitle: 'Relate task',
	selectTaskToContinue: 'Select a task to continue.',
	taskLocationLabel: 'Task location',
	relateTaskInstructionalText:
		'Add or remove tasks that the document should be related to. If the document is evidence, removing it from the last task will move it to temporary files.',
	noResultFound: 'No results found',
	relatedTaskCounter: '{0} task related',
	relatedTasksCounter: '{0} tasks related',
	responsivePSPOSPCounter: '{0} task',
	responsivePSPOSPsCounter: '{0} tasks',
	onlyShowRelatedTasks: 'Only show selected tasks',
	relateTaskName: 'Task name',
	relateTaskType: 'Type',

	/*Relate Entities*/
	relateEntitiesTitle: 'Relate entities',
	relateEntitiesSearchPlaceholder: 'Enter to search by name',
	relateEntitiesName: 'Entity name',
	relateEntitiesIndex: 'Entity standard index',
	relatedEntitiesCounter: '{0} entities',
	relatedEntityCounter: '{0} entities',
	onlyShowRelatedEntities: 'Only show related entities',
	entity: 'Entity',
	noAssertionsRelatedLabel: 'No assertions related.',
	primaryEntity: 'Primary entity',

	// Bulk mark complete:
	bulkMarkCompleteInstructionalText:
		'Below are all the tasks related to this form. In order to mark complete the selected tasks, all documents must be signed-off by at least one preparer and one reviewer.',
	bulkMarkCompleteEngagementColumn: 'Engagement',
	bulkMarkCompleteDocumentsMissingSignOffs: 'Missing sign-offs. Click {bulkMarkCompleteMissingSignOffsClickableText} to sign-off.',
	bulkMarkCompleteMissingSignOffsClickableText: 'here',
	bulkMarkCompleteNoAccessToEngagement: 'You do not have access to the engagement this task is in',
	bulkMarkCompleteInProgressMessage: 'Process is in progress. It may take up to ten minutes. Please refresh for updates',
	bulkMarkCompleteRelatedDocumentsModalTitle: 'Document sign-offs',
	bulkMarkCompleteFilterUnreadyTasks: 'Show only tasks with missing document sign-offs.',
	bulkMarkCompleteNotAllowedModalTitle: 'Unable to mark complete',
	bulkMarkCompleteNotAllowedModalDescription: 'You need to select at least one task to mark complete',
	bulkMarkCompleteRelatedDocumentsModalDescription:
		'In order to mark complete the selected task, all documents must be signed off by at least one preparer and one reviewer.',
	bulkMarkCompleteRelatedDocumentsModalRefreshSignoffs: 'Refresh sign-offs and notes',
	selectedTaskCounter: '({0}) selected task',
	selectedTasksCounter: '({0}) selected tasks',

	// Mark complete (old):
	markCompleteNotAllowedModalDescription:
		'Documents associated to the related task are missing sign-offs. Open the task, complete the missing documents, and then try Mark complete again',
	markCompleteInstructionalText: 'All documents must be signed-off by at least one preparer and one reviewer to mark the activity as complete',

	// Adobe Analytics
	aaCookieConsentTitle: 'Welcome to',
	aaCookieContentPrompt: 'Do you want to allow cookies?',
	aaCookieConsentExplanation:
		'<p>In addition to cookies that are strictly necessary to operate this website, we use the following types of cookies to improve your experience and our services: <strong>Functional cookies</strong> to enhance your experience (e.g. remember settings), <strong>Performance cookies</strong> to measure the website\'s performance and improve your experience, <strong>Advertising/Targeting cookies</strong>, which are set by third parties with whom we execute advertising campaigns and allow us to provide you with advertisements relevant to you.</p><p>Review our <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">cookie policy</a> for more information.</p>',
	aaCookieConsentExplanationWithDoNotTrack:
		'<p>In addition to cookies that are strictly necessary to operate this website, we use the following types of cookies to improve your experience and our services: <strong>Functional cookies</strong> to enhance your experience (e.g. remember settings), <strong>Performance cookies</strong> to measure the website\'s performance and improve your experience, <strong>Advertising/Targeting cookies</strong>, which are set by third parties with whom we execute advertising campaigns and allow us to provide you with advertisements relevant to you.</p><p>We have detected that you have enabled the Do Not Track setting in your browser; as a result, Advertising/Targeting cookies are automatically disabled.</p><p>Review our <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">cookie policy</a> for more information.</p>',
	aaCookieConsentDeclineOptionalAction: 'I decline optional cookies',
	aaCookieConsentAcceptAllAction: 'I accept all cookies',
	aaCookieConsentCustomizeAction: 'Customize cookies',
	aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

	// Cookie Settings
	cookieSettings: {
		title: 'Cookie Settings',
		explanation:
			'Please provide your consent for cookie usage on ey.com and the My EY platform. Select one or more of the cookie types listed below, and then save your selection(s). Refer to the listing below for details on the types of cookies and their purpose.',
		emptyCookieListNotice: 'Cookies from this category are not used in this app',
		nameTableHeader: 'Name of cookie',
		providerTableHeader: 'Cookie provider',
		purposeTableHeader: 'Purpose of cookie',
		typeTableHeader: 'Type of cookie',
		durationTableHeader: 'Duration of cookie',
		formSubmit: 'Save my selection',
		requiredCookieListTitle: 'Required Cookies',
		functionalCookieListTitle: 'Functional Cookies',
		functionalCookieAcceptance: 'I accept the functional cookies below',
		functionalCookieExplanation:
			'Functionality cookies, which allow us to enhance your experience (for example by remembering any settings you may have selected).',
		performanceCookieListTitle: 'Performance Cookies',
		performanceCookieAcceptance: 'I accept the performance cookies below',
		performanceCookieExplanation:
			'Performance cookies, which help us measure the website’s performance and improve your experience. In using performance cookies we do not store any personal data, and only use the information collected through these cookies in aggregated and anonymised form.',
		advertisingCookieListTitle: 'Targeting Cookies',
		advertisingCookieAcceptance: 'I accept the advertising/targeting cookies below',
		advertisingCookieExplanation:
			'Advertising/targeting cookies, which we use to track user activity and sessions so that we can deliver a more personalized service, and (in the case of advertising cookies) which are set by the third parties with whom we execute advertising campaigns and allow us to provide advertisements relevant to you.',
		doNotTrackNotice:
			'We have detected that you have enabled the Do Not Track setting in your browser; as a result, advertising/targeting cookies are automatically disabled.'
	},
	accountFormsMissing: 'Account forms missing for {0} account(s)',
	createAccountForms: 'Create account form(s)',
	createAccountFormsDescription: "Click 'Confirm' to create the document for the related items currently missing a document.",
	createMissingDocuments: 'Related accounts currently missing document(s)',
	accountDocumentsCreated: 'Content delivery in progress.  It may take up to ten minutes for the content to be delivered.',
	evidenceMissingPICSignoffs: 'Evidence missing PIC sign-off(s)',
	evidenceMissingEQRSignoffs: 'Evidence missing EQR sign-off(s)',
	evidenceMissingPICEQRSignoffs: 'Evidence missing PIC and/or EQR sign-off(s)',
	evidenceMissingPICSignoffRequirements: 'Evidence missing PIC sign-off requirement(s)',
	evidenceMissingEQRSignoffRequirements: 'Evidence missing EQR sign-off requirement(s)',
	evidenceMissingPICEQRSignoffRequirements: 'Evidence missing PIC and/or EQR sign-off requirement(s)',
	evidenceMissingSignoffs: 'Evidence missing sign-off(s)',
	taskEntityDocumentValidationMsg: 'This task has entities that do not have any responsive evidence. Toggle "View by entities" to see which entities need additional documentation.',

	// Bulk task relate
	bulkTaskRelateFailureMessage: 'Some of the documents selected were not able to be associated to the selected task(s).',
	/*endoflabels*/
	evidenceMissingPreparerOrReviwerSignoffs: 'Document upload - Missing Preparer or Reviewer Sign-offs',

	manageITProcess: 'Manage IT process',
	manageITRisk: 'Manage IT risk',
	manageITControl: 'Manage IT control',
	manageITSP: 'Manage ITSP',
	manageITApp: 'Manage IT application',
	manageSCOT: 'Manage SCOTs',
	addAresCustomDescription: 'Select the content type to be added to this guided workflow form, input details, and click save.',
	documentImportSuccess: '{0} has been successfully created. It may take up to ten minutes for the content to be delivered.',
	documentImportFailure: 'Document creation failed. Please refresh or try again after some time. If the issue persists, contact the Help Desk.',
	formNotAvailable: 'No matching Canvas form found.',
	selectTask: 'Select Task to relate to guidance',
	canvas: 'Canvas',
	selectEngagement: 'Select engagement',
	relatedSharedTaskInstructionalText: 'This document can be related to one or more tasks from the same engagement or from another engagement in the same workspace. Select the task(s) below within the identified engagement to share this document with.',
	relateReferenceToTaskInstructionalText: 'New references must be related to at least one task. Select a task that this document should be added to as evidence.',

	//Modal Manage sub-scope
	manageSubScopeTitle: 'Manage sub-scopes',
	manageSubScopeDescription: 'Create new sub-scopes or edit or delete existing sub-scopes below.',
	addSubScope: 'Add a sub-scope',
	subScopeName: 'Sub-scope name',
	knowledgeScope: 'Knowledge scope',
	subScopeAlreadyExist: 'Sub-scope name already exist',
	subScopes: 'Sub-scopes',
	notAvailableSubScopes: 'There are no sub-scopes available.',
	SubScopeNameValidation: 'Sub scope name length exceeds more than 255 characters.',

	//CRA Summary
	manageAccount: 'Manage account',
	newAccount: 'New account',
	accountInformation: 'Account information',
	noRelatedObjectITProcessFlow: 'No related object. Relate an object to get started.',

	// Entity type modal name
	manageScots: 'Manage SCOTs',
	manageControl: 'Manage control',
	manageEstimate: 'Manage estimate',
	manageAccountAndDisclosures: 'Manage accounts and disclosures',

	// Group components
	groupComponentSelectorLabel: 'Select group team',
	groupComponentItemSelectedCountTextSingular: 'selected',
	groupComponentItemSelectedCountTextPlural: 'selected',
	groupComponentAllSelected: 'All selected',

	//Relate IT Risks SOCD
	relateITRisksSCOD: {
		relateITRisks: 'Select impacted IT risks',
		deficiency: 'Deficiency',
		itRisk: 'IT risk',
		itRisks: 'IT risks',
	},

	//Relate Unmitigated IT Risks SOCD
	relateUnmitigatedITRisksSCOD: {
		relateUnmitigatedITRisks: 'Select unmitigated IT risks',
		deficiency: 'Deficiency',
		itRisk: 'IT risk',
		itRisks: 'IT risks',
	},

	// Relate IT Controls SOCD
	relateITControlSCOD: {
		relateITControls: 'Relate ITGCs',
		deficiency: 'Deficiency',
		design: 'Design',
		operation: 'Operation',
		itgc: 'ITGC',
		itgcs: 'ITGCs',
		itRisk: 'IT risk',
		itRisks: 'IT risks',
		notSelected: 'Not selected',
		headerIconTitle: 'Knowledge',
	},

	//Relate controls SOCD
	relateControlsSOCD: {
		relateControls: 'Relate controls',
		close: 'Close',
		control: 'control',
		controls: 'controls',
		controlName: 'Control',
		deficiency: 'Deficiency',
		notAbleToRelate: 'The control is already related to the deficiency and cannot be selected here'
	},

	//Relate ITCGs(IT Controls) SOCD
	relateITControlsSOCD: {
		relateITControls: 'Relate ITGCs',
		close: 'Close',
		itcontrol: 'ITGC',
		itcontrols: 'ITGCs',
		itControlName: 'ITGC',
		deficiency: 'Deficiency'
	},

	//Relate IT Applications SOCD
	relateITApplicationsSOCD: {
		relateITRisks: 'Relate IT risks',
		close: 'Close',
		technology: 'technology',
		technologies: 'technologies',
		technologyName: 'Technology',
		deficiency: 'Deficiency:',
		selectUnmitigatedITRisks: 'Select unmitigated IT risks'
	},

	//Relate Assertions SOCD
	relateAssertionsSOCD: {
		relateAssertion: 'Relate assertions',
		relateAccountsAndAssertion: 'Relate accounts and assertions',
		relateAccountsAndAssertionsDescription: 'Select accounts and assertions related to this deficiency.',
		oneAssertion: 'assertion',
		assertions: 'assertions',
		accountName: 'Account',
		assertion: 'Assertion',
		deficiency: 'Deficiency:'
	},

	//Relate entities SOCD
	relateEntitiesSOCD: {
		relateEntities: 'Relate entities',
		close: 'Close',
		entity: 'entity',
		entities: 'entities',
		entityName: 'Entities',
		deficiency: 'Deficiency:'
	},

	//Relate GA Components SOCD
	relateGAComponentsSOCD: {
		relateComponents: 'Relate components',
		manageReferenceOnlyComponents: 'Manage reference components',
		component: 'component',
		components: 'components',
		componentName: 'Components',
		groupScope: 'Group scope',
		referenceOnly: 'Ref.',
		deficiency: 'Deficiency:',
		close: 'Close'
	},

	//Relate Compensating Controls SOCD
	relateCompensatingControlsSOCD: {
		controlListHeaderName: 'Controls',
		title: 'Relate controls',
		close: 'Close',
		deficiency: 'Deficiency:',
		risk: 'ROMM',
		compensatingControl: 'compensating control',
		compensatingControls: 'compensating controls',
		compensatingControlName: 'Compensating control',
		notAbleToRelate: 'The control is already related to the deficiency and cannot be selected here.',
		countLabel: 'controls',
		countLabelSingle: 'control'
	},

	//Relate Mitigating Controls SOCD
	relateMitigatingControlsSOCD: {
		controlListHeaderName: 'Controls',
		title: 'Relate controls',
		close: 'Close',
		deficiency: 'Deficiency:',
		mitigatingControl: 'mitigating control',
		mitigatingControls: 'mitigating controls',
		mitigatingControlName: 'Mitigating control',
		notAbleToRelate: 'The control is already related to the deficiency and cannot be selected here.',
		countLabel: 'controls',
		countLabelSingle: 'control'
	},

	flowchartNoFlowhcartAvailable: 'No flowchart available',// It is for print
	flowchartNewStepNoProcessStepsAvailable: 'No process steps available',// It is for print
	flowchartNewStepConnectedFrom: 'Connected from',// It is for print
	flowchartNewStepConnectedTo: 'Connected to',// It is for print
	flowchartNewStepTitle: 'New process step',
	flowchartStepDocumentEditTitle: 'Edit process step',
	flowchartNewStepInstructionText:
		"Enter process step details below and select <b>'Save and close'</b> to finish. To create another process step, select <b>'Save and create another'.</b>",
	flowchartEditStepInstructionText:
		"Edit process step details and related objects below. Click <b>'Save and close'</b> to save and return to the flowchart. Navigating to other steps using the options below will save your updates.",
	flowchartStepColumnLabelRequired: 'Phase (required)',
	flowchartStepNameLabel: 'Process step name (required)',
	flowchartStepDescLabel: 'Process step description',
	flowchartStepNamePlaceholder: 'Enter process step name',
	flowchartStepDescPlaceholder: 'Enter process step description',

	//Add New Flow Chart Steps
	flowchartStepColumnLabel: 'Phase',
	flowchartStepCounterOf: 'of',
	flowchartStepCounterChar: 'characters',
	flowchartStepErrorMsgStepNameRequired: 'Step name is required',
	flowchartStepErrorMsgStepDescRequired: 'Step description is required',
	required: 'Required',
	flowchartStepErrorMsgStepDescExceedMaxLength: 'Step description exceeds the maximum allowed characters',
	flowchartStepButtonCancel: 'Cancel',
	flowchartStepButtonSaveAndClose: 'Save and close',
	flowchartStepButtonSaveAndView: 'Save and view',
	flowchartStepButtonSaveAndCreateAnother: 'Save and create another',
	flowchartStepUnableToOpenDocumentMessage: 'Unable to open Process step document at this time. Please refresh the page and try again. If the error persists, please contact the help desk.',
	flowchartStepErrorMsgColumnRequired: 'Column is required',
	flowchartStepHeaderNameForWCGW: 'WCGW name',
	flowchartStepHeaderNameForControl: 'Control name',
	flowchartStepHeaderNameForITApp: 'Technology name',
	flowchartStepHeaderNameForServiceOrganisation: 'Service organization name',
	flowchartStepRelateLabelForWCGW: 'Relate WCGWs',
	flowchartStepRelateLabelForControl: 'Relate controls',
	flowchartStepRelateLabelForITApp: 'Relate Technology',
	flowchartStepRelateLabelForServiceOrganisation: 'Relate service organizations',
	designEffectiveness: 'Design effectiveness',
	testing: 'Testing',
	lowerRisk: 'Lower risk',
	flowchartStepWcgwNoRowsMessage: 'No WCGWs have been related. Click {0} to get started',
	flowchartStepControlNoRowsMessage: 'No controls have been related. Click {0} to get started',
	flowchartStepItAppNoRowsMessage: 'No Technologies have been related.Click { 0} to get started',
	flowchartStepServiceOrganisationNoRowsMessage: 'No service organizations have been related. Click {0} to get started',
	flowchartStepWgcwTabLabel: 'WCGWs',
	flowchartStepControlsTabLabel: 'Controls',
	flowchartStepItAppsTabLabel: 'Technologies',
	flowchartStepServiceOrganisationTabLabel: 'Service organizations',
	flowchartStepConnectionSuccessMessage: 'Connection created successfully.',
	flowchartStepConnectionFailedMessage: 'Couldnt establish a connection. Please try again.',
	flowchartStepSelfConnectFailMessage: 'Source and Target cannot be the same.',
	flowchartStepConnectionDuplicateMessage: 'Connection already exists.',
	flowchartStepConnectionDeleteSuccessMessage: 'Connection deleted successfully.',
	flowchartStepConnectionDeleteFailMessage: 'Couldnt delete the connection. Please try again.',
	flowchartStepEditStepFailMessage: "Couldn't edit the step. Please try again.",
	flowchartStepGetByIdFailMessage: 'Invalid step, please refresh and try again.',
	flowchartStepGetByIdFailureMessage:
		'This flowchart step is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	flowchartStepNewStepFailureMessage: 'Process step creation was unsuccessful, please try again.  if the error persists, please contact the helpdesk.',
	flowchartStepDeleteConnector: 'Delete connector',
	flowchartStepEdgeConnectorOptions: 'Connector options',
	flowchartStepEdgeStartPoint: 'Start Point',
	flowchartStepEdgeEndPoint: 'End Point',
	relateDocumentToFlowchartStepError:
		'Operation cannot be completed at this time. Refresh the page and​ try again. If the issue persists, contact the Help Desk.',
	flowchartStepRelateDocumentsOrObjects: 'Relate documents or objects',
	flowchartStepThisstep: 'to this step',
	knowledgeSupported: 'Knowledge supported',
	flowchartStepName: 'Process step name',
	flowchartStepDescription: 'Process step description',
	flowchartStepKnowledgeDescription: 'Process step description',
	flowchartStepCreationSuccessMessage: 'Process step creation was successful, you will be able to edit the step shortly.',
	flowchartStepColumnOptions: [
		{
			id: 1,
			columnName: printLabels.flowchartStepColumnOption_1
		},
		{
			id: 2,
			columnName: printLabels.flowchartStepColumnOption_2
		},
		{
			id: 3,
			columnName: printLabels.flowchartStepColumnOption_3
		},
		{
			id: 4,
			columnName: printLabels.flowchartStepColumnOption_4
		},
		{
			id: 5,
			columnName: printLabels.flowchartStepColumnOption_5
		},
		{
			id: 6,
			columnName: printLabels.flowchartStepColumnOption_6
		},
		{
			id: 7,
			columnName: printLabels.flowchartStepColumnOption_7
		}
	],
	flowchartKnowledgeSteps: {
		manageRejectedSteps: 'Manage removed process steps',
		manageRejectedStepsContent: 'Accept previously removed process steps to add them back to the flowchart. Click on the step name to view the description',
		noRelatedStepDescription: 'No description related to step',
		accept: 'Accept',
		accepted: 'Accepted',
		viewRejectedStepsHeaderName: 'Process step name',
		viewRejectedStepsPhaseHeaderName: 'Process step column',
		searchRejectedSteps: 'Search',
		noSearchResult: 'No results found',
		noRejectedSteps: 'No removed process steps',
		stepCount: 'Process steps'
	},

	flowChartWCGW: {
		wcgwsCounter: '{0} WCGWs',
		wcgwCounter: '{0} WCGW',
		headerName: 'Relate WCGWs',
		showOnlyRelatedText: 'Show only related',
		noResultsFound: 'No results found'
	},

	flowchartITAPPSO: {
		showOnlyRelatedText: 'Show only related',
		noResultsFound: 'No results found'
	},

	flowChartITApplication: {
		itApplicationsCounter: '{0} technologies',
		itApplicationCounter: '{0} technologies',
		headerName: 'Relate technology',
		columnName: 'Technology',
		noDataFound: 'No results found'
	},

	flowChartITSO: {
		itSOsCounter: '{0} SOs',
		itSOCounter: '{0} SOs',
		headerName: 'Relate service organizations',
		columnName: 'Service organizations',
		noDataFound: 'No results found'
	},

	flowChartControl: {
		controlsCounter: '{0} Controls',
		headerName: 'Relate controls',
		showOnlyRelatedText: 'Show only related',
		noResultsFound: 'No results found',
		noWCGWs: 'No controls have been created'
	},

	relateSCOT: {
		header: 'Relate SCOTs',
		estimate: 'Estimate',
		scotsCounter: '{0} SCOTs',
		scotCounter: '{0} SCOT',
		headerName: 'SCOT name',
		showOnlyRelated: 'Show only related',
		noResultsFound: 'No results found',
		noScotCreated: 'No SCOTs created in the engagement',
		scot: 'SCOT',
		scots: 'SCOTs',
		unrelatedScots: 'Unrelated SCOTs',
		unrelatedScotsDescription: 'Unrelated SCOTs must be related to an account or deleted.',
		scotRequiredForDeletion: 'At least one SCOT must be selected for deletion'
	},
	relatedTechnology: {
		header: 'Relate technology',
		estimate: 'Estimate',
		technologiesCounter: '{0} technologies',
		technologyCounter: '{0} technology',
		relateTechnologyName: 'Technology',
		relateTechnologyType: 'Type',
		showOnlyRelated: 'Show only related',
		noResultsFound: 'No results found',
		relateTechnologyCounter: '{0} Technology',
		relateTechnologiesCounter: '{0} technologies'
	},
	relatedStepObjects: {
		relatedWCGWs: 'Related WCGWs',
		relatedControls: 'Related controls',
		relatedDocuments: 'Related evidence',
		relatedITApplications: 'Related technologies',
		relatedSOs: 'Related service organizations',
		relatedROMs: 'Related potential ROMMs',
		relatedROMMs: 'Related ROMMs'
	},

	flowchartEditSteps: {
		nextStep: 'Next step',
		previousStep: 'Previous step',
		editStepTitle: 'Edit process step',
		draftEditStepFailMessage: 'Unable to create flowchart step. Refresh the page and try again. Contact the Help Desk if the error persists.'
	},

	flowChartStepmoreMenu: {
		delete: 'Delete',
		reject: 'Remove',
		edit: 'Edit'
	},

	relateEstimate: {
		scot: 'SCOTs',
		strategy: 'SCOT strategy',
		type: 'Type',
		noSCOT: 'Each estimate must be related to at least one SCOT. Click ',
		noSCOTmsg: ' to get started',
		estimate: 'Estimate',
		routine: 'Routine',
		nonRoutine: 'Non Routine',
		notSelected: 'Not selected',
		relateSCOTs: 'Relate SCOTs',
		remove: 'Remove',
		noEstimate: 'No estimate available',
		FSCP: 'FSCP'
	},

	flowChartStepIconsTooltip: {
		wcgws: 'WCGWs',
		controls: 'Controls',
		iTApps: 'Technologies',
		serviceOrganisations: 'Service organizations',
		roms: 'ROMs',
		romms: 'ROMMs',
		relatedromsWithSignJudgement: 'Potential ROMMs'
	},

	flowChartStepIconTooltip: {
		wcgw: 'WCGW',
		control: 'Control',
		iTApp: 'Technology',
		serviceOrganisation: 'Service organization',
		evidence: 'Evidence',
		rom: 'ROM',
		romm: 'ROMM',
		relatedromWithSignJudgement: 'Potential ROMM'
	},

	flowChartErrorMessage: {
		stepOutsideOfTheColumns: 'Steps cannot be placed outside of the flowchart area',
		stepBetweenTheColumns: 'Steps cannot be placed between the columns',
		stepOnTopOrTooCloseToAnotherStep: 'Steps cannot be placed on top of the other steps',
		flowchartMessageProcessorUpdateInProgress: 'Flowchart update in-progress. Try again later and if the issue persists, contact the Help Desk'
	},

	//Delete Or Reject Flow Chart Steps
	flowChartStepsDeleteReject: {
		deletestep: 'Delete step',
		deleteStepModalMessage:
			'Are you sure you want to delete this step? All ROMMs, Technologies, service organizations and evidence related to the deleted step will be unrelated.',
		cannotBeUndone: 'New or renewed customer contracts',
		deleteStepFailMessage: 'Failed to delete the step. Please try again',
		deleteDraftStepErrorMessage: 'The step created in draft was not deleted. To delete this step, please select the step and action the delete again.',
		rejectStep: 'Remove process step',
		rejectStepModalMessage: 'Are you sure you want to remove this step? This will remove any related objects to the step.',
		rejectStepFailMessage: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
		confirmBtn: 'Confirm'
	},
	notEntered: 'Balances not applicable',
	estimateCategory: 'Estimate category',
	noResultsFoundWithPeriod: 'No results found',
	noEstimateAvailable: 'No estimate available',
	noRelatedObject: 'No related object.',
	relateAnObject: 'Relate an object',
	copyrightMessage: 'Copyright © <year> all rights reserved',
	leadsheet: 'Lead sheet',
	controlName: 'Control name',
	noControlAvailable: 'No control available',
	independenceError: 'All incomplete responses must be completed prior to submitting independence. Use the \'Show incomplete\' option to filter for incomplete questions. If the issue persists, call the Help Desk.',
	riskTypeNotAssociated:
		'Newly added ROMM does not match the allowed ROMM type(s) and therefore does not appear below. Add another ROMM of the allowed type or select from the below list',
	accountsAndRelatedEstimates: 'Accounts and related estimates',
	noEstimatesAssociated: 'No estimates associated',
	noAssertionsAvailable: 'No assertions available',
	noAccountsOrDisclosuresAvailable: 'No accounts or disclosures available',

	relateEstimateToRisk: {
		riskType: 'ROMM type',
		risk: 'ROMM',
		hasestimate: printLabels.HasEstimateLabel,
		accounts: 'Accounts',
		isItRelevant: 'Applies to Estimate?',
		assertions: 'Assertions',
		invalidRiskParentRiskErrMsg: 'Record not found. Please refresh the page to continue.',
		noEstimate: 'No estimate available',
		invalidRelateRiskOrEstimateRelationErrMsg: 'The object has already been related. Please refresh the page to continue.',
		invalidUnRelateRiskOrEstimateRelationErrMsg: 'The object has already been unrelated. Please refresh the page to continue.'
	},

	savingChanges: 'Saving changes',
	showEstimateAccountsWithoutEstimates: 'Show estimate accounts without estimates',
	showEstimateSCOTsWithoutEstimates: 'Show estimate SCOTs without estimates',
	manageSCOTs: 'Manage SCOTs',
	sCOTsAndRelatedEstimates: 'SCOTs and related estimates',
	relateEstimateToRiskNoDataMessage: 'No records available, please relate at least one account and assertion with a ROMM associated if applicable',
	estimateMustHaveRelatedAccount: 'No ROMMs available.\nRelate at least one account to this estimate to see the available ROMMs.',
	maps: 'Maps',
	mapsUpbutSomeLoadingErrorMessage: 'A technical error has occurred that is preventing the maps feature from working. Refresh the page and try again.',
	mapsDownErrorMessage: 'The Maps feature is temporarily unavailable. Refresh the page and try again. If this message persists, contact the Help Desk.',
	financialStatements: 'Financial Statements',
	serviceGatewayAutomation: 'Service Gateway & Automation',
	priorPeriodCategory: 'Prior period category',
	relatedAccountWithColon: 'Related accounts: ',
	noRelatedAccount: 'No related accounts',
	noRetionaleAvailable: 'Supplemental information was not necessary to document the basis for the categorization',
	leftNavIconApprovals: 'Approvals',
	editDuplicateSectionHeader: "Edit the details for the Section and click 'Save'.",
	relatedEvidences: 'Relate evidence',
	relatedEvidencesInstruction: 'Relate an evidence from this engagement.',
	relatedTemporaryFilesInstruction: 'Relate a temporary document from this engagement.',
	noDataLabel: 'No data found',
	editDuplicateSection: 'Edit section',
	showOnlyRelated: 'Show only related',
	aiChatbot: 'EYQ Assurance Assistant',
	StEntityNoRecords: 'No accounts or disclosures are mapped to the selected entity.',
	entityName: `Entity: {0} - {1}`,
	versionLabel: 'Version',
	relatedEstimates: 'Related estimates',
	noRelatedEstimates: 'No related estimates',
	viewEvidenceRelatedToBody: 'View evidence related to the body',
	selectHeaderFromRail: 'Select a header from left navigation pane to proceed',
	manageITProcesses: 'Manage IT processes',
	rationaleForLR: 'Rationale for limited risk account',
	rationaleForInsignificant: 'Rationale for insignificant account',
	rationalIsMissing: 'Rationale is missing.',
	craSummaryText1: 'Each significant account or disclosure must have at least one related assertion. Click ',
	noTechnologyOptionMessage: 'No technologies found',
	numberSelected: '{0} selected',
	scotDetails223: {
		relatedAccounts: 'Related accounts',
		scotType: 'Type',
		manageScot: 'Manage SCOTs',
		editScot: 'Edit SCOT',
		scotNotAvailableMessage: 'SCOTs are not available for this document',
		relatedScotNotAvailableMessage: 'No related SCOT. Relate a SCOT from the attributes page to get started',
		noRelatedRisksMessage: 'No ROMMs related to account',
		relatedRisks: 'Related ROMMs',
		scotNameHeader: 'SCOT'
	},
	veryLowRiskEstimateHeader: 'Related very low risk estimates',
	scotSummarySpecialBody: {
		noScotsMessage: 'No SCOTs available',
		scotSearchNoResultsFound: 'No results found',
		nodataHyphen: '-',
		scotName: 'SCOTs',
		account: 'Accounts',
		technologyOrSOs: 'Technology / SOs',
		technology: 'Technology',
		sos: 'SOs',
		roMMs: 'ROMMs',
		standardROMMs: 'Standard',
		otherROMMs: 'Entity-specific',
		romsWithSignificantJudgement: 'Potential ROMMs requiring explanation',
		otherConsiderations: 'Other observations',
		observations: 'Observations',
		hasJudgement: 'Yes',
		hasConsideration: 'Yes',
		knowledgetitle: 'From knowledge',
		relatedTechnologies: 'Related Technologies',
		relatedSOs: 'Related SOs',
		relatedStandardROMMs: 'Related Standard ROMMs',
		relatedEntitySpecificROMMs: 'Related entity-specific ROMMs',
		technologies: 'Technologies',
		serviceOrganizations: 'Service organizations',
		standardROMM: 'Standard ROMMs',
		entitySpecificROMMs: 'Entity-specific ROMMs',
		scotsWithROMsWithSignificantJudgement: 'SCOTs with potential ROMMs requiring explanation',
		scotsWithOtherConsiderations: 'SCOTs with observations',
		scotsWithEntitySpecificROMMs: 'SCOTs with entity-specific ROMMs',
		relatedromWithSignJudgement: 'Related Potential ROMMs requiring explanation',
		romWithSignJudgement: 'Potential ROMMs',
		risksOfMisstatementWithSignificantJudgement: 'Potential ROMMs',
		entitySpecificContext: 'Entity specific context',
		searchClearTitle: 'Clear search',
		rommsLabel: 'ROMMs',
		rommsUnrelatedToAccounts: 'ROMMs unrelated to accounts'
	},
	scotSummaryESROMMUnrelated: {
		bannerTitle1: 'There is 1 entity-specific ROMM that is not related to a SCOT or estimate',
		bannerTitle: 'There are {0} entity-specific ROMMs that are not related to a SCOT or estimate',
		bannerDescription: "All entity-specific ROMMs must be related to a SCOT or estimate. Relate these ROMMs to a SCOT/estimate or select 'Show unrelated ROMMs' to review and delete them.",
		showUnrelatedROMMs: 'Show unrelated ROMMs',
		modalTitle: 'Unrelated entity-specific ROMMs',
		modalDescription: 'Unrelated entity-specific ROMMs must be associated to a SCOT/estimate or deleted.',
		noResultsFound: 'No results found',
		atLeastOneROMMRequired: 'At least one ROMM must be selected for deletion.',
		deleteConfirmTitle: 'Confirm deletion of selected ROMM(s)',
		deleteConfirmMessage: 'Are you sure that you want to delete this ROMM(s)? All existing relationships will be removed. This action cannot be undone.',
		riskOfMaterialMisstatement: 'Risk of material misstatement'
	},
	socdReferenceROMMUnrelated: {
		bannerTitle1: 'There is 1 reference ROMM not related to an assertion',
		bannerTitle: 'There are {0} reference ROMMs not related to an assertion',
		bannerDescription:
			"All reference ROMMs must be related to an assertion. Select 'Manage reference ROMMs' to review and either relate these reference ROMMs to an assertion or delete them.",
		manageReferenceROMMs: 'Manage reference ROMMs'
	},
	socdReferenceControlUnrelated: {
		bannerTitle1: 'There is 1 reference control not related to a deficiency',
		bannerTitle: 'There are {0} reference controls not related to a deficiency',
		bannerDescription: "All reference controls must be related to a deficiency. Relate these reference controls to a deficiency in the relevant individual deficiency document or select 'Show unrelated reference controls' to review and delete them.",
		showUnrelatedReferenceControls: 'Show unrelated reference controls'
	},
	socdReferenceROMMWithoutReferenceControl: {
		bannerTitle1: 'There is 1 reference ROMM not related to a reference control',
		bannerTitle: 'There are {0} reference ROMMs not related to a reference control',
		bannerDescription: "All reference ROMMs must be related to a reference control. Relate these reference ROMMs to a reference control or select 'Show unrelated reference ROMMs' to review and delete them.",
		showUnrelatedReferenceROMMs: 'Show unrelated reference ROMMs',
		modalTitle: 'Unrelated reference ROMMs',
		modalDescription: 'Unrelated reference ROMMs must be associated to a reference control or deleted.',
		noResultsFound: 'No results found',
		atLeastOneROMMRequired: 'At least one reference ROMM must be selected for deletion.',
		deleteConfirmTitle: 'Confirm deletion of selected reference ROMM(s)',
		deleteConfirmMessage: 'Are you sure that you want to delete the selected reference ROMM(s)?',
		riskBadge: 'Risk badge',
		riskOfMaterialMisstatement: 'ROMMs'
	},
	customTablePagination: {
		show: 'Show',
		first: 'First',
		last: 'Last',
		previous: 'Previous',
		next: 'Next'
	},

	socdSummary298: {
		deficiency: 'Deficiency',
		deficiencies: 'Deficiencies',
		accounts: 'Accounts',
		technology: 'Technology',
		technologies: 'Technologies',
		documentSignOffs: 'Document sign-offs',
		documentsSignedOffBy: 'Documents signed off by',
		documentsNotSignedOffBy: 'Documents not signed off by',
		remediated: 'Remediated',
		conclusion: 'Conclusion',
		socd_deficiencyMagnitudeCode_1: 'CD',
		socd_deficiencyMagnitudeCode_2: 'SD',
		socd_deficiencyMagnitudeCode_3: 'MW',
		socd_deficiencyMagnitudeCode_4: '-',
		socd_deficiencyMagnitudeId_1: 'Control deficiency',
		socd_deficiencyMagnitudeId_2: 'Significant deficiency',
		socd_deficiencyMagnitudeId_3: 'Material weakness',
		socd_deficiencyMagnitudeId_4: '-',
		description: 'Description',
		conclusion: 'Conclusion',
		remediated: 'Remediated',
		changeToCRA: 'Change to CRA',
		compensated: 'Compensated',
		unmitigatedITRisksFSA: 'Unmitigated IT risks (FSA)',
		noChangeToCRA: 'No change to CRA; change to nature, timing, and/or extent of substantive procedures.',
		itRisksMitigatedThroughITSPs: 'IT risks mitigated through performance of ITSPs.',
		entities: 'Entities',
		components: 'Components',
		primary: 'Primary',
		regional: 'Regional',
		socd_tags: 'Tags',
		controls: 'Controls',
		controlType: 'Control type',
		design: 'Design',
		operation: 'Operation',
		explanation: 'Explanation',
		noResultsFound: 'No results found',
		noExplanationProvided: 'No explanation provided',
		noRelatedMitigatingControlsFound: 'No related mitigating controls found.',
		noRelatedCompensatingControlsFound: 'No related compensating controls found.',
		deficientControlsTitle: 'Deficient controls',
		compensatingControlsTitle: 'Compensating controls',
		mitigatingControlsTitle: 'Other controls in the engagement that are not related to the risks related to the deficient control(s)',
		itRisksAndRelatedTechnologiesTitle: 'IT risks and related technologies',
		relatedAccountsAndAssertionsTitle: 'Related accounts and assertions',
		relevantAssertions: 'Relevant assertions',
		romms: 'ROMMs',
		noRelatedRomms: 'No related ROMMs',
		deficientITGCsTitle: 'Deficient ITGCs',
		compensatingITGCsTitle: 'Compensating ITGCs',
		itgcs: 'ITGCs',
		relatedDeficienciesTitle: 'Related deficiencies',
		deficienciesThatCausedThisDeficiency: 'Deficiencies that caused this deficiency',
		deficienciesThatAreCausedByThisDeficiency: 'Deficiencies caused by this deficiency',
		financialStatementImpactTitle: 'Financial statement impact',
		financialStatementImpactAssessmentTitle: 'Effect on financial statement audit procedures',
		incompleteResponse: 'Incomplete response',
		accountBalanceOrTransactionsTitle: 'Description of magnitude and likelihood of potential misstatement',
		immaterialConclusionRationale: 'Evaluation of magnitude and likelihood of potential misstatement',
		otherConsiderations: 'Other considerations',
		otherConsiderationsTitle: 'Other considerations',
		considerations: 'Considerations',
		yes: 'Yes',
		considerationMaterialWeaknessIndicators: 'Indicators of material weakness present and consultation required',
		considerationInterimCommunication: 'Material weakness or significant deficiency requiring interim communication identified',
		considerationITRisksNotImpacted: 'IT risks marked not impacted',
		considerationControlsNotImpacted: 'Controls and ITGCs that are not impacted by the deficiency',
		deficiencyRelationships: 'Deficiency relationships',
		deficiencyCausesOtherDeficiencies: 'Deficiency causes other deficiencies',
		deficiencyCausedByOtherDeficiencies: 'Deficiency caused by other deficiencies',
		referencePillLabel: 'Ref.',
		referencePillTooltip: 'Referenced from other sources',
	},

	socdSummary298UnrelatedReferenceControls: {
		modalTitle: 'Unrelated reference controls',
		modalDescription: 'Unrelated reference controls must be associated to a deficiency or deleted.',
		atLeastOneRequired: 'At least one reference control must be selected for deletion.',
		noResultsFound: 'No results found',
		deleteConfirmTitle: 'Confirm deletion of selected reference control(s)',
		deleteConfirmMessage: 'Are you sure that you want to delete the selected reference control(s)?',
		concurrencyError: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
		controls: 'Controls',
	},

	scotDetails224: {
		riskRelatedWalkthrough: 'ROMMs related in this walkthrough',
		relatedAccounts: 'Related accounts',
		relatedToWTDocuments: 'Related to other WT documents',
		riskNotRelatedWalkthrough: 'ROMMs not related in this walkthrough',
		substantiveNotSufficient: 'Substantive not sufficient',
		journalEntry: 'Journal entry',
		noDirectRiskSourcesAreAvailable: 'No related ROMMs',
		scotNotAvailableMessage: 'SCOTs are not available for this document',
		relatedScotNotAvailableMessage: 'No related SCOT. Relate a SCOT from the attributes page to get started',
		relatedDocuments: 'Related documents',
		risk: 'ROMM:',
		riskSpecialCircumstances: 'Risk special circumstances',
		relateInstructionText:
			'This ROMM has been identified in another SCOT.  Selecting or unselecting a special circumstance here will also update the selection in the other walkthrough.  Are you sure you want to proceed?',
		unrelateInstructionText:
			'This ROMM has been identified in the critical path of another walkthrough.  Selecting or unselecting a special circumstance here will also update the selection in the other walkthrough.  Are you sure you want to proceed?',
		concurrencyErrorMessage: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.'
	},
	ipe: 'IPE',
	scotSummary198: {
		noAccountsDisclosureCreated: printLabels.noAccountsDisclosureCreated,
		noScotEstimateIdentified: 'No SCOTs or estimates have been identified.',
		noScotIdentified: 'No SCOTs Identified',
		scots: 'SCOTs',
		estimates: 'Estimates',
		errorMessage: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
		noResultsFound: 'No results found',
		searchAccounts: 'Search by significant accounts and disclosures',
		searchScotEstimates: 'Search by SCOTs/Estimates',
		searchByScots: 'Search by SCOTs',
		accounts: 'Significant accounts and disclosures',
		scotsOrEstimate: 'SCOTs/Estimates',
		accountNotRelatedToScotValidation:
			'Each significant account or disclosure must be related to at least one SCOT. Select a checkbox to relate a relevant SCOT to this significant account or disclosure.',
		estimateAccountNotRelatedToEstimate:
			'Each significant account or disclosure impacted by an estimate must be related to at least one higher risk estimate or lower risk estimate. Select a checkbox to relate an estimate to this significant account or disclosure.',
		scotNotRelatedToAccountValidation:
			'Each SCOT must be related to at least one significant account or significant disclosure. Select a checkbox to relate this SCOT to a relevant significant account or significant disclosure.',
		showValidations: 'Show validations',
		clearallfilters: 'Clear all filters',
		clearallfilterstitle: 'Clears all active filters and search criteria in the table',
		riskEstimateHasNoRelatedEstimateAccountValidation:
			'Each Higher/Lower risk estimate must be related to at least one significant account/disclosure that is impacted by an estimate. Select a checkbox to relate a relevant significant account or disclosure to this estimate.',
		relatedTechnologiesLabel: 'Select related technologies',
		allTechnologiesLabel: 'All technologies',
		showOnlyValidations: 'Show only accounts with validations'
	},
	craSummary231: {
		searchAccounts: 'Search',
		riskHeader: 'ROMMs',
		assertionsHeader: 'Assertions',
		noSnapshotSelected: 'Please select a date to compare to the current version and view the list of accounts.',
		incompleteAssertionWarning:
			'Relevant assertions must have a CRA. Select the applicable inherent risk assessment and control risk assessment.',
		lowAssertionsWithIsHighRiskWarning: 'One or more ROMMs are selected as contributing to a higher inherent risk assessment. Update the inherent risk assessment for this assertion to higher or deselect the ROMM(s) contributing to a higher inherent risk assessment.',
		noRiskWarningText: `Relevant assertions must have at least one risk of material misstatement. Click on 'Go to source' to associate a ROMM to this assertion or to make this assertion not relevant.`,
		gtsEditInherentRisk: 'To edit the inherent risk, click',
		gtsViewProcessDocs: 'To view process documentation, click',
		gtsEditRiskProp: 'To edit ROMM properties, click',
		gtsEditAccountProp: 'To edit account properties, click',
		gtsEditRiskModalProp: 'To manage ROMMs, click',
		gtsEditAccountModalProp: 'To manage accounts, click'
	},
	scotSummary225: {
		accounts: 'Accounts',
		searchAccounts: 'Search accounts',
		noAccountSelected: 'Select a significant account or disclosure to view the associated SCOTs and estimates',
		relatedScots: 'Related SCOTs',
		relatedAcconts: 'Related Accounts',
		relatedEstimates: 'Related Estimates',
		scotListHeader: 'SCOTs',
		estimateListHeader: 'Estimates',
		accountName: 'Account',
		noEstimateOverlayMessage:
			'Each significant account or disclosure impacted by an estimate must be related to at least one higher risk estimate or lower risk estimate. Relate an estimate to this significant account or disclosure.',
		noScotsMessage:
			'Each significant account or disclosure must be related to at least one SCOT. Create a new SCOT or relate an existing SCOT to this significant account or significant disclosure.',
		noAccountsMessage: printLabels.noAccountsDisclosureCreated,
		noAccountsAvailableOnSearch: 'No results found',
		relateAccounts: 'Relate accounts and disclosures',
		noAccountsCreated: 'No accounts have been created',
		noScotsCreated: 'No SCOTs have been created',
		relateScots: 'Relate SCOTs',
		errorMessage: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
		scotsHeader: 'SCOTs',
		relatedScotsHeader: 'Related SCOTs',
		noSCOTImpactedByEstimate: 'Create or relate a SCOT when the Account is impacted by an embedded estimate.',
		noSCOTNotImpactedByEstimate: 'Each significant account or disclosure must be related to at least one SCOT. Create a {0} or {1} to get started.',
		noSCOTImpactedByEstimateNoKnowledge: 'The account is impacted by an estimate. For embedded estimates, we identify the SCOT within which the estimate is embedded.',
		estimateHeader: 'Estimate category',
		noEstimateMessage:
			"Each significant account or disclosure impacted by an estimate must be related to at least one higher or lower risk estimate. Click 'Go to source' to relate an estimate to this significant account or disclosure.",
		lowerRisk: 'Lower risk',
		higherRisk: 'Higher risk',
		validations: 'Validations',
		showOnlyValidations: 'Show only accounts with validations'
	},
	mapPSPOSPToRiskByAccount: {
		accounts: 'Accounts',
		searchAccounts: 'Search accounts',
		noAccountSelected:
			'Select a significant account or disclosure or limited risk accounts to view the associated ROMMs and Procedures',
		noAccountsAvailableOnSearch: 'No results found'
	},
	scotRisks264: {
		noRelatedRisks: 'No related ROMMs',
		scotNotAvailableMessage: 'SCOTs are not available for this document',
		noRelatedScotMessage: 'No related SCOT. Relate a SCOT from the attributes page to get started.',
		risksTableHeader: 'ROMMs',
		removeCellLabel: 'Remove',
		knowledge: 'Knowledge',
		newRisk: 'New ROMM',
		relateRisk: 'Relate ROMMs',
		yes: 'Yes',
		noDataFound: '-'
	},
	scotRisks286: {
		riskLabel: 'ROMMs',
		noResultsMessage: 'No results found'
	},
	//Relate Risk Control
	relateRiskControlHeader: 'Relate ROMMs',
	relateRiskTableHeader: 'ROMMs',
	relateRiskCountHeader: '{0} ROMMs',
	relateRiskCheckboxDisabledHoverLabel: 'ROMM cannot be unrelated from the process step',
	knowledgeIconTitle: 'ROMM sourced from knowledge',
	knowledgeIconScotsTitle: 'Scot is sourced from knowledge',
	knowledgeIconRisksTitle: 'ROMM sourced from knowledge',
	knowledgeITRiskIconToolTip: 'Sourced from knowledge',
	knowledgeIconTechnologyTitle: 'Technology sourced from knowledge',
	estimateRiskBadgeTitle: 'Entity-specific ROMM sourced from SCOT',
	riskNotRelatedToAnyAccount: 'ROMMs not related to any account',
	allRisksHaveAccountRelationship: 'All ROMMs have account relationships',

	accountsRelatedToThisSCOT: 'Accounts related to this SCOT',
	accountsNotRelatedToThisSCOT: 'Accounts not related to this SCOT',
	noUnRelatedAccounts: 'No unrelated accounts',
	noAccountsSelected: 'No accounts selected',
	noAccountsSelectedInterimPlaceholder: 'No accounts have been selected.{selectAccounts}to get started.',
	interimDateColumnHeader: 'Interim date',
	interimDateSelectLabel: 'Select date',
	accountsColumnHeader: 'Accounts',
	accountsLabel: 'accounts',
	filterByAccounts: 'Filter by account',

	bodyUnavailableInCCP: 'This content is not available via EY Canvas Client Portal.',
	pyBalance: 'PY balance',
	cyBalance: 'CY balance',
	designationNotDefined: 'Designation not defined',
	controlRisk:'Control risk',
	designAndImplementation: 'Design and implementation',
	controlRiskAssessment: 'Control risk assessment',
	first: 'First',
	noImportedTrialBalance: 'No imported trial balance.',
	leadSheetnoImportedTrialBalance: 'No imported trial balance. Click EY Helix connections to relate a new analyzer.',
	placeHolderMessageWhenHelixMappingIsTrue: ' Click {0} to relate a new analyzer.',
	documentPrintSuccess: 'Document print in progress. It may take up to ten minutes. Once completed, the print will be added to the temporary files.',
	documentExportSuccess: 'Document export in progress. It may take up to ten minutes. Once completed, the export will be added to the temporary files.',
	documentPrintError: 'Document failed to print. Please refresh and try again. If issue persists, please contact the Help Desk.',
	backToEvidenceWarningMessage: 'This action could not be completed. Please refresh and try again. If issue persists, please contact the Help Desk.',
	rationaleMissingForLR: 'Each limited risk account shall have a rationale provided',
	rationaleMissingForIR: 'Each insignificant account shall have a rationale provided',
	craSummaryText2: ' Each account shall have designation determined. Click  ',
	contentDrivingEntity: 'Content driving entity',
	contentDrivingEntityPlaceholder: 'Content driving entity has not been selected',
	rationaleForPlaceholder:
		'Document in the text box the process by which transactions are initiated, recorded, processed, and reported, including types and volumes of transactions',
	limitedRiskRationaleLabel: 'Understanding of the related flow of transactions',
	contentDrivingEntityRequired: 'Content driving entity (required)',
	refreshContentLayers: 'Refresh content layers',
	noAccessLabel: 'Unauthorized. Contact your administrator and try again.',
	copyForHelpDeskDetails: 'Copy for Help Desk details',
	copyForHelpDeskDetailsSuccess: 'Details copied to clipboard',

	//toast activity as guest user
	sharedGuidedworkflowEvidenceWarning:
		'This is a shared Guided Workflow Activity. The objects and evidence exist in the original engagement and will not be added to this engagement upon unlink. See <a style="color: #467cbe" href="https://live.atlas.ey.com/#library/104?pref=20058/9/5" target="_blank">enablement here</a> for further details.',
	sharedGuidedworkflowResponseWarning:
		"This is a shared Guided Workflow Activity. The responses are being shared with other activities in the same workspace. View relationships by accessing the 'Show relationships' menu item from this activity's summary section.",
	notShared: 'Not shared',
	notSharedTooltip: 'Responses to this question will not be shared and must be completed in each individual form',
	selectMaxCompare: 'Select maximum number of documents to compare',
	selectCompareAlert: 'Maximum number of documents have been selected',
	reset: 'Reset',
	estimatesTxt: 'Estimates',
	estimatesNotAvailableForDoc: 'Estimate is not available for this document',
	noEstimateFound: 'No estimate available',
	noRelatedTechnologies227: 'No related technologies.',
	scotsNotAvailable: 'SCOTs are not available for this document',
	noRelatedScots: 'No related SCOT. Relate a SCOT from the attributes page to get started.',
	noRelatedTechnologyToSCOT: 'No technologies are related to this SCOT. Click<span>&nbsp;{relateTechnologyLink}&nbsp;</span>to get started',
	noRelatedSOToSCOT: 'No service organizations are related to this SCOT. ',
	relateSOLink: 'Click<span>&nbsp;{relateSOs}&nbsp;</span>to get started',
	relateSOs: 'Relate SOs',
	newSOs: 'New SO',
	manageSOs: 'Manage SOs',

	noRelatedTechnologiesProcessStepGuest: 'No technologies are related to this process step.',
	noRelatedTechnologyToSCOTGuest: 'No technologies are related to this SCOT.',
	noRelatedSOsProcessStepGuest: 'No service organizations are related to this process step.',
	noRelatedSOToSCOTGuest: 'No service organizations are related to this SCOT.',

	cfcRelatedSOs235: {
		noRelatedSO: printLabels.noRelatedSO
	},
	cfcViewMetadata: {
		placeholderText: 'No information available.',
		objectNotAvailableMessage: 'Process Steps are not available for this document',
		noRelatedObjectMessage: 'No related Process Steps. Relate a Process Step from the attributes page to get started.'
	},
	cfcRelatedRisks233: {
		noRelatedROMMs: 'No related ROMMs.',
		objectNotAvailableMessage: 'Process steps are not available for this document',
		noRelatedObjectMessage: 'No related process steps. Relate a process step from the attributes page to get started.',
		risksTableHeader: 'ROMMs'
	},
	bodyPlaceholder234: 'No related technologies.',
	noRelatedTechnologies: 'No technologies are related to this process step. Click <span>{relateTechnologyLink} </span> to get started.',
	processStepNotAvailable: 'Process steps are not available for this document',
	noRelatedProcessSteps: 'No related process steps. Relate a process step from the attributes page to get started.',
	noRelatedSOs: 'No service organizations are related to this process step. ',
	relateServiceOrganization: 'Relate service organizations',
	relateServiceOrganizationLink: 'Relate service organizations',
	serviceOrganizations: 'Service organizations',
	relateServiceOrganizationHeader: 'Relate service organizations',
	serviceOrganizationsCounter: '{0} service organizations',
	serviceOrganizationCounter: '{0} service organization',
	sosCounter: '{0} SOs',

	estimateSummarySpecialBody: {
		noEstimatesMessage: 'No estimates available',
		noResultsFound: 'No results found',
		estimateName: 'Estimates',
		estimateCategory: 'Category',
		relatedAccounts: 'Accounts',
		technology: 'Technologies',
		sos: 'SOs',
		notes: 'Notes',
		considerations: 'Other Observations',
		signOff: 'Sign-offs',
		signOffView: 'Sign-off view',
		documentNoResultFound: 'No related documents',
		romms: 'ROMMs',
		estimateCountTitle: 'Estimates',
		higherRiskEstimatesTitle: 'Higher risk estimates',
		estimatesWithOtherConsiderationsTitle: 'Estimates with observations',
		estimatesWithROMsWithSignificantJudgement: 'Estimates with potential ROMMs requiring explanation',
		estimateCategoryLabel: 'Estimate category',
		relatedAccountsLabel: 'Related accounts',
		guidedWorkflowLabel: 'Guided workflow',
		noResultsFoundPlaceholder: 'No records found',
		noRelatedAccountsPlaceholder: 'None',
		relatedTechnologies: 'Related Technologies',
		technologies: 'Technologies',
		relatedSOs: 'Related SOs',
		serviceOrganizations: 'Service organizations',
		relatedRomms: 'Related ROMMs',
		signJudgementColumn: 'Potential ROMMs requiring explanation',
		signJudgement: 'Related Potential ROMMs requiring explanation',
		signJudgementTableTitle: 'Potential ROMMs',
		signJudgementTypes: 'Likelihood/Magnitude',
		rationale: 'Rationale',
		signJudgementDescription: 'Below are the risks of misstatement with significant judgment and the procedures performed and evidence obtained, beyond inquiry, to support our assessment of likelihood and magnitude including the following: a) whether there is a reasonable possibility that a misstatement will occur, without consideration of relevant controls, and the qualitative factors that we considered, b) Whether the potential misstatements could be material to the financial statements individually or in aggregate, if they were to occur, and how the maximum of potential misstatement was determined, or c) other risk assessment procedures performed and evidence obtained beyond inquiry to confirm our assessment of magnitude and likelihood including data enabled risk assessment procedures.'
	},

	accountLeadsheetPlaceholder: 'Integration with EY Helix is not available. Refresh the page and try again. If the issue persists, contact the Help Desk',

	tickmarksModal: {
		title: 'New tickmark',
		editTitle: 'Edit tickmark',
		addButton: 'Add tickmark',
		cancelButton: 'Cancel',
		saveButton: 'Save and Close',
		placeholder: 'Enter tickmark details below and select <b>\'Save and close\'</b> to finish. To create another tickmark, select <b>\'Save and create another\'</b>.',
		editPlaceholder: 'Edit tickmark details below and select <b>\'Save and close\'</b> to finish.',
		contentLabel: 'Tickmark content',
		inputTextPlaceholder: 'Index (required)',
		description: 'Description (required)',
		descriptionMaxLengthError: 'Description length exceeded maximum allowed length',
		saveAndCreateAnother: 'Save and create another',
		requiredErrorMessage: 'Required'
	},

	technology: 'Technology',
	itgcs: 'ITGCs',
	itsp: 'ITSPs',
	newTechnology: 'New technology',
	relateTechnology: 'Relate technology',
	relateTechnologies: 'Relate technologies',
	relateTechnologyLink: 'Relate technology',
	KnowledgeTechnology: 'Knowledge',
	higherROMMs: 'All Higher ROMMs',
	assertionsLabel: 'Assertions',
	rejectedPSPsLabel: 'Rejected',
	acceptedPSPsLabel: 'Accepted',
	OSPsLabel: 'OSPs',
	TOCsLabel: 'TOCs',
	limitedRiskAccountLabel: 'Limited risk account',
	auditPlanSummarySignificantAccounts: 'Significant accounts',
	searchByAccountsAndDisclosure: 'Search by accounts and disclosures',
	assertionsRelevantForTheAccountLabel: 'Assertions relevant to the account',
	assertionsRelevantForTheROMMLabel: 'Assertions relevant to the ROMM',
	analysisPeriodBalance: 'Analysis Period',

	/*OrphanedRisks*/
	orphanedRisks: 'View unrelated ROMMs',
	orphanedRisksModalHeader: 'Unrelated ROMMs',
	unRelatedOrphanRisks: 'Unrelated ROMMs must be related to an assertion or deleted.',
	noOrphanedRisksDataLabel: 'No unrelated ROMMs available',
	noOrphanedRisksResultLabel: 'No unrelated ROMMs available',
	noRiskSelected: 'At least one ROMM must be selected for deletion.',
	risksDeleteConfirmation: 'Are you sure that you want to delete the selected ROMMs?',
	riskDeleteConfirmationSingle: 'Are you sure that you want to delete the selected ROMM?',
	deleteRiskModalHeader: 'Confirm deletion of selected ROMM',
	deleteRisksModalHeader: 'Confirm deletion of selected ROMMs',

	accountDrawerTabsLabels: [
		{ id: 0, label: 'View by control' },
		{ id: 1, label: 'View by ROMM' }
	],
	accountDrawerHeaderLabels: {
		relateControlsLabel: 'To relate controls to an account,',
		relateControlsLinkText: ' click here'
	},
	viewControlSummaryLinkLabel: 'View control summary',
	noROMMsIdentified: 'No ROMMs have been identified',
	risksIconR: 'R',
	searchAccounts: 'Search',
	ineffectiveDesign: 'Ineffective design',
	ineffectiveOperation: 'Ineffective operation',
	designHeader: 'Design',
	operationHeader: 'Operation',
	knowledge: 'Knowledge',
	openDrawerIconLabel: 'Open drawer',

	manageTechnology: 'Manage technology',
	estimatesNotAvailableForDoc1: 'No technologies available. Select ',
	estimatesNotAvailableForDoc2: ' to relate a technology to the estimate.',
	estimatesRelatedTechnologyNoDataPlaceholder: 'No technology related to the estimate',
	estimatesRelatedSONoDataPlaceholder: 'No service organization related to the estimate',
	estimatesRelatedROMMNoDataPlaceholder: 'No ROMMs related to the estimate',
	estimateTechnology: 'Technology',
	estimateType: 'Type',
	applicationTool: 'Application/Tool',
	database: 'Database',
	network: 'Network',
	operatingSystem: 'Operating system',
	serviceOrganization: 'Service organizations',
	entitySpecificROMMs: 'ROMMs',
	entitySpecificROMMsCounter: '{0} ROMMs',
	entitySpecificROMMCounter: '{0} ROMM',
	newROMM: 'New ROMM',
	manageROMMs: 'Manage ROMMs',
	relateROMMs: 'Relate ROMMs',
	uncategorized: 'Uncategorized',
	formattingDisabled: 'Header formatting not supported in table cells',
	proceduresHeader: 'Procedures',
	procedureLabel: 'Procedure',
	substantiveProcedures: 'Substantive procedures',
	identifyITGCsTabsLabels: [
		{ id: 0, label: 'View by technology' },
		{ id: 1, label: 'View by ITGC' }
	],
	identifyITSPsTabsLabels: [
		{ id: 0, label: 'View by technology' },
		{ id: 1, label: 'View by ITSP' }
	],
	SOCDOnboardITTabsLabels: [
		{ id: 0, label: 'View by technology' }
	],
	controlIdentifyControlsTabsLabels: [
		{ id: 0, label: 'ROMMs that require controls' },
		{
			id: 1, label: 'All other ROMMs'
		}
	],
	controlIdentifyControlsRelatedROMMLabel: 'Related ROMMs',
	controlIdentifyControls: {
		rommFilterLabel: 'ROMMs that require controls',
		relatedControlsLabel: 'Related control',
		relatedControlsSearchPlaceholderText: 'Search controls',
		rommTypeFilterLabel: 'ROMM type',
		rommTypeFilterOptions: [
			{ value: riskTypeFilters.significantRisk, label: 'Significant' },
			{ value: riskTypeFilters.fraudRisk, label: 'Fraud' },
			{ value: riskTypeFilters.higherInherentRisks, label: 'All higher ROMMs' }
		],
		clearFilter: 'Clear filter',
		filters: 'Filters',
		clearAll: 'Clear all'
	},
	selectTechnologyForRisksITGCs: 'Select a technology to view details',
	selectTechnologyForRisksITSPs: 'Select a technology to view details',
	selectTechnologyDefaultMessage: 'Select a technology to view details',
	selectTechnologyForSOCDOnboardIT: 'Select a technology to view details',
	selectITGCForRisksITGCs: 'Select an ITGC to view details',
	selectITGCForRisksITSPs: 'Select an ITSP to view details',
	placeholderForSearchTechnology: 'Search technology',
	placeholderForSearchITGC: 'Search ITGCs',
	placeholderForSearchITSP: 'Search ITSPs',
	newSO: 'New SO',
	relateSO: 'Relate SOs',
	manageSO: 'Manage SOs',
	serviceOrganization252: 'Service organizations',
	noSmartEvidenceSource: 'No related object. Relate an object to get started.',
	noRelatedSOPart1: 'No service organizations are available. Select ',
	noRelatedSOPart2: ' to relate a service organization to the estimate.',
	noRelatedROMMsPart1: 'No ROMMs are available. Select ',
	noRelatedROMMsPart2: ' to relate a ROMM to the estimate.',
	responsiveHeader: 'Responsive',
	taskCounterHeader: 'PSPs/OSPs',
	controlsCounterHeader: 'Controls',
	tocsCounterHeader: 'TOCs',
	oneUnrelatedControlTitle: 'There is 1 unrelated control',
	unrelatedControlsTitle: 'There are {0} unrelated controls',
	unrelatedControlsDescription: "All controls must be related to a ROMM. Relate these controls to a ROMM or select 'Show unrelated controls' to review and delete them.",
	showUnrelatedControls: 'Show unrelated controls',
	oneReferenceControlWithoutROMMTitle: 'There is 1 reference control not related to a ROMM',
	referenceControlsWithoutROMMTitle: 'There are {0} reference controls not related to a ROMM',
	referenceControlsWithoutROMMDescription:
		"All reference controls must be related to a ROMM. Select 'Manage reference controls' to review and either relate these reference controls to a ROMM or delete them.",
	manageReferenceControls263: 'Manage reference controls',
	referenceControlsWithoutROMMModalPlaceholder: 'Edit and delete existing reference controls below.',

	// Without technology or service organization
	oneNoTechnologySOControlTitle: 'There is 1 control without a related technology or service organization',
	noTechnologySOControlsTitle: 'There are {0} controls without a related technology or service organization',
	noTechnologySOControlsDescription: "IT application controls and IT dependent manual controls must have a related Technology or Service Organization. Select 'Show controls' to review and modify them.",
	showNoTechnologySOControls: 'Show controls',

	// Orphaned ROMMs
	unrelatedROMMsTitle: 'There are {0} ROMMs that are not related to an account.',
	unrelatedROMMsDescription:
		"All ROMMs must be related to an account. Relate these ROMMs to an account or select 'Show unrelated ROMMs' to review and delete them.",
	showUnrelatedROMMs: 'Show unrelated ROMMs',
	unrelatedROMMsModalDescription:
		'Review the list of unrelated ROMMs in the engagement and delete any that are not required. To relate any of these ROMMs, select cancel to go back.',
	unrelatedROMMsModalHeader: 'Unrelated risks of material misstatement',
	noROMMSelected: 'At least one ROMM must be selected for deletion.',
	deleteROMMsModalHeader: 'Confirm deletion of selected ROMMs',
	deleteROMMsModalMessage: 'Are you sure that you want to delete the selected ROMM(s)?',
	deleteRiskKnowledgeMessage: 'Standard ROMMs cannot be deleted and must be related to the relevant SCOT or Estimate.',

	/*OrphanedControls*/
	unrelatedControlsModalDescription: 'Unrelated controls must be related to a ROMM or deleted.',
	unrelatedControlsModalHeader: 'Unrelated controls',
	noControlSelected: 'At least one control must be selected for deletion.',
	deleteControlModalHeader: 'Delete controls',
	deleteControlModalMessage: 'Are you sure that you want to delete the selected control(s)? This action cannot be undone.',
	// Technologies - Identify ITGCs - View by technology's
	itRisks: 'IT risks',
	itGCs: 'ITGCs',
	itValidations: 'Validations',
	technologyInfoCardLabel: 'Technology',
	associatedRisks: '',
	noRisksIdentifiedMessage: 'No results found',
	itRiskIconLabel: 'IT',
	oeChipLabel: 'OE',
	fromOtherEngagements: 'From other engagements',
	refChipLabel: 'Ref.',
	refLabel: 'Ref',
	referencedFromOtherSources: 'Referenced from other sources',
	noITGCsRelatedMessage: 'All identified IT risks must have at least one related ITGC or a designation that the IT risk has no ITGCs.',
	noITGCsMitigatesCheckMessage: 'No ITGC mitigates this IT risk',
	noITGCsMitigatesFromOtherEngagementsCheckMessage: 'No reference ITGC mitigates this IT risk',
	noITGCsMitigatesInThisEngagementCheckMessage: 'No ITGC mitigates this IT risk',
	noITGCFromOtherEngagementsMitigatesCheckMessage: 'No reference ITGC mitigates this IT risk',
	newITGCOption: 'New ITGC',
	relateITGCOption: 'Relate ITGCs',
	manageITGCsLinkLabel: 'Manage ITGCs',
	manageITGCsInThisEngagementLinkLabel: 'Manage ITGCs',
	manageITGCsFromOtherEngagementsLinkLabel: 'Manage reference ITGCs',
	showOnlyValidations: 'Show only technologies with validations',
	itGCsTableHeaderLabel: 'ITGCs',
	riskControlTypeDisplay: {
		0: { label: 'Not selected', value: 'Not selected' },
		1: { label: 'ITAC', value: 'IT Application Control' },
		2: { label: 'ITDM', value: 'IT Dependent Manual Control' },
		3: { label: 'Manual', value: 'Manual Prevent' },
		4: { label: 'Manual', value: 'Manual Detect' }
	},
	ControlWithDesignEffectivenessNullBannerTitle: 'There are {0} controls without a design effectiveness',
	ControlWithDesignEffectivenessNullBannerOneTitle: 'There is 1 control without a design effectiveness',
	ControlWithDesignEffectivenessNullBannerDescription:
		"All controls must have a design effectiveness conclusion selected. Update the design conclusion after evaluating each control's design. Select 'show controls' to review and modify them.",
	ControlWithDesignEffectivenessNullBannerLinkText: 'Show controls',
	InconsistentRiskDesignationTitle: 'There are {0} controls with inconsistent risk designation',
	InconsistentRiskDesignationOneTitle: 'There is {0} control with inconsistent risk designation',
	InconsistentRiskDesignationDescription: "Lower risk control should not be related to risks designated as higher inherent risk. Select 'Show controls' to review and modify them.",
	ShowControls: 'Show controls',
	InconsistentRiskDesignationModalTitle: 'Controls with inconsistent risk designation',
	InconsistentRiskDesignationModalDescription: 'Update controls with incorrect risk designation.',
	newITGCClickableText: 'new ITGC',
	newReferenceITGCClickableText: 'new reference ITGC',
	relateClickableText: 'relate',
	createRelateITGCMessage: 'Each IT risk must be related to at least one ITGC or designated that the IT risk has no ITGCs. Create a {newITGCClickableText} or {relateClickableText} an existing ITGC.',
	createRelateITGCFromOtherEngagementsMessage: 'Each IT risk must be related to at least one ITGC or designated that the IT risk has no ITGCs. Create a {newReferenceITGCClickableText} or {relateClickableText} existing reference ITGCs.',
	ControlWithDesignEffectivenessNullModalDescription: 'Update controls without design effectiveness.',
	ControlWithDesignEffectivenessNullModalTitle: 'Controls without design effectiveness',

	itControlsWithoutTechSOModalTitle: 'Controls without related technology or service organization',
	itControlsWithoutTechSOModalDescription: 'Update controls without related technology or service organization.',

	// Technologies - Identify ITSPs - View by technology's
	itSPs: 'ITSPs',
	manageITSPsLinkLabel: 'Manage ITSPs',
	newITSPOption: 'New ITSP',
	relateITSPOption: 'Relate ITSPs',
	noITSPsRelatedMessage: `To relate an ITSP, first relate at least one ITGC or designate that the IT risk has no ITGCs. Click 'Go to source' to perform these actions.`,
	noITSPsMitigatesCheckMessage: `No ITGC mitigates this IT risk. If incorrect, click 'Go to source' to change this designation.`,
	identifyITGCsLinkLabel: 'Identify ITGCs',
	newITSPClickableText: 'new ITSP',
	createRelateITSPMessage: 'Each IT risk can be related to one or more ITSPs. Create a {newITSPClickableText} or {relateClickableText} an existing ITSP.',

	//ITGCs - Identify ITGCs - View by ITGC
	supportedTechnologies: 'Supported technologies',
	relateITRiskLinkLabel: 'Relate IT Risk',
	relatedRisksSectionLabel: 'This ITGC is intended to mitigate the following IT risks',
	selectITRiskLabel: 'Relate IT risk',
	removeLabel: 'Remove',
	technologyLabel: 'Technology',
	relateTechnologyLabel: 'Relate technology',
	itgcInfoCardLabel: 'ITGC',
	itspInfoCardLabel: 'ITSP',
	//Go to source
	itSPInfoCardPrefixLabel: 'To edit ITSP, click ',
	itGCInfoCardPrefixLabel: 'To edit ITGC, click ',
	itSPDetailCardPrefixLabel: 'To review entity specific IT risks in this IT process, click ',
	itGCDetailCardPrefixLabel: 'To review entity specific IT risks in this IT process, click ',
	itSPDetailCardWarningPrefixLabel: 'To relate ITGCs to an IT risk, click ',
	clickHereLabel: ' here',
	itProcessNameLabel: 'IT process: ',
	noTechnologiesRelatedMessageClickableText: 'relate',
	noTechnologiesRelatedMessage:
		'Each IT risk must be related to at least one technology. Click to {noTechnologiesRelatedMessageClickableText} an existing technology.',
	manageTechnologiesPrefixLabel: 'To manage technologies, click',
	manageDeficienciesPrefixLabel: 'To manage deficiencies, click',
	toManageAccountsAndDisclosures: 'To manage accounts and disclosures, click',
	toManageRisks: 'To manage ROMMs, click',

	/*Document Controls*/
	refreshDocument: 'Refresh document',

	// Go to psp and osp
	clickToEditSubstantiveProcedure: 'To edit a Substantive procedure, click',
	clickToEditRejectedPSP: 'To edit a Rejected PSP, click',
	clickToEditRomms: 'To edit a ROMM, click',
	clickToManageEntitySpecificRomms: 'To manage entity-specific ROMMs, click',
	clickToManageStandardRomms: 'To manage standard ROMMs, click',
	clickToEditControls: 'To edit a Control, click',

	/* Audit plan view by account (body type 241) */
	significantAccountsWithRejectedPSPs: 'Significant accounts with Rejected PSPs',
	significantAccountsWithOSPs: 'Significant accounts with OSPs',

	/* Audit plan risk listing (body type 242) */
	accountsWithFraudRisks: 'Accounts with fraud risks',
	accountsWithSignificantRisks: 'Accounts with significant risks',
	accountsWithHigherRisks: 'Accounts with other higher risks',

	// Control Testing Validation Warnings
	controlTestingWarning1:
		'At least one control must be identified as being responsive to this risk of material misstatement. Add a {0} or {1} an existing control.',
	controlTestingWarning2:
		'This ROMM is either related to an assertion for which we intend to rely on controls, or a substantive only approach is not sufficient to address this ROMM. At least one control related to this ROMM must be tested. Click {0} to review and update the testing strategy for related controls or {1} other controls.',
	relateControlLabel: 'relate',
	newControlLabel: 'new control',
	addEDCTaskDescription: 'Evaluate the design of the control and conclude on design effectiveness.',
	addWalkthroughTaskSCOTDescription: 'Understand the process of the SCOT',
	addWalkthroughTaskEstimateDescription: 'Understand the process of the Estimate',
	standardRisksLabel: 'Standard risks of material misstatement',
	associateStandardRisksLabel: 'Select Standard ROMM to add entity specific context',
	associateStandardRisksPlaceholder: 'Select Standard ROMM',
	riskOfMisstatementLabel: 'Potential ROMMs',
	newROM: 'New potential ROMM',
	relatedROMMs: 'Related ROMMs',
	romRationaleIsPCAOB: 'Document the basis to support our assessment of likelihood and magnitude, including the following, as applicable:\n \nLikelihood: Whether there is a reasonable possibility that a misstatement will occur, without consideration of relevant controls, and the qualitative factors that we considered.\n\nMagnitude: Whether the potential misstatement(s) could be material to the financial statements individually or in aggregate, if they were to occur, and how the maximum of potential misstatement was determined.\n\nOther risk assessment procedures performed, including risk assessment procedures using automated techniques, and evidence obtained beyond inquiry to make our assessment of magnitude and likelihood.',
	romRationaleIsNotPCAOB: `Select the rationale above that supports our assessment that the process characteristic is not a ROMM considering whether (a) there is no reasonable possibility of a misstatement occurring (i.e., likelihood) and (b) the misstatement is expected to be at or below TE or is not important to users, if it were to occur (i.e., magnitude).\n\nIn performing this assessment, we may consider knowledge obtained during past audits, reviewing source documents, or performing automated techniques.\n\nProvide further context to support the assessment below.`,
	romRationaleLabel: 'Rationale',
	romSubTypeLabel: 'Likelihood/Magnitude',
	romSubTypeLikelihood: 'Likelihood',
	romSubTypeMagnitude: 'Magnitude',
	romSubTypeBoth: 'Both',

	/*RAAT deeplinks*/
	analyzersTableHeader: 'EY Helix Analyzers',
	analyzerModalTitle: 'Click an analyzer for navigation to EY Helix',
	analyzerModalDescription: 'Click an analyzer from the list below to access EY Helix',
	connectionsTableHeader: 'Connections',
	connectionsModalTitle: 'EY Helix Connections',
	connectionsModalDescription: 'Click a connection from the list below to access EY Helix',
	noHelixConnectionsMessage: 'No EY Helix connections have been created. To create one {noHelixConnectionsMessageClickHere}',
	noHelixConnectionsMessageClickHere: 'click here',
	entitiesTableHeader: 'Entities',
	entitiesModalTitle: 'EY Helix Entity Imports',
	entitiesModalDescription: 'Select an entity from the list below to access EY Helix.',

	/*EDC and 263 form Print labels */
	taskTitleSuffix: '{0}: Evaluate the design of the control',
	rommsRequireControls: 'ROMMs that require controls',
	rommsDoNotRequireControls: 'ROMMs that do not require controls',
	allOtherROMMs: 'All other ROMMs',
	riskSubType_9: "AROMM",
	riskSubType_10: "SROMM",
	riskSubType_11: "PRSROMM",

	manageChangeTitle: 'Technology attributes - Manage Change',
	itRiskAttributesSDLCTitle: 'Technology attributes - SDLC',
	craExpandAll: 'Expand all',

	assessInherentRiskNotRelevantBannerTitle: 'Assertion cannot be marked not relevant because of the following:',
	assessInherentRiskNotRelevantSignificantRisk: 'Has a related Significant Risk',
	assessInherentRiskNotRelevantFraudRisk: 'Has a related Fraud Risk',
	assessInherentRiskNotRelevantROMMs: 'Has a related ROMM',
	assessInherentRiskNotRelevantEstimate: 'Has a related estimate',
	addTagLabel: 'Add tags',
	tags: 'Tags',
	noTags: 'No tags',
	leadsheetNotApplicable: "N/A",
	leadsheetPageUnavailable: 'The selected page is no longer available.',
	relateDeficiency: 'Relate deficiency',
	nonCommunication: 'Non-communication',
	relateDeficiencyNoPlaceholder: 'No results found.  Click {relateDeficiency} to get started.',
	relateChildDeficiencyModalTitle: 'Relate deficiencies',
	relateChildDeficiencyModalDescription: 'Select the deficiencies that are caused by this deficiency.',
	relateChildDeficiencyLabel: 'Deficiencies',
	relateChildDeficiencyAddedLabel: 'Related',
	relateParentDeficiencyButton: 'Relate parent deficiency',
	relateParentDeficiencyModalTitle: 'Relate deficiencies',
	relateParentDeficiencyModalDescription: 'Select the deficiencies that caused this deficiency.',
	relateParentDeficiencyLabel: 'Deficiencies',
	relateParentDeficiencyAddedLabel: 'Related',
	deficiency: 'Deficiency',
	deficiencies: 'Deficiencies',
	misstatementsLabel: 'Misstatements',
	noRelatedAssertionsAndRisksLabel: 'No results found. Click Relate controls above to get started.',
	assertionColumnLabel: 'Assertions relevant for the deficiency',
	relateChildDeficiencyButton: 'Relate child deficiency',
	noResultFoundPlaceholder: 'No results found.  Click {0} to get started.',
	fromOtherEngagements: 'From other engagements',

	disabledTooltipDeficient: 'This is the deficient ITGC',
	disabledTooltipCompensating: 'This ITGC is already selected as a compensating control',
	disabledTooltipMitigating: 'This ITGC is already selected as a mitigating control',
	disabledTooltipNotImpacted: 'This ITGC is already selected as "not impacted" by this deficiency',
	disabledTooltipUpstreamDeficiency: 'This is the deficiency we are evaluating. Select one or more deficiencies caused by this deficiency.',
	disabledTooltipRelatedChildDeficiency: 'This deficiency was caused by the deficiency we are evaluating. It cannot be related again here.',
	disabledTooltipRelatedParentDeficiency: 'This deficiency caused the deficiency we are evaluating. It cannot be related again here.',
	recurring: 'Recurring',
	category: 'Category',

	//Account Leadsheet Card (296)
	accountLeadsheetCardNoTrialBalanceDataAvailable: 'No trial balance data available',
	accountIndex: 'Account index',
	accountEstimateIndex: 'Account estimate index',
	accountLeadsheetCardComparativePeriodBalance: 'Comparative period balance',
	accountLeadsheetCardChange: 'Change',
};

export const groupStructure = {
	createComponent: 'New component',
	deleteComponent: 'Delete component',
	manageComponents: 'Manage components',
	emptyComponents: 'No components have been created. Create a {newComponent} to get started.',
	scope: 'Scope',
	role: 'Role',
	pointOfContact: 'Point of contact',
	linkRequest: 'Link request',
	instructions: 'Instructions',
	instructionsSent: 'Instructions Sent',
	status: 'Status',
	createComponentInstructionalText:
		"Enter component details below and select <b>'Save and close'</b> to finish. To create another component, select <b>'Save and create another'</b>.",
	componentName: 'Component name',
	region: 'Region',
	notUsingCanvas: 'Not using EY Canvas',
	referenceOnly: 'Reference only',
	saveAndCreateAnother: 'Save and create another',
	dueDate: 'Due date',
	components: 'Components',
	allocation: 'Allocation',
	documents: 'Evidence',
	discussions: 'Discussions',
	EDAP: 'EDAPs',
	siteVisits: 'Site visits',
	reviewWorkComponent: 'Review work performed',
	other: 'Other',
	significantUpdates: 'Significant updates',
	executionComplete: 'Execution complete',
	gaRoleTypesLabel: [
		{ id: 1, displayName: 'Primary' },
		{ id: 2, displayName: 'Regional' },
		{ id: 3, displayName: 'Component' }
	],
	gaLinkStatusLabel: [
		{ id: GALinkStatus.NotSent, displayName: 'Send' },
		{ id: GALinkStatus.Sent, displayName: 'Sent/Not accepted' },
		{ id: GALinkStatus.ComponentNotUsingCanvas, displayName: 'Not using EY Canvas' },
		{ id: GALinkStatus.ReferenceOnly, displayName: 'Reference only' },
		{ id: GALinkStatus.Accepted, displayName: 'Accepted' },
		{ id: GALinkStatus.Rejected, displayName: 'Rejected' },
		{ id: GALinkStatus.Unlinked, displayName: 'Unlinked' },
		{ id: GALinkStatus.Pending, displayName: 'Sent/Not accepted' }
	],
	notAvailable: 'Not available',
	search: labels.searchPlaceholder,
	noResultsFound: 'No results found.',
	noComponentsFound: 'No components found.',
	contentSwitcher: [
		{ id: gaRoleTypes.primary, displayName: 'Primary' },
		{ id: gaRoleTypes.component, displayName: 'Component' },
		{ id: gaRoleTypes.regional, displayName: 'Region' }
	],
	gaRegionTypesLabel: { id: gaRegion.notApplicable, displayName: 'Not applicable' },
	//TODO: To be removed
	pointOfContactValues: [
		{ id: pointOfContactTypes.EYcontact, displayName: 'EY Contact' },
		{ id: pointOfContactTypes.externalContact, displayName: 'External contact' }
	],
	saveAndClose: labels.modalSaveAndClose,
	cancelBtn: labels.modalCancelTitle,
	gaScopesValues: [
		{ id: gaScopeType.primaryTeam, displayName: 'Primary team' },
		{ id: gaScopeType.full, displayName: 'Full' },
		{ id: gaScopeType.specific, displayName: 'Specific' },
		{ id: gaScopeType.specifiedAuditProcedures, displayName: 'Specified procedures' },
		{ id: gaScopeType.review, displayName: 'Review' }
	],
	edit: labels.edit,
	delete: labels.delete,
	tooltipIcon: 'Select this option if the component is not using EY Canvas to receive Group audit instructions and submit interoffice deliverables.',
	tooltipReferenceIcon:
		'Components designated as <b>Reference only</b> are used for organizational purposes only. These component engagements will not receive link requests, instructions or tasks and this primary team engagement will also not receive a group task.',
	modalCancelBtnLabel: labels.cancelLabel,
	modalCloseBtnTitletip: labels.closeLabel,
	modalConfirmBtnLabel: labels.confirmLabel,
	clear: 'clear',
	clearUpper: labels.clear,
	nameOrEmail: 'Enter EY point of contact email',
	editComponent: 'Edit component',
	editComponentInstructionalText: "Edit component details below and select <b>'Save'</b> to finish.",
	linkAlreadyAcceptedInfo: 'Only the email field can be edited as the link request has already been sent to the Component team.',
	sendAll: 'Send all',
	send: 'Send',
	resend: 'Resend',
	scopeAndStrategy: 'Scope & strategy',
	execution: 'Execution',
	conclusion: 'Conclusion',
	reportingForms: 'Reporting Forms',
	manageGroupPermission:
		'You do not have the <b>Manage group</b> permission to take this action. Request the <b>Manage group</b> permission from an Engagement Administrator.',
	manageComponentModalDesc: 'Create new components or edit and delete existing components below.',
	editLinkInfo: 'Only the email field can be edited as the link request has already been sent to the Component team.',
	invalidPointOfContact: 'A point of contact is needed in order to send the link request. Edit component to add a point of contact.',
	manageComponentModalActions: 'Actions',
	manageComponentModalComponents: 'Components',
	manageComponentModalDelete: 'Delete',
	noThereAtLeastOneComponentToSendAll:
		'There are no components with eligible statuses to send a link request. The status of a component must be <b>Send</b> or <b>Resend</b> in order to send a link request.',
	showKnowledgeDescription: 'Show title and description from Knowledge',
	hideKnowledgeDescription: 'Hide title and description from Knowledge',
	instructionName: 'Enter instruction name',
	instructionDescriptionPlaceholder: 'Enter instruction description',
	selectDueDate: 'Due date (required)',
	show: 'Show',
	allocationHeader: 'Allocation',
	allocationInstructionForKnowledge: 'Knowledge instructions can only be allocated by scope. Select the relevant scope(s) below.',
	allocationInstructionForCustom:
		'Custom instructions can be allocated by scope or by component. Select the instruction allocation below, then allocate to the relevant scope(s) or component(s).',
	allocateScope: 'Allocate to scopes',
	allocateComponent: 'Allocate to components',
	pillScopesPlural: 'scopes',
	pillScopesSingular: 'scope',
	pillComponentsPlural: 'components',
	pillComponentsSingular: 'component',
	selectScopesPlaceholder: 'Select scopes',
	selectComponentsPlaceholder: 'Select components',
	searchNoResultFoundText: labels.searchNoResultFoundText,
	newCustomInstruction: 'New custom instruction',
	instructionNameNewCustomInstruction: 'Instruction name',
	addCustom: 'Add custom',
	custom: 'Custom',
	required: 'Required',
	remove: 'Remove',
	selectAll: 'Select all',
	unselectAll: 'Unselect all',
	lowerPoC: 'point of contact',
	editPoCTooltip: 'Invalid or no point of contact. Edit point of contact in order to send a link request.',
	recomendationType: [
		{
			id: 1,
			label: 'Required'
		},
		{
			id: 2,
			label: 'Optional'
		},
		{
			id: 3,
			label: 'Not applicable'
		}
	],
	confirmLabel: labels.confirmLabel,
	deleteComponentInstructionalText:
		'<b>Are you sure that you want to delete this component from the Group structure?</b><br />When the component is deleted, the link to the component will be removed and the engagements will no longer be able to exchange documentation. Additionally, all associations between the component and its accounts and instructions will be deleted.',
	noActivitiesAvailable: 'No activities available.',
	relatedComponents: 'Related components',
	relatedComponentsSingular: 'related component',
	relatedComponentsPlural: 'related components',
	publish: 'Publish',
	publishModalHeader: 'Publish changes',
	publishChangesInstructional:
		'<b>Are you sure that you want to publish changes to the group instruction summary?</b><br />The previous set of group instructions will be overwritten.  Once the changes are published, the updated instructions can be sent from the group instruction summary.',
	publishManageGroupPermission: 'You must have the Manage group permission to take this action. Request permission from an Engagement Administrator.',
	lastPublished: 'Last published:',
	publishChangesNotAvailable: 'Not available yet',
	noRecordsFound: labels.noRecordsFound,
	deleteInstruction: 'Delete instruction',
	deleteInstructionInstructionalText: '<b>Are you sure that you want to delete the instruction? </b><br />This action cannot be undone.',
	sendInstructionsTitle: 'Send instructions',
	sendInstructionsInstructionalText:
		"Ensure the latest instructions have been published by clicking 'Publish' on the underlying page. Then, review the component's instructions below and select 'Send' to send the instructions to the component engagement.",
	instructionsAlreadySent: 'The latest version of instructions have already been sent.',
	missingDueDates: 'Reporting form due date missing.',
	createInstructionsModalButton: 'Create instructions',
	createInstructionsModalActionToastMessageStart: 'Group risk assessment instructions are missing for ',
	createInstructionsModalActionToastMessageEnd: ' components.',
	createInstructionsModalDescription:
		'The following Full and Specific scope components do not have Group risk assessment instructions allocated to them. Selecting <b>Create</b> will create a Group risk assessment instruction for each component listed below.',
	createInstructionsModalScope: ' Scope',
	createInstructionsModalHeader: 'Create instructions',
	createInstructionsModalmodalConfirmBtnLabel: 'Create',
	createInstructionsModalmodalCancelBtnLabel: 'Cancel',
	createInstructionsModalmodalCloseBtnTitletip: 'Close',
	createInstructionsModalNewGraInstructionDescription:
		'Enclosed is the risk assessment for accounts relevant for your component.  Review the risk assessment and ensure that your engagement has those accounts and ROMMs identified.  Any additional ROMMs that are identified locally or where the component team does not agree should be communicated with the primary team so that the risk assessment can be adjusted by both the primary team and component team accordingly.',
	createInstructionsModalErrorMessage:
		'Group risk assessment instruction creation failed for the following components: <b>{0}</b>. Please refresh the page and try again.',
	createInstructionsDuplicatedModalErrorMessage: 'Group risk assessment instruction creation failed. Instruction name cannot be duplicated.',
	gaLinkActionTooltip: {
		NotUsingCanvasLabel: 'Not using EY Canvas',
		NotUsingCanvas: 'Clicking <b>Send</b> will create the Primary <br/> Group tasks for this component but <br/> no instructions will be sent.',
		NotLinkedLabel: 'Not linked',
		NotLinked: 'The link request has not been sent to <br/> the Component team. Send the link <br/> request in order to send instructions.',
		Unlinked: 'Unlinked'
	},
	viewHistory: 'View history',
	viewSentInstructionsTitle: 'View sent instructions',
	save: labels.saveLabel,
	cancel: labels.cancelLabel,
	viewHistoryInstructionalText: 'Select instruction to view previous version(s) of instructions sent to the Component team.',
	viewHistorySelectInstruction: 'Select instruction',
	viewHistoryDateSent: 'Date sent: ',
	viewHistoryStatus: 'Status: ',
	viewHistoryStatusAccepted: 'Accepted',
	viewHistoryStatusPending: 'Pending',
	viewHistoryStatusRejected: 'Rejected',
	viewHistoryStatusSystemError: 'System error',
	viewHistorySelectVersion: 'Select version',
	noAccountsFound:
		'No accounts or disclosures have been found in this or other engagements. <br />Select {link} to create new or edit existing accounts or disclosures.',
	generalCommunications: 'General communications',
	reportingDeliverables: 'Reporting deliverables',
	changesPublishedNotSent: 'Changes not sent',
	changesPublishedBrNotSent: 'Changes<br/>not sent',
	changesPublishedNotSentYes: 'Yes',
	deleteSubScopeInstructionalTextModal: 'Are you sure that you want to delete <br/> the selected sub-scope?',
	deleteSubScopeTitleModal: 'Delete sub-scope',
	riskAssessmentModal: {
		headerText: 'Risk assessment',
		modalCloseBtnTitletip: labels.close,
		manageAndDisclosures: 'Manage accounts & disclosures link',
		next: 'Next component',
		back: 'Previous component'
	},
	riskAssessment: 'Risk assessment',
	preview: 'Preview',
	accountsAndDisclosureSummary: 'Account and disclosure',
	noAccountSnapshotPlaceholder: 'There is no account data to display for this component.',
	createOversightProjectButtonLabel: 'Create EY Canvas Oversight project',
	createOversightProjectTitle: 'Do you want an EY Canvas Oversight project to be created with this primary engagement?',
	createOversightProjectDescription:
		'Regional and/or component EY Canvas engagement(s) identified in this group structure will automatically be populated as part of the EY Canvas Oversight project setup.',
	createOversightModalHeader: 'EY Canvas Oversight project name',
	createOversightModalDescription: 'Enter the name of the EY Canvas Oversight project.',
	createOversightModalTextLabel: 'Project name',
	projectRedirectionButtonLabel: 'EY Canvas Oversight projects',
	projectAssociationTextLabel: 'There are EY Canvas Oversight projects connected to this engagement.',
	sendLinkDisableTooltip:
		'This engagement was copied, including components in the Group audit flow. Links cannot be re-sent. Create a new component and send a link, as necessary.',
	instructionsCannotBeSentUntilPublished: 'Instructions cannot be sent until they are published.',
	userSearchLabels: {
		emailForExternal: labels.emailForExternal,
		inValidEmail: labels.inValidEmail,
		noRecord: labels.noRecord,
		clearAllValues: labels.clearAllValues,
		userSearchPlaceholder: labels.userSearchPlaceholder,
		userSearchPlaceholderForExternal: labels.userSearchPlaceholderForExternal,
		required: labels.required,
	}
};

export const groupInvolvement = {
	NoComponentsAvailables: 'No component has been created. <b>Manage components</b> to get started.',
	GroupInvolvementToastMsgStart: 'Group involvement form is missing for ',
	GroupInvolvementToastMsgEnd: ' component(s).',
	CreateGroupInvolvementHeader: 'Create involvement form(s)',
	GroupInvolvementInstructionalText:
		'The following component(s) do not have Group involvement form(s) allocated to them.<br/> Selecting &#39;<b>Create</b>&#39; will create a Group involvement form for each component listed below.',
	createGroupInvolvementDocumentErrorMessage:
		'Group involvement document creation failed for the following components: <b>{0}</b>. Please refresh the page and try again.',
	createGroupInvolvementDocumentSuccessMessage: 'Group involvement form(s) created successfully. Refresh page in 30 seconds to see available documents.',
	involvementTypePlanned: 'Involvement type planned',
	significantUpdatesToPlannedInvolvement: 'Significant updates to planned involvement',
	executionComplete: 'Execution complete',
	generateGroupInvolvementCommunications: 'Print involvement form(s)',
	generateGroupInvolvementInstructionalText:
		'The following component(s) have Group involvement form(s) associated to them. Select which component&#39;s group involvement forms to be included in one document below.<br /><br /> Once the components have been selected, selecting <b>&#39;Create&#39;</b> will create one Group involvement document with each component&#39;s group involvement document listed below.',
	componentTeams: 'Component teams',
	noComponentsSelectedErrorMessage: 'Select components to create a Group involvement communication.',
	invalidTaskIinfo: 'Invalid task information.',
	documentName: '{taskName} group involvement package',
	selectAll: groupStructure.selectAll,
	unselectAll: groupStructure.unselectAll,
	modalConfirmBtnLabel: groupStructure.createInstructionsModalmodalConfirmBtnLabel,
	modalCancelBtnLabel: groupStructure.cancelBtn,
	modalCloseBtnTitletip: groupStructure.modalCloseBtnTitletip
};

export const signJudgementTypesName = {
	14: 'Likelihood',
	15: 'Magnitude',
	16: 'Both',
};

export const itPlanning = {
	supportingITColumnsHeaders: {
		applicationTool: {
			name: 'Applications/Tools'
		},
		network: {
			name: 'Networks'
		},
		database: {
			name: 'Databases'
		},
		operatingSystem: {
			name: 'Operating systems'
		}
	},
	relatedITProcessesColumnsHeaders: {
		relatedITProcess: 'IT Processes',
		category: 'Category'
	},
	itPlanningPlaceholders: {
		smartEvidenceSourceEntityId: 'Related technology not available for this document',
		smartEvidenceSourceId: 'No related object. Relate an object to get started.'
	},
	relatedITProcessesPlaceholders: {
		smartEvidenceSourceEntityId: 'Related technology not available for this document',
		smartEvidenceSourceId: 'No related object. Relate an object to get started.',
		relatedITProcessEmpty: 'No related object. Relate an object to get started.'
	},
	itProcessCategories: {
		manageChange: 'Manage Changes',
		manageAccess: 'Manage Access Rights',
		manageITOperations: 'Manage IT Operations',
		manageSecuritySetting: 'Manage Security Settings',
		manageSystemImplementation: 'Manage System Implementations'
	},
	itRiskITProcessCategories: {
		manageChange: 'Manage changes',
		manageAccess: 'Manage access rights',
		manageSecuritySetting: 'Manage security settings',
		manageITOperations: 'Manage IT operations',
		manageSystemImplementation: 'Manage system implementation​s'
	},
	confirmChangesModal: {
		title: 'Confirm changes',
		body: 'Editing the technology might impact responses and procedures in your workpapers. Do you want to continue?',
		cancel: 'Cancel',
		continue: 'Continue'
	},
	goToSourceItems: {
		toIdentifyEstimates: 'To identify Estimates, click',
		toIdentifyScots: 'To identify SCOTs, click',
		toIdentifyTechnologies: 'To identify technologies, click',
		toManageControls: 'To manage controls, click',
		toManageItgcsThisTechnologySupports: 'To manage ITGCs, click',
		toEditTheTechnology: 'To edit the technology, click',
		toModifyOtherScopingInformation: 'To modify other scoping information, click',
		linkText: 'here'
	},

	noTechnologiesIdentified: 'No technologies have been identified',
	noRelevantITApplicationFound: 'No relevant IT application found.',
	noRelevantITApplicationFoundPart1: 'Go to ',
	noRelevantITApplicationFoundPart2: ' to identify relevant IT applications.',
	itScopeAndStrategy: 'IT scope & strategy',
	fromOtherEngagements: 'Reference IT risks',
	inThisEngagement: 'IT risks',
	addITRisksFromOtherEngagements: 'New reference IT risk',
	editITRiskFromOtherEngagements: 'Edit reference IT risk',
	deleteITRiskFromOtherEngagements: 'Delete reference IT risk',
	deleteITRiskFromOtherEngagementsEntityName: 'reference IT risk',
	deleteITRiskFromOtherEngagementsConfirmLabel: 'Are you sure that you want to delete the selected IT risk? All existing relationships will be removed. This action cannot be undone.',
	newITGCFromOtherEngagements: 'New reference ITGC',
	relateITGCsFromOtherEngagements: 'Relate reference ITGC',
	relateITGCsFromOtherEngagementsModalTitle: 'Relate reference ITGC',
	editITGCFromOtherEngagements: 'Edit reference ITGC',
	deleteITGCFromOtherEngagements: 'Delete reference ITGC',
	deleteITGCFromOtherEngagementsEntityName: 'reference ITGC',
	deleteITGCFromOtherEngagementsConfirmLabel: 'Are you sure you want to delete this ITGC? All existing relationships will be removed. This action cannot be undone.',
	gtsEditReferenceITRisk: 'To edit this reference IT risk, click',
	gtsDeleteReferenceITRisk: 'To delete this reference IT risk, click',
	gtsNewReferenceITGC: 'To add a new reference ITGC, click',
	gtsRelateReferenceITGC: 'To relate a reference ITGC, click',
	gtsEditITRiskToITGCRelationships: 'To edit IT risk to ITGC relationships, click',
	gtsEditITRisk: 'To edit this IT risk, click',
	gtsDeleteITRisk: 'To delete this IT risk, click',
	gtsNewITGCInThisEngagement: 'To add a new reference ITGC, click',
	gtsRelateITGCInThisEngagement: 'To relate a reference ITGC, click',
	noITGCCheckboxDisabledTooltip: 'This selection was made in Scope and Strategy. Please go to Identify ITGC to edit this selection.',
	knowledgeITRiskIconTitle: 'Sourced from knowledge',
	newReferenceITGCLabel: 'New reference ITGC',
	knowledgeSupported: 'Knowledge supported',
	supportingITEmpty: 'No supporting applications/tools related to technology',
	supportingITNetworkEmpty: 'No supporting networks related to the technology',
	searchPlaceholder: 'Search',
	newTechnology: 'New technology',
	noSupportingDatabases: 'No supporting databases related to the technology',
	createEntityFormDocument: 'Create document',
	noSupportingOperatingSystem: 'No supporting operating systems related to the technology',
	manageTechnology: 'Manage technology',
	manageITProcesses: 'Manage IT processes',
	description: labels.description,
	type: labels.type,
	relevance: 'Relevance',
	directlySupports: 'Directly supports',
	significantChanges: 'Significant changes',
	plannedITGCReliance: 'Planned ITGC procedures',
	noPlannedITGCReliance: 'Technology with no planned ITGC procedures',
	guidedWorkflow: 'Guided workflow',
	relevant: 'Relevant',
	notRelevant: 'Not relevant',
	relevantTechnology: 'Relevant technology',
	notRelevantTechnology: 'Not relevant technology',
	notRelevantTechnologyDetails: 'Not relevant determination',
	relevantTechnologies: 'Relevant technologies',
	notRelevantTechnologies: 'Not relevant technologies',
	supportsFinancialReporting: 'Directly supports financial reporting',
	supportsItEnvironment: 'Directly supports IT environment',
	withSignificantChanges: 'Technology with significant changes',
	category: 'Rationale',
	rationale: 'Description',
	technologyWithRiskAssessment: 'Technologies',
	technologyWithNotRelevantITProcessCategories: 'Technologies with not relevant IT process categories',
	technologyWithSystemImplementation: 'Technologies with manage system implementations marked relevant',
	technologyWithSignificantChanges: 'Technologies with significant changes',
	technologyWithRejectedRisks: 'Technologies with not relevant standard IT risks',
	technologyWithEntitySpecificRisks: 'Technologies with entity specific IT risks',
	technologyWithUnassessedRisks: 'Technologies with unassessed risks',
	technologyWithNoPlannedITGCReliance: 'Relevant technologies with no planned ITGC procedures',
	supportsGroupLabel: 'This technology directly supports:',
	itProcessCategoriesLabel: 'IT process categories',
	noRecordsFound: labels.noResultsFound,
	controlsHeader: labels.controlHeader,
	testingHeader: labels.testingTitle,
	scotsEstimatesHeader: 'SCOTs/Estimates',
	ITGCHeader: labels.itGCColumnHeader,
	notRelevantHeader: 'Not relevant',
	relevantHeader: 'Relevant',
	itProcessCategoryHeader: 'IT process category',
	relatedITProcessHeader: 'Related IT process',
	technologiesHeader: 'Technologies',
	technologyDetailsTabTitle: 'Technology details',
	scots: labels.scotHeader,
	estimates: labels.estimatesTxt,
	yes: labels.yes,
	no: labels.no,
	technology: 'Technology',
	allTechnologies: 'All technologies',
	relateITProcessWarningTitle: 'There are one or more required IT processes not related to this technology',
	relateITProcessWarningDescription: 'This technology must be related to IT processes belonging to the following categories:',
	relateITProcessNotAllowedWarningTitle: 'There are one or more IT processes that should not be related to this technology',
	relateITProcessNotAllowedWarningDescription: 'This technology should not be related to IT processes belonging to the following categories:',
	exportRelevantTooltip: 'View and export technology summary',
	exportNotRelevantTooltip: 'Export',
	technologiesWithoutRelatedITRisks: 'Technologies without any related IT risks',
	otherITProcesses: 'Other IT processes',
};
export const itAttributes = {
	smartEvidenceValidations: {
		smartEvidenceSourceEntityId: 'No results found',
		smartEvidenceSourceId: 'No results found'
	},
	manageChangePlaceholders: {
		empty: 'No attributes available.'
	},
	manageEmptyMessage: 'No results found',
	noSmartEvidenceSourceId: 'Technology is no longer available.  Refresh the page and try again.  Contact the Help Desk if the error persists.',
	standardITRisks: 'Standard IT risks',
	// Print Only Labels
	manageAccessPrintTitle: 'Technology attributes - Manage access rights',
	isSelected: 'Is selected?'
};

export const entityDashboardColumns = {
	name: 'Technology',
	type: 'Type',
	controls: 'Controls',
	technology: 'Technologies',
	scotsEstimates: 'SCOTs & Estimates',
	techScotControlGroupLabel: 'This technology supports the following:',
	signOffs: labels.signoffs,
	directlySupports: 'Directly supports',
	notRelatedDetermination: 'Not relevant determination',
	supportedItems: 'Directly supports',
	plannedITGCReliance: 'Planned ITGC procedures',
	itgcs: 'ITGCs',
	yesInOtherEngagement: 'Yes, in other engagements',
	itProcessCategories: 'IT process categories',
	relevance: 'Relevance',
	relevant: 'Relevant',
	notRelevant: 'Not relevant',
	itRisks: 'IT risks',
	standardAccepted: 'Standard relevant',
	standardRejected: 'Not relevant',
	entitySpecific: 'Entity specific',
	documentAndName: 'Technology',
	validations: 'Validations',
	notesCount: 'Notes'
};

export const itPlanningDashboard = {
	noDataFound: 'No results found',
	signOffView: 'Sign-off view',
	noDocumentsPlaceholder: 'No documents',
	multipleDocumentsPlaceholder: 'Multiple documents',
	relatedControlsChartTitle: 'Technologies supporting < 5 financial reporting controls',
	countTotalTechnologies: '<b>{count}</b> total technologies'
};
export const snapshotViewChanges = {
	viewChanges: labels.craViewDetailModalTitle,
	viewChangesModalTitle: labels.craViewDetailModalTitle,
	comparativeLabel: labels.comparative,
	relevanceColumn: itPlanning.relevance,
	relevanceFilterLabel: itPlanning.relevance,
	relevanceAll: labels.all,
	relevanceRelevant: itPlanning.relevant,
	relevanceNotRelevant: itPlanning.notRelevant,
	noRecordsFound: labels.noResultsFound,
	navigateToDetails: 'View details',
	closeLabel: labels.closeLabel,
	backToTechnologies: 'Back to technologies',
	showOnlyChanged: 'Show only changed',
};

export const itAppScopingSnapshotViewChanges = {
	...snapshotViewChanges,
	selectDescription: 'Select a comparative period and then click a technology to view the details.',
	technologiesColumn: 'Technologies',
	technologyInformation: 'Technology information',
	technology: 'Technology',
	knowledgeName: 'Knowledge name',
	directlySupports: 'Directly supports',
	plannedITGCReliance: 'Planned ITGC procedures',
	notRelevantRationale: 'Not relevant rationale',
	notRelevantDescription: 'Not relevant description',
	technologySupporting: 'Technology supporting',
	itProcessCategories: 'IT processes',
	itProcessRelevant: 'Relevant',
	itProcessRationale: 'Rationale',
	itRiskAssessment: 'IT risk assessment',
	standardITRisks: 'Relevant standard IT risks',
	notRelevantStandardITRisks: 'Not relevant standard IT risks',
	entitySpecificITRisks: 'IT risks - entity specific',
	gtsITScopeLabel: 'To edit the technology and other scoping information, click',
	gtsRiskAssessmentLabel: 'To update IT risk assessment for the technology, click',
};

export const deficiencies = {
	clearFilter: 'Clear filter',
	noDeficienciesIdentified: 'No deficiencies have been identified',
	noResultsFound: 'No results found',
	searchPlaceholder: 'Search',
	addNewDeficiencies: 'New deficiency',
	createEntityFormDocument: 'Create document',
	manageDeficiencies: 'Manage deficiencies',
	deficiencyType: 'Deficiency type',
	category: 'Deficiency relates to',
	categoryControl: 'Control',
	categoryBusinessProcessControl: 'Business process',
	categoryITGC: 'IT process',
	confirmationModalTitle: 'Additional deficiency information',
	confirmationModalPrimaryText: 'This deficiency has been saved. Would you like to document additional deficiency information?',
	confirmationModalSecondaryText: "If you select 'No', you can continue documentation at any time by opening the guided workflow below.",
	controlCategory: 'Control category',
	continueToDetails: 'Continue to details ➔',
	successfullyCreated: 'successfully created'
};

export const deficiencyListingQuickFilterOptions = {
	all: labels.all,
	businessProcessControl: 'Business process',
	itControl: 'IT process'
};

export const leadsheetLabels = {
	tickmarksAndReferences: 'Tickmarks & references',
	tickmarks: 'Tickmarks',
	dataImportFile: 'Data import file',
	balanceSheet: 'Balance sheet',
	incomeStatements: 'Income statement',
	accounts: 'Accounts',
	analysisDate: 'Analysis date',
	comparativeDate: 'Comparative date',
	changeFrom: 'Change from',
	percentChangeFrom: '% Change from',
	comparative: 'comparative',
	searchAccounts: 'Search accounts',
	selectOption: 'Select option',
	rowActions: 'Row actions',
	relateReferences: 'Relate references',
	addReferenceToCanvas: 'Add reference to Canvas',
	removeReferences: 'Remove references',
	waive: 'Waive',
	removeWaive: 'Remove waive',
	relateTickmarks: 'Relate tickmarks',
	newTickmark: 'New tickmark',
	removeTickmarks: 'Remove tickmarks',
	addTickmarksOrReferences: 'Add tickmarks or references',
	// Filter labels for Account Leadsheet 294
	testedBalances: 'Tested balances',
	untestedBalances: 'Untested balances',
	incomplete: 'Incomplete',
	tested: 'Tested',
	untested: 'Untested',
	total: 'Total',
	noResultsFound: 'No results found',
	periodEnded: '{count} period ended',
	periodsEnded: '{count} periods ended',
	moreOptions: 'More options',
	openAdjustmentModule: 'Open adjustment module',
	openEYHelixConnections: 'Open EY Helix connections',
	selectAll: 'Select all',
	deselectAll: 'Deselect all',
	bulkAction: 'Bulk action',
	exitBulkMode: 'Exit bulk mode',
	glAccountSelectedSingular: '1 GL Account selected',
	glAccountsSelectedPlural: '{count} GL accounts selected',
	searchGLAccountsPlaceholder: 'Search GL accounts',
	accountType: 'Account type',
	immaterial: 'Immaterial',
	waivedBadgeLabel: 'w',
	immaterialBadgeLabel: 'm',
	viewByFinancialStatement: 'View by financial statement',
	viewByReference: 'View by reference',
	references: 'References',
	tickmarksListTitle: 'Tickmarks',
	tickmarksTooltipFooter: 'To see more, click on the tickmark icon.',
	tickmarksListDescription: 'Create new tickmarks, edit and delete existing tickmarks below.',
	deleteTickmarksTitle: 'Delete tickmark',
	deleteTickmarksConfirm: 'Are you sure you want to delete the selected tickmark?',
	annotationsConcurrencyError: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	documents: 'Document name',
	notes: 'Notes',
	signOff: 'Sign offs',
	confirmImmaterialTitle: 'Confirm designation as immaterial',
	confirmImmaterialMessage: 'Are you sure you want to overwrite the existing reference(s) for this account?',
	confirmImmaterialCount: '{count} GL accounts selected',
	confirmImmaterialConfirm: 'Confirm',
	confirmImmaterialCancel: 'Cancel',
	confirmImmaterialLabel: 'Are you sure you want to overwrite the existing reference(s) for this account?',
	immaterialActionError: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	removeReferencesMessage: 'Are you sure you want to remove the following reference(s)?',
	bulkRemoveReferencesMessage: 'Are you sure you want to remove the references of the following GL accounts?',
	removeTickmarksMessage: 'Are you sure you want to remove the tickmarks of the following GL accounts?',
	selectedSingular: '1 selected',
	selectedPlural: '{count} selected',
	showColumnsLabel: 'Show columns',
	showComparativePeriod: 'Comparative date',
	showChangeFrom: 'Change and % Change from',
	testingStatus: 'Testing status',
	selectedLabel: 'selected',
	columnSelectHeader: 'Select up to two columns',
	filterKeyPrefix: 'leadsheet-toolbar',
	documentsTooltipTitle: 'Documents'

};

export const leadsheetContextMenuLabels = {
	btnTitle: 'Add item',
	btnEditTitle: 'Edit item',
	references: 'References',
	relateFiles: 'Relate files',
	uploadFiles: 'Upload files',
	removeFile: 'Remove files',
	immaterial: 'Immaterial',
	designateImmaterial: 'Designate as immaterial',
	removeImmaterial: 'Remove immaterial',
	tickmarks: 'Tickmarks',
	relateTickmarks: 'Relate tickmarks',
	newTickmark: 'New tickmark',
	removeTickmarks: 'Remove tickmarks',
};

export const relateDocumentModalLabels = {
	glAccount: 'GL Account',
	relateReferencesPlaceholder: 'Select one or more references to relate and close to finish.',
	relateTickmarks: 'Relate tickmarks',
	relateTickmarksPlaceholder: 'Select one or more tickmarks to relate and close to finish.',
	indexLabel: 'Index',
	noOfTickmarks: '{0} tickmarks',
	noOfTickmark: '{0} tickmark',
};

export const deficiencyTypes = {
	1: 'Operation',
	2: 'Design',
	3: 'Design and operating',
	4: 'Uncategorized'
};

export const RelateControlToDeficiencyLabels = {
	controls: 'Controls',
	designEffectiveness: 'Design',
	operatingEffectiveness: 'Operation',
	testing: 'Testing',
	controlType: 'Control type',
	notSelected: 'Not selected',
	noControlsRelated: 'No controls have been related to this deficiency'
};

export const RelateITControlToDeficiency258Labels = {
	itgcs: 'ITGCs',
	designEffectiveness: 'Design',
	operatingEffectiveness: 'Operation',
	noITControlsRelated: 'No ITGCs have been related to this deficiency'
};

export const RelateSTEntityToDeficiencyLabels = {
	entities: 'Entities',
	noStentityRelated: 'No entities have been related to this deficiency'
};

export const RelateCompensatingControlsToDeficiencyLabels = {
	controls: 'Compensating controls',
	noCompensatingControlsRelated: 'No compensating controls have been identified'
};

export const RelateMitigatingControlsToDeficiencyLabels = {
	controls: 'Mitigating controls',
	noMitigatingControlsRelated: 'No mitigating controls have been identified'
};

export const RelateNotImpactedControlsToDeficiency307Labels = {
	controls: 'Not impacted controls',
	controlType: 'Type',
	rationale: 'Rationale',
	rationaleDescriptionRequired: 'Enter rationale',
	rationalePlaceholder: 'Rationale description (required)',
	rationaleRequiredPlaceholder: 'Each not impacted control or ITGC requires a rationale. Click {clickHere} to enter a rationale.',
	rationaleRequiredPrefix: 'Each not impacted control or ITGC requires a rationale. Click ',
	rationaleRequiredLink: labels.clickHere,
	rationaleRequiredSuffix: ' to enter a rationale.',
	rationaleIsRequired: 'Rationale is required',
	save: labels.saveLabel,
	cancel: labels.cancelLabel,
	editRationale: 'Edit rationale',
	editBlockedTooltip: 'You have unsaved changes to another Rationale.\nTo edit here, save or cancel those changes.',
	noNotImpactedControls: 'No controls or ITGCs designated as not impacted',
	noSearchResults: 'No results found',
	searchPlaceholder: labels.searchPlaceholder,
	clearHoverText: labels.clearHoverText,
	itgcs: 'ITGCs',
	businessProcessControls: 'Business process controls'
};

export const itRiskAssesment = {
	accepted: 'Relevant',
	rejected: 'Not relevant',
	accept: 'Relevant',
	reject: 'Not relevant',
	rejectionRationale: 'Rationale description',
	rejectionCategory: 'Rationale',
	smartEvidenceValidations: {
		smartEvidenceSourceEntityId: 'No related object. Relate an object to get started.',
		smartEvidenceSourceId: 'No related object. Relate an object to get started.'
	}
};

export const itRiskFactors = {
	accepted: 'Relevant',
	rejected: 'Not relevant',
	accept: 'Relevant',
	reject: 'Not relevant',
	rejectionDescription: "Enter the details below to determine IT risk is not relevant and click <b>'Save'</b> to finish.",
	rejectionRationale: 'Not relevant rationale description',
	rejectionCategory: 'Not relevant rationale',
	rejectionRationaleRequired: 'Rationale Description (required)',
	rejectionCategoryRequired: 'Rationale (required)',
	riskName: 'IT Risk',
	editRejectionRationaleText: 'Edit not relevant rationale',
	smartEvidenceValidations: {
		smartEvidenceSourceEntityId: 'IT Risks not available for this document',
		smartEvidenceSourceId: 'No related object. Relate an object to get started.'
	},
	manageChangePlaceholders: {
		empty: 'No IT Risks have been identified for this technology',
		emptyAccepted: 'All IT Risks have been deemed not relevant'
	},
	manageOperationsPlaceholders: {
		empty: 'No IT Risks have been identified for this technology',
		emptyAccepted: 'All IT Risks have been deemed not relevant'
	},
	manageAccessPlaceholders: {
		empty: 'No IT Risks have been identified for this technology',
		emptyAccepted: 'All IT Risks have been deemed not relevant'
	},
	SDLCPlaceholders: {
		empty: 'No IT Risks have been identified for this technology',
		emptyAccepted: 'All IT Risks have been deemed not relevant'
	},
	manageSecuritySettingsPlaceholders: {
		empty: 'No IT Risks have been identified for this technology',
		emptyAccepted: 'All IT Risks have been deemed not relevant'
	}
};

export const ITRiskAttributes = {
	accepted: itRiskFactors.accepted,
	rejected: itRiskFactors.rejected,
	accept: itRiskFactors.accept,
	reject: itRiskFactors.reject,
	editRejectionRationaleText: 'Edit not relevant rationale',
	rejectionDescription: "Select the entity-specific rationale supporting our assessment that the IT risk is not relevant or will not be created in this EY Canvas engagement. Additional details may be provided in the text box if needed.",
	rejectionDescriptionPCAOB: 'Select the entity-specific rationale supporting our assessment that the IT risk is not relevant or will not be created in this EY Canvas engagement. If the IT risk is directly addressed by a business control, identify the specific control which is being relied upon.',
	rejectionRationale: itRiskFactors.rejectionRationale,
	rejectionCategory: itRiskFactors.rejectionCategory,
	rejectionRationaleRequired: 'Rationale description (required)',
	rejectionCategoryRequired: 'Rationale (required)',
	itRiskNotRelevant: 'IT risk not relevant'
};

export const rejectionTypeResource = [
	{
		id: rejectionType.rommLikelihood,
		label: 'Likelihood - no reasonable possibility of occurring'
	},
	{
		id: rejectionType.rommMagnitude, label: 'Magnitude – misstatement is expected to be at or below TE or is not important to users if it were to occur'
	},
	{
		id: rejectionType.rommNotMaterial, label: 'Likelihood and magnitude - no reasonable possibility of occurring or being material'
	},
	{
		id: rejectionType.rommGroupAudit, label: 'ROMM is applicable, but addressed in another Canvas engagement'
	},
	{
		id: rejectionType.itRiskOption2,
		label: 'IT risk is directly addressed by a business control for a significant account or disclosure'
	},
	{ id: rejectionType.itRiskOption3, label: 'IT risk is applicable, but addressed in a service organization report (e.g., SOC1)' },
	{ id: rejectionType.itRiskPlaceholder1, label: 'IT risk is applicable, but addressed in another EY Canvas engagement' },
	{ id: rejectionType.itRiskOther, label: 'Other' }
];

export const rommControlsFilterTypes = [
	{ id: 0, label: 'All controls' },
	{ id: 1, label: 'Controls related to this ROMM' },
	{ id: 2, label: 'Controls not related to any ROMM' },
	{ id: 3, label: 'Controls related to ROMMs for this account' }
];

export const sampleList = {
	newSample: 'New sample',
	createSampleModalDescription: `Enter sample details below and select '<b>{0}</b>' to finish. To create another sample, select '<b>{1}</b>'.`,
	saveAndCreateAnother: 'Save and create another',
	saveAndClose: 'Save and close',
	sampleDescription: 'Sample description (required)',
	sampleDate: 'Sample date (required)',
	sampleListId: 'Sample List Id',
	ok: 'Ok',
	addSample: 'Add Sample',
	cancel: 'Cancel',
	saveAndCloseForHeader: 'Save and close',
	saveAndCreateAnotherHeader: 'Save and create another',
	required: 'Required',
	description: 'Sample description',
	date: 'Date',
	attributeStatus: 'Attributes',
	tags: 'Tags',
	open: 'Open',
	notApplicableLabel: 'Not applicable',
	notPresent: 'Not present',
	present: 'Present',
	pagingShowtext: 'Show',
	placeHolderMessage: 'No samples available. Click {clickHere} to get started.',
	noSampleListAvailable: 'No sample list available',
	editSample: 'Edit sample',
	editSampleDescription: `Edit sample details below and select '<b>{0}</b>' to finish.`,
	editSampleSave: 'Save',
	sampleCanNotBeCreated: 'Samples cannot be created for this document.',
	noRelatedObject: 'No related object.  Relate an object to get started.',
	noResultsFound: 'No results found'
};

export const sampleItem = {
	newSample: 'New sample',
	manageSamples: 'Manage samples',
	threeDm: '3dm',
	filter: 'Filter',
	searchPlaceholder: 'Search',
	sampleItemPlaceHolderMessage: 'No samples have been created. Click {clickHere} to get started.',
	testingProcedureTickmarks: 'Testing procedure tickmarks',
	manageTickmarks: 'Manage tickmarks',
	byTestingProcedure: 'By testing procedure',
	summary: 'Summary',
	noResultsFound: 'No results found'
};

export const AdditionDocumentationLabels = {
	addAdditionalDocumentation: 'Add additional documentation',
	editAdditionalDocTitle: 'Edit additional documentation',
	removeAdditionalDocumentation: 'Remove additional documentation',
	cancel: 'Cancel',
	save: 'Save',
	of: 'of',
	additionalDocTitlePlaceholder: 'Additional documentation (required)',
	additionalDocTitle: 'Additional documentation (required)',
	remove: 'Remove',
	enterAdditionalDocTitle: "Enter additional documentation below and select <b>'{0}'</b> to finish.",
	editAdditionalDocDesc: "Edit additional documentation below and select <b>'{0}'</b> to finish.",
	characters: 'characters',
	required: 'Required',
	descriptionMaxLengthError: 'Response exceeds maximum allowed.',
	attributeIndexLabel: 'Attribute index'
};

export const sampletAttributeConstants = [
	{ id: 1, label: 'Open' },
	{ id: 3, label: 'Present' },
	{ id: 7, label: 'Present with comments' },
	{ id: 5, label: 'Not present' },
	{ id: 4, label: 'Not applicable' }
];

export const groupInstructions = {
	ALRAPackageModalTitle: 'ALRA package name',
	ALRAPackageModalInstructionalText: 'Enter the name of the ALRA package that you are adding to Evidence.',
	ALRAPackageModalNameField: 'Enter name',
	ALRAPackageSuccessToastMessage: 'The package creation process has been started. It may take up to ten minutes for it to be completed.',
	ALRAPackageInProgressToastMessage: 'The package creation process is in progress, It may take up to ten minutes for it to be completed.',
	delete: labels.delete,
	deleteSectionModalTitle: labels.deleteSection,
	deleteSectionInstructionalText: '<b>Are you sure that you want to delete the section?</b><br />This action cannot be undone.',
	deleteSectionTooltipText: 'Instructions must be deleted<br />before section can be deleted.',
	modalConfirmBtnLabel: labels.confirmLabel,
	modalCancelBtnLabel: labels.cancelLabel,
	modalCloseBtnTitletip: labels.closeLabel,
	missing: 'Missing',
	sendAllModalTriggerButton: 'Send All',
	sendAllModalTooltipText: 'There are no instructions available to send to component teams.',
	publishModalTooltipText:
		'Group instructions need to be published before they are sent. When instructions are published, any changes are saved as new instructions, overriding the previous version of instructions. These new instructions can then be sent to component teams.',
	sendAllModalErrorMessage:
		'Group instructions for the following Components were not sent because one or more documents are in multi-user edit mode. End multi-editing mode and try to send instructions again. If the problem persists, contact EY Help Desk. <br /> <b>{0}</b>',
	sendAllModalHeaderText: 'Send all instructions',
	sendModalHeaderText: 'Send instructions',
	sendAllModalConfirmBtnLabel: 'Send',
	sendAllModalCancelBtnLabel: 'Cancel',
	sendAllModalCloseBtnTitletip: 'Close',
	sendAllModalDescription: 'Selecting <b>Send</b> will send instructions to the following component teams.',
	sendModalDescription:
		"Select which component's instructions to send from the list of components with instructions available below. Once the components have been selected, selecting <b>'Send'</b> will send instructions to the selected component teams.",
	generateGroupRiskAssessmentCommunications: 'Generate group ALRA',
	bulkALRAPackageName: '{instructionName} account level risk assessment package',
	groupInstructionSummaryReport: 'Group instruction summary report',
	groupInstructionSummaryReportTitletip: 'View and export Group instruction details, instruction history and changes to Component/Account mapping.',
	exportGroupRiskAssessment: 'Export summary',
	reportingDeliverables: groupStructure.reportingDeliverables,
	groupRiskAssessment: 'Group risk assessment',
	componentTeams: 'Component teams',
	componentTeam: 'Component team',
	required: 'Select at least one component to send.'
};

export const sectionTitles = [
	{ id: KnowledgeSectionIds.GeneralCommunications, sectionTitle: groupStructure.generalCommunications },
	{ id: KnowledgeSectionIds.ScopeOfWork, sectionTitle: 'Scope of work' },
	{ id: KnowledgeSectionIds.ReportingForms, sectionTitle: groupStructure.reportingDeliverables },
	{ id: KnowledgeSectionIds.ProceduresPerformedCentrally, sectionTitle: 'Procedures performed centrally' },
	{ id: KnowledgeSectionIds.GroupRiskAssessment, sectionTitle: groupInstructions.groupRiskAssessment },
	{ id: KnowledgeSectionIds.OtherCommunications, sectionTitle: 'Other communications' }
];

export const groupAuditToolbar = {
	search: labels.placeholderForSearch
};

export const AccountType = [
	{ id: 1, accounttypename: 'Significant account', accountAbbreviation: 'Significant' },
	{ id: 2, accounttypename: 'Limited risk account', accountAbbreviation: 'Limited risk' },
	{ id: 3, accounttypename: 'Insignificant account', accountAbbreviation: 'Insignificant' },
	{ id: 4, accounttypename: 'Other account' },
	{ id: 5, accounttypename: 'Significant disclosure', accountAbbreviation: 'Significant disclosure' }
];

export const PriorityType = [
	{ value: 1, label: 'Low' },
	{ value: 2, label: 'Medium' },
	{ value: 3, label: 'High' },
	{ value: 4, label: 'Critical' }
];

export const AccountSummaryAccountType = [
	{ id: '0', accounttypename: 'All accounts' },
	{ id: '1', accounttypename: 'Significant accounts' },
	{ id: '2', accounttypename: 'Limited risk accounts' },
	{ id: '3', accounttypename: 'Insignificant accounts' },
	{ id: '4', accounttypename: 'Account - Others' },
	{ id: '5', accounttypename: 'Significant disclosures' }
];

export const TaskStatus = [
	{ id: 1, status: 'Open' },
	{ id: 2, status: 'In progress' },
	{ id: 3, status: 'In review' },
	{ id: 4, status: 'Complete' },
	{ id: 5, status: 'Removed' }
];

export const reviewNoteLabels = {
	/*Review Notes*/
	emptyNoteDetailsMessage:
		'Select a note to view details. To enable bulk controls, use the control or shift key and select multiple review notes. If you would like to work on an individual note, then select that note from the list.',
	documentReviewNotesLabel: 'Document notes',
	addNewReviewNoteButtonText: 'Add note',
	noNotesAssociatedWithDocumentLabel: 'There are no notes associated to this document',
	allNotesLabel: 'All notes',
	charactersLabel: 'characters',
	myNotesLabel: 'My notes',
	showClearedLabel: 'Show cleared',
	showClosedLabel: 'Show closed',
	toLabel: 'to',
	toUserLabel: 'To',
	ofLabel: 'of',
	textAreaPlaceholder: 'Enter note',
	addNewNoteModalClose: 'Close',
	addNewNoteModalTitleLabel: 'Add new note',
	editNoteModalTitleLabel: 'Edit note',
	deleteIconHoverText: 'Delete',
	deleteIconModalAcceptText: 'Delete',
	deleteIconModalConfirmMessage: 'Are you sure that you want to delete your reply to this note?',
	deleteIconModalConfirmMessageParent: 'Are you sure that you want to delete the selected note?',
	deleteIconModalTitleLabel: 'Delete note',
	deleteReplyIconModalTitle: 'Delete reply',
	emptyRepliesMessage: 'No replies yet',
	replyInputPlaceholder: 'Reply to this note',
	replyText: 'Reply text',
	editReplyModelTitle: 'Edit reply',
	noteDueDateLabel: 'Due: ',
	fromUserLabel: 'From',
	priorityLabel: 'Priority',
	dueDateLabel: 'Due date',
	dueLabel: 'Due',
	status: 'Status',
	noteModifiedDateLabel: 'Modified:',
	cancelLabel: 'Cancel',
	saveLabel: 'Save',
	clearedBy: 'Cleared by',
	closedBy: 'Closed by',
	reopenedBy: 'Reopened by',
	reply: 'Reply',
	editIconHoverTextLabel: 'Edit',
	required: 'Required',
	closeTitle: 'Close',
	otherEngagementNotes: 'Other engagement notes',
	closeLabel: 'Close',
	showMore: 'Show more',
	showLess: 'Show less',
	showMoreEllipsis: 'Show more...',
	showLessEllipsis: 'Show less...',
	noResultFound: 'No results found',
	engagementNameLabel: 'Engagement name:',
	drag: 'Drag',
	formMaxLength: 'Text cannot exceed {number} characters.',
	voiceNoteButtonLabel: 'Voice note',
	stopRecordingButtonLabel: 'Stop',
	reopen: 'Reopen',
	noNotesFound: 'No notes found',
	noNotesFoundInstructional: 'Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	microphoneBlockedMessage: 'Allow browser to access your microphone to use voice notes. If already allowed, please refresh and try again.',
	microphoneBlockedOnVideoMessage:
		'Allow browser to access your microphone to use voice in screen recording. If already allowed, please refresh and try again.',
	notInMainWindowVoice: 'Voice recordings are not allowed inside the drawer, please open the document in a new tab to perform the action.',
	notInMainWindowScreen: 'Screen recordings are not allowed inside the drawer, please open the document in a new tab to perform the action.',
	voiceNoteNotAvailable: 'Voice note and screen recording is not available in drawer view. Switch to full screen view to use these features.',
	playButtonTitle: 'Play',
	deleteButtonTitle: 'Delete',
	pauseButtonTitle: 'Pause',
	screenRecord: 'Screen record',
	playbackReview: 'Playback review'
};

export const IndividualAccountAttributeLabels = {
	attributesNotAvailableForDocument: 'Account attributes are not available for this document.',
	noRelatedOnject: 'No related object.  Relate an object to get started.',
	noAttributesAvailable: 'No attributes available',
	noRisksAvailable: 'No ROMMs available',
	attributeStandardRomms: 'Standard ROMMs',
	continueButtonTitle: 'Continue',
	closeButtonTitle: 'Cancel',
	newAssertionModalPlaceholder:
		'This characteristic relates to an assertion currently designated as not relevant. Select "Continue" to update the assertion to relevant. The default inherent risk assessment will be set to lower. Evaluate whether this is appropriate and update if necessary. "Cancel" unselects the additional charcteristic.',
	assertion: 'Assertion',
	inherentRiskType: 'Inherent risk',
	assertionModalTitle: 'New assertion',
	riskType: 'Lower',
	romms: 'ROMMs'
};

export const RelateAssertionToDeficiencyLabels = {
	significantAccounts: 'Significant accounts/disclosures',
	affectedAssertions: 'Affected assertions',
	noAssertionsRelated: 'No assertions have been related to this deficiency',
	noAssertionsRelatedLine1: 'No results found.',
	noAssertionsRelatedLine2: 'Click {relateAccountsAndAssertions} to get started.'
};

export const entities = [
	{ id: 0, name: 'All' },
	{ id: Entity.Document, name: 'Document' },
	{ id: Entity.LeadSchedule, name: 'LeadSchedule' },
	{ id: Entity.Account, name: 'Account' },
	{ id: Entity.SCOT, name: 'SCOT' },
	{ id: Entity.ITProcess, name: 'IT Process' },
	{ id: Entity.AuditPlan, name: 'Audit Plan' },
	{ id: Entity.Risk, name: 'ROMM' },
	{ id: Entity.Task, name: 'Task' },
	{ id: Entity.Misstatement, name: 'Misstatement' },
	{ id: Entity.Deficiency, name: 'Deficiency' },
	{ id: Entity.GAComponent, name: 'GA Component' },
	{ id: Entity.GAComponentInstruction, name: 'GA Component Instruction' },
	{ id: Entity.GAComponentEvidence, name: 'GA Component Evidence' },
	{ id: Entity.GAScope, name: 'GA Scope' },
	{ id: Entity.GAPrimaryInstruction, name: 'GA Primary Instruction' },
	{ id: Entity.GAPrimary, name: 'GA Primary' },
	{ id: Entity.ClientRequest, name: 'Client Request' },
	{ id: Entity.WCGW, name: 'WCGW' },
	{ id: Entity.Control, name: 'Control' },
	{ id: Entity.ITSOApplication, name: 'Service Organization' },
	{ id: Entity.CanvasForm, name: 'Canvas Form' },
	{ id: Entity.FormSection, name: 'Form Section' },
	{ id: Entity.FormBody, name: 'Form Body' },
	{ id: Entity.Assertion, name: 'Assertion' },
	{ id: Entity.ClientEngagement, name: 'Client Engagement' },
	{ id: Entity.ClientGroup, name: 'Client Group' },
	{ id: Entity.EngagementTag, name: 'Engagement Tag' },
	{ id: Entity.Engagement, name: 'Engagement' },
	{ id: Entity.FormHeader, name: 'Form Header' },
	{ id: Entity.FormStatus, name: 'Form Status' },
	{ id: Entity.EngagementUser, name: 'Engagement User' },
	{ id: Entity.ClientGroupUser, name: 'Client Group User' },
	{ id: Entity.PSPIndex, name: 'PSP Index' },
	{ id: Entity.ITControl, name: 'ITGC' },
	{ id: Entity.ITRisk, name: 'IT Risk' },
	{ id: Entity.AutomationLineItem, name: 'Automation Line Item' },
	{ id: Entity.PMAmount, name: 'PM Amount' },
	{ id: Entity.TEAmount, name: 'TE Amount' },
	{ id: Entity.SADNominalAmount, name: 'SAD Nominal Amount' },
	{ id: Entity.UMTAmount, name: 'UMT Amount' },
	{ id: Entity.Annotation, name: 'Annotation' },
	{ id: Entity.EngagementComment, name: 'EngagementComment' },
	{ id: Entity.Assignment, name: 'Assignment' },
	{ id: Entity.PACEType, name: 'PACE Type' },
	{ id: Entity.TaskSection, name: 'Task Section' },
	{ id: Entity.CalendarEvent, name: 'Calendar Event' },
	{ id: Entity.TimePhase, name: 'Timephase' },
	{ id: Entity.Approval, name: 'Approval' },
	{ id: Entity.DocumentQuickReference, name: 'DocumentQuickReference' },
	{ id: Entity.STEntity, name: 'STEntity' },
	{ id: Entity.Estimate, name: 'Estimate' },
	{ id: Entity.GLAccount, name: 'GLAccount' },
	{ id: Entity.SampleItem, name: 'SampleItem' },
	{ id: Entity.SampleTagGroups, name: 'SampleTagGroup' },
	{ id: Entity.BusinessRiskFactor, name: 'Business Risk Factor' },
	{ id: Entity.ITRiskFactor, name: 'IT Risk Factor' },
	{ id: Entity.TrialBalance, name: 'Trial Balance' },
	{ id: Entity.AttributesAccount, name: 'Attributes - Account' },
	{ id: Entity.FlowchartStep, name: 'FlowchartStep' },
	{ id: Entity.CRASummaryV2Snapshot, name: 'CRA Summary V2 Snapshot' },
	{ id: Entity.ITAttribute, name: 'IT Attribute' }
];

export const PaceType = [
	{ id: 1, paceTypename: 'Low' },
	{ id: 2, paceTypename: 'Moderate' },
	{ id: 3, paceTypename: 'High' },
	{ id: 4, paceTypename: 'Close Monitoring' }
];

export const DocumentHelper = {
	400: 'Unable to complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	401: 'Unable to complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	403: 'User does not have sufficient permissions to perform the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	406: 'Failed to upload, check the file size and type. If issue persist contact help desk.',
	409: 'Document with the same name exists. Please rename the document and try again.',
	410: 'This document has been deleted and therefore it cannot be opened.',
	411: 'Empty documents are not permitted.',
	412: 'A Document with name already exists in this engagement',
	413: 'Document exceeds the maximum allowable file size (250mb) and cannot be uploaded. Reduce the file size and try again.',
	414: 'Name exceeds the maximum length ({0} characters).',
	417: 'is marked as read-only and cannot be uploaded. Remove the read-only attribute and try again.',
	4099: 'Document with the same name already exists' /*this is a hack as we dont always know why conflict happened.*/
};

export const Errors = {
	/*Doc Helper Custom Messages */
	0: 'Connection lost. Reconnect and try again. If the issue persists, contact the Help desk.',
	10: 'An issue has been detected with EY Canvas Document Helper. Click <a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">here</a> for instructions of how to resolve this issue.',
	101: 'Invalid Engagement Status.',
	102: 'Valid engagement user not found.',
	103: 'Missing Engagement User Independence compliance.',
	104: 'Missing required Azure AD Scopes',
	105: 'An error occurred obtaining engagement permissions. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	106: 'Insufficient roles to edit content. Work with an engagement administrator to get sufficient rights.',
	107: 'Valid engagement user not found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	108: 'Engagement profile is incomplete. Please go to Landing page and complete profile.',
	303: 'A document with the same name is currently being uploaded.',
	403: 'Access to this document is not available.  If this document is shared ensure you have access to the source engagement.  Refresh the page and try again.  If the error persists contact the Help Desk.',
	406: 'Document cannot be empty.',
	412: 'A document with the same name already exists in this engagement.',
	414: 'Name exceeds the maximum length (120 characters).',
	411: 'Empty documents are not permitted.',
	500: 'Connection lost. Reconnect and try again. If the issue persists, contact the Help Desk.',
	600: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk.',
	601: 'Error downloading the screenshot. Refresh the page and try again. If the issue persists, contact the Help desk.',
	602: 'Document is already in collaboration',
	935: 'User does not have sufficient permissions to perform the operation.',
	zip:
		'The .zip file cannot be uploaded because it contains one or more unsupported file types, or it contains more than the maximum amount of embedded .zip files.',
	401000: 'Network change is detected and please reload the page to continue',

	/*Accounts*/
	1001: 'Create Account call failed.',
	1002: 'Missing Account name.',
	1003: 'The selected Account has been deleted. Close this modal to see the updated list.',
	1004: 'No results found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	1005: 'Invalid Engagement Id.',
	1006: 'Invalid Account type.',
	1007: 'Invalid Statement type.',
	1008: 'The selected account has been deleted. Close this modal to see the updated list.',
	1009: 'Get Account by Id call failed.',
	1010: 'Get Account by Engagement Id call failed.',
	1011: 'Get SEM Summary for an accountid call failed due to invalid request.',
	1012: 'Invalid Summary type.',
	1013: 'Create Account Review call failed.',
	1014: 'Delete Account Review call failed.',
	1015: 'Invalid Account Review create request.',
	1016: 'Invalid Account Review ID.',
	1017: 'Account is not part of this Engagement or it has been deleted.',
	1018: 'Account Review was created by another user.',
	1019: 'Account has been deleted by another user. Refresh the page and try again.',
	1020: 'Account need PSP to update',
	1024: 'Account name is more than 500 characters.',
	1025: 'Limited Risk or Insignificant account can not be estimated',
	1026: 'Account cannot have duplicate assertions',
	1027: 'Invalid assertion id',
	1037: 'Can not have duplicate PSP Indexes',
	1039: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	1048: 'Account has been invalid execution type.',
	1053: 'Account has ROMM or Estimate associated, can not set to Limited Risk Account or Insignificant Account.',
	1054: 'Changes cannot be made to an assertion(s) that has a related entity-specific ROMM, estimate or additional account characteristic.',
	1070: 'Trial balance Id can not be null when Included Helix.',
	1072: 'Action cannot be completed.  Refresh the page and try again.  If the issue persists contact the Help Desk.',
	1076: 'Unable to create related document.',

	1250: 'Item is already downloaded and the local file is locked.',
	1266: 'Engagement has reached maximum number of multi-user edit mode documents. Check some documents back in and try again. If the issue persists, please contact the Help Desk.',
	1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, please contact the Help Desk.',
	1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, please contact the Help Desk.',
	1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, please contact the Help Desk.',
	1270: 'Document versions cannot be deleted or updated while in Multi-user edit mode. Please end Multi-user edit and try again. If the issue persists, please contact the Help Desk.',
	1271: 'Document is not in co-edit mode or end co-edit mode is in progress. If the issue persists, contact the Help Desk',
	1272: 'Multi-user edit mode is not allowed because the document is protected. If the issue persists, please contact the Help Desk.',
	1273: 'Action cannot be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Assertions*/
	2001: 'Invalid create request.',
	2002: 'Missing assertion name.',
	2003: 'Missing assertion.',
	2004: 'Get assertion call failed.',
	2005: 'Invalid Engagement Id.',
	2006: 'Get assertion by Id call failed.',
	2007: 'Get assertion WCGWs call failed.',
	2058: 'Inherent risk type selection invalid because of associated Fraud or Significant Risk.',

	/*Risks*/
	4001: 'Operation could not be completed at this time. Refresh the page and try again. If the issue persists, contact the Help desk.',
	4002: 'Missing ROMM name.',
	4003: 'Missing ROMM.',
	4004: 'Get ROMM call failed.',
	4005: 'Invalid Engagement Id.',
	4006: 'Get ROMM by Id call failed.',
	4007: 'Invalid query request.',
	4008: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4009: 'Invalid update request.',
	4010: 'Specific WCGW already assigned to this ROMM',
	4011: 'WCGW list cannot be null.',
	4012: 'Failed to get ROMM Types.',
	4013: 'Invalid create request.',
	4014: 'The related assertion is not valid.  Refresh the page and try again. If this error persists, contact the Help Desk.',
	4015: 'The WCGW is not valid.  Refresh the page and try again. If this error persists, contact the Help Desk.',
	4016: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4017: 'The Assertion is not valid for the ROMM. Refresh the page and try again. If this error persists, contact the Help Desk.',
	4018: 'The ROMM type id passed is invalid.',
	4019: 'ROMM name is not valid.',
	4020: 'Invalid Document ID.',
	4021: 'ROMM name should not be more than 500 characters.',
	4022: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4023: 'AssertionIds list cannot be null.',
	4024: 'Limited ROMM documentation form could not be created due to an error. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4025: 'Invalid account id.',
	4026: 'Invalid assertion id.',
	4027: 'AssertionRisk Model cannot be empty',
	4028: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4031: 'Invalid ROMM or Form Body option.',
	4035: 'Cannot edit IsHigherRisk for Significant or Fraud ROMMs.',
	4036: 'KnowledgeAssertionId cannot be empty if no AssertionId is passed in. KnowledgeAssertionId must be in enums',
	4037: 'KnowledgeAssertionId already exists for this account.',
	4038: 'RiskTypeId does not match permissible options.',
	4040: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4046: 'Invalid Control Id. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4061: 'Please select at least one account which is related to this estimate.',
	4062: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4063: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4064: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4065: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4066: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4070: 'Update ROMM/Estimate call has failed.',
	4076: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4079: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4088: 'ROMM SubType Id is invalid.',
	4089: 'No risk control association found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4104: 'Unable to create related document.',
	4071: 'Cannot change Estimate category because it has a Significant Risk/Fraud Risk/ROMM contributing to higher inherent risk associated to it.',
	4113: 'ROMM Type must be significant or fraud for provided higher risk value.',
	4091: 'Risk control association already exists. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4092: 'Invalid ROMM Id. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4093: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4094: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4101: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4117: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4119: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*TASK*/
	5001: 'Get all tasks failed.',
	5002: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	5003: 'Get documents for task failed. Invalid request parameters.',
	5004: 'Get document related task failed. Invalid request parameters.',
	5005: 'Get Task By Id failed.',
	5006: 'Get Task Categories call failed.',
	5007: 'Get Task SubCategories call failed.',
	5008: 'Get Task Description call failed.',
	5009: 'Get Task ClientRequests call failed.',
	5010: 'Save Task ClientRequests call failed.',
	5011: 'The task that you are attempting to relate items to has been deleted or rejected.',
	5012: 'The item that you are attempting to relate has been deleted.',
	5013: 'The task that you are attempting to relate items to has been deleted or rejected.',
	5014: 'The document that you are attempting to relate has been deleted.',
	5015: 'Get Task Evidences call failed.',
	5016: 'Get WCGW Task call failed.',
	5017: 'Engagement Id should be greater that zero.',
	5018: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5019: 'Task description is empty',
	5020: 'The selected task has been deleted or rejected. As such, this action cannot be completed at this time.',
	5021: 'Source engagement id is missing.',
	5022: 'Save Annotation Failed',
	5023: 'Engagement User not found.',
	5024: 'Delete Task call failed.',
	5025: 'Delete Tasks call failed.',
	5026: 'Task list is empty',
	5027: 'Review not not found.',
	5028: 'File name is required.',
	5029: 'File extension is required.',
	5030: 'File name cannot include: */:<>\\?|"',
	5031: 'Error updating the document name.',
	5032: 'Invalid document id.',
	5033: 'Operation type not found.',
	5034: 'Change Task Status Failed',
	5035: 'The action you are trying to perform cannot be completed at this time. Please try again later. Contact the Help Desk if this error persists.',
	5036: 'Body cannot be null or empty in the call.',
	5037: 'Request cannot be null in the call.',
	5038: 'Enter a unique file name to proceed.',
	5039: 'File name is required.',
	5040: 'File name is limited to 100 characters.',
	5041: 'File name cannot include: */:<>\\?|"',
	5042: 'The selected Task is rejected.',
	5043: 'The Task is a build step Task.',
	5044: 'The Task is a milestone Task.',
	5045: 'The Task is neither PSP or OSP type.',
	5046: 'Character limit is exceeded.',
	5047: 'Character limit is exceeded.',
	5048: 'Required field.',
	5049: 'The selected document cannot be removed from this task. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5050: 'Task group id should not be zero or invalid',
	5051: 'Task section id should not be zero  or invalid',
	5052: 'Error while trying to add this document to the current task. Call failed.',
	5053: 'Error while trying to update this document in the current task. Call failed.',
	5054: 'Error while trying to add a copy of this document in the current task. Call failed.',
	5055: 'Error while trying to rename the document. Call failed.',
	5056: 'Cannot edit task title for knowledge or group task',
	5057: 'Task type should be Ost Type',
	5058: 'This document can not be removed from the task because is system associated.',
	5059: 'Invalid time phase value.',
	5060: 'Add to Evidence error. Call Failed',
	5061: 'Another user has updated the information presented.  Refresh the page and try again.  If the error persists, contact the Help Desk.',
	5062: 'The requested document is not available for your engagement’s selected Channel in EY Atlas. Please, contact the Help Desk so information can be given to the content authors for future inclusion.',
	5063: 'Invalid Patch Operation.',
	5064: 'The selected task has been deleted or rejected. As such, this action cannot be completed at this time.',
	5065: 'Unable to update task source type. Request is invalid.',
	5066: 'Get guidance error. Call failed.',
	5067: 'Unable to update task nature type. Request is invalid.',
	5068: 'Unable to update task nature type. Request is invalid.',
	5069: 'Delete Task Assignment call failed.',
	5070: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5071: 'Unable to update the assignment. Request is invalid.',
	5072: 'Preparer not found. Request is invalid.',
	5073: 'Assignment not found.',
	5074: 'Save task assignment failed',
	5075: 'The same team member can only be assigned to one task assignment other than Preparer. Please try again or contact the Help Desk if the error persists.',
	5076: 'The selected team member is not an active member of this engagement. Please try again or contact the Help Desk if the error persists.',
	5077: 'One or more selected tasks have been deleted. Please try again or contact the Help Desk if the error persists.',
	5078: 'The selected task assignment has been removed. Please try again or contact the Help Desk if the error persists.',
	5079: 'One or more selected tasks have been deleted. Please try again or contact the Help Desk if the error persists.',
	5080: 'Docuement version record does not exist.',
	5081: 'The user who is currently assigned to this task cannot be reassigned as the Preparer. Please try again or contact the Help Desk if the error persists.',
	5082: 'Update failed. Document name should be unique for an engagement. Refresh the page to remove this message.',
	5083: 'Task Detail characters limit is exceeded.',
	5084: 'Task Document create call failed.',
	5085: 'Task Document delete call failed.',
	5086: 'Task Handoffs create call failed.',
	5087: 'Task patch call failed.',
	5088: 'This task must contain evidence to hand-off. Try again or contact the Help Desk.',
	5089: 'All evidence associated to this task (with the exception of paper profiles) must have at least one preparer and reviewer to mark complete. Try again and contact the Help Desk if the error persists.',
	5091: 'Paper profile name already exists in the engagement.',
	5092: 'Name cannot contain any of the following characters: */:<>\\?|\\',
	5093: 'Paper profile name exceeds the maximum length (100 characters).',
	5111: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5113: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5116: 'Document type is invalid.',
	5136: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5137: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5139: 'Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5140: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5131: 'Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5146: 'Task cannot be marked completed.',
	5156: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5157: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5207: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5138: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5185: 'Task has invalid documents or documents which are System Associated.',
	5191: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5192: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5193: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5208: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5209: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5210: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5211: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5212: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5213: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5214: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5215: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5216: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5219: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5220: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5221: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5226: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*WCGW*/
	6001: 'Create WCGW call failed.',
	6002: 'Missing WCGW name.',
	6003: 'Missing WCGW.',
	6004: 'Get WCGW call failed.',
	6005: 'Invalid Engagement Id.',
	6006: 'Invalid Assertion id.',
	6007: 'Get WCGW by Id call failed.',
	6008: 'Invalid request.',
	6009: 'Invalid WCGWId.',
	6010: 'The task could not be associated to the WCGW.',
	6011: 'The selected WCGW is deleted.',
	6012: 'Task and WCGW are not related to the same assertion.',
	6013: 'The selected Task does not belong to the same Engagment.',
	6014: 'The task could not be disassociated from the WCGW.',
	6015: 'The task could not be associated to the WCGW.',
	6016: 'The task is rejected and cannot be associated to the WCGW.',
	6017: 'The task is not a milestone task and cannot be associated to the WCGW.',
	6018: 'The task is not a build step task and cannot be associated to the WCGW.',
	6019: 'The task is not a PSP or OSP and cannot be associated to the WCGW.',
	6020: 'The task and WCGW are associated to the same assertion and cannot be associated to the WCGW.',

	/*Engagement*/
	7001: 'Get by ID not found.',
	7002: 'Get engagements by workspace ID call failed.',
	7003: 'GetAll engagement entities call failed.',
	7004: 'Get engagement by ID call failed.',
	7005: 'GetAll engagement users call failed.',
	7006: 'Last name should not exceed 250 characters.',
	7007: 'Invalid User Type Error.',
	7008: 'First name should not exceed 250 characters.',
	7009: 'User GUI can not be null.',
	7010: 'Invalid User Status Error.',
	7011: 'Create engagement user call failed.',
	7012: '{0} {1} cannot be invited because he/she is already an active or pending team member.',
	7013: 'Initials should not exceed 3 characters.',
	7014: 'The EY Canvas Landing Page is not accessible at this time. Try again and if the issue persists, contact the Help Desk.',
	7015: '{0} {1} cannot be invited as the following access group(s): {2} have been deleted from the engagement. Refresh and try again.',
	7016: '{0} {1}  cannot be invited as the user is already an active team member in the following access group(s): {2}',
	7017: 'Domain is not allowed for selected group(s): {0}',
	7018: 'Email Address should not be null.',
	7019: 'First Name should not be null.',
	7020: 'Last Name should not be null',
	7021: 'User Initial should not be null.',
	7022: 'User PrimaryOffice should not be null.',
	7023: 'User LoginName should not be null.',
	7024: 'User EYRole should not be null.',
	7025: 'User Engagement Role should not be null.',
	7026: 'Unable to complete operation. Try again and if the issue persists, contact the Help Desk.',
	7027: 'Invalid email address',
	7028: 'Patch Engagement User call failed.',
	7029: 'EngagementUsers - Invalid EngagementUserStatusId.',
	7030: 'EngagementUsers - Invalid EngagementUserRoleId.',
	7031: 'One or more engagement userid not found.',
	7032: 'Email should not be greater than 250 characters.',
	7033: 'Requested User cannot be Null.',
	7034: 'Universal Message Processor Queue Failed.',
	7035: 'Initials should not exceed 3 characters.',
	7036: 'First name should not exceed 250 characters.',
	7037: 'Last name should not exceed 250 characters.',
	7038: 'Create external user call failed.',
	7039: 'One or more users cannot be invited because they are already an active or pending team member.  Refresh the page and try again, if issue persists contact the Help Desk',
	7040: 'First name should not exceed 250 characters.',
	7041: 'Last name should not exceed 250 characters.',
	7042: 'Initials should not exceed 3 characters.',
	7043: 'GPN should not be greater than 250 characters.',
	7044: 'GUI should not be greater than 250 characters.',
	7045: 'Get external user by ID failed.',
	7046: 'User should not be null.',
	7047: 'Cannot save changes at the moment. Try again and if the issue persists, contact the Help Desk.',
	7048: 'The EY Canvas Landing Page is not accessible at this time and is required to edit. Try again and if the issue persists, contact the Help Desk.',
	7049: 'Update Engagement User call failed.',
	7050: 'Members cannot be deactivated. Engagement must have at least one member who has permissions to administer engagement. Update your selection and try again. If the issue persists, contact the Help Desk.',
	7051: 'Get internal user by ID failed.',
	7052: 'User not found.',
	7053: 'Get by ID not found.',
	7054: 'Get quick links by engagement ID call failed.',
	7055: 'Insufficient rights to add prior members. Speak with an engagement team member with the appropriate rights to take this action.',
	7056: 'EY Canvas could not save changes at this time. Try again and if the issue persists, contact the Help Desk.',
	7057: 'Insufficient rights to add new members. Speak with an engagement team member with the appropriate rights to take this action.',
	7058: 'User status has changed.  Refresh the page and try again. If the issue persists, contact the Help Desk.',
	7062: 'EY Canvas Client Portal is not accessible at this time and is required to update existing member information. Try again and if the issue persists, contact the Help Desk.',
	7063: 'Cannot deactivate external members. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	7064: 'Invalid Patch Operation.',
	7065: '{0} {1} cannot be activated in one or more access groups. Domain is not allowed for selected group(s): {2}.',
	7066: '{0} is not a valid user.',
	7067: 'Put external user call failed.',
	7068: 'EY Canvas Client Portal is not accessible at this time and is required to update existing member information. Try again and if the issue persists, contact the Help Desk.',
	7069: 'Selected access groups are not active: {0}. Remove and try again.',
	7072: 'An error occurred during the unlink engagement process. Refresh the page and try again. Contact the Help Desk if the error persists.',
	7074: 'Changes cannot be saved. Engagement must have at least one active member who has permissions to administer engagement and has resolved independence. If the issue persists, contact the Help Desk.',
	7079: 'Submit independence call failed.',
	7080: 'Invalid User ID or Independence submission is not allowed as user ID does not belong to logged in user.',
	7081: "Complete all questions prior to clicking 'Submit'. Use the 'Show incomplete' option to filter for incomplete questions. If the issue persists, call the Help Desk.",
	7082: 'No independence document found for the request.',
	7083: 'SDM Summary call failed.',
	7084: 'User ID not valid or Independence Action is not allowed for the logged in user.',
	7085: 'Independence comment should be less than 4,000 characters.',
	7086: 'Independence Action call failed.',
	7087: 'Your role must be Partner in Charge; Engagement Partner; or Executive Director to grant, deny or override access for this user.',
	7088: 'Inpedendence submit changes failed, try again later.',
	7098: 'Invalid Pacetype Id.',
	7099: 'No Independence template available, try again and if the issue persists call the Help Desk.',
	7154: 'No users found for the current canvas form',
	7155: 'Submit profile is not allowed for restored engagement.',
	7156: 'The content is being refreshed. Try again later. If issue persists for extended time, contact IT Help Desk.',
	7158: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*SCOT*/
	8001: 'Create Scot call failed.',
	8002: 'Missing Scot name.',
	8003: 'Missing Scot.',
	8004: 'Get Scot call failed.',
	8005: 'Invalid Engagement Id.',
	8006: 'Invalid Assertion id.',
	8007: 'Get Scot by Id call failed.',
	8008: 'Invalid request.',
	8009: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	8010: 'SCOT ID cannot be null or empty.',
	8011: 'SCOT ID should be greater than zero.',
	8012: 'Document ID is not valid.',
	8013: 'Scot update call failed.',
	8014: 'Scot name cannot be null or empty.',
	8015: 'Scot name cannot be more than 500 characters.',
	8016: 'Scot strategy type is invalid.',
	8017: 'Scot type is invalid.',
	8018: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	8019: 'Scot ITApplication should be empty when HasNoITApplication is applied.',
	8028: 'The selected SCOT has been deleted. Close this modal to see the updated list.',
	8052: 'Unable to create related document.',

	/*User*/
	10001: 'Logged in User preferences not found.',
	10002: 'User GetAll call failed.',
	10003: 'User Presence Get call failed.',
	10005: 'Unable to retrieve user details',

	/*Risk Type*/
	11001: 'Invalid create request.',
	11002: 'Missing RiskType name.',
	11003: 'Missing RiskType.',
	11004: 'Get RiskType call failed.',
	11005: 'Invalid Engagement Id.',

	/*TaskDocuments*/
	80004: 'One or more tasks are invalid.',
	80005: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	80011: 'Confidential documents are not eligible to be shared',
	80014: 'The selected form\'s responses are already linked to one or more other forms, and it cannot be shared into another engagement until the form is unlinked',

	/*Edit Control*/
	83001: 'Failed to get controls.',
	83002: 'Failed to get control by id.',
	83003: 'Control Id is null or empty.',
	83004: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	83005: 'Document Id is invalid.',
	83006: 'Missing control name.',
	83007: 'Invalid control name length.',
	83008: 'Invalid request.',
	83009: 'Invalid Control FrequencyId.',
	83010: 'Invalid Control TypeId.',
	83011: 'Invalid Control ITApplications.',
	83012: 'Invalid Control DesignEffectivenessTypeId.',
	83013: 'Invalid ITApplicationIds.',
	83014: 'Only SO type ITApplications are allowed, If the control type is manual prevent or manual detect type.',
	83015: 'Only ITDM may have manual IPE testing selected.',
	83016: 'Lower Risk controls are not allowed for engagements with this profile.',
	83017: 'Duplicate FilterSCOTs.',
	83018: 'Control name is more than 500 characters.',
	83019: 'Invalid WCGW Ids.',
	83020: 'Duplicate WCGW Ids are not allowed.',
	83021: 'Duplicate ITApplication Ids are not allowed.',
	83022: 'Parameter {0} is not valid.',
	83023: 'Invalid current page.',
	83024: 'Invalid page size.',
	83025: 'Search String should not be more than 100 characters.',
	83026: 'IT APP without service organisation can only be associated to control of type ITDependentManualControl or ITApplicationControl',
	83027: 'Duplicate FilterWCGWs.',
	83028: 'Invalid knowledge control Id.',
	83037: 'Control not found. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	112000: 'No documents found for source and target documents.',
	112001: 'Unable to perform call because the request is null.',
	112002: 'Request body cannot be null or empty in the call.',
	112003: 'Source and target documentId should not be equal.',
	112004: 'Source documentId should not be null or empty.',
	112005: 'Target documentId should not be null or empty.',
	112006: 'Source EngagementId should not be null or empty.',
	112007: 'Target EngagementId should not be null or empty.',
	112008: 'Source document is not valid for given engagement.',
	112009: 'Target document is not valid for given engagement.',
	112010: 'Target engagementId not found.',
	112011: 'Insufficient roles to link forms for source enagagment.  Work with an engagement administrator to get sufficient rights.',
	112012: 'Insufficient roles to link forms for target enagagment.  Work with an engagement administrator to get sufficient rights.',
	112013: 'Invalid user for source engagement.',
	112014: 'Invalid user for target engagement.',
	112015: 'Invalid source document type for sharing.',
	112016: 'Invalid target document type for sharing.',
	112017: 'Source and target document types are not matched.',
	112018: "Source and target knowledge formId's are not matched.",
	112019: 'Sharing link already exists for source and destination documents.',
	112020: 'Source and target engagements workspace not matched.',
	112021: 'Target document cannot be a target.',
	112022: 'The selected activity is already shared with other activities, and it cannot be further selected for sharing.',
	112023: 'Source document cannot be a target.',
	112024: 'Cannot find engagement Id of target documentId.',
	112025: 'Cannot find engagement Id of source documentId.',
	112026: 'Source document of source and target documentId should not be equal.',
	112027: 'Cannot proceed with submission of profile since the engagement has shared EY Canvas FIT enablement activities. Unlink the activities in order to proceed.',
	112028: 'Source and target EngagementId should not be equal.',
	112029: 'Source or Target EngagementId and documentId should match with route EngagementId and documentId.',
	112030: 'Document is not valid for given engagement.',
	112031: 'DocumentId should not be null or empty.',
	112032: 'EngagementId should not be null or empty.',
	112033: 'Target Document IDs Should Be Unique.',
	112034: 'Target or source document(s) already shared.',
	112035: 'For existing linked response relataion document there can only be single target.',
	113020: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	113021: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*MissingDocument*/
	116001: 'Create form failed.',
	116002: 'No knowledge document found for the given DocumentTypeID.',
	116004: 'Document creation failed. Please refresh or try again after some time. If the issue persists, contact the Help desk.',

	/* Annotation Errors*/
	12001: 'Invalid request parameters.',
	12002: 'Create Annotation call failed.',
	12003: 'Get Annotation failed.',
	12004: 'Invalid Engagement ID.',
	12005: 'IDs in collection must be greater than zero.',
	12006: 'ID collection cannot be empty.',
	12007: 'Invalid Task ID.',
	12008: 'Invalid Document ID.',
	12009: 'Must have valid DocumentId or Task ID.',
	12010: 'Replies require parent.',
	12011: 'Invalid Status ID.',
	12012: 'Document type should be 440GL.',
	12013: 'Invalid annontation type.',
	12014: 'Invalid Engagement User.',
	12015: 'This document has been deleted by another user.',
	12016: 'Update Annotation call failed.',
	12017: 'The note that you are replying to has been deleted by another team member. Refresh the page and try again.',
	12018: 'Annotation change action type should not be Null.',
	12019: 'Review note deleted.',
	12020: 'Invalid action to perform.',
	12021: 'User is not author of annotation.',
	12022: 'Missing authoring user.',
	12023: "Authoring user doesn't exist or belong to the engagement.",
	12024: 'Assigned user required.',
	12025: 'Assigned user does not exist or belong to the engagement.',
	12026: 'Invalid comments.',
	12027: 'Comments must not be empty.',
	12028: 'Due date required.',
	12029: 'Valid priority required.',
	12030: 'The status of this note has changed. You can no longer edit or respond to the note. Please close and re-open the window to see updated data and continue editing.',
	12031: 'Annotation must be top level.',
	12032: 'Annotation must not be top level.',
	12033: 'At least one of the following values must not be empty: priority type, due date, status or assigned user.',
	12034: 'Comment exceeds maximum length (4,000 characters).',
	12035: 'Search string exceeds maximum length (500 characters).',
	12036: 'Only TaskId Or DocumentId should be accepted both are not allowed.',
	12037: 'Invalid Patch Operation.',
	12038: 'You are trying to edit a note that no longer exists. Refresh the page and try again.',
	12039: 'You are trying to edit the same note as another team member. Refresh the page and try again.',
	12040: 'Get Annotation users call failed.',
	12041: 'Get annotation users failed. Invalid query value.',
	12042: 'Document type is not valid to create an annotation.',
	12043: 'You are trying to add a note to a task or document that no longer exists. Refresh the page and try again.',
	12044: 'You are trying to edit a reply to a note that no longer exists. Refresh the page and try again.',
	12045: 'Review note not found.',
	12046: 'The selected note has already been deleted by another user.',
	12047: 'You can only delete replies to notes that are in Open status. Refresh the page and try again.',
	12048: 'You are trying to change the status of a note that no longer exists. Refresh the page and try again.',
	12049: 'You are trying to delete a reply to a note that has already been deleted by another team member. Refresh the page and try again.',
	12050: 'You can only delete notes that are in Closed status.',
	12051: 'Comment type annotations can only be created for valid Helix documents.',
	12052: 'The Comment type annotation that you are looking for is deleted.',
	12060: 'Reference number is required, must be greater than 0 and less than 1000.',
	12061: 'Reference number must be null.',
	12062: 'Annotations can only create to a comment.',
	12066: 'You are trying to reply to a note that is not open.',
	12067: 'You are trying to delete a reply to a comment that has already been deleted by another team member. Refresh the page and try again.',
	12068: 'You are trying to add a note with a recording that is invalid or no longer exists. Refresh the page and try again.',
	12069: 'You are trying to update a note with a recording that is invalid or no longer exists. Refresh the page and try again.',
	12070: 'You can only add one comment per financial statement. Please edit the existing.',
	12071: 'Failed to delete the information. Please try again. If the issue persists, contact the help desk.',
	123019: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123065: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	/*FlowchartStepControl*/
	123054: 'Control relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123045: 'This control is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123059: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123061: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*FlowchartStepWCGW*/
	123022: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123023: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123055: 'WCGW relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*FlowchartStepITApplicationSO*/
	123056: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*FlowchartStepDocument*/
	123048: 'Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123033: 'This flowchart step is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123002: 'This document is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/* GL Account Immaterial Errors */
	113022: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/* ITRiskFactor Errors  */
	124001: 'Invalid ITRiskFactorId.',
	124002: 'Rationale must not be empty when IsRejected is true.',
	124003: 'Rationale must be empty when IsRejected is false.',
	124004: 'Rationale should not be more than 4000 characters.',
	124005: 'Invalid ITApplicationId.',
	124006: 'RejectionTypeId must not be empty when IsRejected is true.',
	124007: 'RejectionTypeId must be empty when IsRejected is false.',
	124008: 'Invalid RejectionTypeID.',

	/*Configuration*/
	13001: 'Configurations not found.',
	13002: 'Get Configurations API call failed.',

	/*Documents*/
	14001: 'Unable to perform call because the request is null.',
	14002: 'Document not found. Call failed.',
	14003: 'Engagement Id should be greater that zero.',
	14004: 'Document Id should not be null or empty.',
	14005: 'Error while trying to get associated tasks. Call failed.',
	14006: 'The selected document cannot be delete. Try again later. If the issue persists, contact the Help Desk.',
	14007: 'An unexpected error has occurred.',
	14008: 'An unexpected error has occurred during sign off.',
	14009: 'An error occurred while adding a sign off.',
	14010: 'The approval ID should be greater than zero.',
	14011: 'An error occurred while deleting a sign off.',
	14012: 'Body cannot be empty.',
	14013: 'The selected document cannot be unlinked. Try again later. If the issue persists, contact the Help Desk.',
	14014: 'Get Account By Document Id Call Failed.',
	14015: 'Invalid related entity.',
	14016: 'Get Document Approval call failed.',
	14017: 'GetAll Document Findings call failed.',
	14018: 'GetAll Documents call failed.',
	14019: 'Sign-off not found.',
	14020: 'Invalid action value.',
	14021: 'Invalid finding type.',
	14022: 'The document does not belong to the engagement.',
	14023: 'The document change type is not valid.',
	14024: 'GetAll Documents call failed. Parameter is not valid.',
	14025: 'An error has occurred while creating the document review. The API call has failed.',
	14026: 'An error has occurred while deleting the document review. The API call has failed.',
	14027: 'The Engagement ID should not be null or empty.',
	14028: 'The User ID is invalid.',
	14029: 'The User is not authorized to perform this action.',
	14030: 'No Document with the passed ID was found in this Engagement.',
	14031: 'The Document Review ID is not valid.',
	14032: 'The Document Review was not found.',
	14033: 'The Document was already approved.',
	14034: 'An Unlink process is in-progress for another engagement in the workspace or this document has already been unlinked. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	14035: 'The document is not shared with the given engagement.',
	14036: 'Version number should be greater that zero.',
	14037: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk',
	14038: 'Failed to get document change reasons.',
	14039: 'Failed to get document change reason by ID.',
	14040: 'Failed to update change reason.',
	14041: 'Invalid change reason.',
	14042: 'Update change reason failed.',
	14043: 'Failed to create change reason.',
	14044: 'Failed to delete change reason.',
	14045: 'Invalid change reason Id.',
	14046: 'Document is not available.  Refresh the page and try again.  If the issue persists, contact the Help Desk.',
	14047: 'Document already has a change reason assigned.',
	14048: 'Document has a conflict, please resolve before proceeding.',
	14049: 'Invalid data to check whether document is added to team or user.',
	14050: 'Error while removing reference document.',
	14052: 'Search text exceeds the maximum permitted length (500 characters).',
	14053: 'Unable to perform call because the request is null.',
	14054: 'Invalid Patch Operation.',
	14055: 'Resolve Document history call failed.',
	14056: 'An error has occurred when trying to queue the message.',
	14057: 'A document with the same name already exists in the engagement.',
	14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
	14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
	14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
	14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
	14062: 'The document confidentiality type id is not valid.',
	14063: 'Cannot change confidentiality type of this document type.',
	14064: 'User doesnt have permission.',
	14065: 'Invalid custom description.',
	14066: 'Failed to update extension.',
	14067: 'Invalid extension.',
	14068: 'Failed to get document extensions.',
	14069: 'This document has already been unlinked by another team member. Refresh the page and contact the Help Desk if the error persists.',
	14070: 'Invalid file type.',
	14071: 'The selected document version is no longer available. Please close and reopen this window to see the latest set of historical versions for the document.',
	14072: 'Source document Id should not be null or empty.',
	14073: 'Canvas form ids should not be null or empty.',
	14074: "Canvas form ID's should not be duplicates.",
	14075: 'Failed to associate document to canvas forms.',
	14076: 'Source document associated Canvas forms not found.',
	14077: 'Source document not found. Call failed.',
	14078: 'Current document is already associated with given canvas forms.',
	14079: 'This document has been deleted and therefore it cannot be opened.',
	14080: 'The source approval user id is invalid.',
	14081: 'The source approval user id should valid GUID and must not be empty GUID.',
	14082: 'The modify user id is invalid.',
	14083: 'The modify user id should be a valid GUID and must not be empty GUID.',
	14084: 'File name cannot include: */:<>\\?|""',
	14085: 'The document name exceeded maximum length allowed.',
	14086: 'DocService failed while updating document details.',
	14087: 'The input is not valid.',
	14088: 'A input has duplicate document names.',
	14089: 'The bookmark observation is not valid.',
	14090: 'Request status has changed. Please refresh the page and try again if required. If the issue persists, contact the help desk.',
	14091: 'This request has been deleted. Refresh the page to view updated data. If the issue persists, contact the Help Desk.',
	14092: 'Document not eligible for update. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	14093: 'Document not eligible for sign off. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	14094: 'Document operation not permitted. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	14180: 'This document is in multi-user editing mode and cannot be opened as read-only. Please try again after the document has been checked in.',

	/*SEM*/
	15001: 'Get SEM Summary for an account id call failed due to invalid request.',
	15002: 'Invalid Account Id.',
	15003: 'Invalid Engagement Id.',
	15004: 'Invalid Summary type.',
	15005: 'Related account cannot be found. Refresh the page and try again. Contact the Help Desk if the issue persists.',

	/*Timephase*/
	16001: 'Get time phases failed.',
	16002: 'The engagement must be greater than zero.',
	16003: 'The time phase must be greater than zero.',
	16004: 'Invalid task ID value.',
	16005: 'Invalid time phase value.',

	/*Validations*/
	17001: 'Missing build step id or document type id.',
	17003: 'The document could not be found. Refresh the page and try again. If the issue persists, contact Help Desk.',

	/*TaskGroupSection*/
	18001: 'GetAll task group section call failed.',

	/*Assignments*/
	19001: 'Create assignment call failed.',
	19002: 'Get assignment call failed.',

	/*Client Request*/
	21001: 'Client request association call has failed.',

	/*Component Creation*/
	22001: 'Get related components call failed.',
	22002: 'Get group components call failed.',
	22003: 'Create group components call failed.',
	22004: 'Invalid parent component id, the parent component you specified does not exist.',
	22005: 'The team name has exceeded maximum length.',
	22006: 'The team legal name has exceeded maximum length.',
	22008: 'The scope you specified does not exist.',
	22009: 'Invalid component short name.',
	22010: 'Invalid component legal name.',
	22011: 'Invalid component scope id.',
	22012: 'If the point of contact email was supplied then the point of contact guid cannot be null or empty.',
	22013: 'If the point of contact email was supplied then the point of contact text cannot be null or empty.',
	22014: "The email you specified does not exist in Active Directory.",
	22015: "Patch group components call failed.",
	22016: 'The component that you are trying to delete is not available or already deleted.',
	22017: "A link request has been sent to the team, then the user should not be able to edit scope id, reference only designation or component not using canvas designation.",
	22018: "Delete team component call failed.",
	22024: 'The component that you are trying to send instructions to is not available or has already been deleted.',
	22027: 'Group Instruction found with no due date.',
	22028: 'Scope instruction is not yet published for the component.',
	22029: 'No new instruction published for the component to send.',
	22039: "The engagement is not a Component Team Engagement, Cannot import the instruction.",
	22040: 'Instructions could not be sent. Check engagement type is correct.',
	22041: "Accept Version call failed.",
	22042: "The primary instruction set id cannot be empty.",
	22043: 'Send Instructions call failed.',
	22044: "Get group component by id call failed.",
	22045: "Group components risk assessments call failed.",
	22046: 'Invalid component id.',
	22047: "Only one of SnapshotId, IsLiveVersion, or SetSnapshotId should be set.",
	22048: 'The component you are trying to update is copied from another engagement while copy engagement.',

	/*Send Instruction*/
	22049: 'Group instructions cannot be sent because one or more documents are in multi-user edit mode. End multi-editing mode and try to send instructions again. If the problem persists, contact EY Help Desk.',
	22050: 'Point of contact email must be null for reference-only components.',
	22051: 'Point of contact text must be null for reference-only components.',
	22052: 'Point of contact GUID must be null for reference-only components.',
	22053: 'Scope ID must be null for reference-only components.',
	22054: 'Parent component ID must be null for reference-only components.',
	22055: 'Invalid GA Link Status for reference-only components.',
	22056: 'GAParentComponentID must be null when GARoleTypeId is Region.',
	22057: 'POCEmail is more than 255 characters.',
	22058: 'POCText is more than 255 characters.',
	22059: 'POCGui is more than 100 characters.',
	22060: 'GARoleTypeId must be 2 (Regional) or 3 (Component).',
	22061: 'GARoleTypeId must be 3 (Component) for reference-only components.',
	22062: 'ShortName can only be updated when GALinkStatus is ReferenceOnly (13).',
	22063: 'The point of contact does not exist in Active Directory.',
	22065: 'Editing the component failed. Refresh the page and try again. If the issue persists, contact Help Desk.',
	22066: 'Scope is required. Please provide a valid scope.',
 	22067: 'Reference-only components should be saved without point of contact.',
 	22068: 'Instructions need to be published for this engagement in order to send.',

	/*User Presence*/
	23001: 'Logged in user presence not found.',
	23002: 'User presence get call failed.',
	23003: 'User presence document validation failed.',
	23004: 'User presence delete call failed.',
	23005: 'Document is no longer opened by any other users. Refresh the page and try again. Contact the Help Desk if the issue persists.',

	/* Forms */
	24001: 'Get form call failed.',
	24002: 'Invalid Engagement ID.',
	24003: 'Document Id should not be null or empty.',
	24005: 'Form header not found.',
	24004: 'The document could not be found. Refresh the page and try again. If the issue persists, contact Help Desk.',
	24006: 'Section is not available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	24007: 'Invalid request parameters.',
	24008: 'Header id should not be null or empty.',
	24009: 'Section id should not be null or empty.',
	24010: 'Form body response update operation failed.',
	24011: 'Invalid request for form body response update.',
	24012: 'Body is not available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	24013: 'Invalid form body option id.',
	24014: 'Invalid form body type id.',
	24015: 'Invalid request body for given body type id.',
	24016: 'Invalid free text for given body type id.',
	24017: 'Maximum characters, includes rich text formatting tags. Either reduce the length or remove unnecessary formatting and try again.',
	24018: 'For given body type id response is not allowed.',
	24019: 'Body id should not be null or empty.',
	24020: 'Invalid Request Body.',
	24021: 'Body is deleted.',
	24022: 'Country should not be null or empty.',
	24023: 'Language should not be null or empty.',
	24024: 'SubsericeLine should not be null or empty.',
	24025: 'GamLayers should not be null or empty.',
	24026: 'Header creation call failed.',
	24027: 'Invalid request for header creation.',
	24028: 'Duplicate unit creation call failed.',
	24029: 'Invalid form unit type.',
	24030: 'Section has been deleted. Refresh the page and try again.If the issue persists, contact the Help Desk.',
	24031: 'Body is not custom body.',
	24032: 'Header creation request is not valid.',
	24033: 'Supplied document entity id is not valid.',
	24034: 'Supplied entity id is not valid.',
	24035: 'An error occurred on creating related document.',
	24036: 'An error occurred on deleting related document.',
	24037: 'RelatedDocumentId could not be null or empty.',
	24038: 'Document is not valid or does not exist.',
	24039: 'Related document is not valid or does not exist.',
	24040: 'Custom body creation failed.',
	24041: 'Body creation request is not valid.',
	24042: 'Section creation request is not valid.',
	24043: 'Section get by id call failed.',
	24044: 'Section creation failed.',
	24045: 'Invalid current page.',
	24046: 'Invalid page size.',
	24047: 'Invalid document related object id.',
	24048: 'Object is already related to the canvas form.',
	24049: 'Object not found.',
	24050: 'The passed in entity UId is not valid.',
	24051: 'If EntityId is provided, EntityUid must be provided and viceversa.',
	24052: 'Canvas form snapshot creation failed.',
	24053: 'Header get by id call failed.',
	24054: 'Body get by id call failed.',
	24055: 'An error occurred on form profile create.',
	24056: 'Document FormProfile already exists.',
	24057: 'Document FormProfile validation failed.',
	24058: 'Document FormProfile does not exists.',
	24059: 'Section is not custom.',
	24060: 'Document FormProfile validation failed. If PCAOB-IA is true then PCAOB-FS should be true.',
	24061: 'Document FormProfile validation failed. If PCAOB-FS is false then PCAOB-IA should be false.',
	24062: "Document FormProfile validation failed. If 'Non- complex' then 'PCAOB - FS'/'PCAOB - IA' should be false.",
	24063: 'CountryId is invalid.',
	24064: 'LanguageId is invalid.',
	24065: 'Header is not custom.',
	24066: 'Form section related object creation failed.',
	24067: 'Object not found.',
	24068: 'Wcgw is not related to Scot.',
	24069: 'Parameter {0} is not valid.',
	24070: 'The passed in parent entity UId is not valid.',
	24071: 'Form section related object get failed.',
	24072: 'Section is not available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	24073: 'Cannot retrieve snapshot. Refresh the page and try again. If the issue persists contact the Help Desk.',
	24074: 'Snapshots not available for the selected document. Refresh the page and try again. If the issue persists contact the Help Desk.',
	24075: 'Invalid Snapshot Id.',
	24076: 'Entity Id should not be null or empty',
	24077: 'The passed in form section related object ID is not valid.',
	24078: 'Form Section Related Object ID should not be null or empty.',
	24079: 'Supplied Parent Entity ID is not valid.',
	24080: 'FormSectionRelatedObject : Parent Entity Record not found.',
	24081: 'Object not found.',
	24082: 'Object not found.',
	24083: 'An error ocurred on Form Profile Update.',
	24084: 'Document FormProfile is not exists.',
	24085: 'Language id should be greater than 0.',
	24086: 'Country id should be greater than 0.',
	24087: "Knowledge delivered documents cannot be updated. Update Engagement Profile to change this form's profile.",
	24088: 'Insufficient roles to edit content. Work with an engagement administrator to get sufficient rights.',
	24089: 'Custom Header Name has exceeded the maximum length (500 characters). Please adjust the name and try again.',
	24090: 'Custom Section Name has exceeded the maximum length (500 characters). Please adjust the name and try again.',
	24091: 'Section Custom Label has exceeded the maximum length (100 characters). Please adjust the name and try again.',
	24092: 'Custom Body Name has exceeded the maximum length (500 characters). Please adjust the name and try again.',
	24093: 'Custom Section Name should not be null or empty.',
	24094: 'Body Name should not be null or empty.',
	24096: 'Custom Header Name should not be null or empty.',
	24097: 'The overwrite cannot be completed at this time.',
	24098: 'Source or target document type id not valid.',
	24099: 'Source and target document knowledge form id is not same.',
	24100: 'Source Document ID should not be null or empty.',
	24101: 'Target Document ID should not be null or empty.',
	24103: 'Header has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	24104: 'Header cannot be edited.',
	24105: 'Body cannot be edited.',
	24106: 'Update action is invalid.',
	24107: 'Document FormProfile validation failed. If PCAOB-FS is true then complex should be true.',
	24108: 'Document FormProfile validation failed. If PCAOB-IA is true then PCAOB-FS should be true.',
	24110: 'Content update currently in-progress.Manually update the contents of this form on the Canvas Form content update page once the current content update has completed.',
	24111: 'Map & Unlink values cannot be the same.',
	24112: 'Source document should not be shared.',
	24114: 'Failed to add the evidence. Refresh the page and try again.',
	24115: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	24116: 'Failed to submit profile. Refresh the page and try again.',
	24117: 'Form has incomplete responses. Refresh the page and try again.',
	24118: 'Document ID and RelatedDocument ID cannot be the same.',
	24119: 'Editing body related objects failed.',
	24120: 'Body related object ID should not be null or empty.',
	24121: 'Object not found.',
	24122: 'Missing concurrency token',
	24124: 'Invalid target document(s) found.',
	24125: 'Target canvas form(s) not found.',
	24126: 'Request should not be null or empty.',
	24127: 'The import of data from EY Helix was not successful. Import data again from EY Helix settings and try again. If the issue persists contact the Help Desk.',
	24155: 'Submit profile is not allowed for restored engagement.',
	24164: 'You do not have appropriate permissions to make changes to the template.',
	24166: 'Save profile is not permitted. Form is not available for this profile.',
	24167: 'Body type cannot be updated',
	24168: 'Modify User Id should not be null or empty',
	24169: 'Modify User Id can only have value when linkedResponseUpdate is false',
	24170: 'Invalid task id in request',
	24171: 'Duplicate body ids in request',
	24172: 'Section compare call failed',
	24173: 'Document Ids cannot be empty. As well it cannot exceed distinct 50 documents at a time',
	24174: 'Route document should be part of request body documentids',
	24175: 'Invalid smart evidence entity id in request body',
	24176: 'Body documentids should have same knowledge form id',
	24177: 'Invalid section id',
	24178: 'Invalid combination of DocumentID and DocumentIDList',
	24179: 'DocumentIds list cannot be greater than 50',
	24180: 'Materiality could not be updated',
	24181: 'Invalid Form Body ID',
	24182: 'Invalid Knowledge Form ID Or Knowledge Form Body ID',
	24183: 'An error has occurred while relating the document to this form. Please refresh the page and try again. If the issue persists, contact Help Desk.',
	24184: 'User is not active for this EY Canvas engagement. Invite the user via manage team and then try again. If the issue persists contact the Help Desk',
	24185: 'Failed to print form. Please refresh the page and try again. If the issue persists, contact the Help Desk.',
	24188: 'One or more records are no longer available. Please refresh the page.',
	24201: 'Only one of  Small, Standard, or Complex need to be selected.',

	/*Document Change Types*/
	25001: 'Get Document Change Types call failed.',
	25002: 'Invalid engagement ID.',
	25003: 'Invalid request.',

	/* Manage team */
	26001: 'ClientUserGroups GetAll call failed.',
	26002: 'Create new Client Group/ Email domain call failed.',
	26003: 'GroupName should not be null.',
	26004: 'Email domain should not be null.',
	26005: '{0} Email Domain label should not exceed 263 characters.',
	26006: '{0} Email Domain should not exceed 263 characters.',
	26007: '{0} First part of email domain can be * or alphanumeric, other special characters not allowed.',
	26008: '{0} If the first part is a wild card, then it must have two or more parts following.',
	26009: '{0} First part can be * or alphanumeric, other domain parts special characters not allowed.',
	26010: 'Email domain should be unique.',
	26011: 'Provided client access group ID is not valid.',
	26012: 'An error occurred while deleting the access group. Ensure that there are no requests/external tasks assigned to this group or to the members of this group and try again.',
	26013: 'Access group has already been deleted, please refresh the page to get the latest data.',
	26014: 'At least one email domain is required.',
	26015: 'EY Canvas Client Portal is not accessible at this time and is required to update existing member information. Try again and if the issue persists, contact the Help Desk.',
	26016: 'Error during delete operation.',
	26017: 'Get data operation failed.',
	26018: 'Concurrency issue, access group is no longer active.',
	26019: 'Save operation failed.',
	26020: 'Email domains cannot be removed when they have active users assigned. Changes have not been saved.',

	/* TimePhaseTypes - Milestones */
	27001: 'Get milestone details failed.',

	/*Client Request Counts*/
	28001: 'Get Client Requests Info call did not fetch any results.',

	/*Content updates Error messages*/
	29001: 'Get by ID not found.',
	29002: 'Acton type not found.',
	29003: 'Content ID(s) not found.',
	29004: 'Content update API call failed.',
	29005: 'Content update in-progress. Try again later and if the issue persists, contact the Help Desk.',
	29006: 'Invalid request parameters.',
	29021: 'Save profile is not permitted. Form is not available for this profile.',
	/*IT Process*/
	30001: 'Get all ITProcess failed.',
	30002: 'Get all ITProcess - invalid engagement ID.',
	30003: 'ITProcess name cannot be empty.',
	30004: 'ITProcessName should not be more than 500 characters.',
	30005: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	30006: 'Get itprocess by id call failed.',
	30007: 'Invalid request.',
	30008: 'IT process is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	30009: 'Document not found.',
	30010: 'Cannot complete deletion. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	30012: 'Cannot complete deletion. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	30017: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	30018: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	30019: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	30036: 'Unable to create related document.',

	/*Checklist*/
	31001: 'GetAll CheckLists call failed.',
	31002: 'Put CheckLists call failed.',
	31003: 'Invalid CheckList parameter.',
	31004: 'Invalid Engagement Error.',
	31005: 'Invalid Request Parameters Error.',
	31006: 'Invalid IsChecked request parameter Error.',

	/*Archive*/
	32001: 'Engagement Status ID is invalid.',
	32002: 'Archive failed.',
	32003: 'V1 ARC Call is failing, Refresh the page, resolve the validations, and try the archive process again. Contact the Help Desk if the error persists.',
	32004: 'Engagement Status Update In LDC failed.',
	32005: 'Invalidate Engagement Cache Error.',
	32006: 'A content update is in progress. You cannot archive this engagement until the content update is complete. Try again later and contact the Help Desk if the error persists.',
	32007: 'ArcGUID is null Or empty.',
	32008: 'FileGuid is null Or empty.',
	32009: 'FileStoreHostTcp is null Or empty.',
	32200: 'There are unresolved validations in this engagement. Refresh the page, resolve the validations, and try the archive process again. Contact the Help Desk if the error persists.',
	32300: 'There are unresolved validations in this engagement. Refresh the page, resolve the validations, and try the archive process again. Contact the Help Desk if the error persists.',

	/*RBAC*/
	33001: 'Engagement ID not found.',
	33002: 'User ID not found.',

	/*Helix Linked Projects*/
	34001: 'Unable to perform call because the request is null.',
	34002: 'Engagement ID should not be null or empty.',
	34003: 'Body cannot be null or empty in the call.',
	34004: 'Project ID cannot be null or empty.',
	34005: 'Project Name cannot be null or empty.',
	34006: 'Project has already been linked, refresh the page and try again.',
	34007: 'GetAll Helix Projects call failed.',
	34008: 'Engagement ID should be greater that zero.',
	34010: 'Save could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	34009: 'Project ID has changed. Refresh the page and try again.',
	34011: 'Currency Type cannot be null in the call.',
	34012: 'Currency Code cannot be null in the call.',
	34013: 'Business Unit cannot be null or empty in the call.',
	34014: 'Linked EY Helix Project has changed, cannot update the settings.',
	34017: 'Could not connect to EY Helix. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	34018: 'Operation could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	34019: 'Import completed but data not valid. Refresh the page and click Import to try again.',
	34027: 'Helix Project is in progress.',
	34036: 'Could not connect to EY Helix. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	34039: 'This EY Helix project is no longer the primary project for your engagement. Please refresh the page and try again.',
	34040: 'You must have the <b>EY Helix Import</b> permission to take this action. Speak with an engagement administrator to gain access.',

	/* PAANS */
	35001: 'The EY Policy Authoring, Approvals and Notification Service​ is unavailable at this time. We are unable to confirm if all relevant policies have been completed. If you have not reviewed the relevant policies, refresh the page and try again. If the issue persists, contact the Help Desk.',

	/* Controls */
	36001: 'Unable to perform call because the request is null.',
	36019: 'This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	36020: 'Invalid Control ID.',
	36021: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	36025: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	36029: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	36032: 'Document is already related to this deficiency',
	36039: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	36059: 'Unable to create related document.',
	36075: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	36076: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	36079: 'At least one ITRisk is required',
	36080: 'ITRisk ID is invalid. Value must be non-zero, belong to engagement, be displayed, not be deleted, and not be rejected',
	36081: 'Duplicate ITRisk are not allowed',
	36082: 'Deficiency must be for ITControl entity only',
	36083: 'Deficiency must have at least one related ITControl',
	36084: 'ITRisk must be related to at least one ITControl associated with the deficiency',
	36087: 'This ITRisk already exists for the deficiency',

	// DeficiencyITRiskITApplication patch
	36088: 'At least one valid patch operation with a positive integer ID is required',
	36089: 'One or more DeficiencyITRiskITApplication IDs are invalid, non-positive, or do not belong to the deficiency',
	36090: 'Only one patch allowed per request',
	36104: 'Exactly one of KnowledgeITRiskId, ITRiskId, or DeficiencyITRiskId must be provided.',
	36105: 'KnowledgeITRiskId, ITRiskId, and DeficiencyITRiskId are mutually exclusive. Provide only one.',
	36106: 'KnowledgeITRiskId must be greater than 0.',
	36107: 'DeficiencyITRiskId must be greater than 0.',
	36108: 'No matching DeficiencyITRisk record(s) were found.',

	/* Assertions */
	36023: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	36036: 'The assertion was not found',
	36037: 'This assertion is already related to the deficiency',
	36041: 'The deficiency and assertion relationship was not found',

	37001: 'Unable to perform call because the request is null',
	37002: 'Failed to get misstatements',
	37003: 'Engagement Id should be greater than zero',
	37004: 'Document Id should not be null or empty',
	37005: 'Create misstatement failed',
	37006: 'TrialBalance id should be greater than zero',
	37007: 'Misstatement index should not be null or empty',
	37008: 'Misstatement index exceeds more than 15 characters',
	37009: 'Description should not be null or empty',
	37010: 'Description exceeds more than 4000 characters',
	37011: 'Adjustments should not be null or empty',
	37012: 'The sum of amounts where IsCredit is true must equal to the sum where IsCredit is false',
	37013: 'No duplicate display orders are allowed',
	37014: 'Adjustment amount should be greater than zero',
	37015: 'Adjustment GLAccountId should be greater than zero',
	37016: 'Invalid create misstatement request',
	37017: 'Invalid or deleted trialbalance id',
	37018: 'Invalid or deleted gl account ids for given trialbalance id',
	37019: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37020: 'Duplicate gl account ids are found',
	37021: 'No duplicate misstatement types are allowed',
	37022: 'Search string length should not exceed 100 characters',
	37023: 'Misstatement id should be greater than zero',
	37024: 'GLAccountId should be greater than zero',
	37025: 'Misstatement types contains invalid values',
	37026: 'Page should be greater than zero',
	37027: 'Page size should be greater than zero',
	37028: 'Misstatement id is not valid',
	37029: 'Invalid update misstatement request',
	37030: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37031: 'The document that you are attempting to create for provided misstatement is not valid',
	37032: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37033: 'The document that you are attempting to delete for provided misstatement is not valid',
	37034: 'Invalid misstatement period type',
	37035: 'Duplicate period type are found',
	37036: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37037: 'Adjustments should be empty',
	37038: 'Misstatement index should be null or empty',
	37039: 'Update misstatement failed',
	37040: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37041: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37042: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37043: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37044: 'Failed to get misstatement metrics',
	37045: 'ViewType is invalid. Must be All, Corrected, or Uncorrected',
	37046: 'Multi-entity id should be greater than zero',
	37047: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37048: 'Group component id should be greater than zero',
	37049: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37050: 'This Misstatement and Component relationship is not found',
	37051: 'Parent Misstatement Id should be greater than zero',
	37052: 'Parent Misstatement Id cannot be the same as Misstatement Id',
	37053: 'Parent Misstatement does not exist or is deleted',
	37054: 'Misstatement and Parent Misstatement relationship already exists',
	37055: 'Parent Misstatement Id is invalid. Value must be non-zero',
	37056: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*Engagement Comments*/
	38001: 'Create EngagementComments call failed',
	38002: 'GetAll EngagementComments call failed',
	38003: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38004: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38005: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38006: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38007: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38008: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38009: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38010: 'Body should not be null',
	38011: 'CommentText should not be null or empty',
	38012: 'Entity does not exist in given engagement',
	38013: 'EngagementCommentStatusId should be greater than 0',
	38014: 'ParentEngagementCommentId should be greater than 0',
	38015: 'There was no canvas form body matching the specified criteria',
	38016: 'The note that you are replying to has been deleted by another team member. Refresh the page and try again',
	38017: 'The parent engagement comment supplied is cleared',
	38018: 'The parent engagement comment supplied is a reply itself',
	38019: 'The provided comment text should not be shorter than 1 and not longer than 4000 characters',
	38020: 'The provided entity uid is invalid',
	38021: 'The provided parent entity uid is invalid',
	38022: 'Delete EngagementComments call failed',
	38023: 'The comment id should not be empty',
	38024: 'The action should be a valid action',
	38025: 'You are trying to delete a comment that no longer exists. Refresh the page and try again.',
	38026: 'You are not the owner of the comment',
	38027: 'There was no comment found to update',
	38028: 'Updates on cleared comments are not allowed',
	38029: "Only the author can change the comment's text",
	38030: 'The engagement comment Id is invalid',
	38031: 'The comment status Id should not be empty',
	38032: 'There was no relationship record between the requested user and the engagement. Refresh the page and try again. If the error persists contact the Help Desk',
	38033: 'Update action is invalid',
	38034: 'The requested CommentId is already being used by another comment',
	38035: 'The supplied Comment Id is invalid',
	38036: 'Document Id should not be null or empty',
	38037: 'The Id of the user the comment will be assigned to should not be null',
	38038: 'The comment should not be reassigned while opening it or closing it',
	38039: 'The note that you are deleting a reply from has already been deleted. Refresh the page and try again',
	38040: 'Reply should not have due date',
	38041: 'Reply should not have priority',
	38042: 'Comment should have due date',
	38043: 'Comment should have priority',
	38044: 'You are trying to edit a reply to a comment that no longer exists. Refresh the page and try again',
	38045: 'Editing both the engagement status ID and its content, assigned to user, or priority is not allowed',
	38046: 'Update EngagementComments call failed',
	38047: 'You can only reply to open notes',
	39004: 'This tag group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*IT App/SO*/
	81001: 'Get all ITApplication failed.',
	81002: 'Get all ITApplication - invalid engagement id.',
	81003: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81004: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81005: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81006: 'Invalid strategy type.',
	81007: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	81008: 'Get ITApplication by ID failed.',
	81009: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81010: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81011: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81012: 'ITApplicationID should not be null or empty.',
	81013: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81014: 'Delete ITApplicationITProcess call failed.',
	81015: '"ITApplicationITProcessId" should not be empty.',
	81016: 'Invalid ITApplicationITProcessId.',
	81017: 'Relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',
	81018: 'Create ITApplicationITProcess call failed.',
	81019: 'Passed Service Organization instead of ITApplication.',
	81020: 'Cannot complete deletion. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81039: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81041: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81044: 'Strategy Type should be valid enum.',
	81045: 'Duplicate Filter Strategy Types.',
	81046: 'Combination of ITApplicationId and ITProcess already exists.',
	81052: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	81066: 'Invalid IT Application Strategy for IT Environment Type Document.',
	81070: 'Invalid ITApplication Type.',
	81071: 'Unable to create related document.',

	/* ITControl */
	84001: 'Failed to get IT controls.',
	84002: 'Failed to get IT control by id.',
	84003: 'IT Control Id is null or empty.',
	84004: 'Invalid IT control Id.',
	84005: 'Document Id is invalid.',
	84006: 'Missing IT control name.',
	84007: 'Invalid IT control name length.',
	84008: 'Invalid IT Control FrequencyId.',
	84009: 'Invalid IT Control ApprochTypeId.',
	84010: 'Invalid IT Control DesignEffectivenessTypeId.',
	84011: 'Invalid IT Control Testing value.',
	84012: 'Invalid IT Control OperatingEffectivenessTypeId.',
	84013: 'Missing IT control frequency.',
	84014: 'Delete IT Control failed.',
	84015: 'Search String should not be more than 100 characters.',
	84016: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	84018: 'Could not complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	84019: 'Cannot complete update. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	84033: 'Document not found.',
	84042: 'The IT Control cannot be deleted because it has a related IT Risk.',

	/*ITRisk*/
	86001: 'ITRisk name cannot be empty.',
	86002: 'ITRisk name should not be more than 500 characters.',
	86003: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	86004: 'Get ITRisk by id call failed.',
	86005: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	86006: 'Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	86007: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	86008: 'Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	86009: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	86010: 'Delete IT risk failed',
	86016: 'Get IT risk failed',
	86021: 'Cannot set HasNoITGC to true because this ITRisk has associated ITControls with Control approach type. Please remove the Control approach ITControls first.',
	86022: 'Invalid IT application ids.',
	86023: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*RiskFactorFormHeaders*/
	89001: 'Risk factor relation not found.',
	89002: 'Document not found.',
	89003: 'Missing document id.',
	89004: 'Rationale length exceeds more than 4000 characters.',
	89005: 'ROMM could not be related to selected risk factor. Refresh the page and try again. If the issue persists, contact the Help desk.',
	89014: 'The ROMM id is not valid',
	89020: 'Risk factor cannot be saved.  Refresh the page and try again.  If the issue persists contact the Help Desk',

	/*Materiality*/
	91001: 'Materiality not found.',
	91002: 'Data could not be saved. Refresh the page and try again. If the issue persists contact the Help Desk.',
	91003: 'Invalid Materiality update request.',
	91004: 'Missing IsAnnualizedAmountExpectedToBeReported.',
	91005: 'When updating IsAnnualizedAmountExpectedToBeReported to true, it is mandatory to specify a BasisForecastAmount.',
	91006: 'Basis forecast amount should not be more than 15 digits or have any decimals.',
	91007: 'When updating IsAnnualizedAmountExpectedToBeReported to true, BasisForecastAmountRationale must be null.',
	91008: 'The basis forecast amount rationale is either too short or too long.',
	91009: 'Invalid materiality id',
	91010: 'Invalid materiality body type id',
	91011: 'Nominal amount cannot exceed the higher end of the range',
	91012: 'Materiality amount should not be more than 15 digits and 4 decimals',
	91013: 'Invalid STEntityId',
	91014: 'Invalid FilterMaterialityView',
	91015: 'Invalid AuditPhaseId',
	91016: 'Invalid MaterialityTypeId',
	91017: 'MaterialityTypeId is only allowed when AuditPhaseId is Conclusion',
	91018: 'A Materiality record already exists for the supplied combination of engagement, audit phase, and entity',
	91019: 'Invalid MultiEntityId',
	91020: 'Invalid FilterMaterialityCategory',
	91021: 'Materiality can only be deleted when AuditPhaseId is Conclusion (3)',
	91022: 'PM amount must be greater than zero, a whole number, and not exceed 15 digits',
	91023: 'TE amount must be greater than zero, a whole number, and not exceed 15 digits',
	91024: 'SAD nominal amount must be greater than zero, a whole number, and not exceed 15 digits',

	/*Group Structure - Sub Scopes */
	92013: 'Sub-scope cannot be deleted because there is at least one related region/component team.',
	92016: 'Sub-scope name already exist',

	/*Helix Account Mappings */
	94001: 'Account mapping could not be saved. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	94004: 'One or more EY Canvas accounts have been deleted and could not be mapped. Refresh the page and try again.',
	94005: 'Unable to resume project. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Group Instructions */
	98001: 'An error occurred retrieving group instructions. Refresh the page and try again. If the issue persists, contact the Help desk.',
	98002: 'One or more Knowledge instruction section IDs is not valid.',
	98003: 'An error occurred creating group instructions. Refresh the page and try again. If the issue persists, contact the Help desk.',
	98004: 'Instruction name cannot be empty.',
	98005: 'Instruction name cannot have more than 500 characters.',
	98006: 'Instruction description cannot be empty.',
	98007: 'Instruction description cannot have more than 30,000 characters.',
	98009: 'Instruction name cannot be duplicated.',
	98010: 'Due date cannot be empty.',
	98011: 'Instruction already deleted.',
	98012: 'Instruction not found.',
	98013: 'Instruction ID must be greater than zero.',
	98014: 'An error occurred saving group instructions. Refresh the page and try again. If the issue persists, contact the Help desk.',
	98015: 'Instruction mandatory scopes cannot be deleted.',
	98016: 'Instruction has been deleted',
	98017: 'Group task already deleted.',
	98018: 'Edit group task after delete.',
	98019: 'Entity not found.',

	98020: 'Unable to generate the risk assessment package. Refresh the page and try again. If the issue persists, please contact the Help Desk.',

	98021: 'Document name cannot be empty.',
	98022: 'Document name cannot have more than 115 characters.',
	98023: 'Document name cannot have invalid XML characters.',
	98024: 'The package creation process is in progress, it may take up to ten minutes for it to be completed',
	98025: 'Some instruction(s) do not have related component(s). Allocate component(s) to instructions and then Generate Group risk assessment communications again.',
	98026: 'Some component(s) do not have related account(s). Relate account(s) to component(s) and then Generate Group risk assessment communications again.',
	98027: 'Some Account(s) do not have Account document(s). Create Account document and then Generate Group risk assessment communications again.',
	98028: 'This Canvas Form is not associated to a valid task.',
	98029: 'One or more components are reference only.',
	98030: "One or more components aren't from this primary team engagement.",
	98031: 'One or more scopes are not from this primary team engagement.',
	98032: 'Document count has exceeded the limit.',
	98033: 'Required scopes cannot be deleted from the instruction.',
	98035: 'One or more documents is not evidence and cannot be attached to the instructions.',

	/*Estimate */
	115017: 'Estimate not found',

	/* Group Audit */
	106003: 'Error. Please refresh and try again.',

	/* TasksOverview */
	117001: 'Get all TaskOverview call failed.',
	117002: 'Get all TaskOverview request cannot be empty.',
	117003: 'Invalid engagement ID.',
	117004: 'Invalid TaskCategory value.',
	117005: 'Invalid View value.',
	117006: 'Invalid DocumentCategorySearch value.',
	117007: 'Duplicate TaskCategory IDs.',
	117008: 'Duplicate TimePhase IDs.',
	117009: 'Duplicate Task IDs.',
	117010: 'Duplicate Document IDs.',
	117011: 'Duplicate AssignedToUser IDs.',

	/* Multientity */
	114001: 'Get all MultiEntity failed.',
	114002: 'STEntityName cannot be empty.',
	114003: 'STEntityName should not be more than 500 characters.',
	114004: 'STLegalName cannot be empty.',
	114005: 'STLegalName should not be more than 500 characters.',
	114006: 'Multi Entity can be created only with MEST Engagements.',
	114007: 'Create Multi Entity Account call failed.',
	114008: 'One or more records are no longer available. Refresh the page and try again',
	114009: 'Invalid account id.',
	114010: 'STEntityShortName should not be more than 100 characters.',
	114011: 'STEntity submit profile request is invalid.',
	114012: 'STEntity submit profile request body is invalid.',
	114013: 'STEntity submit profile request body should have distinct STEntityIDs.',
	114014: 'STEntityIDs for submit profile request are invalid.',
	114015: 'Form has incomplete responses. Refresh the page and try again.',
	114016: 'The content update is disabled for this.',
	114017: 'Engagement has no Multi Entity Individual Profile document.',
	114018: 'STEntity IDs missing Multi entity individual profile.',
	114019: 'One or more entity that you are mapping no longer exists in the engagement. Please refresh the page and try again.',
	114020: 'STEntityShortName cannot be empty.',
	114021: 'Invalid DocumentId.',
	114022: 'Invalid EngagementId.',
	114023: 'STEntityDocument record already exists.',
	114024: 'STEntityDocument record does not exist.',
	114025: 'STEntityDocument record IsSystemAssociated.',
	114026: 'Invalid Request Body.',
	114028: 'Each entity does not have one profile document.',
	114035: 'STEntity relation already exists.',
	114036: 'Atleast one Profile document should be valid when requesting all entity update.',
	114037: 'STEntity and Account relationship already been removed.',
	114038: 'Get all MultiEntity layers failed.',
	114039: 'Profile can only be submitted when a Primary Entity has been selected. Once selected, submit the Profile again. If the issue persists, contact the Help Desk.',
	114040: 'Profile can only be submitted when a Primary Entity has been selected. Once selected, submit the Profile again. If the issue persists, contact the Help Desk.',
	114041: 'Insufficient permissions to make this the Primary Entity. Contact your engagement administrator and request permission to make it the Primary Entity.',
	114042: 'Unable to create related document.',

	/* Sample List */
	121101: 'Invalid Sample List ID.',
	121008: 'Invalid sample list ID.',
	121011: 'This sample is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121013: 'This sample is no longer available in this engagement. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121016: 'This sample is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121037: 'An error occurred while taking this action. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121012: 'Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121025: 'This document is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121027: 'Document relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	121028: 'Document relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	121014: 'Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121029: 'This attribute is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121021: 'Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*Control Attributes */
	122018: 'Could not complete action. Refresh the page and try again. If the issue persists contact the Help Desk.',
	122021: 'An error occurred while taking this action. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*Flow chart*/
	123031: 'Form Body Id cannot not be linked to more than one flowcharts.',

	/*Control Step */
	129011: 'Smart Evidence Source ID not found for the document.',
	129012: 'Smart Evidence Source Entity ID not found for the document.',
	129013: 'Invalid before item Id.',
	129014: 'Invalid after item Id.',
	129015: 'Document ID must not be empty.',
	129022: 'Unable to create related document.',
	
	4073: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4074: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	1034: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	1035: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	/*Group Instructions */
	196033: 'Instructions cannot have 0 allocation items, they must have at least 1.',

	/*Information Security */
	200001: 'The action taken was forbidden by EY Information Security. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Tags */
	40007: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	40029: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/* Leadsheet */
	113121: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	113122: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	113124: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*Axios Error codes */
	ERR_NETWORK: 'The application network is experiencing an error. Refresh the page and try again later. Contact the Help Desk if the error persists.'
};

export const roleForMember = [
	{ id: 1, role: 'Partner in Charge', roleAbbreviation: 'PIC' },
	{ id: 2, role: 'Engagement Partner', roleAbbreviation: 'EP' },
	{ id: 3, role: 'Executive Director', roleAbbreviation: 'ED' },
	{ id: 4, role: 'Principal', roleAbbreviation: 'Principle' },
	{ id: 5, role: 'Senior Manager', roleAbbreviation: 'Sr. Manager' },
	{ id: 6, role: 'Manager', roleAbbreviation: 'Manager' },
	{ id: 7, role: 'Senior', roleAbbreviation: 'Senior' },
	{ id: 8, role: 'Staff', roleAbbreviation: 'Staff' },
	{ id: 9, role: 'Intern', roleAbbreviation: 'Intrn' },
	{ id: 10, role: 'Engagement Quality Reviewer', roleAbbreviation: 'EQR' },
	{ id: 11, role: 'Other Partner', roleAbbreviation: 'Other Partner' },
	{ id: 12, role: 'GDS - Staff', roleAbbreviation: 'GDS Staff' },
	{ id: 13, role: 'Advisory (ITRA,TAS,Human Capital or Other)', roleAbbreviation: 'ADV' },
	{ id: 14, role: 'Tax', roleAbbreviation: 'Tax' },
	{ id: 15, role: 'Executive Support Services', roleAbbreviation: 'ESS' },
	{ id: 16, role: 'General Counsel', roleAbbreviation: 'GCO' },
	{ id: 17, role: 'Audit Quality Reviewer', roleAbbreviation: 'AQR' },
	{ id: 18, role: 'ML Component Team', roleAbbreviation: 'MCT' },
	{ id: 19, role: 'Client Supervisor', roleAbbreviation: 'C. Supervisor' },
	{ id: 20, role: 'Client Staff', roleAbbreviation: 'C. Staff' },
	{ id: 21, role: 'Internal Audit Supervisor', roleAbbreviation: 'IA Supervisor' },
	{ id: 22, role: 'Internal Audit Staff', roleAbbreviation: 'IA Staff' },
	{ id: 23, role: 'Regulator', roleAbbreviation: 'Regulator' },
	{ id: 24, role: 'Other (e.g. due diligence review)', roleAbbreviation: 'Other' },
	{ id: 25, role: 'Office', roleAbbreviation: 'Office' },
	{ id: 26, role: 'Area', roleAbbreviation: 'Area' },
	{ id: 27, role: 'Industry', roleAbbreviation: 'IND' },
	{ id: 28, role: 'National', roleAbbreviation: 'NAT' },
	{ id: 29, role: 'Global', roleAbbreviation: 'GBL' },
	{ id: 30, role: 'GDS - Senior', roleAbbreviation: 'GDS Senior' },
	{ id: 31, role: 'GDS - Manager', roleAbbreviation: 'GDS Manager' }
];

export const accountConclusionTabs = {
	conclusions: 'Conclusions'
};

export const assertions = [
	{ id: 1, assertionname: 'Completeness', assertionabbreviation: 'C', statementtypeid: 2, displayorder: 1 },
	{ id: 2, assertionname: 'Existence', assertionabbreviation: 'E', statementtypeid: 2, displayorder: 2 },
	{ id: 3, assertionname: 'Valuation', assertionabbreviation: 'V', statementtypeid: 2, displayorder: 3 },
	{ id: 4, assertionname: 'Rights and Obligations', assertionabbreviation: 'R&O', statementtypeid: 2, displayorder: 4 },
	{
		id: 5,
		assertionname: 'Presentation and Disclosure',
		assertionabbreviation: 'P&D',
		statementtypeid: 2,
		displayorder: 5
	},
	{ id: 6, assertionname: 'Completeness', assertionabbreviation: 'C', statementtypeid: 1, displayorder: 6 },
	{ id: 7, assertionname: 'Occurrence', assertionabbreviation: 'O', statementtypeid: 1, displayorder: 7 },
	{ id: 8, assertionname: 'Measurement', assertionabbreviation: 'M', statementtypeid: 1, displayorder: 8 },
	{
		id: 9,
		assertionname: 'Presentation and Disclosure',
		assertionabbreviation: 'P&D',
		statementtypeid: 1,
		displayorder: 9
	},
	{ id: 10, assertionname: 'Completeness', assertionabbreviation: 'C', statementtypeid: 3, displayorder: 10 },
	{ id: 11, assertionname: 'Existence/Occurrence', assertionabbreviation: 'E/O', statementtypeid: 3, displayorder: 11 },
	{ id: 12, assertionname: 'Measurement/Valuation', assertionabbreviation: 'M/V', statementtypeid: 3, displayorder: 12 },
	{ id: 13, assertionname: 'Rights and Obligations', assertionabbreviation: 'R&O', statementtypeid: 3, displayorder: 13 },
	{
		id: 14,
		assertionname: 'Presentation and Disclosure',
		assertionabbreviation: 'P&D',
		statementtypeid: 3,
		displayorder: 14
	}
];

export const documentChangeTypesOptions = [
	{ value: 1, label: 'Non-administrative change' },
	{ value: 2, label: 'Accepting revisions when the track changes functionality was used' },
	{ value: 3, label: 'Adding additional cross referencing to evidence that already exists' },
	{ value: 4, label: 'Adding an original confirmation response previously received via fax or email' },
	{ value: 5, label: 'Cosmetic change' },
	{ value: 6, label: 'Completing Form AP and substantial role evaluation' },
	{ value: 7, label: 'Deleting or discarding superseded documentation' },
	{ value: 8, label: 'Preparing the management letter' },
	{ value: 9, label: 'Signing off on completion checklists relating to the archive process' },
	{ value: 10, label: 'Sorting, collating and cross-referencing final documents' },
	{
		value: 12,
		label: 'MEST only: Modification to evidence related to entities with a report date later than the report date in EY Canvas'
	},
	{
		value: 11,
		label: 'When adjusted to the local time zone, the modification is on or before the report date (Americas only)'
	}
];

export const KnowledgeFormProfileAnswer = [
	{ value: 1, label: 'Complex', display: true },
	{ value: 2, label: 'Non-complex', display: true },
	{ value: 3, label: 'Listed', display: true },
	{ value: 4, label: 'Non-listed', display: false },
	{ value: 5, label: 'PCAOB - IA', display: true },
	{ value: 6, label: 'Non-PCAOB-IA', display: false },
	{ value: 7, label: 'PCAOB - FS', display: true },
	{ value: 8, label: 'Non-PCAOB-FS', display: false },
	{ value: 9, label: 'Group Audit', display: true },
	{ value: 10, label: 'Non-Group Audit', display: false },
	{ value: 11, label: 'Digital', display: true },
	{ value: 12, label: 'Core', display: true }
];

export const KnowledgeFormProfileAnswerV2 = [
	{ value: 9, Question: 7, label: 'Group', display: true },
	{ value: 13, Question: 10, label: 'PCAOB', display: true },
	{ value: 15, Question: 11, label: 'Integrated audit', display: true },
	{ value: 17, Question: 12, label: 'Publicly traded entity', display: true },
	{ value: 19, Question: 13, label: 'Public interest entity', display: true },
	{ value: 27, Question: 17, label: 'Non-public interest entity', display: true },
	{ value: 21, Question: 14, label: 'Small', display: true },
	{ value: 23, Question: 15, label: 'Standard', display: true },
	{ value: 25, Question: 16, label: 'Complex', display: true }
];

export const strategyType = [
	{ StrategyTypeId: 1, StrategyTypeName: 'Controls' },
	{ StrategyTypeId: 2, StrategyTypeName: 'Substantive' }
];

export const controlTypeName = {
	1: 'Application',
	2: 'ITDM',
	3: 'Manual Prevent',
	4: 'Manual Detect'
};

export const inCompleteList = [{ value: 1, label: 'Incomplete', title: 'Incomplete' }];

export const scotTypes = [
	{ value: 1, label: 'Routine', title: 'Routine', isDisabled: false },
	{ value: 2, label: 'Non Routine', title: 'Non Routine', isDisabled: false },
	{ value: 3, label: 'Estimation', title: 'Estimation', isDisabled: false },
	{ value: 4, label: 'FSCP', title: 'FSCP', isDisabled: false }
];

export const scotTypesNew = [
	{ value: 1, label: 'Routine', title: 'Routine', isDisabled: false },
	{ value: 2, label: 'Non routine', title: 'Non routine', isDisabled: false },
	{ value: 3, label: 'Estimation', title: 'Estimation', isDisabled: false },
	{ value: 4, label: 'FSCP', title: 'FSCP', isDisabled: false }
];

export const estimationTypes = [
	{ value: 1, label: 'No', title: 'No', isDisabled: false },
	{ value: 2, label: 'Yes', title: 'Yes', isDisabled: false }
];

/* IT Control */
export const itApproachType = [
	{ ITApproachTypeId: 1, ITApproachTypeName: 'Controls' },
	{ ITApproachTypeId: 2, ITApproachTypeName: 'Substantive' }
];

/*Controls */
export const controlFrequencyType = [
	{ value: 1, label: 'Many times per day', title: 'Many times per day' },
	{ value: 2, label: 'Daily', title: 'Daily' },
	{ value: 3, label: 'Weekly', title: 'Weekly' },
	{ value: 4, label: 'Monthly', title: 'Monthly' },
	{ value: 5, label: 'Quarterly', title: 'Quarterly' },
	{ value: 6, label: 'Annually', title: 'Annually' },
	{ value: 8, label: 'Other', title: 'Other' }
];

export const controlTypesAbbreviation = [
	{ value: 1, label: 'ITAC' },
	{ value: 2, label: 'ITDM' },
	{ value: 3, label: 'Manual' },
	{ value: 4, label: 'Manual' }
];

export const controlTypes = [
	{ value: 1, label: 'IT application control' },
	{ value: 2, label: 'IT dependent manual control' },
	{ value: 3, label: 'Manual prevent' },
	{ value: 4, label: 'Manual detect' }
];

export const controlTypesWithAbbreviation = [
	{ value: 1, label: 'ITAC', tooltip: 'IT application control' },
	{ value: 2, label: 'ITDM', tooltip: 'IT dependent manual control' },
	{ value: 3, label: 'Manual', tooltip: 'Manual prevent' },
	{ value: 4, label: 'Manual', tooltip: 'Manual detect' }
];

export const strategyTypeCheck = {
	1: 'Controls',
	2: 'Substantive'
};

export const designEffectivenessType = [
	{ DesignEffectivenessTypeId: 1, DesignEffectivenessTypeName: 'Effective' },
	{ DesignEffectivenessTypeId: 2, DesignEffectivenessTypeName: 'Ineffective' }
];

export const controlEffectivenessType = [
	{ ControlEffectivenessTypeId: 1, ControlEffectivenessTypeName: 'Effective' },
	{ ControlEffectivenessTypeId: 2, ControlEffectivenessTypeName: 'Ineffective' }
];

export const testing = [
	{ testingId: 1, testingDescription: 'Yes' },
	{ testingId: 2, testingDescription: 'No' }
];

export const controlType = [
	{ value: 1, label: 'IT application control', title: 'IT application control' },
	{ value: 2, label: 'IT dependent manual control', title: 'IT dependent manual control' },
	{ value: 3, label: 'Manual prevent', title: 'Manual prevent' },
	{ value: 4, label: 'Manual detect', title: 'Manual detect' }
];

export const aggregateITEvaluationType = [
	{ value: 1, label: 'Support', title: 'Support' },
	{ value: 2, label: 'Not Support', title: 'Not Support' },
	{ value: 3, label: 'FS & ICFR Support', title: 'FS & ICFR Support' },
	{ value: 4, label: 'FS Only Support', title: 'FS Only Support' }
];

export const KnowledgeFormProfileQuestion = [
	{ value: 1, label: 'Complex' },
	{ value: 2, label: 'Listed' },
	{ value: 3, label: 'PCAOB - IA' },
	{ value: 4, label: 'PCAOB - FS' },
	{ value: 5, label: 'Location' },
	{ value: 6, label: 'Language' },
	{ value: 7, label: 'Group Audit' },
	{ value: 8, label: 'Digital' },
	{ value: 9, label: 'Multi Entity' }
];

export const KnowledgeLanguage = [
	{ value: 1, label: 'English' },
	{ value: 2, label: 'Spanish (Latin America)' },
	{ value: 3, label: 'French (Canada)' },
	{ value: 4, label: 'Dutch' },
	{ value: 5, label: 'Croatian' },
	{ value: 6, label: 'Czech' },
	{ value: 7, label: 'Danish' },
	{ value: 8, label: 'Finnish' },
	{ value: 9, label: 'German (Germany, Austria)' },
	{ value: 10, label: 'Hungarian' },
	{ value: 11, label: 'Italian' },
	{ value: 12, label: 'Japanese (Japan)' },
	{ value: 13, label: 'Norwegian (Norway)' },
	{ value: 14, label: 'Polish' },
	{ value: 15, label: 'Slovak' },
	{ value: 16, label: 'Slovenian' },
	{ value: 17, label: 'Swedish' },
	{ value: 18, label: 'Arabic' },
	{ value: 19, label: 'Simplified Chinese (China)' },
	{ value: 20, label: 'Traditional Chinese (Taiwan)' },
	{ value: 21, label: 'Greek' },
	{ value: 22, label: 'Hebrew (Israel)' },
	{ value: 23, label: 'Indonesian' },
	{ value: 24, label: 'Korean (Republic of Korea)' },
	{ value: 25, label: 'Portuguese (Brazil)' },
	{ value: 26, label: 'Romanian' },
	{ value: 27, label: 'Russian (Russia)' },
	{ value: 28, label: 'Thai' },
	{ value: 29, label: 'Turkish' },
	{ value: 30, label: 'Vietnamese' },
	{ value: 31, label: 'PCAOB - English' },
	{ value: 32, label: 'PCAOB - Spanish (Latin America)' },
	{ value: 33, label: 'PCAOB - French (Canada)' },
	{ value: 34, label: 'PCAOB - Dutch' },
	{ value: 35, label: 'PCAOB - Croatian' },
	{ value: 36, label: 'PCAOB - Czech' },
	{ value: 37, label: 'PCAOB - Danish' },
	{ value: 38, label: 'PCAOB - Finnish' },
	{ value: 39, label: 'PCAOB - German (Germany, Austria)' },
	{ value: 40, label: 'PCAOB - Hungarian' },
	{ value: 41, label: 'PCAOB - Italian' },
	{ value: 42, label: 'PCAOB - Japanese (Japan)' },
	{ value: 43, label: 'PCAOB - Norwegian (Norway)' },
	{ value: 44, label: 'PCAOB - Polish' },
	{ value: 45, label: 'PCAOB - Slovak' },
	{ value: 46, label: 'PCAOB - Slovenian' },
	{ value: 47, label: 'PCAOB - Swedish' },
	{ value: 48, label: 'PCAOB - Arabic' },
	{ value: 49, label: 'PCAOB - Simplified Chinese (China)' },
	{ value: 50, label: 'PCAOB - Traditional Chinese (Taiwan)' },
	{ value: 51, label: 'PCAOB - Greek' },
	{ value: 52, label: 'PCAOB - Hebrew (Israel)' },
	{ value: 53, label: 'PCAOB - Indonesian' },
	{ value: 54, label: 'PCAOB - Korean (Republic of Korea)' },
	{ value: 55, label: 'PCAOB - Portuguese (Brazil)' },
	{ value: 56, label: 'PCAOB - Romanian' },
	{ value: 57, label: 'PCAOB - Russian (Russia)' },
	{ value: 58, label: 'PCAOB - Thai' },
	{ value: 59, label: 'PCAOB - Turkish' },
	{ value: 60, label: 'PCAOB - Vietnamese' }
];

export const KnowledgeCountry = [
	{ value: 1, label: 'Mayotte' },
	{ value: 2, label: 'British Virgin Islands' },
	{ value: 3, label: 'Spain' },
	{ value: 4, label: 'Belize' },
	{ value: 5, label: 'Peru' },

	{ value: 6, label: 'Slovakia' },
	{ value: 7, label: 'Venezuela' },
	{ value: 8, label: 'Norway' },
	{ value: 9, label: 'Falkland Islands (Malvinas)' },
	{ value: 10, label: 'Mozambique' },

	{ value: 11, label: 'China' },
	{ value: 12, label: 'Sudan' },
	{ value: 13, label: 'Israel' },
	{ value: 14, label: 'Belgium' },
	{ value: 15, label: 'Saudi Arabia' },

	{ value: 16, label: 'Gibraltar' },
	{ value: 17, label: 'Guam' },
	{ value: 18, label: 'Norfolk Islands' },
	{ value: 19, label: 'Zambia' },
	{ value: 20, label: 'Reunion' },

	{ value: 21, label: 'Azerbaijan' },
	{ value: 22, label: 'Saint Helena' },
	{ value: 23, label: 'Iran' },
	{ value: 24, label: 'Monaco' },
	{ value: 25, label: 'Saint Pierre and Miquelon' },

	{ value: 26, label: 'New Zealand' },
	{ value: 27, label: 'Cook Islands' },
	{ value: 28, label: 'Saint Lucia' },
	{ value: 29, label: 'Zimbabwe' },
	{ value: 30, label: 'Iraq' },

	{ value: 31, label: 'Tonga' },
	{ value: 32, label: 'American Samoa' },
	{ value: 33, label: 'Maldives' },
	{ value: 34, label: 'Morocco' },
	{ value: 35, label: 'International Standards on Auditing (ISA)' },

	{ value: 36, label: 'Albania' },
	{ value: 37, label: 'Afghanistan' },
	{ value: 38, label: 'Gambia' },
	{ value: 39, label: 'Burkina Faso' },
	{ value: 40, label: 'Tokelau' },

	{ value: 41, label: 'Libya' },
	{ value: 42, label: 'Canada' },
	{ value: 43, label: 'United Arab Emirates' },
	{ value: 44, label: "Korea,Democratic People's Republic of" },
	{ value: 45, label: 'Montserrat' },

	{ value: 46, label: 'Greenland' },
	{ value: 47, label: 'Rwanda' },
	{ value: 48, label: 'Fiji' },
	{ value: 49, label: 'Djibouti' },
	{ value: 50, label: 'Botswana' },

	{ value: 51, label: 'Kuwait' },
	{ value: 52, label: 'Madagascar' },
	{ value: 53, label: 'Isle of Man' },
	{ value: 54, label: 'Hungary' },
	{ value: 55, label: 'Namibia' },

	{ value: 56, label: 'Malta' },
	{ value: 57, label: 'Jersey' },
	{ value: 58, label: 'Thailand' },
	{ value: 59, label: 'Saint Kitts and Nevis' },
	{ value: 60, label: 'Bhutan' },

	{ value: 61, label: 'Panama' },
	{ value: 62, label: 'Somalia' },
	{ value: 63, label: 'Bahrain' },
	{ value: 64, label: 'Bosnia and Herzegovina' },
	{ value: 65, label: 'France' },

	{ value: 66, label: 'Korea,Republic of' },
	{ value: 67, label: 'Iceland' },
	{ value: 68, label: 'Portugal' },
	{ value: 69, label: 'Tunisia' },
	{ value: 70, label: 'Ghana' },

	{ value: 71, label: 'Cameroon' },
	{ value: 72, label: 'Greece' },
	{ value: 73, label: 'French Southern Territories' },
	{ value: 74, label: 'Heard and McDonald Islands' },
	{ value: 75, label: 'Andorra' },

	{ value: 76, label: 'Luxembourg' },
	{ value: 77, label: 'Samoa' },
	{ value: 78, label: 'Anguilla' },
	{ value: 79, label: 'Netherlands' },
	{ value: 80, label: 'Guinea-Bissau' },

	{ value: 81, label: 'Nicaragua' },
	{ value: 82, label: 'Paraguay' },
	{ value: 83, label: 'Antigua and Barbuda' },
	{ value: 84, label: 'International Financial Reporting Standard (IFRS)' },
	{ value: 85, label: 'Niger' },

	{ value: 86, label: 'Egypt' },
	{ value: 87, label: 'Vatican City State' },
	{ value: 88, label: 'Latvia' },
	{ value: 89, label: 'Cyprus' },
	{ value: 90, label: 'US Minor Outlying Islands' },

	{ value: 91, label: 'Russia' },
	{ value: 92, label: 'Saint Vincent and the Grenadines' },
	{ value: 93, label: 'Guernsey' },
	{ value: 94, label: 'Burundi' },
	{ value: 95, label: 'Cuba' },

	{ value: 96, label: 'Equatorial Guinea' },
	{ value: 97, label: 'British Indian Ocean Territory' },
	{ value: 98, label: 'Sweden' },
	{ value: 99, label: 'Uganda' },
	{ value: 100, label: 'Macedonia,the Former Yugoslav Republic of' },

	{ value: 101, label: 'Swaziland' },
	{ value: 102, label: 'El Salvador' },
	{ value: 103, label: 'Kyrgyzstan' },
	{ value: 104, label: 'Ireland' },
	{ value: 105, label: 'Kazakhstan' },

	{ value: 106, label: 'Honduras' },
	{ value: 107, label: 'Uruguay' },
	{ value: 108, label: 'Georgia' },
	{ value: 109, label: 'Trinidad and Tobago' },
	{ value: 110, label: 'Palestinian Authority' },

	{ value: 111, label: 'Martinique' },
	{ value: 112, label: 'Aland Islands' },
	{ value: 113, label: 'French Polynesia' },
	{ value: 114, label: 'Ivory Coast' },
	{ value: 115, label: 'Montenegro' },

	{ value: 116, label: 'South Africa' },
	{ value: 117, label: 'South Georgia and the South Sandwich Islands' },
	{ value: 118, label: 'Yemen' },
	{ value: 119, label: 'Hong Kong China' },
	{ value: 120, label: 'Kenya' },

	{ value: 121, label: 'Chad' },
	{ value: 122, label: 'Colombia' },
	{ value: 123, label: 'Costa Rica' },
	{ value: 124, label: 'Angola' },
	{ value: 125, label: 'Lithuania' },

	{ value: 126, label: 'Syria' },
	{ value: 127, label: 'Malaysia' },
	{ value: 128, label: 'Sierra Leone' },
	{ value: 129, label: 'Serbia' },
	{ value: 130, label: 'Poland' },

	{ value: 131, label: 'Suriname' },
	{ value: 132, label: 'Haiti' },
	{ value: 133, label: 'Nauru' },
	{ value: 134, label: 'Sao Tome and Principe' },
	{ value: 135, label: 'Svalbard and Jan Mayen' },

	{ value: 136, label: 'Singapore' },
	{ value: 137, label: 'Moldova' },
	{ value: 138, label: 'Taiwan' },
	{ value: 139, label: 'Senegal' },
	{ value: 140, label: 'Gabon' },

	{ value: 141, label: 'Mexico' },
	{ value: 142, label: 'Seychelles' },
	{ value: 143, label: 'Micronesia,Federated States of' },
	{ value: 144, label: 'Algeria' },
	{ value: 145, label: 'Italy' },

	{ value: 146, label: 'San Marino' },
	{ value: 147, label: 'Liberia' },
	{ value: 148, label: 'Brazil' },
	{ value: 149, label: 'Croatia' },
	{ value: 150, label: 'Faroe Islands' },

	{ value: 151, label: 'Palau' },
	{ value: 152, label: 'Finland' },
	{ value: 153, label: 'Philippines' },
	{ value: 154, label: 'Jamaica' },
	{ value: 155, label: 'French Guiana' },

	{ value: 156, label: 'Cape Verde' },
	{ value: 157, label: 'Myanmar' },
	{ value: 158, label: 'Lesotho' },
	{ value: 159, label: 'US Virgin Islands' },
	{ value: 160, label: 'Cayman Islands' },

	{ value: 161, label: 'Niue' },
	{ value: 162, label: 'Togo' },
	{ value: 163, label: 'Belarus' },
	{ value: 164, label: 'Dominica' },
	{ value: 165, label: 'Indonesia' },

	{ value: 166, label: 'Uzbekistan' },
	{ value: 167, label: 'Nigeria' },
	{ value: 168, label: 'Wallis and Futuna' },
	{ value: 169, label: 'Barbados' },
	{ value: 170, label: 'Sri Lanka' },

	{ value: 171, label: 'United Kingdom' },
	{ value: 172, label: 'Ecuador' },
	{ value: 173, label: 'Guadeloupe' },
	{ value: 174, label: 'Laos' },
	{ value: 175, label: 'Jordan' },

	{ value: 176, label: 'Solomon Islands' },
	{ value: 177, label: 'East Timor' },
	{ value: 178, label: 'Lebanon' },
	{ value: 179, label: 'Central African Republic' },
	{ value: 180, label: 'India' },

	{ value: 181, label: 'Christmas Island' },
	{ value: 182, label: 'Vanuatu' },
	{ value: 183, label: 'Brunei' },
	{ value: 184, label: 'Bangladesh' },
	{ value: 185, label: 'Antarctica' },

	{ value: 186, label: 'Bolivia' },
	{ value: 187, label: 'Turkey' },
	{ value: 188, label: 'Bahamas' },
	{ value: 189, label: 'Comoros' },
	{ value: 190, label: 'Western Sahara' },

	{ value: 191, label: 'Czech Republic' },
	{ value: 192, label: 'Ukraine' },
	{ value: 193, label: 'Estonia' },
	{ value: 194, label: 'Bulgaria' },
	{ value: 195, label: 'Mauritania' },

	{ value: 196, label: 'Congo,The Democratic Republic of the' },
	{ value: 197, label: 'Liechtenstein' },
	{ value: 198, label: 'Pitcairn' },
	{ value: 199, label: 'Denmark' },
	{ value: 200, label: 'Marshall Islands' },

	{ value: 201, label: 'Japan' },
	{ value: 202, label: 'Austria' },
	{ value: 203, label: 'Oman' },
	{ value: 204, label: 'Mongolia' },
	{ value: 205, label: 'Tajikistan' },

	{ value: 206, label: 'Switzerland' },
	{ value: 207, label: 'Guatemala' },
	{ value: 208, label: 'Eritrea' },
	{ value: 209, label: 'Nepal' },
	{ value: 210, label: 'Mali' },

	{ value: 211, label: 'Slovenia' },
	{ value: 212, label: 'Northern Mariana Islands' },
	{ value: 213, label: '(Not Applicable)' },
	{ value: 214, label: 'Aruba' },
	{ value: 215, label: 'Congo' },

	{ value: 216, label: 'Qatar' },
	{ value: 217, label: 'Guinea' },
	{ value: 218, label: 'United States' },
	{ value: 219, label: 'Ethiopia' },
	{ value: 220, label: 'Other' },

	{ value: 221, label: 'Guyana' },
	{ value: 222, label: 'Germany' },
	{ value: 223, label: 'Bermuda' },
	{ value: 224, label: 'Turks and Caicos Islands' },
	{ value: 225, label: 'Australia' },

	{ value: 226, label: 'Kiribati' },
	{ value: 227, label: 'Puerto Rico' },
	{ value: 228, label: 'Pakistan' },
	{ value: 229, label: 'Mauritius' },
	{ value: 230, label: 'Malawi' },

	{ value: 231, label: 'Turkmenistan' },
	{ value: 232, label: 'Cambodia' },
	{ value: 233, label: 'Chile' },
	{ value: 234, label: 'New Caledonia' },
	{ value: 235, label: 'Papua New Guinea' },

	{ value: 236, label: 'Bouvet Island' },
	{ value: 237, label: 'Tuvalu' },
	{ value: 238, label: 'Curacao' },
	{ value: 239, label: 'Dominican Republic' },
	{ value: 240, label: 'Vietnam' },

	{ value: 241, label: 'Cocos (Keeling) Islands' },
	{ value: 242, label: 'Grenada' },
	{ value: 243, label: 'Tanzania' },
	{ value: 244, label: 'Argentina' },
	{ value: 245, label: 'Macau, China' },

	{ value: 246, label: 'Benin' },
	{ value: 247, label: 'Romania' },
	{ value: 248, label: 'Armenia' },
	{ value: 249, label: 'global' },
	{ value: 250, label: 'IFRS for SMEs' },

	{ value: 251, label: 'US GAAP' },
	{ value: 252, label: 'AICPA financial reporting framework for small and medium sized entities' },
	{ value: 253, label: 'South Sudan' }
];

export const pagingSvgHoverText = {
	first: 'First Page',
	previous: 'Previous Page',
	next: 'Next Page',
	last: 'Last Page'
};

export const priorityTypesForDropdown = [
	{ value: 1, label: 'Low', className: 'Low' },
	{ value: 2, label: 'Medium', className: 'Medium' },
	{ value: 3, label: 'High', className: 'High' },
	{ value: 4, label: 'Critical', className: 'Critical' }
];

export const reviewNoteFilterTypes = [
	{ value: 0, label: 'All' },
	{ value: 1, label: 'Open' },
	{ value: 2, label: 'Cleared' },
	{ value: 3, label: 'Closed' }
];

export const RejectionCategory = [
	{ id: 1, label: 'Likelihood - no reasonable possibility of occurring (without consideration of controls)' },
	{ id: 2, label: 'Magnitude - potential misstatement is immaterial' },
	{ id: 3, label: 'Risk is not material for this engagement' },
	{ id: 4, label: 'ROMM is addressed in another engagement (Group audits only)' },
	{ id: 5, label: 'Other' },
	{ id: 6, label: 'Addressed by business controls for a significant account or disclosure (specify the controls)' },
	{ id: 7, label: 'Addressed in a service organization report (e.g., SOC1)' },
	{ id: 8, label: 'Applicable, but addressed in another EY Canvas engagement' }
];

export const reviewStatus = [
	{ id: 1, name: 'Open' },
	{ id: 2, name: 'Cleared' },
	{ id: 3, name: 'Closed' }
];

export const reviewNoteOpenStatusOption = [
	{ value: 2, label: 'Clear' },
	{ value: 3, label: 'Close' }
];

export const reviewNoteClearedStatusOption = [
	{ value: 1, label: 'Reopen' },
	{ value: 3, label: 'Close' }
];

export const reviewNoteBulkClearedStatusOption = [
	{ value: 1, label: 'Reopen' },
	{ value: 2, label: 'Clear' },
	{ value: 3, label: 'Close' }
];

export const reviewNoteClosedStatusOption = [
	{ value: 1, label: 'Reopen' },
	{ value: 4, label: 'Delete' }
];

export const taskTypeBadge = {
	1: 'OST',
	2: 'PST',
	3: 'UDP',
	4: 'TOC',
	5: 'OSP',
	6: 'PSP',
	7: 'RT',
	8: 'GT',
	9: 'PIC',
	10: 'EQR',
	11: 'PIC/EQR',
	12: 'ST',
	13: 'OST',
	14: 'PST',
	15: 'ST',
	16: 'OSP',
	17: 'PSP',
	18: 'WT',
	19: 'UDP',
	20: 'SCOT',
	22: 'ACT',
	23: 'UDP',
	24: 'GT',
	25: 'GT',
	26: 'OSP',
	27: 'GT',
	28: 'ESTIMATES',
	29: 'EDC',
	30: 'UDP',
	32: 'EDC',
	31: 'UDPS',
	33: 'RT',
	34: 'RT',
	35: 'RT'
};
export const taskTypeBadgeLabel = {
	OST: {
		label: 'Other standard tasks',
		count: 0,
		warningLabel: `Each control must have at least one other standard task. Create {0} or {1}.`,
		newLabel: 'New OST',
		relateLabel: 'Relate OSTs',
		taskTypeId: 1,
		translation: taskTypeBadge[1]
	},
	PST: {
		label: 'Primary standard tasks',
		count: 0,
		warningLabel: `Each control must have at least one primary standard task. Create {0} or {1}.`,
		newLabel: 'New PST',
		relateLabel: 'Relate PSTs',
		taskTypeId: 2,
		translation: taskTypeBadge[2]
	},
	WT: {
		label: 'Understand and document the process tasks',
		count: 0,
		warningLabel: 'Each control tested must have at least one evaluate the design of the control task',
		newLabel: 'New UDP',
		relateLabel: 'Relate UDP',
		taskTypeId: 19,
		translation: taskTypeBadge[3]
	},
	TOC: {
		label: 'Test of control tasks',
		count: 0,
		warningLabel: `Each control must have at least one related test of control task. Create {0} or {1}.`,
		newLabel: 'New TOC',
		relateLabel: 'Relate TOC',
		taskTypeId: 2,
		translation: taskTypeBadge[4],
		taskNamePrefix: '{0} - Test of control',
		taskDescription: 'Perform our designed tests of the control to obtain sufficient appropriate evidence of its operating effectiveness throughout the period of reliance.'
	},
	OSP: {
		label: 'Other substantive procedure tasks',
		count: 0,
		warningLabel: `Each control must have at least one other substantive procedure task. Create {0} or {1}.`,
		newLabel: 'New OSP',
		relateLabel: 'Relate OSPs',
		taskTypeId: 5,
		translation: taskTypeBadge[5]
	},
	PSP: {
		label: 'Primary substantive procedure tasks',
		count: 0,
		warningLabel: `Each control must have at least one primary substantive procedure task. Create {0} or {1}.`,
		newLabel: 'New PSP',
		relateLabel: 'Relate PSPs',
		taskTypeId: 6,
		translation: taskTypeBadge[6]
	},
	RT: {
		label: 'Response tasks',
		count: 0,
		warningLabel: `Each control must have at least one response task. Create {0} or {1}.`,
		newLabel: 'New RT',
		relateLabel: 'Relate RTs',
		taskTypeId: 7,
		translation: taskTypeBadge[7]
	},
	GT: {
		label: 'Group tasks',
		count: 0,
		warningLabel: `Each control must have at least one group task. Create {0} or {1}.`,
		newLabel: 'New GT',
		relateLabel: 'Relate GTs',
		taskTypeId: 8,
		translation: taskTypeBadge[8]
	},
	ACT: {
		label: 'Account conclusion tasks',
		count: 0,
		warningLabel: `Each control must have at least one account conclusion task. Create {0} or {1}.`,
		newLabel: 'New ACT',
		relateLabel: 'Relate ACTs',
		taskTypeId: 22,
		translation: taskTypeBadge[22]
	},
	UDP: {
		label: 'UDP tasks',
		count: 0,
		warningLabel: `Each control must have at least one UDP task. Create {0} or {1}.`,
		newLabel: 'New UDP',
		relateLabel: 'Relate UDP',
		taskTypeId: 23,
		translation: taskTypeBadge[23]
	},
	ITRA: {
		label: 'UDP tasks',
		count: 0,
		warningLabel: `Each technology must have at least one related UDP. Create {0} or {1}.`,
		newLabel: 'New UDP',
		relateLabel: 'Relate UDPs',
		taskTypeId: TaskTypeEnum.WALKTHROUGH_TASK_IT_RISK_ASSESSMENT,
		translation: taskTypeBadge[TaskTypeEnum.WALKTHROUGH_TASK_IT_RISK_ASSESSMENT],
		taskNamePrefix: '{0} - IT Risk Assessment',
		taskDescription: 'Identify relevant IT processes and associated IT risks based on the characteristics of how the entity uses the relevant information technology.'
	},
	SCOT: {
		label: 'UDP (Scot) tasks',
		count: 0,
		warningLabel: `Each SCOT must have at least one understand and document the process (UDP) task. Create {0} or {1}.`,
		newLabel: 'New UDP',
		relateLabel: 'Relate UDP',
		taskTypeId: 20,
		translation: 'SCOTs',
		taskNamePrefix: '{0} - Understand',
		taskDescription: 'Obtain and document our understanding of the process.'
	},
	ESTIMATE: {
		label: 'Estimate tasks',
		count: 0,
		warningLabel: `Each Estimate must have at least one understand and document the process (UDP) task. Create {0} or {1}.`,
		newLabel: 'New UDP',
		relateLabel: 'Relate UDP',
		taskTypeId: 28,
		translation: 'Estimates',
		taskNamePrefix: '{0} - Understand',
		taskDescription: 'Obtain and document our understanding of the estimation process.'
	},
	EDC: {
		label: 'EDC tasks',
		count: 0,
		warningLabel: `Each control must have at least one Evaluate the design of controls (EDC) task. Create {0} or {1}.`,
		newLabel: 'New EDC',
		relateLabel: 'Relate EDC',
		taskTypeId: 29,
		translation: taskTypeBadge[3],
		taskNamePrefix: '{0} - Evaluate the design of the control',
		taskDescription: 'Evaluate the design of the control and determine whether it has been implemented.'
	},
	ITPUDP: {
		label: 'UDP tasks',
		count: 0,
		warningLabel: `Each IT process must have at least one related UDP. Create {0} or {1}.`,
		newLabel: 'New UDP',
		relateLabel: 'Relate UDP',
		taskTypeId: 19,
		translation: taskTypeBadge[23],
		taskNamePrefix: '{0} - Understand',
		taskDescription: 'Obtain and document our understanding of the IT process.'
	},
	ITSCOPING: {
		label: 'Technologies and related IT scope & strategy tasks',
		count: 0,
		warningLabel: `Each technology must have at least one related UDP. Create {0} or {1}.`,
		newLabel: 'New UDP',
		relateLabel: 'Relate UDPs',
		taskTypeId: 30,
		translation: taskTypeBadge[30],
		taskNamePrefix: '{0} - IT scope & strategy',
		taskDescription: 'Determine relevance and planned ITGC reliance for the information technology and perform other scoping procedures as required.'
	},
	ITSPOSP: {
		label: 'IT substantive procedures and related tasks',
		count: 0,
		warningLabel: ` Each IT substantive procedure must have at least one related OSP. Create {0} or {1}.`,
		newLabel: 'New OSP',
		relateLabel: 'Relate OSP',
		taskTypeId: 26,
		translation: taskTypeBadge[26],
		taskNamePrefix: '',
		taskDescription: 'Customize this task description to design the nature, timing and extent of IT-substantive procedures to obtain sufficient appropriate audit evidence that the IT risk(s) is addressed throughout the period of reliance, as necessary.'
	},
	WALKTHROUGHTASKCONTROL: {
		label: 'IT general controls and related tasks',
		count: 0,
		warningLabel: `Each ITGC must have at least one related EDC. Create {0} or {1}.`,
		newLabel: 'New EDC',
		relateLabel: 'Relate EDC',
		taskTypeId: 32,
		translation: taskTypeBadge[32],
		taskNamePrefix: '{0} - Evaluate the design of the ITGC',
		taskDescription: 'Evaluate the design of the ITGC and determine whether it has been implemented.'
	},
	CONTROLTASKITSO: {
		label: 'IT general controls and related tasks',
		count: 0,
		warningLabel: `Each tested ITGC must have at least one TOC. Create {0} or {1}.`,
		newLabel: 'New TOC',
		relateLabel: 'Relate TOC',
		taskTypeId: 4,
		translation: taskTypeBadge[4],
		taskNamePrefix: '{0} - Test of ITGC',
		taskDescription: 'Perform our designed tests of ITGC to obtain sufficient appropriate evidence of its operating effectiveness throughout the period of reliance.'
	},
	WALKTHROUGHTASKITCONTROL: {
		label: 'IT general controls and related tasks',
		count: 0,
		warningLabel: `Each ITGC must have at least one related EDC. Create {0} or {1}.`,
		newLabel: 'New EDC',
		relateLabel: 'Relate EDCs',
		taskTypeId: 32,
		translation: taskTypeBadge[32],
		taskNamePrefix: '{0} - Evaluate the design of the ITGC',
		taskDescription: 'Evaluate the design of the ITGC and determine whether it has been implemented.'
	},
	CONTROLTASKITSOV2: {
		label: 'IT general controls and related tasks',
		count: 0,
		warningLabel: `Each tested ITGC must have at least one TOC. Create {0} or {1}.`,
		newLabel: 'New TOC',
		relateLabel: 'Relate TOCs',
		taskTypeId: 4,
		translation: taskTypeBadge[4],
		taskNamePrefix: '{0} - Test of ITGC',
		taskDescription: 'Perform our designed tests of ITGC to obtain sufficient appropriate evidence of its operating effectiveness throughout the period of reliance.'
	},
	DEFICIENCYRESPONSETASKV2: {
		label: 'Tasks',
		count: 0,
		warningLabel: `Each deficiency must have at least one related RT. Create {0} or {1}.`,
		newLabel: 'New RT',
		relateLabel: 'Relate RT',
		newDeficiencyLinkLabel: 'Create new deficiency task',
		relateDeficiencyLinkLabel: 'relate deficiency tasks',
		taskTypeId: 34,
		taskNamePrefix: '{0} - Response',
		taskDescription: 'Determine whether the control deficiency constitutes a significant deficiency (or material weakness if required to be communicated in the jurisdiction) in internal control to be communicated to those charged with governance. Assess the effect of the control deficiency on our audit.',
		translation: taskTypeBadge[34]
	},
	ITDEFICIENCYRESPONSETASKV2: {
		label: 'Tasks',
		count: 0,
		warningLabel: `Each deficiency must have at least one related RT. Create {0} or {1}.`,
		newLabel: 'New RT',
		relateLabel: 'Relate RT',
		newDeficiencyLinkLabel: 'Create new deficiency task',
		relateDeficiencyLinkLabel: 'relate deficiency tasks',
		taskTypeId: 35,
		taskNamePrefix: '{0} - Response',
		taskDescription: 'Determine whether the control deficiency constitutes a significant deficiency (or material weakness if required to be communicated in the jurisdiction) in internal control to be communicated to those charged with governance. Assess the effect of the control deficiency on our audit.',
		translation: taskTypeBadge[35]
	}
};
export const riskTypes = [
	{ id: 1, name: 'Significant risks', abbrev: 'S', label: 'Significant', title: 'Significant risk' },
	{ id: 2, name: 'Fraud risks', abbrev: 'F', label: 'Fraud', title: 'Fraud risk' },
	{
		id: 3,
		name: 'Risk of material misstatement',
		abbrev: 'R',
		label: 'Risk of material misstatement',
		title: 'Risk of material misstatement'
	},
	//This is not a db representation of a valid risk type. This is just an UI sub category of how types 3 are displayed.
	{
		id: 99,
		name: 'Higher risk',
		abbrev: 'H',
		label: 'Higher risk',
		title: 'Higher risk'
	},
	//Reference risks reuse the R/H abbreviations, so 'label' is the suffix shown after each risk name.
	{
		id: 17,
		name: 'Reference ROMMs',
		abbrev: 'R',
		label: 'Ref.',
		title: 'Reference ROMMs'
	}
];

export const relatedRisksDropdownRiskTypes = [
	{ id: 1, name: 'Significant risk', abbrev: 'S', label: 'Significant', title: 'Significant risk' },
	{ id: 2, name: 'Fraud risk', abbrev: 'F', label: 'Fraud', title: 'Fraud risk' },
	{
		id: 3,
		name: 'Risk of material misstatement',
		abbrev: 'R',
		label: 'Risk of material misstatement',
		title: 'Risk of material misstatement'
	}
];

export const estimateTypes = [
	{ id: 4, name: 'Very low risk estimate', abbrev: 'VLRE', label: 'Very Low', title: 'Very low risk estimate' },
	{ id: 5, name: 'Lower risk estimate', abbrev: 'LRE', label: 'Lower', title: 'Lower risk estimate' },
	{ id: 6, name: 'Higher risk estimate', abbrev: 'HRE', label: 'Higher', title: 'Higher risk estimate' },
	{ id: 7, name: 'Estimate - Not selected', abbrev: 'NA', label: 'Not selected', title: 'Estimate - Not selected' }
];

export const statementTypes = [
	{ id: 1, name: 'Income Statement' },
	{ id: 2, name: 'Balance Sheet' },
	{ id: 3, name: 'Both' }
];

export const RbacErrors = {
	106: 'Insufficient permissions to edit content. Work with an engagement administrator to get sufficient rights.'
};

export const HelixProjectValidationErrors = {
	800: 'It looks like you have not accessed EY Helix before? Go to',
	801: 'You are not an authorized team member of the linked project. Contact the EY Helix project administrator to get access.',
	901: 'The selected EY Helix Project is no longer available. Click EY Helix projects to link a new project.',
	902: 'The selected EY Helix Project is marked for deletion. Click EY Helix projects to link a new project.',
	903: 'The selected EY Helix Project is marked for storage. Click EY Helix projects to link a new project.',
	926: 'The selected analyzer is not available in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.',
	927: 'Analytics are not available in the linked project. Go to EY Helix and complete the data & analytics processing steps to continue.',
	928: 'Invalid or missing analyzer in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.',
	929: 'An error occurred related to the linked EY Helix project. Data cannot be imported.'
};

export const EngagementProfileRequirementErrors = {
	108: 'Engagement Profile is not complete.'
};

export const IndependenceRequirementErrors = {
	103: 'Missing Engagement user independence compliance.'
};

export const strategyTypes = [
	{ id: 3, name: 'In scope' },
	{ id: 4, name: 'Out of scope' }
];

export const itAppTypes = [
	{ value: 0, label: 'IT application' },
	{ value: 1, label: 'Service Organization' }
];

export const confidentialityLevels = {
	[confidentialityTypes.DEFAULT]: 'Default',
	[confidentialityTypes.LOW]: 'Low',
	[confidentialityTypes.MODERATE]: 'Moderate',
	[confidentialityTypes.HIGH]: 'High'

	// This has been disabled for release 2.5, uncomment if required
	// [confidentialityTypes.CONFIDENTIAL]: 'Confidential'
};

export const formBodyOptionRiskTypes = [
	{ id: 1, label: 'Significant Risk' },
	{ id: 2, label: 'Fraud Risk' },
	{ id: 99, label: 'Higher Risk' },
	{ id: 3, label: 'Risk of material misstatement' }
];

export const formViewTypes = [
	{ value: 0, label: 'Form' },
	{ value: 1, label: 'Changes' },
	{ value: 2, label: 'Details' }
];

export const railFilterValidations = [
	{ value: 0, label: 'All' },
	{ value: 1, label: 'Incomplete responses' },
	{ value: 2, label: 'Unresolved comments' }
];

export const aresRiskTypes = [
	{ id: 1, name: 'Significant risk' },
	{ id: 2, name: 'Fraud risk' },
	{ id: 3, name: 'Risk of material misstatement' },
	{ id: 4, name: 'Very low risk estimate' },
	{ id: 5, name: 'Lower risk estimate' },
	{ id: 6, name: 'Higher risk estimate' },
	{ id: 7, name: 'Estimate - Not selected' }
];

export const materialityTypes = [
	{ value: 1, label: 'Pretax income' },
	{ value: 2, label: 'EBIT (Earnings before interest and taxes)' },
	{ value: 3, label: 'EBITDA (Earnings before interest, taxes, depreciation, and amortization)' },
	{ value: 4, label: 'Gross margin' },
	{ value: 5, label: 'Revenues' },
	{ value: 6, label: 'Operating expenses' },
	{ value: 7, label: 'Equity' },
	{ value: 8, label: 'Assets' },
	{ value: 9, label: 'Activity based measures (Other)' },
	{ value: 10, label: 'Pretax losses' },
	{ value: 11, label: 'Capital based measures (Other)' },
	{ value: 12, label: 'Earnings based measures (Other)' },
	{ value: 13, label: 'Normalized earnings' },
	{ value: 14, label: 'Funds from operations' },
	{ value: 15, label: 'Net asset value' },
	{ value: 16, label: 'Net assets without donor restrictions' },
	{ value: 17, label: 'Operating revenues' },
	{ value: 18, label: 'Excess net capital' },
	{ value: 19, label: 'Capital and surplus' }
];

export const helixCurrencyType = {
	[currencyType.Functional]: 'Functional',
	[currencyType.Reporting]: 'Reporting'
};

export const controlRiskType = [
	{
		id: 1,
		name: 'Rely'
	},
	{
		id: 2,
		name: 'Not rely'
	},
	{
		id: 3,
		name: 'Test MP'
	}
];

export const inherentRiskType = [
	{
		id: 1,
		name: 'Higher'
	},
	{
		id: 2,
		name: 'Lower'
	},
	{
		id: 3,
		name: 'Very Low'
	}
];

export const AlraInherentRiskType = [
	{
		id: 3,
		name: 'Not Relevant'
	},
	{
		id: 2,
		name: 'Lower'
	},
	{
		id: 1,
		name: 'Higher'
	}
];

export const scotInherentRiskType = [
	{
		id: 1,
		name: 'Higher'
	},
	{
		id: 2,
		name: 'Lower'
	},
	{
		id: 3,
		name: 'Non-routine SCOT'
	}
];

export const CRAStrings = {
	Minimal: 'Minimal',
	Low: 'Low',
	'Low +SC': 'Low',
	Moderate: 'Moderate',
	High: 'High',
	'High +SC': 'High'
};

export const priorityType = [
	{
		id: 1,
		name: 'Low',
		className: 'Low',
		label: 'L'
	},
	{
		id: 2,
		name: 'Medium',
		className: 'Medium',
		label: 'M'
	},
	{
		id: 3,
		name: 'High',
		className: 'High',
		label: 'H'
	},
	{
		id: 4,
		name: 'Critical',
		className: 'Critical',
		label: 'C'
	}
];

export const kendoLabels = {
	addComment: 'Add comment',
	addColumnBefore: 'Add column to left',
	addColumnAfter: 'Add column to right',
	addInlineComment: 'Add inline comment',
	addRowAbove: 'Add row above',
	addRowBelow: 'Add row below',
	alignLeft: 'Justify left',
	alignRight: 'Justify right',
	alignCenter: 'Justify center',
	alignFull: 'Justify full',
	backgroundColor: 'Background color',
	bulletList: 'Insert unordered list',
	bold: 'Bold',
	backColor: 'Highlight',
	createLink: 'Insert hyperlink',
	createTable: 'Create table',
	cleanFormatting: 'Clean formatting',
	deleteRow: 'Delete row',
	deleteColumn: 'Delete column',
	deleteTable: 'Delete table',
	fontSizeInherit: 'Font size',
	foreColor: 'Font color',
	format: 'Format',
	fontSize: 'Font size',
	hyperlink: 'Insert link',
	italic: 'Italic',
	indent: 'Indent',
	insertTableHint: 'Create a {0} by {1} table',
	huge: 'Huge',
	'hyperlink-dialog-content-address': 'Web Address',
	'hyperlink-dialog-title': 'Insert hyperlink',
	'hyperlink-dialog-content-title': 'Title',
	'hyperlink-dialog-content-newwindow': 'Open link in new window',
	'hyperlink-dialog-cancel': 'Cancel',
	'hyperlink-dialog-insert': 'Insert',
	large: 'Large',
	noDataPlaceholder: 'Enter text',
	normal: 'Normal',
	orderedList: 'Insert ordered list',
	outdent: 'Outdent',
	paragraphSize: 'Paragraph size',
	print: 'Print',
	pdf: 'Export to pdf',
	redo: 'Redo',
	removeFormatting: 'Remove formatting',
	strikethrough: 'Strikethrough',
	small: 'Small',
	subscript: 'Subscript',
	superscript: 'Superscript',
	underline: 'Underline',
	undo: 'Undo',
	unlink: 'Unlink',
	'ql-tooltip-visit-url': 'Visit URL:',
	'ql-tooltip-enter-link': 'Enter link:',
	'ql-tooltip-edit': 'Edit',
	'ql-tooltip-remove': 'Remove',
	'ql-tooltip-save': 'Save'
};

export const kendoFormatOptions = [
	{ text: 'Paragraph', value: 'p' },
	{ text: 'Heading 1', value: 'h1' },
	{ text: 'Heading 2', value: 'h2' },
	{ text: 'Heading 3', value: 'h3' },
	{ text: 'Heading 4', value: 'h4' },
	{ text: 'Heading 5', value: 'h5' },
	{ text: 'Heading 6', value: 'h6' }
];

export const kendoFontSize = [
	{ text: '8', value: '8px' },
	{ text: '9', value: '9px' },
	{ text: '10', value: '10px' },
	{ text: '11', value: '11px' },
	{ text: '12', value: '12px' },
	{ text: '14', value: '14px' },
	{ text: '16', value: '16px' },
	{ text: '18', value: '18px' },
	{ text: '20', value: '20px' },
	{ text: '22', value: '22px' },
	{ text: '24', value: '24px' },
	{ text: '26', value: '26px' },
	{ text: '28', value: '28px' },
	{ text: '36', value: '36px' },
	{ text: '48', value: '48px' },
	{ text: '72', value: '72px' }
];

export const ItFlowValidationLabels = {
	ITAppWithoutAtLeastOneRelatedITProcess: 'Unrelated IT application',
	ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne: 'Unrelated ITGC',
	ITSPHasNorelatedITRisk: 'Unrelated ITSP',
	ITProcessHasNoRelatedITApplication: 'Unrelated IT process',
	ITRiskHasNoITGCIsZeroHasNoRelatedITGC: 'Missing ITGC or mark none exists',
	ITSPNotDeletedWhenCorrespondingBodyIsNotDisplayed: 'ITSP to be deleted',
	ITGCNotDeletedWhenCorrespondingBodyIsNotDisplayed: 'ITGC to be deleted',
	ITRiskIsNotDeletedWhenCorrespondingBodyIsNotDisplayed: 'IT risk to be deleted',
	ITGCWithHasItControlTestingIsOneExistsWhenCorrespondingBodyIsNotDisplayed: 'ITGC with invalid testing strategy',
	ITGCWithoutASelectedDesignEffectiveness: 'Missing ITGC design evaluation',
	AnyITDMorITACWithHasControlTestingIsOneExistsAndFormBodyTypeId111IsNotDisplayed: 'Inconsistent response for testing controls',
	ITDMorITACWithNoRelatedITApplication: 'App/ITDM control with no IT app',
	SCOTWithoutITApplicationsWhereHasNoITApplicationIsZero: 'Unrelated SCOT',
	SCOTWithHasNoITApplicationHasITDMOrAppControls: 'IT application in SCOT missing',
	ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication: 'Missing IT risk',
	ValidationTypeID237: 'IT risks without ITGC',
	UnrelatedITGCsBody310: 'Unrelated reference ITGCs'
};

export const ISA315ITFlowValidationTypeResourceMapping = createISA315ITFlowValidationTypeResourceMapping(ItFlowValidationLabels);

/* Notes modal labels */

export const reviewNoteModalLabels = {
	/*Review Notes*/
	engagement: 'Engagement',
	emptyReplyErrorMsg: 'Add text to continue',
	lengthReplyErrorMsg: 'The reply cannot exceed 4,000 characters.',
	documentLabel: 'Document',
	task: 'Task',
	allEngagementFilterLabel: 'All other engagements',
	otherEngagementComments: 'Other engagement notes',
	notesModalInstructionalText: 'View and respond to notes for the selected {0} below.',
	commentThread: 'Note thread',
	singleNoteInstructionalText: 'View and respond to the selected note below.',
	emptyNoteDetailsMessage:
		'Select a note to view details. To enable bulk controls, use the control or shift key and select multiple review notes. If you would like to work on an individual note, then select that note from the list.',
	documentReviewNotesLabel: 'Document notes',
	addNewReviewNoteButtonText: 'Add note',
	noNotesAssociatedWithDocumentLabel: 'Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	noNotesFound: 'No notes found',
	noNotesAssociatedWithTaskLabel: 'There are no {0} notes associated to the task.',
	allNotesLabel: 'All notes',
	charactersLabel: 'characters',
	myNotesLabel: 'My notes',
	showClearedLabel: 'Show cleared',
	showClosedLabel: 'Show closed',
	assignedToLabel: 'Assigned to',

	ofLabel: 'of',
	enterNoteText: 'Enter note',
	addNewNoteModalClose: 'Close',
	addNewNoteModalTitleLabel: 'Add new note',
	editNoteModalTitleLabel: 'Edit note',
	deleteIconHoverText: 'Delete',
	deleteIconModalAcceptText: 'Delete',
	deleteIconModalConfirmMessage: 'Are you sure that you want to delete your reply to this note?',
	deleteIconModalConfirmMessageParent: 'Are you sure that you want to delete the selected note?',
	deleteIconModalTitleLabel: 'Delete note',
	deleteReplyIconModalTitle: 'Delete reply',
	emptyRepliesMessage: 'No replies yet',
	replyInputPlaceholder: 'Reply to this note',
	replyInputPlaceholderEdit: 'Edit reply with a note or a voice note',
	noteInputPlaceholderEdit: 'Edit with a note or a voice note',
	replyText: 'Reply text',
	editReplyModelTitle: 'Edit reply',
	editReplyPlaceholder: 'Enter reply',
	noteDueDateLabel: 'Due',

	priorityLabel: 'Priority',
	dueDateLabel: 'Due date',
	dueLabel: 'Due',
	status: 'Status',
	noteModifiedDateLabel: 'Modified',
	cancelLabel: 'Cancel',
	saveLabel: 'Save',
	clearedBy: 'Cleared by',
	closedBy: 'Closed by',
	reopenedBy: 'Reopened by',
	reply: 'Reply',
	editIconHoverTextLabel: 'Edit',
	required: 'Required',
	closeTitle: 'Close',
	otherEngagementNotes: 'Other engagement notes',
	closeLabel: 'Close',
	showMore: 'Show more',
	showLess: 'Show less',
	showMoreEllipsis: 'Show more...',
	showLessEllipsis: 'Show less...',
	noResultFound: 'No results found',
	engagementNameLabel: 'Engagement name:',
	taskReviewNotesLabel: 'Task notes',
	fromUserLabel: 'From',
	toUserLabel: 'To',
	view: 'View',
	dueDateRequiredTextError: 'Due date is required'
};

export const notesFilterLabels = [
	{ id: notesFilter.allNotes, label: 'All notes', value: notesFilter.allNotes },
	{ id: notesFilter.myNotes, label: 'My notes', value: notesFilter.myNotes },
	{ id: notesFilter.authoredByMeNotes, label: 'Assigned to me', value: notesFilter.authoredByMeNotes }
];

export const reviewerAssignments = {
	taskLayoutHeaderAssignments: 'Assignments',
	manageAssigmentsStep2: 'Edit task assignment',
	editAssignment: 'Edit assignment',
	deleteAssignment: 'Delete assignment',
	manageAssigmentsStep3: 'Complete assignment',
	taskAssigmentStatusHeader: 'Assignment status',
	taskAssignmentName: 'Assignment',
	dueDateAssigment: 'Due',
	editDueDate: 'Optional: Edit days prior to end date',
	teamMemberAssigmentLabel: 'Team member',
	currentAssigmentLabel: 'Current',
	handOffToAssigmentLabel: 'Handed off to:',
	priorToEndDateLabel: 'prior to end date',
	noTimePhaseAssigmentLabel: 'No assigned time phase',
	closedByAssigmentLabel: 'Closed by ',
	onAssingmentLabel: 'on',
	preparerAssigmentOpenTitleTip: 'Hand off this task to close your task assignment',
	reviewerAssigmentOpenTitleTip: 'Mark task assignment as closed',
	reviewerAssigmentClosedTitleTip: 'Mark task assignment as open',
	AssigmentLabel: 'Hand off this task to close your task assignment',
	timePhaseName: 'Time Phase: ',
	timePhaseEndDate: 'End date: ',
	AssignmentType: [
		{ id: 1, displayName: 'Preparer' },
		{ id: 2, displayName: 'Detail reviewer' },
		{ id: 3, displayName: 'General reviewer' },
		{ id: 4, displayName: 'Partner' },
		{ id: 5, displayName: 'EQR' },
		{ id: 6, displayName: 'Other' }
	],
	AssignmentStatus: [
		{ id: 1, displayName: 'Open' },
		{ id: 2, displayName: 'In progress' },
		{ id: 3, displayName: 'Closed' },
		{ id: 4, displayName: 'Unassigned' }
	],
	assignmentTableColumnHeader: 'Assignment',
	teamMemberTableColumnHeader: 'Team member',
	dueDaysTableColumnHeader: 'Due',
	daysPriorToEndDate: 'days prior to end date',
	handoffButton: 'Hand-off'
};
/* Notes modal labels */

export const handOffModal = {
	title: 'Hand-off',
	description: 'Hand off this task to the next team member. To sign off on an evidence file, select from the options below.',
	dropdownLabel: 'Hand-off to',
	closeTitle: 'Cancel',
	confirmButton: 'Hand-off',
	evidence: 'Evidence',
	evidenceSignOffTitle: 'Sign off on all as:',
	existingSignOffs: 'Existing sign-offs',
	noDocumentsAvailable: 'No documents available'
};

// manage scot modal labels
export const manageSCOTModal = {
	title: 'Manage SCOTs',
	description: 'You can create, edit or delete existing SCOTs. Changes will be applied once saved.',
	addSCOTLink: 'Add SCOT'
};

export const deleteSCOTModal = {
	title: 'Delete SCOTs',
	description: 'Are you sure you want to delete the selected SCOTs? This action cannot be undone.',
};

export const manageITAppModalLabels = {
	title: 'Manage IT applications',
	description: 'Create new IT applications or edit and delete existing IT applications below.',
	inputNameTitle: 'IT application name',
	deleteConfirmMessage: 'Are you sure you want to delete the IT application <b>{0}</b>? This cannot be undone.',
	addSuccessMessage: "Successfully created the IT application '{0}'",
	editSuccessMessage: "Successfully saved edits to the IT application '{0}'",
	deleteSuccessMessage: "'{0}' has been successfully deleted"
};

export const manageSOModalLabels = {
	title: 'Manage service organizations',
	description: 'Create new service organizations or edit and delete existing service organizations below.',
	inputNameTitle: 'Service organization name',
	deleteConfirmMessage: 'Are you sure you want to delete the Service organization <b>{0}</b>? This cannot be undone.',
	addSuccessMessage: "Successfully created the Service organization '{0}'",
	editSuccessMessage: "Successfully saved edits to the Service organization '{0}'",
	deleteSuccessMessage: "'{0}' has been successfully deleted",
	addServiceOrganization: 'Add Service organization',
	editServiceOrganization: 'Edit Service organization',
	deleteServiceOrganization: 'Delete Service organization'
};

export const customNameModal = {
	title: 'JE source name suffix',
	closeTitle: 'Cancel',
	save: 'Save',
	suffixRequired: 'Suffix required!',
	suffix: 'Suffix',
	addSuffix: 'Add suffix',
	editSuffix: 'Edit suffix'
};

export const GuidedWorkFlowLabels = {
	RiskFactorsUnrelatedToARiskOrMarkedAsNotAROMM: 'Unrelated events and conditions / risk of misstatement',
	RisksUnrelatedToAnAssertionForGuidedWorkflow: 'Unrelated ROMMs',
	IncompleteMeasurementBasisForecastAmount: 'Incomplete basis',
	IncompleteMeasurementBasisForecastAmountRationale: 'Basis rationale required',
	IncompleteMeasurementBasisAdjustedAmount: 'Incomplete adjusted amount',
	IncompletePlanningMateriality: 'Incomplete PM',
	PlanningMaterialityGreaterThanMaximumAmount: 'PM too large',
	IncompletePlanningMaterialityRationale: 'PM rationale required',
	IncompleteTolerableError: 'Incomplete TE',
	TENotWithinRangeOfAllowedValues: 'Invalid TE percent',
	IncompleteTolerableErrorRationale: 'TE rationale required',
	IncompleteSAD: 'Incomplete SAD',
	SADGreaterThanMaximum: 'SAD too large',
	IncompleteSADRationale: 'SAD rationale required',
	IncompletePACESelection: 'Incomplete PACE',
	AccountWithoutIndividualRiskAssessmentForm: 'Account{0} missing document',
	EstimateWithoutIndividualEstimateForm: 'Estimate{0} missing document',
	AccountWithoutIndividualAnalyticForm: 'Account{0} missing document',
	MultiEntityWithoutIndividualProfileForm: 'Entity without Multi-Entity Individual Profile document',
	AccountAccountTypeIDDoesNotMatchAction: 'Inconsistent account designation selection',
	AccountHasEstimateDoesNotMatchAction: 'Inconsistent account estimate selection',
	AccountFormOptionHasRelatedRisksNotAssociatedToAccount: 'Risk without related account association',
	AccountHigherInherentRiskAssertionWithoutRelatedIsHigherRisk: 'Higher inherent risk assertion without related ROMM',
	AccountMissingSubstantiveProcedure: 'Account/Entities with no substantive procedure',
	MultiEntityNotRelatedToALLPSTACTForRelatedAccount: 'Account/Entities require content update',
	ComponentWithoutGroupInvolvementForm: 'Component without a Group Involvement Form (Excluding Reference Only Components)',
	ComponentWithoutRelatedGroupAssessmentInstruction: 'Component without Group risk assessment instruction',
	IncompleteAssertionRiskLevel: 'Incomplete assertion risk level',
	EstimateAccountWithoutEsimatePSPIndex: 'Estimate account without estimate Account Index',
	AccountExecutedWithoutRelatedComponent: 'Group - Accounts (Executed in other engagements) without a related Full or Specific scope Component',
	MultiEntityAccountWithoutRelatedToAnyMultiEntity: 'Account without related entity',
	ChangeNotSubmittedMultiEntityFullProfile: 'Changes not submitted',
	ChangeNotSubmittedMultiEntityIndividualDocument: 'Changes not submitted',
	AccountTypeWithMissingInformation: 'Account missing information',
	DocumentUploadMissingRequiredPICEQRSignOffs: 'Evidence missing sign-off(s)',
	DocumentUploadMissingRequiredPICEQRSignOffRequirements: 'Evidence missing sign-off requirement(s)',
	SignificantAccountOrDisclosureWithoutRelatedAssertions: 'Significant account/disclosure without any related assertions',
	DocumentUploadMissingPreparerOrReviewerSignOffs: 'Document upload - Missing Preparer or Reviewer Sign-offs',
	ITAppWithoutAtLeastOneRelatedITProcess: 'Unrelated IT application',
	ITProcessHasNoRelatedITApplication: 'Unrelated IT process',
	ITGCWithoutASelectedDesignEffectiveness: 'Missing ITGC design evaluation',
	ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne: 'Unrelated ITGC',
	ITSPHasNorelatedITRisk: 'Unrelated ITSP',
	ITRiskHasNoITGCIsZeroHasNoRelatedITGC: 'Missing ITGC or mark none exists',
	EstimateWithoutAccountRelated: 'Estimate without valid Estimate account',
	EstimateHigherOrLowerRiskEstimateRelatedToNonEstimateAccount: 'Higher/lower risk estimate related to non-estimate account',
	RiskEstimateRiskTypeIDDoesNotMatchAction: "Estimate category response not aligned to designation in 'Edit estimate'",
	LowerorHigherRiskEstimateWithoutEstimateSCOT: 'Estimate without valid SCOT',
	EstimateWithoutIndividualEstimateDocument: 'Estimate missing individual document',
	EstimateAccountWithoutHigherOrLowerRiskEstimate: 'Account without valid estimate',
	EstimateAccountWithoutHigherOrLowerRiskEstimateEstimateSummary: 'Estimate account without Higher or Lower risk Estimate',
	EstimateScotWithoutHigherOrLowerRiskEstimate: 'Estimate SCOT without Higher or Lower risk Estimate',
	HigherRiskEstimateWithoutRisk: 'Higher risk estimate without valid risk related',
	PICEQRSignOffRequirements: 'PIC or EQR Signoff requirement does not match response',
	AdjustmentsWithoutAnyEvidence: 'Adjustments without evidence',
	AdjustmentsThatDoNotNet: 'Adjustments that do not net',
	DocumentCheckedOutOrInTheProcessOfBeingCheckedOutForCollaboration: 'Document checked out or in the process of being checked out for collaboration',
	NonEngagementWideTasksMissingEvidence: 'Non-Engagement wide tasks missing evidence',
	EstimatesMustBeMarkedHigherRisk: 'Significant/Fraud risk related to an estimate that is not a Higher risk',
	SCOTEstimateNoRelatedWalkthroughForm: 'Missing document',
	SCOTWithNoRelatedSignificantAccountOrSignificantDisclosureV2: 'SCOT without related account',
	AccountSignificantDisclosureWithNoRelatedSCOTV2: 'Significant account/disclosure has no related SCOT or estimate',
	ITApplicationWithoutITAppRiskAssessmentIndividualDocument: 'Technology risk assessment missing document',
	ITApplicationWithoutITAppPlanningIndividualDocument: 'Technology missing document',
	FormContentWithoutHeader: 'Form Content without Header',
	RisksWithoutAnyRelatedAssertions: 'ROMM without assertion',
	AssertionsWithIncompleteCRA: 'Assertions with incomplete CRA',
	LimitedRiskOrInsignificantAccountMissingRationale: 'Incomplete documentation',
	ITProcessWithoutWalkthroughDocument: 'IT process without Understand the IT Process form',
	ITProcessIsUncategorized: 'IT process missing category',
	ITProcessWithNoRelatedITApplication: 'ITProcess - ITProcess with no related IT Application',
	ProfileSubProfileWithoutDisplayedBodies: 'Form missing content',
	ProfileNoPrimaryEntityIdentifiedNotApplicableForArchive: 'Missing Primary entity',
	LowerOrHigherRiskEstimateWithoutRelatedSignificantAccountDisclosure: 'Lower or higher risk estimate without related significant account/disclosure',
	AccountAssertionWithoutRelatedRisk: 'Relevant assertion without related ROMM',
	FlowchartStepNoRelatedWalkthroughForm: 'Missing document',
	AccountHigherInherentRiskAssertionWithoutRelatedIsHigherRiskV2: 'Assertion without valid ROMM contributing to higher inherent risk',
	AccountRiskWithoutRelatedControl:
		'ROMM is required to be related to at least one control',
	AccountAssertionWithoutSubstantiveTask: 'Assertion without responsive substantive task',
	RiskAssertionCombinationWithoutSubstantiveTask: 'Risk/assertion without substantive task',
	AccountLimitedRiskWithoutSubstantiveTask: 'The Limited Risk Account does not have any related substantive tasks',
	ITApplicationRelevantRelyWithoutRelatedITRisk: 'Technology without IT risk',
	ITControlWithoutITRisk: 'ITGC without IT risk',
	ITSPWithoutOSP: 'ITSP without required OSP',
	ITGCWithoutEDC: 'ITGC without required EDC',
	ITGCTestedWithoutTOC: 'ITGC without required TOC',
	TaskITOSPWithoutITSP: 'Task without related ITSP',
	TaskITTOCWithoutITGC: 'TOC without related ITGC',
	TaskITEDCWithoutITGC: 'EDC without related ITGC',
	ITApplicationWithoutITScopingTask: 'Technology without required IT scope & strategy UDP',
	ITApplicationWithoutITRiskAssessmentTask: 'Technology without required IT risk assessment UDP',
	TaskITScopingWithoutITApplication: 'Task without related Technology',
	TaskITRiskAssessmentWithoutITApplication: 'Task without related Technology',
	SCOTWithoutWTV2: 'SCOT without UDP task',
	TaskWTWithoutSCOT: 'UDP task without SCOT',
	EstimateWithoutWT: 'Estimate without UDP task',
	TaskEstimateWTWithoutEstimate: 'UDP task without valid estimate',
	ControlWithoutRelatedRisk: 'Control without ROMM',
	ControlWithoutEDC: 'Control without EDC task',
	ControlWithoutTOCV2: 'Control without TOC task',
	EDCControlWithoutControl: 'EDC task without control',
	TOCControlWithoutControlV2: 'TOC task without valid control',
	AccountRelatedRisksWithoutTestedControls: 'Assertion relying on controls has a related ROMM without any control selected for testing',
	ValidationTypeID212:
		'Assertion with ROMM contributing to higher inherent risk has lower inherent risk assessment',
	ValidationTypeID213: 'Control without technology or SO',
	ControlWithDesignEffectivenessTypeIdNull: 'Control without design effectiveness',
	ValidationTypeID215: 'IT risk without technology',
	ValidationTypeID216: 'IT Process without required task',
	ValidationTypeID217: 'Task without related IT process',
	ValidationTypeID218: 'Incomplete flowchart',
	ValidationTypeID219: 'ITSP without IT risk',
	ValidationTypeID220: 'IT risk deemed not relevant without rationale',
	ValidationTypeID221: 'Required SCOTs not associated to Account',
	ValidationTypeID222: 'Incomplete rejection',
	ValidationTypeID223: 'IT risk without ITGC',
	ValidationTypeID224: 'Technology without required related IT process',
	ValidationTypeID225: 'ROMM without SCOT or estimate',
	ValidationTypeID226: 'Lower risk control associated to ROMMs contributing to a higher inherent risk assessment',
	ValidationTypeID227: 'Significant, Fraud, or Higher risk related to an estimate that is not higher risk',
	ValidationTypeID228: 'Higher risk estimate without valid risk related',
	ITDMorITACWithNoRelatedITApplication: 'App/ITDM control with no IT app',
	SCOTWithoutITApplicationsWhereHasNoITApplicationIsZero: 'Unrelated SCOT',
	SCOTWithHasNoITApplicationHasITDMOrAppControls: 'IT application in SCOT missing',
	ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication: 'Missing IT risk',
	ValidationTypeID230: 'Technology with inapplicable IT process',
	ValidationTypeID231: 'Estimate account without Higher or Lower risk Estimate',
	ValidationTypeID233: 'Account without account index',
	IncompleteDate: 'Incomplete date',
	NotImpactedControlWithoutRationale: 'Invalid control or control missing rationale',
	DeficiencyWithoutRelatedDeficiencyResponseTask: 'Deficiency without required task',
	DeficiencyResponseTaskWithoutRelatedDeficiency: 'Task without required deficiency',
	ValidationTypeID237: 'IT risks without ITGC',
	UnrelatedITGCsBody310: 'Unrelated reference ITGCs',
	MultiEntityWithNoSADEvaluationDocument: 'MultiEntity - MultiEntity with any related misstatement(that is not a top-up adjustment) but no SAD Entity Evaluation document',
	SADUnbalancedBalanceSheetOrIncomplete: 'Incomplete misstatement',
	SADBalanceMissingIncompleteOrUnbalanced: 'Incomplete final trial balance and/or balance sheet does not balance',
	UnrelatedOtherEngagementITRisksForRelevantITApplications: 'Unrelated reference IT risks',
	ReferenceControlWithNoRelatedROMM: 'Unrelated reference control',
	ReferenceROMMWithNoRelatedAssertion: 'Unrelated reference ROMM',
	ReferenceROMMWithNoRelatedReferenceControl: 'Reference risk without related reference control',
	ReferenceControlWithNoRelatedDeficiency: 'Reference control without related deficiency'
};

export const GuidedWorkFlowValidationTypeResourceMapping = createGuidedWorkFlowValidationTypeResourceMapping(GuidedWorkFlowLabels);

// Label overrides (redefine here labels / objects that apply for a different part of the application)
export const resourceOverrides = {
	['Ares']: {
		labels: {
			notAROMM: 'Not a Risk of material misstatement',
			fraudRisk: 'Fraud Risk',
			significantRisk: 'Significant Risk',
			identifiedRiskFactors: 'Identified event/condition, Risk of material misstatement, significant risks, and fraud risks',
			countUnassociatedRisk: "events/conditions are unrelated/not marked as 'Not a Risk of material misstatement'."
		},
		riskTypes: [
			{ id: 1, name: 'Significant risk', abbrev: 'S', label: 'Significant', title: 'Significant risk' },
			{ id: 2, name: 'Fraud risk', abbrev: 'F', label: 'Fraud', title: 'Fraud risk' },
			{
				id: 3,
				name: 'Risk of material misstatement',
				abbrev: 'R',
				label: 'Risk of material misstatement',
				title: 'Risk of material misstatement'
			}
		]
	}
};

export const jeSourceTypes = [
	{ value: 1, label: 'System generated' },
	{ value: 2, label: 'Manual' },
	{ value: 3, label: 'Both' }
];

export const hasJournalEntriesOption = [
	{ value: 1, label: 'Yes' },
	{ value: 2, label: 'No' }
];

export const filterReviewNoteStatus = [
	{
		value: 1,
		label: 'Open'
	},
	{
		value: 2,
		label: 'Cleared'
	},
	{
		value: 3,
		label: 'Closed'
	}
];

export const EntitiesLabels = {
	close: 'Close',
	cancel: 'Cancel',
	clear: 'Clear',
	repNoRecordMessage: 'No results found',
	edit: 'Edit',
	delete: 'Delete',
	actions: 'Actions',
	show: 'Show',
	first: 'First',
	last: 'Last',
	prev: 'Previous page',
	next: 'Next page',
	search: 'Search',
	primary: 'Primary',
	refChipLabel: labels.refChipLabel,
	referencedFromOtherSources: labels.referencedFromOtherSources,
	estimateRiskBadgeTitle: labels.estimateRiskBadgeTitle,
	knowledgeIconScotsTitle: labels.knowledgeIconScotsTitle,
	knowledgeIconTechnologyTitle: labels.knowledgeIconTechnologyTitle,
	knowledgeIconRisksTitle: labels.knowledgeIconRisksTitle,
	sourcedFromSCOTTitle: 'ROMM sourced from SCOT',
	knowledgeTitle: 'ROMM sourced from knowledge',
	knowledgeRiskLabel: 'ROMMs from knowledge cannot be edited or deleted',
	sortAscending: 'Sort ascending',
	sortDescending: 'Sort descending',
	removeSorting: 'Remove sorting',
	[Entity.Account]: {
		manageEntity: 'Manage accounts and disclosures',
		searchEntity: 'Search accounts',
		createEntity: 'New account',
		entityName: 'account',
		entityNameCaps: 'Account',
		entityNamePlural: 'Accounts',
		placeholderText: 'Create new accounts and disclosures or edit and delete existing accounts and disclosures below.',
		deleteConfirmLabel: 'Are you sure you want to delete this account? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Estimate]: {
		manageEntity: 'Manage estimates',
		searchEntity: 'Search estimates',
		createEntity: 'New estimate',
		entityName: 'estimate',
		entityNameCaps: 'Estimate',
		entityNamePlural: 'Estimates',
		placeholderText: 'Create new estimates or edit and delete existing estimates below.',
		deleteConfirmLabel: 'Are you sure you want to delete this estimate? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Risk]: {
		manageEntity: 'Manage risks of material misstatement',
		searchEntity: 'Search',
		createEntity: 'New ROMM',
		entityName: 'risk of material misstatement',
		entityNameCaps: 'Risk of material misstatement',
		entityNamePlural: 'Risks of material misstatement',
		placeholderText: 'Create new ROMMs or edit and delete existing ROMMs below.',
		deleteConfirmLabel: 'Are you sure you want to delete this ROMM? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.STEntity]: {
		manageEntity: 'Manage entities',
		searchEntity: 'Search entities',
		createEntity: 'New entity',
		entityName: 'entity',
		entityNameCaps: 'Entity',
		entityNamePlural: 'Entities',
		placeholderText: 'Create new entities or edit and delete existing entities below.',
		deleteEntity: 'Delete entity',
		deleteConfirmLabel: 'Are you sure you want to delete this entity? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Control]: {
		manageEntity: 'Manage controls',
		searchEntity: 'Search controls',
		createEntity: 'New control',
		entityName: 'control',
		entityNameCaps: 'Control',
		entityNamePlural: 'Controls',
		placeholderText: 'Create new controls or edit and delete existing controls below.',
		deleteEntity: 'Delete control',
		deleteConfirmLabel: 'Are you sure you want to delete this control? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Deficiency]: {
		manageEntity: 'Manage deficiencies',
		searchEntity: 'Search deficiencies',
		createEntity: 'New deficiency',
		entityName: 'deficiency',
		entityNameCaps: 'Deficiency',
		entityNamePlural: 'Deficiencies',
		placeholderText: 'Create new deficiencies or edit and delete existing deficiencies below.',
		deleteEntity: 'Delete deficiency',
		deleteConfirmLabel: 'Are you sure you want to delete this deficiency? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.EngagementTag]: {
		manageEntity: 'Manage tags',
		searchEntity: 'Search tags',
		createEntity: 'New tag',
		entityName: 'tag',
		entityNameCaps: 'Tag',
		entityNamePlural: 'Tags',
		placeholderText: 'Create new tags or edit and delete existing tags below.',
		deleteEntity: 'Delete tag',
		deleteConfirmLabel: 'Are you sure you want to delete this tag? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.ITProcess]: {
		manageEntity: 'Manage IT processes',
		searchEntity: 'Search IT process',
		createEntity: 'New IT process',
		entityName: 'IT process',
		entityNameCaps: 'IT process',
		entityNamePlural: 'IT processes',
		placeholderText: 'Create new IT process or edit and delete existing IT processes below.',
		deleteEntity: 'Delete IT process',
		deleteConfirmLabel: 'Are you sure you want to delete this IT process? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.ITRisk]: {
		manageEntity: 'Manage IT risks',
		searchEntity: 'Search IT risks',
		createEntity: 'New IT risk',
		entityName: 'IT risk',
		entityNameCaps: 'IT risks',
		entityNamePlural: 'IT risks',
		placeholderText: 'Create new IT risks or edit and delete existing IT risks below.',
		deleteEntity: 'Delete IT risk',
		deleteConfirmLabel: 'Are you sure you want to delete this IT risk? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.ITControl]: {
		ITGC: {
			manageEntity: 'Manage ITGCs',
			searchEntity: 'Search ITGCs',
			createEntity: 'New ITGC',
			editEntity: 'Edit ITGC',
			viewEntity: 'View ITGC',
			entityName: 'ITGC',
			entityNameCaps: 'ITGC',
			entityNamePlural: 'ITGCs',
			placeholderText: 'Create new ITGC or edit and delete existing ITGCs below.',
			deleteEntity: 'Delete ITGC ',
			close: 'Close',
			cancel: 'Cancel',
			processIdRequired: 'IT process is required',
			save: 'Save',
			confirm: 'Confirm',
			iTProcesslabel: 'IT process',
			saveAndCloseLabel: 'Save and close',
			saveAndCreateLabel: 'Save and create another',
			deleteConfirmLabel: 'Are you sure you want to delete this ITGC? All existing relationships will be removed. This action cannot be undone.',
			operationEffectiveness: 'Operation effectiveness',
			itDesignEffectivenessHeader: 'Design effectiveness',
			itTestingColumnHeader: 'Testing',
			testingTitle: 'Testing',
			frequency: 'Frequency',
			controlOpertaingEffectiveness: 'Operating effectiveness',
			designEffectiveness: 'Design effectiveness',
			frequencyITGC: 'Select frequency',
			nameITGC: 'ITGC name (required)',
			itspNameRequired: 'ITSP name (required)',
			noResultsFound: 'No results found',
			selectITRisk: 'Select IT risk (required)',
			itRiskRequired: 'IT risk (required)',
			itRiskName: 'IT risk',
			inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|"',
			itControlNameRequired: 'ITGC name is required',
			itgcTaskDescription:
				'Perform our designed tests of ITGCs to obtain sufficient appropriate audit evidence of their operating effectiveness throughout the period of reliance.',
			selectITProcess: 'Select IT process (required)',
			itProcessRequired: 'IT process (required)',
			riskNameRequired: 'IT risk is required',
			addModalDescription: 'Enter the ITGC description.',
			createModalDescription: `Enter the ITGC details below and select '<b>{0}</b>' to finish. To create another ITGC, select '<b>{1}</b>'.`,
			controlDesignEffectiveness: {
				[0]: { description: 'Not selected' },
				[1]: { description: 'Effective' },
				[2]: { description: 'Ineffective' }
			},
			controlTesting: {
				[0]: { description: 'Not selected' },
				[1]: { description: 'Yes' },
				[2]: { description: 'No' }
			},
			controlOperationEffectiveness: {
				[0]: { description: 'Not selected' },
				[1]: { description: 'Effective' },
				[2]: { description: 'Ineffective' }
			},
			required: 'Required'
		},
		ITSP: {
			manageEntity: 'Manage ITSPs',
			searchEntity: 'Search ITSPs',
			createEntity: 'New ITSP',
			editEntity: 'Edit ITSP',
			viewEntity: 'View ITSP',
			inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|"',
			addModalDescription: 'Enter the ITSP description.',
			editModalDescription: 'Edit the ITSP and its associated attributes.',
			entityName: 'ITSP',
			selectITProcess: 'Select IT process (required)',
			entityNameCaps: 'ITSP',
			processIdRequired: 'IT process is required',
			entityNamePlural: 'ITSPs',
			itspRequired: 'ITSP name is required',
			close: 'Close',
			cancel: 'Cancel',
			iTProcesslabel: 'IT process',
			save: 'Save',
			confirm: 'Confirm',
			saveAndCloseLabel: 'Save and close',
			riskNameRequired: 'IT risk is required',
			saveAndCreateLabel: 'Save and create another',
			placeholderText: 'Create new ITSP or edit and delete existing ITSPs below.',
			deleteEntity: 'Delete ITGC ',
			deleteConfirmLabel: 'Are you sure you want to delete this ITSP? All existing relationships will be removed. This action cannot be undone.',
			itspTaskDescription:
				'Customize this task description to design the nature, timing and extent of IT-substantive procedures to obtain sufficient appropriate audit evidence that the IT risks are addressed effectively throughout the period of reliance.<br />When the IT-substantive procedure is performed as of an interim date, design and perform procedures to obtain additional evidence that the IT risks are addressed for the period covered by our interim procedures through period-end.<br />We conclude on the results of our IT-substantive procedures.',
			operationEffectiveness: 'Operation effectiveness',
			itDesignEffectivenessHeader: 'Design effectiveness',
			itTestingColumnHeader: 'Testing',
			testingTitle: 'Testing',
			frequency: 'Frequency',
			controlOpertaingEffectiveness: 'Operating effectiveness',
			designEffectiveness: 'Design effectiveness',
			frequencyITGC: 'Select frequency',
			nameITGC: 'ITGC name (required)',
			itspNameRequired: 'ITSP name (required)',
			noResultsFound: 'No results found',
			selectITRisk: 'Select IT risk (required)',
			itRiskRequired: 'IT risk (required)',
			itRiskName: 'IT risk',
			itProcessRequired: 'IT process (required)',
			controlDesignEffectiveness: {
				[0]: { description: 'Not selected' },
				[1]: { description: 'Effective' },
				[2]: { description: 'Ineffective' }
			},
			controlTesting: {
				[0]: { description: 'Not selected' },
				[1]: { description: 'Yes' },
				[2]: { description: 'No' }
			},
			controlOperationEffectiveness: {
				[0]: { description: 'Not selected' },
				[1]: { description: 'Effective' },
				[2]: { description: 'Ineffective' }
			},
			required: 'Required'
		}
	},
	[Entity.ITApplication]: {
		manageEntity: 'Manage technology',
		searchEntity: 'Search',
		createEntity: 'New technology',
		entityName: 'technology',
		entityNameCaps: 'Technology',
		entityNamePlural: 'Technologies',
		placeholderText: 'Create new technologies or edit and delete existing technologies below.',
		deleteEntity: 'Delete technology',
		deleteConfirmLabel: 'Are you sure you want to delete this technology? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.SCOT]: {
		manageEntity: 'Manage SCOTs',
		searchEntity: 'Search SCOTs',
		createEntity: 'New SCOT',
		entityName: 'SCOT',
		entityNameCaps: 'SCOTs',
		entityNamePlural: 'SCOTs',
		placeholderText: 'Create new SCOTs or edit and delete existing SCOTs below.',
		deleteEntity: 'Delete SCOT',
		deleteConfirmLabel: 'Are you sure that you want to delete this SCOT? All existing relationships will be removed. Understand the SCOT  tasks that are only related to the deleted SCOT will be deleted. This action cannot be undone.'
	},
	[Entity.SampleItem]: {
		manageEntity: 'Manage sample tags',
		searchEntity: 'Search tags',
		createEntity: 'New tag',
		createManageTagEntity: 'Manage tag groups',
		entityName: 'sample tag',
		entityNamePlural: 'Tags',
		entityNameForTagGroupPlural: 'Tag group',
		placeholderText: "Create new tags or edit and delete existing tags below. If you need to create new tag groups, click on <b>'Manage tag groups'</b>.",
		deleteEntity: 'Delete sample tag',
		deleteConfirmLabel:
			'Are you sure that you want to delete selected tag? It will be removed from all the samples it is related to. This action cannot be undone.'
	},
	[Entity.SampleTagGroups]: {
		manageEntity: 'Manage sample tag groups',
		searchEntity: 'Search tag groups',
		createEntity: 'New tag group',
		entityName: 'sample tag group',
		entityNameCaps: 'Tag group',
		entityNamePlural: 'Tag groups',
		placeholderText: 'Create new tag groups or edit and delete existing sample tag groups below.',
		deleteConfirmLabel:
			'Are you sure that you want to delete selected tag group? Any tags associated to tag group will be also deleted. This action cannot be undone.'
	},
	[Entity.ITSOApplication]: {
		manageEntity: 'Manage service organizations',
		searchEntity: 'Search service organizations',
		createEntity: 'New SO',
		entityName: 'Service Organization',
		entityNameCaps: 'SO',
		entityNamePlural: 'Service Organizations',
		placeholderText: 'Create new service organizations or edit and delete existing service organizations below.',
		deleteEntity: 'Delete service organization',
		deleteConfirmLabel: 'Are you sure you want to delete this service organization? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.GAComponent]: {
		manageEntity: 'Manage group components',
		searchEntity: 'Search by component name',
		createEntity: 'New component',
		entityName: 'Group component',
		entityNameCaps: 'GA Component',
		entityNamePlural: 'GA Components',
		placeholderText: 'Create new components or edit and delete existing components below.',
		deleteEntity: 'Delete component',
		deleteConfirmLabel: 'Are you sure you want to delete this component? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.ReferenceOnlyGAComponent]: {
		manageEntity: 'Manage reference components',
		searchEntity: 'Search',
		createEntity: 'New reference component',
		entityName: 'reference component',
		entityNameCaps: 'Reference component',
		entityNamePlural: 'Reference components',
		placeholderText: 'Create new reference components, or edit and delete existing reference components below.',
		deleteEntity: 'Delete reference component',
		deleteConfirmLabel: 'Are you sure you want to delete this reference component? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Misstatement]: {
		manageEntity: 'Manage misstatements',
		searchEntity: 'Search',
		createEntity: 'New misstatement',
		entityName: 'misstatement',
		entityNameCaps: 'Misstatement',
		entityNamePlural: 'Misstatements',
		placeholderText: 'Create new misstatements or edit and delete existing misstatements below.',
		deleteConfirmLabel: 'Are you sure you want to delete this misstatement? All existing relationships will be removed. This action cannot be undone.',
		deleteConcurrencyError: 'This misstatement is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
		restoreConcurrencyError: 'This misstatement is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
		deletedPriorPeriod: {
			manageEntity: 'Deleted prior period misstatements',
			placeholderText: 'Review the list of deleted prior period misstatements below.'
		},
		restore: 'Restore',
		disableRestoreLabel: 'Unable to restore misstatement of this type'
	}
};

export const inherentRiskFactorTypes = [
	{ id: 1, label: 'Complexity', displayOrder: 1 },
	{ id: 2, label: 'Subjectivity Uncertainty', displayOrder: 2 },
	{ id: 3, label: 'Fraud or error', displayOrder: 3 },
	{ id: 4, label: 'Change', displayOrder: 4 },
	{ id: 5, label: 'Nature of account', displayOrder: 5 },
	{ id: 6, label: 'Related parties', displayOrder: 6 }
];

export const executionType = [
	{
		id: 1,
		label: 'PT',
		toolTip: 'Procedures in this engagement [PT-only]',
		value: 'In this engagement'
	},
	{
		id: 2,
		label: 'CT',
		toolTip: 'Procedures in other engagement(s) [CT-only]',
		value: 'In other engagement(s) [CT-only]'
	},
	{
		id: 3,
		label: 'PT/CT',
		toolTip: 'Procedures in this and other engagement(s) [PT/CT]',
		value: 'In this and other engagement(s) [PT/CT]'
	}
];

export const createEditAccountModalLabels = {
	createModalDescription: `Enter the new account details below and select '<b>{0}</b>' to finish. To create another account, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the account details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	createAccount: 'New account',
	editAccount: 'Edit account',
	newSignificantDisclosure: 'New significant disclosure',
	save: 'Save',
	confirm: 'Confirm',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	accountNameLabel: 'Account name (required)',
	accountDesignationLabel: 'Designation',
	accountExecutionTypeLabel: 'In which Canvas engagement will procedures for this account be performed and documented?',
	accountEstimateLabel: 'Is this account impacted by a lower/higher risk estimate?',
	yes: 'Yes',
	no: 'No',
	accountStatementTypeLabel: 'Statement type',
	pspIndexDropdownLabel: 'Account and disclosure index (required, select up to 5)',
	removePSPIndexLabel: 'Remove account and disclosure index',
	Confirmchanges: 'Confirm changes',
	assertionsLabel: 'Select relevant assertions',
	accountTypeOptions: AccountType,
	assertionOptions: assertions,
	executionTypeOptions: executionType,
	statementTypeOptions: statementTypes,
	noOptionsMessage: 'No results found',
	accountNameErrorMsg: 'Required',
	pspIndexErrorMsg: 'Required',
	assertionWarningMessage:
		'You cannot make changes to assertion(s) that have a Significant risk, Fraud risk, Risk of material misstatement, or Estimate related. You need to remove these relations first.',
	confirmChanges: 'Confirm changes',
	executionTypeWarningMessage:
		'The changes you are going to save to this account will affect the existing assertions and PSPs, the links will be removed. Are you sure that you want to proceed? This action can not be undone.',
	contentUpdateToastMessage: 'Content update is available for {0}. Please initiate the content update from the Content update page.',
	assertionsRequired: 'At least one assertion should be selected',
	pspIndexDisabledLabel: 'Select up to five PSP Indexes. Deselect one or more options to continue.',
	updateWarningMessage:
		'The changes you are going to save to this account will affect the existing assertions, the standard risks of material misstatements and PSPs for this account, the links will be broken. Are you sure that you want to proceed? This action cannot be undone.'
};

export const createEditRiskModalLabels = {
	createModalDescription: `Enter the new ROMM details below and select '<b>{0}</b>' to finish. To create another ROMM, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the ROMM details below and select '<b>{0}</b>' to finish.`,
	editROMMModalDescription: `Edit accounts and disclosures and special circumstances below. Click "Go to source" to edit risk name and risk type.`,
	close: 'Close',
	cancel: 'Cancel',
	createRisk: 'New risk of material misstatement',
	editRisk: 'Edit risk of material misstatement',
	riskType: 'ROMM type (required)',
	of: labels.of,
	characters: labels.characters,
	riskTypeOptions: [
		{ value: 1, label: 'Significant risk' },
		{ value: 2, label: 'Fraud risk' },
		{ value: 3, label: 'Risk of material misstatement' }
	],
	isHigherRiskLabel: 'Contributes to higher inherent risk',
	specialCircumstanceOptions: [
		{
			value: 1, label: 'Substantive procedures alone are not sufficient'
		},
		{ value: 2, label: 'Journal entries' },
		{
			value: 3, label: 'Related Parties (PCAOB only)'
		},
		{
			value: 4, label: 'Significant Unusual transactions (PCAOB only)'
		}
	],
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	riskNameLabel: 'ROMM name (required)',
	relatedAccountsAssertionsLabel: 'Related accounts and assertions (optional)',
	relateAccounts: 'Relate accounts and assertions',
	relateAccountsRequired: 'Relate accounts and assertions (required)',
	relatedEstimateAccountErrorMsg: 'Please select at least one account which is related to this estimate',
	assertionsLabel: 'Select relevant assertions',
	riskNameErrorMsg: 'Required',
	riskTypeErrorMsg: 'Required',
	assertionOptions: assertions,
	removeAccountLabel: 'Remove account',
	required: 'Required',
	assertionsRequired: 'At least one assertion should be selected',
	esROMMRiskSubTypeOptions: [
		{ value: 9, label: 'Standard ROMM' },
		{ value: 10, label: 'Standard ROMM' },
		{
			value: 12, label: 'Risk of material misstatement'
		}
	],
	accountLabels: {
		tabLabel: 'Accounts and assertions',
		dropdownLabel: 'Relate accounts and assertions',
		noRelatedItems: 'No related accounts'
	},
	specialCircumstanceLabels: {
		tabLabel: 'ROMMs that require controls',
		listLabel: 'Does the ROMM relate to any of the following?',
		listLabelSystemAssociated: 'Special circumstances identified'
	},
	notAllowedLabel: 'Not-Allowed'
};

export const createEditROMLabels = {
	createModalDescription: `Enter the new Potential ROMM details below and select '<b>{0}</b>' to finish. To create another Potential ROMM, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the ROMM details below and select '<b>{0}</b>' to finish.`,
	rationaleLabel_1: 'Document the basis to support our assessment of likelihood and magnitude, including the following, as applicable:\n \nLikelihood: Whether there is a reasonable possibility that a misstatement will occur, without consideration of relevant controls, and the qualitative factors that we considered.\n\nMagnitude: Whether the potential misstatement(s) could be material to the financial statements individually or in aggregate, if they were to occur, and how the maximum of potential misstatement was determined.\n\nOther risk assessment procedures performed, including risk assessment procedures using automated techniques, and evidence obtained beyond inquiry to make our assessment of magnitude and likelihood.',
	rationaleLabel_2: 'Provide further context to support the conclusion.',
	saveAndCreateLabel: 'Save and create another',
	saveAndCloseLabel: 'Save and close',
	createROM: 'New potential ROMM',
	editROM: 'Edit potential ROMM',
	save: 'Save',
	close: 'Close',
	cancel: 'Cancel',
	riskOfMisstatementLabel: 'Potential ROMM (required)',
	likelihoodMagnitudeLabel: 'Likelihood / Magnitude (required)',
	deleteConfirmLabel: 'Are you sure you want to delete this Potential ROMM?',
	deleteEntity: 'Potential ROMM',
	delete: 'Delete',
}

export const CreateEditMestLabels = {
	createModalTitle: 'New entity',
	createModalDescription: `Enter the new entity details below and select '<b>{0}</b>' to finish. To create another entity, select '<b>{1}</b>'.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	confirm: 'Confirm',
	primary: 'Primary',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	entityNameLabel: 'Entity name (required)',
	entityStandardIndexLabel: 'Entity standard index (required)',
	entityDescriptionLabel: 'Entity description',
	entityNameErrorMsg: 'Required',
	entityStandardIndexErrorMsg: 'Required',
	editModalTitle: 'Edit entity',
	editModalDescription: `Edit the entity details below and select '<b>{0}</b>' to finish.`,
	primaryEntitySelectionLabel: 'Select as the primary entity',
	primaryEntitySelectionMsg:
		"Only one entity in the engagement can be selected as the primary entity, which will be the determinant for the content delivered to the engagement. An entity will need to be selected as the primary to be able to submit the engagement profile. 'Update content' permission is required to make or edit the primary entity selection.",
	primaryEntityDisableSelectionLabel: "To change the primary entity designation, select from the 'Edit' of the entity you wish to designate as primary",
	noAccessLabel: 'Unauthorized. Contact your administrator and try again.',
	primaryEntityConfirmationLabel: 'Primary entity confirmation',
	primaryEntityConfirmationDisplay: '{0} is currently selected as the primary entity. Are you sure you want to change the primary entity?',
	profileV2ChangeNotSubmittedBannerMessage:
		'Changes have been made to the profile that will result in content updates. Submit the profile to receive the new content or revert the answers to the previous state.'
};

export const CreateEditITProcessLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'delete',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	newITProcessLabel: 'New IT process',
	editITProcessLabel: 'Edit IT process',
	viewITProcessLabel: 'View IT process',
	addDescriptionLabel: `Enter the new IT process details below and select '<b>{0}</b>' to finish. To create another IT process, select '<b>{1}</b>'.`,
	editDescriptionLabel: `Edit the IT process details below and select '<b>{0}</b>' to finish.`,
	iTProcessNameLabel: 'IT process name (required)',
	itProcessCategory: 'Category (required)',
	confirm: 'Confirm',
	confirmChanges: 'Confirm',
	iTProcessNameErrorMsg: 'Required',
	remove: 'Remove',
	manageChangeGeneral: 'Manage changes',
	manageAccessRightsGeneral: 'Manage access rights',
	manageSecuritySettingsGeneral: 'Manage security settings',
	manageITOperationsGeneral: 'Manage IT operations',
	manageSystemImplementationGeneral: 'Manage system implementations'
};

export const ITProcessTypes = {
	0: 'Other',
	8: 'Manage changes',
	9: 'Manage access rights',
	10: 'Manage security settings',
	11: 'Manage IT operations',
	12: 'Manage system implementations'
};

export const CreateEditITRiskLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'delete',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	newITRiskLabel: 'New IT risk',
	editITRiskLabel: 'Edit IT risk',
	itRiskNameLabel: 'IT risk (required)',
	confirm: 'Confirm',
	confirmChanges: 'Confirm',
	itRiskNameErrorMsg: 'Required',
	itProcessNotSelectedErrorMsg: 'Required',
	hasNoITGCLabel: 'There are no ITGCs that address the IT risk',
	editModalDescription: 'Edit IT risk description.',
	createModalDescription: 'Enter IT risk description.',
	selectITProcess: 'Select IT process (required)',
	noITProcessAvailable: 'No IT processes created',
	relatedITProcessLabel: 'Related IT process',
	inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|"',
	remove: 'Remove'
};

export const CreateEditEstimateLabels = {
	createModalDescription: `Enter the new estimate details below and select '<b>{0}</b>' to finish. To create another estimate, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the estimate details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	createModalTitle: 'New estimate',
	editEstimateLabel: 'Edit estimate',
	estimateNameLabel: 'Estimate name (required)',
	analysisPeriodBalance: 'Analysis date balance (required)',
	analysisPeriodDate: 'Analysis date (required)',
	comparativePeriodBalance: 'Comparative date balance (required)',
	comparativePeriodDate: 'Comparative date (required)',
	estimateCategory: 'Estimate category',
	confirm: 'Confirm',
	estimateNameErrorMsg: 'Required',
	analysisPeriodBalanceErrorMsg: 'Required',
	analysisPeriodDateErrorMsg: 'Required',
	comparativePeriodBalanceErrorMsg: 'Required',
	comparativePeriodDateErrorMsg: 'Required',
	estimateCategoryErrorMsg: 'Required',
	remove: 'Remove',
	balanceNOTApplicable: 'Balances not applicable / very low risk estimate',
	wtDetailPrefixForEstimate: '<p>Complete the estimate walkthrough task.</p>',

	riskLevelOptions: [
		{ value: 4, label: 'Very low risk' },
		{ value: 5, label: 'Lower risk' },
		{ value: 6, label: 'Higher risk' },
		{ value: 7, label: 'Not selected' }
	]
};

export const KnowledgeTechnologyLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'Delete',
	save: 'Save',
	closeTitle: 'Close',
	edit: 'Edit',
	actions: 'Actions',
	show: 'Show',
	first: 'First',
	last: 'Last',
	prev: 'Previous page',
	next: 'Next page',
	search: 'Search',
	primary: 'Primary',
	continueLabel: 'Continue',
	continueInfoMessage: 'Select a technology from the knowledge library to continue.',
	createCustomLabel: 'Create custom technology',
	title: 'New technology',
	connectTechnologyTitle: 'Connect technology',
	connectPlaceholderText: "Select a technology from the Knowledge library below and click <b>'Continue with selection'</b> to add additional details about the technology. If the technology is not in the library, create a custom technology by clicking <b>'Create custom'</b> below.",
	modalNamePlural: 'Technologies',
	modalNameSingular: 'Technology',
	vendor: 'Vendor',
	type: 'Type',
	createCustomTechnologyLabel: 'Create custom technology',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	technologyTypeLabel: 'Type',
	searchLabel: 'Search',
	noOptionsMessage: 'No results found',
	placeholderText: 'Select a technology from Knowledge or create a custom technology.',
	technologyTypeOptions: [
		{ value: 0, label: 'All' },
		{ value: 1, label: 'Application/Tool' },
		{ value: 2, label: 'Database' },
		{ value: 3, label: 'Operating system' },
		{ value: 4, label: 'Network' }
	]
};

export const CreateEditControlLabels = {
	createModalTitle: 'New control',
	editModalTitle: 'Edit control',
	viewModalTitle: 'View control',
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	controlNameLabel: 'Control name (required)',
	frequency: 'Frequency',
	controlType: 'Control type',
	frequencyTypeOptions: controlFrequencyType,
	controlTypeOptions: controlTypes,
	designEffectiveness: 'Design effectiveness',
	operatingEffectiveness: 'Operating effectiveness',
	testingLabel: 'Testing',
	lowerRiskLabel: 'Is control lower risk?',
	effective: 'Effective',
	ineffective: 'Ineffective',
	yes: 'Yes',
	no: 'No',
	required: 'Required',
	remove: 'Remove',
	noOptionsMessage: 'No results found',
	disabledTabTooltipMessage: 'Select "Control type" as "IT application control" or "IT dependent manual control" to relate IT applications',
	itAppLabels: {
		tabLabel: 'Technologies',
		dropdownLabel: 'Relate Technologies',
		noRelatedItems: 'No related Technologies',
		itApplications: 'Technologies'
	},
	soLabels: {
		tabLabel: 'SOs',
		dropdownLabel: 'Relate service organizations',
		noRelatedItems: 'No related service organizations',
		serviceOrganizations: 'Service organizations'
	},
	rommLabels: {
		tabLabel: 'ROMMs',
		noRelatedItems: 'No related ROMMs',
		romms: 'ROMMs (read only)',
		editRommClickText: 'To edit ROMMs related to the control click',
		hereText: 'here',
		sourcedFromSCOTTitle: 'ROMM sourced from SCOT',
		knowledgeTitle: 'ROMM sourced from knowledge',
		relateRisksLabel: 'Relate ROMMs',
		referenceOnlyControlLabel: 'Reference only control',
		referenceOnlyRiskLabel: 'Ref.',
		relateRiskTableHeader: 'ROMMs',
		account: 'Account',
		searchROMMPlaceholder: 'Search',
		referenceRiskPillTitle: 'Referenced from other sources',
	},
	controlNameErrorMsg: 'Required',
	createModalDescriptionLabel: `Enter the new control details below and select '<b>{0}</b>' to finish. To create another control, select '<b>{1}</b>'.`,
	editModalDescriptionLabel: `Edit the control details below and select '<b>{0}</b>' to finish.`,
	viewModalDescriptionLabel: 'View the control and related technologies and service organizations',
	wcgwLabel: 'WCGW',
	frequencyTypeOptions: [
		{ value: 1, label: 'Many times per day' },
		{ value: 2, label: 'Daily' },
		{ value: 3, label: 'Weekly' },
		{ value: 4, label: 'Monthly' },
		{ value: 5, label: 'Quarterly' },
		{ value: 6, label: 'Annually' },
		{ value: 8, label: 'Other' }
	],
	controlTypeOptions: [
		{ value: 1, label: 'IT application control' },
		{ value: 2, label: 'IT dependent manual control' },
		{ value: 3, label: 'Manual prevent' },
		{ value: 4, label: 'Manual detect' }
	]
};

export const CreateEditITRiskV2Labels = {
	cancel: 'Cancel',
	yes: 'Yes',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	newITRiskLabel: 'New IT risk',
	editITRiskLabel: 'Edit IT risk',
	itRiskNameLabel: 'IT risk name (required)',
	requiredErrorMsg: 'Required',
	editModalDescription: `Edit IT risk details below and select '<b>{0}</b>' to finish.`,
	createModalDescription: `Enter IT risk details below and select '<b>{0}</b>' to finish. To create another IT risk, select '<b>{1}</b>'.`,
	inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|"',
	remove: 'Remove',
	relateTechnologiesRequired: 'Relate technology (required)',
	relatedTechnologies: 'Technology',
	noRelatedTechnologies: 'No related technology',
	technologyHeader: 'Technologies',
	technologyTypeHeader: 'Type',
	categoryLabel: 'Category',
	noOptionsMessage: 'No result found',
	notSelected: 'Not selected',
	itProcess: 'IT process',
	ItProcessTypeOptions: [
		{
			ITProcessTypeID: ITProcessType.ManageChangeGeneral,
			value: CreateEditITProcessLabels.manageChangeGeneral,
			label: CreateEditITProcessLabels.manageChangeGeneral
		},
		{
			ITProcessTypeID: ITProcessType.ManageAccessRightsGeneral,
			value: CreateEditITProcessLabels.manageAccessRightsGeneral,
			label: CreateEditITProcessLabels.manageAccessRightsGeneral
		},
		{
			ITProcessTypeID: ITProcessType.ManageSecuritySettingsGeneral,
			value: CreateEditITProcessLabels.manageSecuritySettingsGeneral,
			label: CreateEditITProcessLabels.manageSecuritySettingsGeneral
		},
		{
			ITProcessTypeID: ITProcessType.ManageITOperationsGeneral,
			value: CreateEditITProcessLabels.manageITOperationsGeneral,
			label: CreateEditITProcessLabels.manageITOperationsGeneral
		},
		{
			ITProcessTypeID: ITProcessType.ManageSystemImplementationGeneral,
			value: CreateEditITProcessLabels.manageSystemImplementationGeneral,
			label: CreateEditITProcessLabels.manageSystemImplementationGeneral
		}
	]
};

export const CreateEditForeignITRiskLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'Delete',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	newForeignITRiskLabel: 'New reference IT risk',
	editForeignITRiskLabel: 'Edit reference IT risk',
	viewForeignITRiskLabel: 'View reference IT risk',
	foreignITRiskNameLabel: 'IT risk name (required)',
	confirm: 'Confirm',
	confirmChanges: 'Confirm changes',
	noOptionsMessage: 'No results found',
	foreignITRiskNameErrorMsg: 'Required',
	foreignITRiskCategoryErrorMsg: 'Required',
	remove: 'Remove',
	foreignITRiskCategory: 'Category (required)',
	manageChangeGeneral: 'Manage changes',
	manageAccessRightsGeneral: 'Manage access rights',
	manageSecuritySettingsGeneral: 'Manage security settings',
	manageITOperationsGeneral: 'Manage IT operations',
	manageSystemImplementationGeneral: 'Manage system implementations',
	editDescriptionLabel: `Edit IT risk details below and select '<b>{0}</b>' to finish.`,
	addDescriptionLabel: `Enter IT risk details below and select '<b>{0}</b>' to finish. To create another IT risk, select '<b>{1}</b>'.`
};

export const ITApplicationTypeLabels = [
	{ value: 1, label: 'Application/Tool' },
	{ value: 2, label: 'Database' },
	{ value: 3, label: 'Operating system' },
	{ value: 4, label: 'Network' },
	{ value: 6, label: 'Uncategorized' }
];

export const ITApplicationTypeLabelsPlural = [
	{ value: 1, label: 'Applications/Tools' },
	{ value: 2, label: 'Databases' },
	{ value: 3, label: 'Operating systems' },
	{ value: 4, label: 'Networks' },
	{ value: 6, label: 'Uncategorized' }
];

export const CreateEditITApplicationLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'Delete',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	newITApplicationLabel: 'New IT application',
	editITApplicationLabel: 'Edit IT application',
	iTApplicationNameLabel: 'IT application name (required)',
	confirm: 'Confirm',
	confirmChanges: 'Confirm changes',
	noOptionsMessage: 'No results found',
	iTAppNameErrorMsg: 'Required',
	controls: 'Controls',
	substantive: 'Substantive',
	remove: 'Remove',
	iTApplicationStrategyLabel: 'IT application strategy',
	SCOTsLabel: 'SCOT names',
	StrategyLabel: 'Strategy',
	ControlsLabel: 'Controls',
	ControlTypeLabel: 'Type',
	addDescriptionLabel: `Enter the new IT application details below and select '<b>{0}</b>' to finish. To create another IT application, select '<b>{1}</b>'.`,
	editDescriptionLabel: `Edit the IT application details below and select '<b>{0}</b>' to finish.`,
	scotErrorMessage: 'SCOT may not be unrelated from the IT application, since there are controls related.',
	SCOTsLabels: {
		tabLabel: 'SCOTs',
		dropdownLabel: 'Relate SCOTs',
		noRelatedItems: 'No related SCOTs'
	},
	ControlsLabels: {
		tabLabel: 'Controls',
		dropdownLabel: 'Relate controls',
		noRelatedItems: 'No related controls'
	},
	strategyType: {
		0: 'Not selected',
		1: 'Controls',
		2: 'Substantive',
		3: 'Rely',
		4: 'Not Rely'
	},
	controlType: {
		1: 'IT Application',
		2: 'IT Dependent Manual',
		3: 'Manual Prevent',
		4: 'Manual Detect'
	},
	technologyTypeOptions: ITApplicationTypeLabels,
	technologyType: 'Select technology type'
};

export const CreateEditMisstatementLabels = {
	modalTitle: 'New misstatement',
	modalDescription: `Enter the misstatement details below and select <span class="save-close">'{1}'</span> to add the misstatement to the listing of identified misstatements. Select <span class="save-edit">'{0}'</span> to finish entering the misstatement details.`,
	modalDescriptionSaveAndCloseOnly: `Enter the misstatement details below and select <span class="save-close">'{0}'</span> to add the misstatement to the listing of identified misstatements.`,
	cancel: 'Cancel',
	saveAndEditDetailsLabel: 'Save and edit details',
	saveAndProceedLabel: 'Save and edit details',
	saveAndCloseLabel: 'Save and close',
	misstatementIndexLabel: 'Misstatement index (required)',
	misstatementIndexMaxLength: 100,
	descriptionLabel: 'Misstatement description (required)',
	descriptionMaxLength: 500,
	descriptionHintText:
		'Briefly describe the nature of the misstatement and its effect on the financial statement line items or disclosures.',
	misstatementTypeLabel: 'Effect on (required)',
	relatedEntityLabel: 'Reporting entity (required)',
	componentLabel: 'Identified by (required)',
	primaryTeamLabel: 'Primary Team',
	misstatementPeriodLabel: 'Misstatement period (required)',
	required: 'Required',
	misstatementIndexErrorMsg: 'Required',
	descriptionErrorMsg: 'Required',
	misstatementTypeErrorMsg: 'Required',
	relatedEntityErrorMsg: 'Required',
	componentErrorMsg: 'Required',
	misstatementPeriodErrorMsg: 'Required',
	characters: 'characters',
	ofLabel: 'of',
	noneAvailable: 'None available',
	noOptionsMessage: 'No results found',
	close: labels.closeLabel,
	showExistingMisstatementsLabel: 'Show existing misstatements',
	existingMisstatementsModalTitle: 'Existing misstatements',
	existingMisstatementsModalDescription: 'List of existing misstatements in the engagement',
	existingMisstatementsColumnLabel: labels.misstatementsLabel,
	existingMisstatementsSearchPlaceholder: labels.searchPlaceholder,
	existingMisstatementsNoResultsLabel: labels.noResultsFound,
	pagingSvgHoverText: pagingSvgHoverText,
	pagingShowtext: labels.pagingShowtext,
	clearHoverText: labels.clearHoverText,
	misstatementTypeOptions: [
		{ value: 7, label: 'Income, OCI or balance sheet' },
		{ value: 9, label: 'Cash flow' },
		{ value: 10, label: 'Disclosure' }
	]
};

export const CreateEditTechnologyLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'Delete',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	newITApplicationLabel: 'New technology',
	editITApplicationLabel: 'Edit technology',
	iTApplicationNameLabel: 'Technology name (required)',
	confirm: 'Confirm',
	confirmChanges: 'Confirm changes',
	noOptionsMessage: 'No results found',
	iTAppNameErrorMsg: 'Required',
	inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|"',
	controls: 'Controls',
	substantive: 'Substantive',
	remove: 'Remove',
	iTApplicationStrategyLabel: 'technology strategy',
	SCOTsLabel: 'SCOTs',
	StrategyLabel: 'Strategy',
	ControlsLabel: 'Controls',
	ControlTypeLabel: 'Type',
	addDescriptionLabel: `Enter the new technology details below and select '<b>{0}</b>' to finish. To create another technology, select '<b>{1}</b>'.`,
	editDescriptionLabel: `Edit the technology details below and select '<b>{0}</b>' to finish.`,
	scotErrorMessage: 'SCOT may not be unrelated from the technology, since there are controls related.',
	technologyTypeErrorMsg: 'Required',
	knowledgeNameLabel: 'Knowledge name',
	connectedToKnowledgeHelperText: "Connected to Knowledge, click 'Save' to finish.",
	disconnectedToKnowledgeHelperText: "Disconnected from Knowledge, click 'Save' to finish.",
	connectToKnowledgeLabel: 'Connect to Knowledge',
	disconnectFromKnowledgeLabel: 'Disconnect from Knowledge',
	confirmationModalDescriptionLabel: 'Editing the technology might impact responses and procedures in your workpapers. Do you want to continue?',
	confirmationModalTitleLabel: 'Confirm changes',
	continueBtnLabel: labels.continue,

	SCOTsLabels: {
		tabLabel: 'SCOTs',
		dropdownLabel: 'Relate SCOTs',
		noRelatedItems: 'No related SCOTs'
	},
	ControlsLabels: {
		tabLabel: 'Controls',
		dropdownLabel: 'Relate controls',
		noRelatedItems: 'No related controls'
	},
	strategyType: {
		1: 'Controls',
		2: 'Substantive',
		3: 'Rely',
		4: 'Not Rely'
	},
	controlType: {
		1: 'IT Application',
		2: 'IT Dependent Manual',
		3: 'Manual Prevent',
		4: 'Manual Detect'
	},
	technologyTypeOptions: [
		{ value: 1, label: 'Application/Tool' },
		{ value: 2, label: 'Database' },
		{ value: 3, label: 'Operating system' },
		{ value: 4, label: 'Network' }
	],
	technologyType: 'Type (required)',
	knowledgeTechnologyType: 'Type',
	directlySupportsLabel: 'Directly supports',
	financialReporting: 'Financial reporting',
	itEnvironment: 'IT environment'
};

export const CreateEditSOLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'Delete',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	newSOLabel: 'New service organization',
	editSOLabel: 'Edit service organization',
	iTApplicationNameLabel: 'Service organization name (required)',
	confirm: 'Confirm',
	confirmChanges: 'Confirm changes',
	noOptionsMessage: 'No results found',
	iTAppNameErrorMsg: 'Required',
	addDescriptionLabel: `Enter the new service organization details below and select '<b>{0}</b>' to finish. To create another service organization, select '<b>{1}</b>'.`,
	editDescriptionLabel: `Edit the service organization details below and select '<b>{0}</b>' to finish.`,
	title: 'New service organization',
	remove: 'Remove',
	SCOTsLabel: 'SCOTs',
	ControlTypeLabel: 'Control type',
	ControlsLabel: 'Controls',
	scotErrorMessage: 'SCOT may not be unrelated from the technology, since there are controls related.',
	SCOTsLabels: {
		tabLabel: 'SCOTs',
		dropdownLabel: 'Relate SCOTs to the service organization',
		noRelatedItems: 'No related SCOTs'
	},
	ControlsLabels: {
		tabLabel: 'Controls',
		dropdownLabel: 'Relate Controls to the service organization',
		noRelatedItems: 'No related controls'
	},
	strategyType: {
		1: 'Controls',
		2: 'Substantive',
		3: 'Rely',
		4: 'Not Rely'
	},
	controlType: {
		1: 'IT Application',
		2: 'IT Dependent Manual',
		3: 'Manual Prevent',
		4: 'Manual Detect',
		notSelected: 'Not Selected'
	}
};

export const CreateEditSCOTLabels = {
	createModalTitle: 'New SCOT',
	editModalTitle: 'Edit SCOT',
	viewModalTitle: 'View SCOT',
	createModalDescription: `Enter the new SCOT details below and select '<b>{0}</b>' to finish. To create another SCOT, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the SCOT details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	scotNameLabel: 'SCOT name (required)',
	scotStrategyLabel: 'SCOT strategy',
	scotTypeLabel: 'SCOT type (required)',
	scotTypeErrorMsg: 'Required',
	hasEstimateLabel: 'Is this SCOT impacted by an estimate?',
	itAPPUsedLabel: 'Is it supported by any technology?',
	routine: 'Routine',
	nonRoutine: 'Non-Routine',
	financialStatementCloseProcess: 'FSCP',
	controls: 'Controls',
	substantive: 'Substantive',
	yes: 'Yes',
	scotNameErrorMsg: 'Required',
	remove: 'Remove',
	noOptionsMessage: 'No results found',
	disabledTabTooltipMessage: 'Select "Is it supported by any technology?" to relate technology',
	scotIndexName: 'SCOT index',
	knowledgeSupported: 'Knowledge supported',
	itAppLabels: {
		itApplications: labels.relatedTechnologyLabel,
		tabLabel: 'Technology',
		dropdownLabel: 'Relate technology',
		noRelatedItems: 'No related technology'
	},
	soLabels: {
		serviceOrganizations: 'Related service organizations',
		tabLabel: 'SOs',
		dropdownLabel: 'Relate service organizations',
		noRelatedItems: 'No related service organizations'
	},
	wtDetailPrefix:
		'<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period using a combination of risk assessment procedures (e.g., automated techniques, inquiry, observation and inspection) to enable us to identify risks of material misstatement. In addition, for PCAOB audits, we perform these same procedures for SCOTs impacted by higher or lower risk estimates. <br/>We conclude that our documentation accurately describes the critical path of the SCOT and we have identified all appropriate ROMMs, including risks that arise from using IT. <br/><br/> For SCOTs impacted by higher or lower risk estimates, when we use a substantive only strategy, we determine whether our understanding of the SCOT is appropriate based on our substantive procedures. .</p>'
};

export const ViewSampleItemLabels = {
	previous: 'Previous',
	next: 'Next',
	sampleDateLabel: 'Sample date',
	attributesHeader: 'Attributes',
	statusHeader: 'Status',
	noAttributesLabel: 'No attributes available.',
	present: 'Present',
	presentWithComments: 'Present with comments',
	notPresent: 'Not present',
	notApplicatable: 'Not applicable',
	naLabel: 'N/A',
	additionDocumentation: 'Additional documentation',
	deleteSampleHeader: 'Delete sample',
	deleteSmapleDescription: 'Are you sure that you want to delete the selected sample? This action cannot be undone.',
	deleteSamplePreText: 'Sample description',
	relateTagModalTitle: 'Relate tags to sample',
	relateTagModalDescription:
		"Relate one or more tags to the sample. To add a new tag, click <b>'Manage tags'</b>. Tag associations will not be archived but the tags themselves will be archived so they are available for use on rollforward.",
	relateTagTableHeader: 'Tag name',
	relateTagTableSubHeader: 'Tag group',
	tagsCounter: '{0} Tags',
	tagCounter: '{0} Tag',
	relateTagGroupLabel: 'Tag group',
	relateTagSearchPlaceholder: 'Search',
	relateTagClearSearch: 'Clear',
	relateTagShowSelectedOnly: 'Show only related',
	manageTagsLabel: 'Manage tags',
	addTag: 'Add tag',
	supportingDocumentationTitle: 'Supporting documentation',
	dropdownAll: 'All',
	noResultsLabel: 'No results found',
	noDataLabel: 'No data found',
	attributeStatusModalTitle: 'Mark all as present',
	attributeStatusModalCancelButton: 'Cancel',
	attributeStatusModalConfirmButton: 'Save',
	attributeStatusModalDescription:
		'Are you sure you want to mark attributes as present? Only attributes that have no status selected will be marked as present.',
	attributeModalDeleteErrorMessage: 'Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists.'
};

export const ShortRiskTypeForAres = {
	1: 'Significant',
	2: 'Fraud',
	3: 'Inherent',
	4: 'Very low risk',
	5: 'Lower risk',
	6: 'Higher risk',
	7: 'Not selected'
};

export const RelateEstimateToAssertionLabels = {
	relateAccountsAndAssertions: 'Relate accounts and assertions',
	relateAccountsToEstimate: 'Relate accounts to estimate',
	accounts: 'Accounts',
	designation: 'Designation',
	relatedAssertions: 'Related assertions',
	accountNameField: 'accountName',
	accountTypeIdField: 'accountTypeId',
	assertionsField: 'assertions',
	executionTypeIdField: 'executionTypeId',
	notSelected: 'Not selected',
	pathField: 'path',
	noAccountsAvailable: 'No accounts available',
	noRelatedAccounts: 'No accounts related to estimate',
	accountId: 'accountId',
	remove: 'Remove'
};

//Send instructions switcher
export const sendIntructionsSwitcherLabels = {
	[sendInstructionsSwitcherIds.groupInstructions]: 'Group instructions',
	[sendInstructionsSwitcherIds.groupRiskAssessment]: 'Group risk assessment'
};

export const RelateEstimateToAccountLabels = {
	relatEstimatesToAccount: 'Relate estimates to account',
	showOnlyRelatedEstimates: 'Show only related estimates',
	noEstimatesResult: labels.noResultsFound,
	noEstimatesLabel: 'No estimates created in the engagement',
	estimateNameHeader: 'Estimate name',
	relatedEstimateCounter: '{0} estimate',
	relatedEstimatesCounter: '{0} estimates',
	relatedAccount: 'Account/disclosure',
	close: labels.close
};

export const RelateAccountsToEstimateLabels = {
	relateAccountsToEstimate: 'Relate accounts to estimate',
	showOnlyRelatedAccounts: 'Show only related accounts',
	noAccountsResult: labels.noResultsFound,
	noAccountsLabel: 'No accounts created in the engagement',
	accountNameHeader: 'Account',
	relatedAccountCounter: '{0} account',
	relatedAccountsCounter: '{0} accounts',
	relatedEstimate: labels.estimate,
	close: labels.close
};

export const SelectAccountsForInterimLabels = {
	selectAccountsTrigger: 'Select accounts',
	modalTitle: 'Select accounts',
	modalDescription: 'Select accounts that will be concluded at interim.',
	close: labels.close,
	showOnlySelected: 'Show only selected',
	accountColumn: 'Account',
	assertionsColumn: 'Assertions',
	accountCountSingular: '1 account',
	accountCountPlural: '{0} accounts',
	fromKnowledge: 'From knowledge',
	primaryAndComponentTeam: 'PT/CT',
	primaryAndComponentTeamDescription: 'Executed in both this and the component team engagement',
	incompleteCra: 'Combined risk assessment is not complete',
	loadFailed: 'Something went wrong. Please try again.',
	retry: 'Retry',
	searchAccountsAriaLabel: 'Search accounts by name'
};

export const SupportingDocumentationLabels = {
	evidence: 'Evidence',
	priorPeriod: 'Prior period',
	temporaryFiles: 'Temporary files',
	externalDocuments: 'External documents',
	addEvidenceBtn: 'Add evidence',
	addTemporaryFilesBtn: 'Add temporary file',
	notes: 'Notes',
	signOffs: 'Sign-offs',
	name: 'Name',
	supportingDocumentationTitle: 'Supporting documentation',
	temporaryFilesEmptyPlaceholder1: 'No related temporary documents.',
	temporaryFilesEmptyPlaceholder2: 'To relate a temporary document click {addTemporaryFiles}.',
	evidencePlaceholderLine1: 'No related evidence.',
	evidencePlaceholderLine2: 'To relate an evidence click {addEvidenceBtn}.',
	removeFromSample: 'Remove from sample',
	unlink: 'Unlink',
	retailControlEvidenceLabel: 'Did we retain control evidence to support our testing of the attribute(s) for this specific sample item?',
	removeEvidenceModalTitle: 'Remove evidence from sample',
	removeEvidenceModalDesc: 'Are you sure you want to remove all evidence from this sample?',
	removeEvidenceErrorMessage:
		'These documents are no longer available in this sample. Refresh the page and try again. Contact the Help Desk if the error persists.'
};

export const deleteSampleItemAttributeModal = {
	modalDescription: 'Are you sure that you want to remove the selection for this attribute? Additional documentation will be deleted.',
	modalTitle: 'Remove selection',
	modalConfirmButton: 'Remove',
	modalCancelButton: 'Cancel',
	additionalDocumentationLabel: 'Additional documentation'
};
export const accountsFilterLabels = [
	{ id: accountsFilter.allAccounts, label: 'All accounts', value: accountsFilter.allAccounts },
	{
		id: accountsFilter.accountsWithRelatedEstimates,
		label: 'Accounts with related estimates',
		value: accountsFilter.accountsWithRelatedEstimates
	},
	{
		id: accountsFilter.accountsWithoutRelatedEstimates,
		label: 'Accounts with no related estimates',
		value: accountsFilter.accountsWithoutRelatedEstimates
	}
];

export const changeSampleItemAttributeModal = {
	modalDescription: 'Are you sure that you want to change the selection for this attribute? Additional documentation will be deleted.',
	modalTitle: 'Change selection',
	modalConfirmButton: 'Change',
	modalCancelButton: 'Cancel'
};
export const scotsFilterLabels = [
	{ id: scotsFilter.allScots, label: 'All SCOTs', value: scotsFilter.allScots },
	{
		id: scotsFilter.scotsWithRelatedEstimates,
		label: 'SCOTs with related estimate',
		value: scotsFilter.scotsWithRelatedEstimates
	},
	{
		id: scotsFilter.scotsWithoutRelatedEstimates,
		label: 'SCOTs without related estimate',
		value: scotsFilter.scotsWithoutRelatedEstimates
	}
];

export const CreateEditTagGroupLabels = {
	createModalTitle: 'New sample tag group',
	editModalTitle: 'Edit sample tag group',
	createModalDescription: `Enter tag group details below and select <b>\'Save and close\'</b> to finish. To create another tag group, select <b>\'Save and create another\'</b>.`,
	editModalDescription: `Edit tag group details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	tagGroupNameLabel: 'Tag group name (required)',
	required: 'Required'
};

export const TaskSuffixAndDescriptionLabels = {
	taskDescriptionForEstimateWTTaskType28: 'Obtain and document our understanding of the estimation process.',
	taskSuffixForEstimateWTTaskType28: ' - Understand',

	taskDescriptionForScotWTTaskType20: 'Obtain and document our understanding of the process.',
	taskSuffixForScotWTTaskType20: ' - Understand',

	taskDescriptionForITProcessWTTaskType19: 'Obtain and document our understanding of the IT process.',
	taskSuffixForITProcessWTTaskType19: ' - Understand',

	taskDescriptionForITSPWTTaskType26: 'Customize this task description to design the nature, timing and extent of IT-substantive procedures to obtain sufficient appropriate audit evidence that the IT risk(s) is addressed throughout the period of reliance, as necessary.',
	taskSuffixForITSPWTTaskType26: '',

	taskDescriptionForITSOWTTaskType4: 'Perform our designed tests of ITGC to obtain sufficient appropriate evidence of its operating effectiveness throughout the period of reliance.',
	taskSuffixForITSOWTTaskType4: ' - Test of ITGC',

	taskDescriptionForitgcWT29: 'Evaluate the design of the control and determine whether it has been implemented.',
	taskSuffixForitgcWT29: ' - Evaluate the design of the control',

	taskDescriptionForITControlWTTaskType32: 'Evaluate the design of the ITGC and determine whether it has been implemented.',
	taskSuffixForITControlWTTaskType32: ' - Evaluate the design of the ITGC',

	taskDescriptionForTOCTTaskType2: 'Perform our designed tests of the control to obtain sufficient appropriate evidence of its operating effectiveness throughout the period of reliance.',
	taskSuffixForTOCTTaskType2: ' - Test of control',

	taskDescriptionForUDPTaskType30: 'Determine relevance and planned approach for the information technology and perform other scoping procedures as required.',
	taskSuffixForUDPTaskType30: ' - IT scope & strategy',

	taskDescriptionForUDPITRiskAssessmentTaskType31: 'Identify relevant IT processes and associated IT risks based on the characteristics of how the entity uses the relevant information technology.',
	taskSuffixForUDPITRiskAssessmentTaskType31: 'IT risk assessment'

};

export const CreateEditTagLabels = {
	createModalTitle: 'New sample tag',
	editModalTitle: 'Edit sample tag',
	createModalDescription:
		"Enter tag details below and select '<b>Save and close</b>' to finish. To create another tag, select '<b>Save and create another</b>'.",
	editModalDescription: `Edit the tag details below and select '<b>{0}</b>' to finish.`,
	tagNameLabel: 'Tag name (required)',
	tagGroupNameLabel: 'Tag group name (required)',
	tagColorLabel: 'Color (required)',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	cancelLabel: 'Cancel',
	required: 'Required',
	save: 'Save',
	noresultsLabel: 'No tag groups available',
	tagColors: [
		{ id: 1, label: 'Red' },
		{ id: 2, label: 'Orange' },
		{ id: 3, label: 'Teal' },
		{ id: 4, label: 'Blue' },
		{ id: 5, label: 'Purple' },
		{ id: 6, label: 'Green' }
	]
};

export const CreateEditEngagementTagLabels = {
	createModalTitle: 'New tag',
	editModalTitle: 'Edit tag',
	createModalDescription:
		"Enter the new tag details below and select '<b>Save and close</b>' to finish. To create another tag, select '<b>Save and create another</b>'.",
	editModalDescription: `Edit the tag details below and select '<b>Save</b>' to finish.`,
	tagNameLabel: 'Tag name (required)',
	tagNamePlaceholder: '',
	tagColorLabel: 'Color (required)',
	tagColorPlaceholder: '',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	closeLabel: 'Close',
	cancelLabel: 'Cancel',
	required: 'Required',
	save: 'Save',
	tagColors: [
		{ id: 3, label: 'Blue' },
		{ id: 5, label: 'Green' },
		{ id: 0, label: 'Red' },
		{ id: 6, label: 'Maroon' },
		{ id: 1, label: 'Orange' },
		{ id: 4, label: 'Purple' }
	]
};

export const ITProcessFlowLabels = {
	itProcess: 'IT process',
	technology: 'Technology',
	technologies: 'Technologies',
	technologyName: 'Technology name',
	supportingTechnologyName: 'Supporting technology name',
	technologyType: 'Type',
	showOnlyRelated: 'Show only related',
	technologiesCounter: '{0} technologies',
	technologyCounter: '{0} Technology',
	supportingTechnologyLabel: 'Supporting technology',
	relatedITAppNoDataPlaceholder: 'No technology related to the IT process',
	relateTechnology: 'Relate technology',
	supportingITPAppNoDataPlaceholder: 'No technology supporting the IT process',
	itRiskHeader: 'IT risks',
	itgcHeader: 'ITGCs',
	itspHeader: 'ITSPs',
	noDataPlaceholderITGC:
		'At least one ITGC must be identified or a designation that the IT risk has no ITGCs. Create {createNewITGC}, {relateITGC} or indicate that there are {noITGC} that address the IT risk.',
	noDataPlaceholderITSP:
		'If we have evaluated ITGCs as ineffective or determined there are no ITGCs that exist to address the IT risk, we may be able to perform IT-substantive testing procedures (ITSPs) to obtain reasonable assurance that the IT risk within the IT process associated with the ineffective ITGC was not exploited. Create {createNewITSP} or {relateITSP}.',
	noRecordsFound: 'No IT risks identified for this IT process',
	noITGCPlaceholder: 'There are no ITGCs that address the IT risk.',
	relateSupportingTechnology: 'Relate supporting technology',
	relatedTechnologiesNotAvailable: 'Related technologies not available for this document',
	supportingTechNotAvailable: 'Supporting technologies not available for this document',
	relatedITRisksNotAvailable: 'Related IT risks not available for this document',
	relateITGC: 'Relate ITGCs',
	itRisk: 'IT risk',
	itgcCounter: '{0} ITGC',
	itgcsCounter: '{0} ITGCs',
	itspCounter: '{0} ITSP',
	itspsCounter: '{0} ITSPs',
	itgcName: 'ITGCs',
	itspName: 'ITSP',
	plannedItgcProcedure: 'Planned ITGC procedures',
	yes: 'Yes',
	no: 'No',
	notSelected: 'Not selected',
	relatedITSPDescription: 'Select one or more ITSPs to relate to the IT risk. To unrelate from IT risk, deselect the relevant ITSP.',
	relatedITGCDescription: 'Select one or more ITGCs to relate to the IT risk.',
	relatedITProcessCheckboxTitle: 'This technology is being tested in another engagement and cannot be related to an IT process in this engagement.',
	relatedITProcessCheckboxDisabledTitle: 'Planned ITGC procedures for this technology have not been selected.',
	relatedTechnologyDescription: 'Select one or more technologies to relate to the {0}. To unrelate from {0}, deselect the relevant technology.'
};

export const ITRisksFlowLabels = {
	itRisk: 'IT risk',
	relatedITRiskNoDataPlaceholder: 'No IT risks related to the IT process',
	newITRisk: 'New IT risk',
	newCustomITRisk: 'New custom IT risk',
	relatedITRisksNotAvailable: 'Related IT risks not available for this document',
	deleteConfirmLabel: 'Are you sure that you want to delete the selected IT risk? This action cannot be undone.',
	deleteITRisk: 'Delete IT risk',
	noRelatedITRisk: 'No entity specific IT risks have been identified for this IT process',
	itRiskWarningMsg:
		'Identify at least one relevant technology where ITGCs are being tested that this IT risk is relevant for in by {editing} the IT risk or {deleting} the IT risk.',
	itRiskReadOnlyWarningMsg:
		'Identify at least one relevant technology where ITGCs are being tested that this IT risk is relevant for in by editing the IT risk or deleting the IT risk.',
	CreateITFlowITRiskLabels: {
		close: 'Close',
		cancel: 'Cancel',
		yes: 'Yes',
		no: 'No',
		delete: 'delete',
		save: 'Save',
		saveAndCloseLabel: 'Save and close',
		saveAndCreateLabel: 'Save and create another',
		newITRiskLabel: 'New IT risk',
		itRiskNameLabel: 'IT risk name (required)',
		itRiskCharactersLabel: 'characters',
		itRiskOfLabel: 'of',
		confirm: 'Confirm',
		confirmChanges: 'Confirm',
		itRiskNameErrorMsg: 'Required',
		itProcessNotSelectedErrorMsg: 'Required',
		hasNoITGCLabel: 'There are no ITGCs that address the IT risk',
		createModalDescription:
			"Enter the IT risk details below and select '<b>Save and close</b>' to finish. To create another IT risk, select '<b>Save and create another</b>'.",
		relatedITProcessLabel: 'IT process',
		inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|"',
		remove: 'Remove',
		editModalDescription: "Edit the IT risk details below and select '<b>Save</b>' to finish.",
		editITRiskLabel: 'Edit IT risk'
	}
};

export const ControlFlowLabels = {
	noTechnologyRelatedToControl: 'No results found. Click {relateTechnologies} to get started.',
	noTechnologyRelatedToITControl: 'No results found. Click {relateTechnologies} to get started.',
	noRommsRelatedToControl: 'No ROMMs related to the control',
	noITApplicationControlsRelatedToControl: 'No IT Application Controls related to the control',
	relateDeficiencies: 'Relate deficiencies',
	relateDeficienciesDisabledTooltip: 'The deficiency is already related to the control as a compensating or impacted control and it cannot be selected',
	deficienciesColumnLabel: 'Deficiencies',
	designColumnLabel: 'Design',
	operationColumnLabel: 'Operation',
	relevance: 'Relevance',
	relevant: 'Relevant',
	notRelevant: 'Not relevant',
	notSelected: 'Not selected',
	goToSourceManageTechnologies: 'To manage technologies, click',
	goToSourceHere: 'here'
};

export const RelatedDeficiencyLabels = {
	noDeficienciesRelatedToControl: 'No deficiencies have been related to this control',
	newDeficiency: 'New deficiency',
	relateDeficiencies: 'Relate deficiencies',
	remediated: 'Remediated',
	unremediated: 'Unremediated',
	businessProcess: 'Business process',
	deficiencyTypeOperation: 'Operation',
	deficiencyTypeDesign: 'Design',
	deficiencyTypeDesignAndOperation: 'Design and operation',
	deficiencyTypeUncategorized: 'Uncategorized',
	yes: 'Yes',
	no: 'No',
	signoffs: 'Sign-offs',
	notes: 'Notes',
	noDeficienciesRelatedToITGC: 'No deficiencies have been related to this ITGC',
	itProcess: 'IT process'
};

export const UnrelatedITGCsModalLabels = {
	title: 'Unrelated ITGCs',
	description: 'Unrelated ITGCs must be related to an IT risk or deleted.',
	searchPlaceholder: 'Search',
	noResultsFound: 'No results found',
	columnName: 'ITGCs',
	deleteSelected: 'Delete',
	cancel: 'Cancel',
	atLeastOneEntityMustBeSelected: 'At least one ITGC must be selected for deletion.',
	confirmDeletionTitle: 'Delete ITGCs',
	confirmDeletionMessage: 'Are you sure that you want to delete the selected ITGC(s)? This action cannot be undone.',
	delete: 'Delete',
	concurrencyWarningAlreadyDeleted: 'One or more selected ITGCs have been deleted. Please try again or contact the Help Desk if the error persists.',
	concurrencyWarningAlreadyRelated: 'One or more selected ITGCs cannot be deleted. Please try again or contact the Help Desk if the error persists.',
	deleteErrorMessage: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	viewUnrelatedITGCs: 'View unrelated ITGCs',
	modalCancelTitle: labels.modalCancelTitle,
	cancelButtonLabel: labels.cancelButtonLabel
};

export const UnrelatedITGCsFromOtherEngagementsModalLabels = {
	title: 'Unrelated reference ITGCs',
	description: 'Unrelated ITGCs must be associated to an IT risk or deleted.',
	searchPlaceholder: 'Search',
	noResultsFound: 'No results found',
	columnName: 'ITGCs',
	deleteSelected: 'Delete',
	cancel: 'Cancel',
	atLeastOneEntityMustBeSelected: 'At least one ITGC must be selected for deletion.',
	confirmDeletionTitle: 'Delete reference ITGCs',
	confirmDeletionMessage: 'Are you sure that you want to delete the selected ITGC(s)? This action cannot be undone.',
	delete: 'Delete',
	concurrencyWarningAlreadyDeleted: 'One or more selected ITGCs have been deleted. Please try again or contact the Help Desk if the error persists.',
	concurrencyWarningAlreadyRelated: 'One or more selected ITGCs cannot be deleted. Please try again or contact the Help Desk if the error persists.',
	deleteErrorMessage: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	viewUnrelatedITGCs: 'View unrelated ITGCs',
	modalCancelTitle: labels.modalCancelTitle,
	cancelButtonLabel: labels.cancelButtonLabel,
	refChipLabel: labels.refChipLabel,
	referencedFromOtherSources: labels.referencedFromOtherSources
};

export const orphanedITGCsWarningLabels = {
	titleOne: 'There is 1 unrelated ITGC',
	titleMany: 'There are {0} unrelated ITGCs',
	description: "All ITGCs must be related to an IT risk. Relate these ITGCs to an IT risk or click on 'Show unrelated ITGCs' to review and delete them.",
	unRelatedLinkText: 'Show unrelated ITGCs'
};

export const orphanedITGCsFromOtherEngagementsWarningLabels = {
	titleOne: 'There is 1 unrelated reference ITGC',
	titleMany: 'There are {0} unrelated reference ITGCs',
	description: "All reference ITGCs must be related to an IT risk. Relate these ITGCs to an IT risk or click on 'Show unrelated ITGCs' to review and delete them.",
	unRelatedLinkText: 'Show unrelated ITGCs'
};

export const orphanedITSPsWarningLabels = {
	titleOne: 'There is 1 unrelated ITSP',
	titleMany: 'There are {0} unrelated ITSPs',
	description: "All ITSPs must be related to an IT risk. Relate these ITSPs to an IT risk or click on 'Show unrelated ITSPs' to review and delete them.",
	unRelatedLinkText: 'Show unrelated ITSPs'
};

export const UnrelatedITSPsModalLabels = {
	title: 'Unrelated ITSPs',
	description: 'Unrelated ITSPs must be related to an IT risk or deleted.',
	searchPlaceholder: 'Search',
	noResultsFound: 'No results found',
	columnName: 'ITSPs',
	deleteSelected: 'Delete',
	cancel: 'Cancel',
	atLeastOneEntityMustBeSelected: 'At least one ITSP must be selected for deletion.',
	confirmDeletionTitle: 'Delete ITSPs',
	confirmDeletionMessage: 'Are you sure that you want to delete the selected ITSP(s)? This action cannot be undone.',
	delete: 'Delete',
	concurrencyWarningAlreadyDeleted: 'One or more selected ITSPs have been deleted. Please try again or contact the Help Desk if the error persists.',
	concurrencyWarningAlreadyRelated: 'One or more selected ITSPs cannot be deleted. Please try again or contact the Help Desk if the error persists.',
	deleteErrorMessage: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	viewUnrelatedITSPs: 'View unrelated ITSPs',
	modalCancelTitle: labels.modalCancelTitle,
	cancelButtonLabel: labels.cancelButtonLabel
};

export const orphanedITRisksFromOtherEngagementsWarningLabels = {
	titleOne: 'There is 1 unrelated reference IT risk',
	titleMany: 'There are {0} unrelated reference IT risks',
	description: "All reference IT risks must be related to a relevant technology. Relate these IT risks to a relevant technology or click on 'Show unrelated IT risks' to review and delete them.",
	unRelatedLinkText: 'Show unrelated IT risks'
};

export const UnrelatedITRisksFromOtherEngagementsModalLabels = {
	title: 'Unrelated reference IT risks',
	description: 'Unrelated IT risks must be associated to a relevant technology or deleted.',
	searchPlaceholder: 'Search',
	noResultsFound: 'No results found',
	columnName: 'IT risks',
	deleteSelected: 'Delete',
	cancel: 'Cancel',
	atLeastOneEntityMustBeSelected: 'At least one IT risk must be selected for deletion.',
	confirmDeletionTitle: 'Delete reference IT risks',
	confirmDeletionMessage: 'Are you sure that you want to delete the selected IT risk(s)? This action cannot be undone.',
	delete: 'Delete',
	concurrencyWarningAlreadyDeleted: 'One or more selected IT risks have been deleted. Please try again or contact the Help Desk if the error persists.',
	concurrencyWarningAlreadyRelated: 'One or more selected IT risks cannot be deleted. Please try again or contact the Help Desk if the error persists.',
	deleteErrorMessage: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	modalCancelTitle: labels.modalCancelTitle,
	cancelButtonLabel: labels.cancelButtonLabel,
	refChipLabel: labels.refChipLabel,
	referencedFromOtherSources: labels.referencedFromOtherSources
};

export const ITProcessListingLabels = {
	all: 'All',
	manageChange: 'Changes',
	manageAccess: 'Access rights',
	manageSecuritySettings: 'Security settings',
	itOperations: 'IT operations',
	systemImplementation: 'System implementations',
	category: 'Category',
	uncategorized: 'Not selected',
	technologies: 'Technologies',
	showValidations: 'Show validations'
};

export const ITApplicationDisplayLabels = {
	uncategorized: 'Not selected'
};

export const ITProcessQuickFilterOptions = {
	0: ITProcessListingLabels.all,
	1: ITProcessListingLabels.manageChange,
	2: ITProcessListingLabels.manageAccess,
	3: ITProcessListingLabels.manageSecuritySettings,
	4: ITProcessListingLabels.itOperations,
	5: ITProcessListingLabels.systemImplementation
};

// Relate Technology Modal
export const RelateTechnologyModalLabels = {
	relateTechnology: 'Relate technology',
	relatedTechnologiesDescription: 'Technology',
	supportingTechnologyName: 'Supporting technology',
	technology: '{0} supporting technology',
	technologies: '{0} supporting technologies',
	itNoResultFound: 'No results found'
};

// Relate ITProcess Modal
export const RelateITProcessModalLabels = {
	relateITProcesses: 'Relate IT processes',
	relateITProcessesDescription: 'Technology',
	category: 'Category',
	processName: 'IT process',
	process: '{0}  IT process',
	processes: '{0}  IT processes',
	noDataLabel: 'No IT process available.'
};

export const addKnowledgeITRiskLabels = {
	title: 'New reference IT risk',
	placeholder: "Select an IT risk from the knowledge library below and click 'Save and close' to import them into the engagement. If a relevant IT risk (e.g., entity-specific risk) is not in the library, create it by clicking 'Create entity-specific IT risk' below.",
	searchPlaceholder: 'Search',
	noResultsFound: 'No results found',
	itRisksColumn: 'IT risks',
	categoryColumn: 'Category',
	saveAndClose: 'Save and close',
	createCustomITRisk: 'Create entity-specific IT risk',
	itRisksCount: '{0} IT risks',
	itRiskCount: '{0} IT risk',
	selectValidationMessage: 'Select an IT risk from Knowledge to proceed.',
	disabledRadioTooltip: 'This IT risk from Knowledge has already been created for this technology',
	duplicateKnowledgeITRiskError: 'This IT risk from Knowledge has already been created for this technology. Refresh the page and try again. If the issue persists, contact the Help Desk.'
};

export const AccountStandardROMMListingLabels = {
	accountRisksNotAvailableForDocument: 'Account ROMMs are not available for this document',
	noRelatedObject: 'No related object. Relate an object to get started.',
	noResultsFound: 'No ROMMs available',
	acceptedText: 'Standard',
	rejectedText: 'Standard ROMMs that are not ROMMs in this engagement',
	allText: 'All',
	allRisksRejected: 'All ROMMs have been rejected',
	relevantAssertions: 'Relevant assertions',
	rejectLabel: 'Not a ROMM',
	acceptLabel: 'Accept',
	allLabel: 'All',
	rejectionRationaleLabel: 'Rationale',
	rejectionCategoryText: 'Rationale',
	editRejectionRationaleText: 'Edit rationale',
	rejectionRationalePlaceholder: `Select the entity-specific rationale supporting our assessment that the Standard ROMM is not a ROMM. When significant judgment is applied, provide further context to support the assessment. When the ROMM is applicable but is addressed in another EY Canvas engagement, indicate where the ROMM is addressed.
	Document the entity-specific rationale supporting our assessment that the Standard ROMM is not a ROMM. Describe the procedures performed and evidence obtained, beyond inquiry, to support our assessment of likelihood and magnitude including the following. When the ROMM is applicable but is addressed in another EY Canvas engagement, indicate where the ROMM is addressed.
	• Whether there is a reasonable possibility that a misstatement will occur, without consideration of relevant controls, and the qualitative factors that we considered.
	• Whether the potential misstatement(s) could be material to the financial statements individually or in aggregate, if they were to occur, and how the maximum of potential misstatement was determined.
	• Other risk assessment procedures performed, including risk assessment procedures using automated techniques, and evidence obtained beyond inquiry to make our assessment of magnitude and likelihood.`,
	rejectionDetailsPlaceholder:
		'Select the entity-specific rationale supporting our assessment that the standard ROMM is not a ROMM. When significant judgement is applied, provide further context to support the conclusion.',
	save: 'Save',
	cancel: 'Cancel',
	rejectionRationaleTextAreaPlaceholder: 'Rationale description (required)',
	rejectionRationaleTextAreaLabel: 'Rationale description (required)',
	rejectionCategoryDropdownPlaceholder: 'Rationale (required)',
	required: 'Required',
	preRejectedText: 'Standard risks of misstatement that are not ROMMs in this engagement',
	additionalContextPlaceholder: 'Entity- specific context',
	additionalContextwhyRiskShouldBeRejected: 'Click {0} to document the entity-specific rationale.',
	hereLink: 'here',
	editAdditionalContextText: 'Edit entity-specific context',
	rejectionDetailsLabel: 'Rationale for not a ROMM',
	entitySpecificContextLabel: 'Entity-specific context',
	editRejectionDetailsPlaceholder: 'The entity-specific context has not been modified. Edit the context to proceed or cancel to exit.',
	additionalContextTextAreaPlaceholder: 'Entity-specific context',
	additionalContextLabel: 'Entity- specific context',
	notRommLabel: 'Not a ROMM',
	promoteToRommLabel: 'Promote to ROMM',
	rationaleDescription: 'Rationale description',
	standardROMMs: 'Standard ROMMs',
	risksOfMaterialMisstatement: 'Risks of material misstatement',
	notRisksOfMaterialMisstatement: 'Not risks of material misstatement',
	standardROMsNotROMMsInEngagement: 'Potential ROMMs that are not ROMMs in this engagement',
	standardROMsNotROMMs: 'Potential ROMMs that are not ROMMs in this engagement',
	assertionsLabel: 'Assertions',
	promotedTooltipText:
		'This ROMM is commonly concluded as not reasonably possible to occur, but has been promoted to a ROMM in this engagement.',
	promotedLabel: 'Promoted',
	preRejectedDescriptionLabel:
		'Below are potential ROMMs commonly concluded as not reasonably possible to occur for this type of account or disclosure. Considering the rationale, assess whether the potential ROMMs represent ROMMs to the entity. If a potential ROMM is relevant to the entity, promote it to a ROMM.',
	standardROMMsNotInThisEng: 'Standard ROMMs that are not ROMMs in this engagement'
};

export const AccountsRejectedROMMsSummary = {
	rommLabel: 'Standard ROMMs',
	rommRejectedLabel: 'Standard ROMMs that are not ROMMs in this engagement',
	rommAcceptedLabel: 'Standard ROMMs',
	rommPreRejectedLabel: 'Potential ROMMs that are not ROMMs in this engagement',
	allRommsLabel: 'All ROMMs',
	noResultsPlaceholder: 'No accounts available',
	rommSummaryRejectedAccountsHeader: 'Significant accounts and disclosures with rejected standard ROMMs',
	rommSummaryAcceptedAccountsHeader: 'Significant accounts and disclosures with accepted standard ROMMs',
	rommSummaryAssertionsHeader: 'Relevant Assertions',
	rommSummaryAssertionsSubHeader: 'Assertions',
	rommSummaryAccountSearchPlaceholder: 'Search account',
	stEntityNoResultsPlaceholder: 'No accounts available',
	supportedAccountsLabel: 'Supported Accounts',
	accountsWithAcceptedROMMs: 'Accounts with standard ROMMs',
	accountsWithRejectedROMMs: 'Accounts with standard ROMMs that are not ROMMs in this engagement',
	gtsEditAccountDocumentation: 'To edit account documentation, click'
};

export const ITProcessRejectionCategory = [
	{ id: 1, label: 'Likelihood - no reasonable possibility of occurring (without consideration of controls)' },
	{ id: 2, label: 'Magnitude - potential misstatement is immaterial' },
	{ id: 3, label: 'Risk is not material for this engagement' },
	{ id: 4, label: 'ROMM is addressed in another engagement (Group audits only)' },
	{ id: 5, label: 'Other' },
	{ id: 6, label: 'Addressed by business controls for a significant account or disclosure (specify the controls)' },
	{ id: 7, label: 'Addressed in a service organization report (e.g., SOC1)' },
	{ id: 8, label: 'Applicable, but addressed in another EY Canvas engagement' }
];

export const ROMMsRejectionCategory = [
	{
		id: 1, label: 'Likelihood - no reasonable possibility of occurring'
	},
	{
		id: 2, label: 'Magnitude - misstatement is expected to be at or below TE or is not important to users if it were to occur'
	},
	{
		id: 3, label: 'Likelihood and magnitude - no reasonable possibility of occurring or being material'
	},
	{
		id: 4, label: 'ROMM is applicable, but addressed in another EY Canvas engagement'
	}
];

export const createNewDeficiencyLabels = {
	createModalTitle: 'New deficiency',
	createModalDescription: "Enter the new deficiency details below and select <b>'Save and close'</b> to finish. To create another deficiency, select <b>'Save and create another'</b>.",
	createModalDescriptionForSaveAndEdit: "Enter the new deficiency and select <b>'Save and edit details'</b> to enter more details. To close, select <b>'Save and close'</b>.",
	waitToastMessage: 'Creating deficiency, please wait.',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	saveAndEditDetailsLabel: 'Save and edit details',
	entityDescriptionLabel: 'Deficiency description (required)',
	entityDescriptionPlaceholder: 'Enter deficiency description',
	referencePlaceholder: 'Enter deficiency name',
	referenceInputHeaderLabel: 'Deficiency name (required)',
	required: 'Required',
	cancel: 'Cancel',
	ofLabel: 'of',
	characters: 'characters',
	save: 'Save',
	delete: 'Delete',
	editModalTitle: 'Edit deficiency',
	editModalDescription: 'Edit the deficiency details below and select <strong>\'Save\'</strong> to finish.',
	control: 'Control',
	itgc: 'ITGC',
	businessProcessOptionLabel: 'Business process',
	itProcessOptionLabel: 'IT process',
	businessProcessInfoTooltip: 'Business process deficiencies also include deficiencies related to entity-level controls and ITACs.',
	deficiencyITControlLabel: 'Deficiency relates to (required):',
	deficiencyNameRequired: 'Deficiency name (required)',
	deficiencyDescriptionRequired: 'Deficiency description (required)',
	deficiencyRelatedTo: 'Deficiency relates to'
};

export const formLabels = {
	required: labels.required,
	maxLength: labels.maxLength
};

export const paginationLabels = {
	show: labels.pagingShowtext,
	first: 'First page',
	last: 'Last page',
	previous: 'Previous page',
	next: 'Next page'
};

export const accountDesignPSPOSPBodyLabels = {
	pageTitle: 'Audit plan',
	accountsOrDisclosure: 'Accounts and disclosures',
	pspAndosp: 'PSPs/OSPs',
	rejected: 'Rejected',
	risks: 'ROMMs',
	relevantAssertions: 'Relevant assertions',
	assertions: 'Assertions',
	importPsps: 'Import PSPs',
	importOsps: 'Import OSPs',
	ospModelTitle: 'New OSP',
	addOsps: 'Add OSPs',
	psps: 'PSPs',
	responsiveHeading: 'Responsive PSPs/OSPs',
	additionalInfo: ' Rationale:',
	limitRiskAssertionLabel: 'Limited risk account',
	noResultsFound: 'No significant accounts or disclosures have been created.',
	noAssertionsAvailableLabel: 'No assertions available',
	allPSPsRejected: 'All PSPs have been rejected.',
	editRelatedAssertions: 'Edit related assertions',
	rejectedPspsHeading: 'Rejected PSPs',
	acceptButton: 'Accept',
	rejectButton: 'Reject',
	noAssertionAvailableTooltip: 'No assertion available. Click <strong>Manage accounts and disclosures</strong> to add assertions.',
	noAssertionTooltipMessage:
		'Each significant account or significant disclosure must have at least one related assertion available to add a substantive procedure. Click {0} to add assertions.',
	manageAccountAndDisclosures: 'Manage accounts and disclosures',
	disabledAddOspTooltip:
		'At least one assertion must be available to add a substantive task. Click <strong>Manage accounts and disclosures</strong> to add assertions.',
	noPSPorOSPErrorMessage:
		'Each assertion must have at least one responsive substantive procedure. None of the assertions have responsive PSPs/OSPs. {0} or create a {1} to address all assertions for the account.',
	noOspsAndAllPspAreRejected:
		'Each assertion must have at least one responsive substantive procedure. All PSPs have been rejected and none of the assertions have responsive PSPs/OSPs. Create a {0} to address all assertions for the account.',
	limitedRiskErrorMessage:
		'Each limited risk account must have at least one responsive substantive procedure. Create a {0} to respond to the ROMMs of this account.',
	noPspOrOspAttachedToAssertion:
		'Each assertion must have at least one responsive substantive procedure. The following assertion(s) do not have any responsive PSPs/OSPs: <b>{orphanAssertions}</b>. {0}, add a {1} to address all assertions for the account or click on the edit icon for existing PSPs/OSPs responsive to this account to relate them to other assertions.',
	commonContentUpdateSuccessMessage:
		'Content update in progress. This may take up to fifteen minutes to complete. Refresh the page to see newly imported PSPs.',
	showErrInProgressMsg: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	importPSPButtonText: 'Import PSPs',
	toggleFilterWarningMessage: 'Show only accounts and disclosures without any substantive procedures ',
	rbacNoRightsForContentUpdateToolTip:
		'Insufficient permissions to perform content update. Contact your engagement administrator and request permission to initiate a content update.'
};

export const riskIdentifyProceduresBodyLabels = {
	pageTitle: 'Audit plan',
	romms: 'ROMMs',
	tocs: 'TOCs',
	pspAndosp: 'PSPs/OSPs',
	noResultsFound: 'No results found',
	responsiveHeading: 'Responsive procedures',
	relatedResponsiveHeading: 'Relate responsive procedures',
	ospModelTitle: 'New OSP',
	rommsAssertionLabel: 'Assertions relevant to the ROMM',
	norelatedAssertionPlaceHolder:
		'Each significant, fraud or higher risk must have at least one assertion identified as being related to this risk. Click {0}  to identify related assertions.',
	norelatedTaskPlaceHolder:
		'Each assertion relevant to this risk must have at least one responsive substantive procedure. Click {0} or {1} to identify responsive substantive procedures.',
	relateResponsiveProcedure: 'Relate responsive procedure',
	responsivePSPsOSPsHeader: 'Relate responsive PSPs/OSPs'
};

export const newOSPModalLabels = {
	prefix: 'Prefix',
	suffix: 'Suffix',
	title: 'Title',
	save: 'Save',
	saveAndCreateAnother: 'Save and create another',
	cancel: 'Cancel',
	timePhase: 'Time phase',
	assertions: 'Assertions',
	customizedDescription: 'Customized task description (required)',
	newOsp: 'New OSP',
	required: 'Required',
	optional: '(optional)',
	accountLabel: 'Account:',
	characters: 'characters',
	descriptionMaxLengthError: 'Description length exceeded maximum allowed length',
	ospWarningMessage: 'The newly created OSP does not address the assertions relevant to the ROMM and is therefore not displayed.'
};

export const rejectPspTaskModalLabels = {
	modaltitle: 'Reject PSP',
	modalDescription: 'Are you sure that you want to reject the selected PSP?',
	modalSecondDescription: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files.',
	rejectRationaleLabel: 'Rationale (required)',
	required: 'Required',
	characters: 'characters',
	cancel: 'Cancel',
	reject: 'Reject',
	editRejectionRationale: 'Edit rejection rationale',
	editRejectionRationaleLabel: 'Rationale for rejecting PSP',
};

export const deleteOSPTaskModalLabels = {
	modaltitle: 'Delete OSP',
	modalDescription: 'Are you sure you want to delete this task?',
	modalSecondDescription: 'Related evidence not related to any other tasks in this engagement will be moved to temporary files.',
	modalSecondDescription1: 'Findings and response tasks not related to any other evidence will be deleted.',
	delete: 'Delete'
};

export const controlSummaryColumnHeaders = {
	accountName: labels.accountLabel,
	distinctRelatedControlsCount: labels.controlTotal,
	lowerRiskOfRelatedControlsCount: labels.lowerRisk,
	ineffectiveDesignOfRelatedControlsCount: labels.designHeader,
	ineffectiveOperationOfRelatedControlsCount: labels.operationHeader
};

export const accountControlsTableHeaderLabels = {
	controlName: labels.controlHeader,
	lowerRisk: labels.lowerRisk,
	design: labels.design,
	operating: labels.operating
};

export const ITGCControlsTableHeaderLabels = {
	controlName: labels.itGCs,
	design: labels.design,
	testing: labels.testing,
	operation: labels.operationHeader
};

export const ITSPControlsTableHeaderLabels = {
	controlName: labels.itSPs,
	operation: labels.conclusionLabel
};

export const editRelatedAssertionsModalLabels = {
	modaltitle: 'Edit related assertions',
	modalDescription: 'Add or remove assertions for the task. There must be at least one assertion selected.',
	save: 'Save',
	task: 'Task',
	cancel: 'Cancel',
	account: 'Account',
	assertions: 'Assertions',
	assertionCannotEdited: 'Assertions with a disabled checkbox have been set by EY methodology and cannot be edited.',
	required: 'Required',
	taskAssertionnotModified: 'The task assertions have not been modified. Edit the assertion relationship to proceed or click cancel to exit.'
};

export const RelateGAComponentToDeficiencyLabels = {
	componentName: 'Components',
	groupScope: 'Group scope',
	referenceOnly: 'Ref.',
	notSelected: 'Not selected',
	noGAComponentsRelated: 'No components have been related to this deficiency'
};

export const CreateEditReferenceOnlyComponentLabels = {
	createModalTitle: 'New reference component',
	editModalTitle: 'Edit reference component',
	createModalDescription:
		"Enter the description of the component that is affected by the deficiency and select '<b>Save</b>' to finish. This does not create a component in the EY Canvas group structure and is being entered for reference on the Summary of control deficiencies.",
	editModalDescription: "Edit the reference component details below and select '<b>{0}</b>' to finish.",
	nameLabel: 'Reference component name (required)',
	namePlaceholder: 'Reference component name (required)',
	scopeLabel: 'Scope (required)',
	scopePlaceholder: 'Scope (required)',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	cancelLabel: 'Cancel',
	save: 'Save',
	required: 'Required'
};
export const RelateITApplicationToDeficiencyLabels = {
	bothLabel: 'Both',
	financialReporting: 'Financial reporting',
	itEnvironment: 'IT environment',
	technologyName: 'Technology',
	technologyDirectlySupports: 'Directly supports',
	noITComponentsRelated: 'No related technologies have been identified'
};

export const RelateITRiskITApplication259Labels = {
	itRiskName: 'IT risks',
	itLabel: 'IT',
	relatedTechnologies: 'Related technologies',
	relateTechnologies: 'Relate technologies',
	noITRiskITApplicationsRelated: 'No related IT risks have been identified',
	noUnmitigatedITRisksRelated: 'No unmitigated IT risks have been identified',
	knowledgeIconTitle: "Knowledge",
	executionType: 'OE',
	viewRelatedTechnology: 'View related technology',
	viewRelatedTechnologies: 'View related technologies',
	technology: 'Technology',
	type: 'Type',
	showOnlyRelated: 'Show only related',
	impactedITRisksHeader: 'Impacted IT risks',
	notImpactedITRisksHeader: 'Not impacted IT risks',
	noImpactedITRisksRelated: 'No impacted IT risks have been identified',
	noNotImpactedITRisksRelated: 'No non-impacted IT risks have been identified',
	unselectAll: 'Unselect all',
	technologyTypes: {
		applicationTool: 'Application/Tool',
		database: 'Database',
		operatingSystem: 'Operating system',
		network: 'Network',
		uncategorized: 'Uncategorized'
	},
	technologyCount: {
		singular: 'technology',
		plural: 'technologies'
	}
};

export const PagingButtonLabels = {
	first: 'First',
	last: 'Last',
	previous: 'Previous page',
	next: 'Next page'
};

export const directlySupportsLabels = {
	directlySupports: 'Directly supports',
	tooltip: 'Financial reporting and IT environment',
	financialReporting: 'Financial reporting',
	ITEnvironment: 'IT environment',
	both: 'Both',
	none: labels.noOptionSelected
};

export const responsivePSPOSPTaskLabels = {
	responsivePSPsOSPsHeader: 'Relate responsive PSP/OSP'
};

export const RelateCompensatingAndMitigatingITControlsLabels = {
	effectiveLabel: 'Effective',
	ineffectiveLabel: 'Ineffective',
	compensatingAndMitigatingITControls: 'ITGCs',
	designEffectiveness: 'Design',
	testingEffectiveness: 'Testing',
	operationEffectiveness: 'Operation',
	noCompensatingAndMitigatingITControlsIdentified: 'No ITGCs have been identified',
	executionType: 'OE'
};

export const yesNoOptions = [
	{ value: 1, label: 'Yes' },
	{ value: 0, label: 'No' }
];

export const controlDeficiencyFilter = [
	{ value: 1, label: 'Yes' },
	{ value: 0, label: 'No' }
];

export const designEffectivenessFilter = [
	{ value: '1', label: 'Effective' },
	{ value: '2', label: 'Ineffective' },
	{ value: '0', label: 'Not selected' }
];

export const operatingEffectivenessFilter = [
	{ value: '1', label: 'Effective' },
	{ value: '0', label: 'Ineffective' },
	{ value: '2', label: 'Not selected' }
];

export const booleanCustomFilter = [
	{ value: 1, label: 'Yes' },
	{ value: 0, label: 'No' }
];

export const singleLevelCustomFilter = [
	{ value: 1, label: 'Yes' }
];

export const booleanSingleLevelCustomFilter = [
	{ value: true, label: 'Yes' }
];

export const goToSource = {
	goToSource: 'Go to source',
	noResultsFound: labels.noResultsFound,
	activeText: 'here',
	sourceNotFound: 'Source not found. Refresh the page and try again. If the issue persists contact the Help Desk.',
	goToSourceManageEstimates: 'To manage estimates, click',
	goToSourceAccount: 'To manage accounts and disclosures, click',
	goToSourceEditAccount: 'To edit the account, click',
	goToSourceAddEstimate: 'To add an estimate, click'
};

export const scotDrawerLabels = {
	typeOfScot: 'Type of SCOT',
	relatedVeryLowRisk: 'Related very low risk estimate',
	relatedAccounts: 'Related accounts',
	none: 'None',
	hyphen: '-',
	guidedWorkflow: 'Guided workflow',
	noRecordsFound: 'No records found'
};

export const walkthroughControlTaskLabels = {
	goToSourceManageControls: 'To manage controls, click',
	goToSourceManageITGCs: 'To manage ITGCs, click',
	goToSourceManageITSPs: 'To manage ITSPs, click',
	goToSourceManageSCOTS: 'To manage SCOTs, click',
	goToSourceManageEstimates: 'To manage estimates, click',
	goToSourceViewEstimateListing: 'To view estimate listing, click',
	goToSourceHere: 'here'
};

export const goToSourceItems = {
	manageITProcesses: {
		label: 'To manage IT processes, click',
		linkText: 'here'
	},
	relateITProcesses: {
		label: 'To relate IT processes, click',
		linkText: 'here'
	},
	editControlSource: {
		label: 'To edit ROMMs related to the control click',
		linkText: 'here'
	},
	manageITSPs: {
		label: 'To manage ITSPs, click',
		linkText: 'here'
	},
	manageITGCs: {
		label: 'To manage ITGCs, click',
		linkText: 'here'
	},
};

export const relateControlDeficiencyGoToSourceLabels = {
	manageThisEngagement: 'To manage controls from this engagement, click',
	manageOtherEngagements: 'To manage controls from other engagements, click',
	manageReferenceRomms: 'To manage Reference ROMMs, click',
	clickHere: 'here'
};

export const relateITControlDeficiencyGoToSourceLabels = {
	manageThisEngagement: 'To manage ITGCs, click',
	manageOtherEngagements: 'To manage reference ITGCs, click',
	manageOtherEngagements258: 'To define ITGC gaps, inadequate IT processes, or to manage other reference ITGCs, click',
	clickHere: 'here'
};

export const goToSourceEstimateItems = {
	identificationDoclabel: 'To view identification documentation, click',
	editEstimatelabel: 'To edit estimate categorization, click',
	linkText: 'here'
};

export const goToSourceRiskItems = {
	editRiskSource: {
		label: 'To make changes to this standard ROMM, click',
		linkText: 'here'
	}
};

export const scotOtherConsiderationsLabels = {
	otherConsiderations: 'SCOTs with observations'
};

export const scotSummaryTypeLabels = {
	6: 'Changes to the SCOT',
	7: 'Policies or internal control matters',
	8: 'Higher likelihood of management override',
	9: 'Known or suspected fraud'
};

export const relateITRiskLabels = {
	relateITRiskHeader: 'This ITGC is intended to mitigate the following IT risks',
	relateITRisk: 'Relate IT risk',
	relatedITRisks: 'Related IT risks',
	itRisk: labels.itRiskName,
	itRisksCount: '{0} IT risks',
	itRiskCount: '{0} IT risk',
	oneObjectShouldBeSelected: 'One object should be selected in order to proceed',
	itRiskAlreadyRelatedTooltip: 'IT risk is already related',
	category: 'Category'
};

const commonUnrelatedModalLabels = {
	modalTitle: 'Unrelated tasks',
	closeLabel: 'Cancel',
	okLabel: 'Delete',
	searchPlaceholder: 'Search',
	clearHoverText: 'Clear',
	showLabel: 'Show',
	noResultsFound: 'No results found',
	tasks: 'Tasks',
	taskHeaderColumnName: 'Task',
	typeHeaderColumnName: 'Type',
	toastWarning: 'At least one task must be selected for deletion.',
	deleteModal: {
		deleteTitle: 'Confirm deletion of selected task(s)',
		deleteDescription:
			'Are you sure that you want to delete the selected task(s)? Related evidence that is not related to any other tasks in this engagement will be moved to temporary files.',
		okLabel: 'Delete',
		closeLabel: 'Cancel'
	}
};

export const ITProcessWalkthroughLabels = {
	UnrelatedTitle: 'There are {0} tasks that are not related to an IT Process',
	UnrelatedDescription:
		"All tasks must be related to an IT Process.  Relate these tasks to an IT Process or select 'Show unrelated tasks' to review and delete them.",
	unRelatedLinkText: 'Show unrelated tasks',
	modalLabels: {
		...commonUnrelatedModalLabels,
		modalTitle: 'Unrelated UDP tasks',
		unrelatedTasksHeader: 'Unrelated tasks must be associated to a IT process or deleted.',
		closeLabel: 'Cancel'
	}
};

export const ControlWalkthroughLabels = {
	UnrelatedTitle: 'There are {0} tasks that are not related to a control',
	UnrelatedDescription: "All tasks must be related to a control. Relate these tasks to a control or select 'Show unrelated tasks' to review and delete them.",
	unRelatedLinkText: 'Show unrelated tasks',
	modalLabels: {
		...commonUnrelatedModalLabels,
		unrelatedTasksHeader: 'Unrelated tasks must be associated to a control or deleted.',
		closeLabel: 'Cancel'
	}
};

export const ITControlWalkthroughLabels = {
	UnrelatedTitle: 'There are {0} tasks that are not related to an ITGC',
	UnrelatedDescription: "All tasks must be related to an ITGC.  Relate these tasks to an ITGC or select 'Show unrelated tasks' to review and delete them.",
	unRelatedLinkText: 'Show unrelated tasks',
	modalLabels: {
		...commonUnrelatedModalLabels,
		unrelatedTasksHeader: 'Unrelated tasks must be associated to an ITGC or deleted.',
		closeLabel: 'Cancel',
		modalTitle: 'Unrelated EDC/TOC tasks'
	}
};

export const ITSPOSPTaskLabels = {
	unrelatedTitle: 'There are {0} tasks that are not related to an ITSP',
	unrelatedDescription: "All tasks must be related to an ITSP. Relate these tasks to an ITSP or select 'Show unrelated tasks' to review and delete them.",
	unrelatedLinkText: 'Show unrelated tasks',
	modalLabels: {
		...commonUnrelatedModalLabels,
		unrelatedTasksHeader: 'Unrelated tasks must be associated to an ITSP or deleted.',
		closeLabel: 'Cancel',
		modalTitle: 'Unrelated OSP tasks'
	}
};

export const UnrelatedTaskLabels = {
	unrelatedTitle: 'There are {0} tasks that are not related to an ITGC',
	unrelatedDescription: "All tasks must be related to an ITGC. Relate these tasks to an ITGC or select 'Show unrelated UDP tasks' to review and delete them.",
	unrelatedLinkText: 'Show unrelated UDP tasks',
	modalLabels: {
		...commonUnrelatedModalLabels,
		unrelatedTasksHeader: 'Unrelated tasks must be associated to an ITGC or deleted.',
		closeLabel: 'Cancel',
		modalTitle: 'Unrelated UDP tasks'
	}
};

export const addOspConfirmModalLabels = {
	modalTitle: 'Confirm selected assertions',
	modalDescription: `All of the assertions selected are not relevant for the ROMM.  Clicking continue will create the task but will not make the task responsive for the ROMM. Assertions relevant for the ROMM are: <b>{0}</b>. Do you want to continue?`
};

export const KnowledgeScotsLabels = {
	title: 'New SCOT',
	importScot: 'Import SCOT',
	description: 'Select a SCOT from Knowledge below or create a custom SCOT.',
	firstColumnHeader: 'SCOT',
	noResultsFound: 'No results found',
	close: 'Close',
	showOnlySelected: 'Show only selected',
	saveAndCloseLabel: 'Import SCOT',
	saveAndCreateLabel: 'Create custom SCOT',
	cancelLabel: 'Cancel',
	searchPlaceholder: labels.searchPlaceholder,
	clearHoverText: labels.clearHoverText,
	pagingSvgHoverText: pagingSvgHoverText,
	pagingShowtext: labels.pagingShowtext,
	knowledge: labels.knowledge,
	toastWarning: 'At least one SCOT must be selected.'
};

export const ITScopingTasksLabels = {
	unrelatedLabel: 'View unrelated UDPs',
	modalLabels: {
		modalTitle: 'Unrelated UDP tasks',
		closeLabel: 'Cancel',
		okLabel: 'Delete',
		searchPlaceholder: 'Search',
		clearHoverText: 'Clear',
		showLabel: 'Show',
		noResultsFound: 'No results found',
		unrelatedTasksHeader: 'Unrelated tasks must be associated to a technology or deleted.',
		task: 'Task',
		type: 'Type',
		toastWarning: 'At least one task must be selected for deletion.',
		selectedTaskCounter: '{0} Task',
		selectedTasksCounter: '{0} Tasks',
		deleteModal: {
			deleteTitle: 'Confirm deletion of selected task(s)',
			deleteDescription:
				'Are you sure that you want to delete the selected task(s)? Related evidence that is not related to any other tasks in this engagement will be moved to temporary files.',
			okLabel: 'Delete',
			closeLabel: 'Cancel'
		}
	}
};

export const ITRiskAssessmentTasksLabels = {
	unrelatedTitle: 'There are {0} tasks that are not related to a technology',
	unrelatedDescription: "All tasks must be related to a technology. Relate these tasks to a technology or select 'Show unrelated UDP tasks' to review and delete them.",
	unrelatedLinkText: 'Show unrelated UDP tasks',
	unrelatedLabel: 'View unrelated UDPs',
	modalLabels: {
		modalTitle: 'Unrelated UDP tasks',
		closeLabel: 'Cancel',
		okLabel: 'Delete',
		searchPlaceholder: 'Search',
		clearHoverText: 'Clear',
		showLabel: 'Show',
		noResultsFound: 'No results found',
		unrelatedTasksHeader: 'Unrelated tasks must be associated to a technology or deleted.',
		task: 'Task',
		type: 'Type',
		toastWarning: 'At least one task must be selected for deletion.',
		selectedTaskCounter: '{0} Task',
		selectedTasksCounter: '{0} Tasks',
		deleteModal: {
			deleteTitle: 'Confirm deletion of selected task(s)',
			deleteDescription:
				'Are you sure that you want to delete the selected task(s)? Related evidence that is not related to any other tasks in this engagement will be moved to temporary files.',
			okLabel: 'Delete',
			closeLabel: 'Cancel'
		}
	}
};

export const relateTechnologyLabels = {
	relateTechnology: labels.relateTechnologyLabel,
	showOnlyRelated: labels.showOnlyRelated,
	technology: labels.technology,
	technologiesCount: '{0} technologies',
	technologyCount: '{0} technology',
	technologyTypeHeader: labels.type,
};

export const ManageWalkthrough276ScotBodyLabels = {
	UnrelatedTitle: 'There are {0} tasks that are not related to a SCOT',
	UnrelatedDescription:
		'All SCOT tasks must be related to a SCOT.  Relate these tasks to a SCOT or select \'Show unrelated tasks\' to review and delete them.',
	unRelatedLinkText: 'Show unrelated tasks',
	modalLabels: {
		...commonUnrelatedModalLabels,
		unrelatedTasksHeader: 'Unrelated tasks must be associated to a SCOT or deleted.'
	}
};

export const ManageWalkthrough276EstimateBodyLabels = {
	UnrelatedTitle: 'There are {0} tasks that are not related to an Estimate',
	UnrelatedDescription:
		'All estimate tasks must be related to an Estimate.  Relate these tasks to an Estimate or select \'Show unrelated tasks\' to review and delete them.',
	unRelatedLinkText: 'Show unrelated tasks',
	modalLabels: {
		...commonUnrelatedModalLabels,
		unrelatedTasksHeader: 'Unrelated tasks must be associated to an estimate or deleted.'
	}
};

export const orphanSCOTsLabels = {
	UnrelatedTitle1: 'There is 1 unrelated SCOT',
	UnrelatedTitle2: 'There are {0} unrelated SCOTs',
	UnrelatedDescription:
		"All SCOTs must be related to an account. Relate these SCOTs to an account or click on 'Show unrelated SCOTs' to review and delete them.",
	UnRelatedBtnText: 'Show unrelated SCOTs'
};

export const goToSourceROMMItems = {
	editROMMSource: {
		label: 'To edit and upfront ROMM, click',
		linkText: 'here'
	}
};

export const manageResponseTasksFormLabels = {
	formTitleLabel: 'Deficiency tasks',
	taskCountLabel: 'Tasks',
	concurrencyErrorMessage: 'This action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	relateModalTitle: 'Relate response tasks',
	relateModalSectionLabel: 'Deficiency',
	unrelatedTitleSingular: 'There is 1 task not related to a deficiency',
	unrelatedTitle: 'There are {0} tasks not related to a deficiency',
	unrelatedDescription:
		"All deficiency tasks must be related to a deficiency. Relate these tasks to a deficiency or select 'Show unrelated tasks' to review and delete them.",
	unrelatedLinkText: 'Show unrelated tasks',
	modalLabels: {
		...commonUnrelatedModalLabels,
		modalTitle: 'Unrelated tasks',
		unrelatedTasksHeader: 'Unrelated tasks must be associated to a deficiency or deleted.',
		closeLabel: 'Cancel',
		task: 'Task',
		type: 'Type',
		selectedTaskCounter: '{0} task',
		selectedTasksCounter: '{0} tasks'
	}
};

export const ITApplicationTypeAllLabels = [
	{ value: 1, label: 'Application/Tool' },
	{ value: 2, label: 'Database' },
	{ value: 3, label: 'Operating system' },
	{ value: 4, label: 'Network' },
	{ value: 5, label: 'Service organization' },
	{ value: 6, label: 'Not selected' }
];

export const ITProcessTypeCategoryOptions = [
	{ value: 8, label: 'Manage changes' },
	{ value: 9, label: 'Manage access rights' },
	{ value: 10, label: 'Manage security settings' },
	{ value: 11, label: 'Manage IT operations' },
	{ value: 12, label: 'Manage system implementations' }
];

export const SADExportModal = {
	title: 'SAD Export',
	close: 'Close',
	cancel: 'Cancel',
	print: 'Export',
	step1Label: 'Step 1: Select export type',
	selectPrintTypeLabel: '',
	stepSelectEntitiesLabel: 'Step 2: Select entities',
	stepOutputFormatLabel: 'Step 3: Select combined or separate output',
	selectPrintTypeDescription: 'Select one of the export types below.',
	exportAll: 'Export all',
	exportAllDescription: 'Export all misstatements within this engagement. This version is primarily for internal use only.',
	exportForManagement: 'Export for letter of representations attachment',
	exportForManagementDescription: 'Export uncorrected misstatements for the purpose of attaching to the letter of representations.',
	exportForTCWG: 'Export for those charged with governance',
	exportForTCWGDescription:
		'Export corrected and uncorrected misstatements for the purpose of communicating to those charged with governance.',
	selectEntitiesDescription: 'Select one or more entities to export misstatements for.',
	selectEntitiesPlaceholder: 'Select entities',
	entitiesSelected: 'selected',
	allEntitiesSelected: 'All',
	entitySelectionRequired: 'Required',
	selectOutputFormatDescription: 'Select one of the export outputs below for multiple entities.',
	combineAllEntities: 'Combine all entities in one output',
	combineAllEntitiesDescription: 'Export all misstatements for the selected entities in one output.',
	separateOutput: 'Separate output for individual entities',
	separateOutputDescription: 'Export misstatements for each individual selected entity on its own.'
};
export const SOCDExportModal = {
	title: 'SOCD Export',
	close: 'Close',
	cancel: 'Cancel',
	print: 'Export',
	step1Label: '',
	selectPrintTypeDescription: 'Select one of the export types below.',
	export: 'Export',
	exportAll: 'Export all',
	exportAllDescription: 'Export all deficiencies - for internal use only.',
	exportForManagement: 'Export for management',
	exportForManagementDescription: 'Export all deficiencies - for external use.',
	exportForTCWG: 'Export for those charged with governance (TCWG)',
	exportForTCWGDescription: 'Export deficiencies that are Significant Deficiencies or Material Weaknesses.'
};

export const SadSummary304 = {
	newMisstatement: 'New misstatement',
	manageMisstatements: 'Manage misstatements',
	uncorrected: 'Uncorrected misstatements',
	corrected: 'Corrected misstatements',
	allMisstatements: 'All misstatements',
	withIncomeEffect: 'Misstatements with income effect',
	withoutIncomeEffect: 'Misstatements without income effect',
	cashflow: 'Cash flow misstatements',
	disclosure: 'Disclosure misstatements',
	allCorrectedMisstatements: 'Corrected misstatements',
	allUncorrectedMisstatements: 'Uncorrected misstatements',
	userFilters: '',
	withEffectOnIncome: 'Misstatements that have an effect on income or OCI',
	withNoIncomeEffect: 'Misstatements that do not have an effect on income or OCI',
	cashFlowMisstatements: 'Cash flow misstatements',
	discloseMisstatements: 'Disclosure misstatements',
	misstatement: 'Misstatement',
	misstatements: 'Misstatements',
	showDetails: 'Show details',
	value: 'CY net income effect Dr./(Cr.)',
	amount: 'Amount',
	incomeEffectAmount: `Gross current period effect on income`,
	grossAmount: 'Income effect before turnaround',
	netAmountAfterTurnaround: 'Income effect after turnaround',
	statementOfCashflowsLineItem: 'Statement of cash flows line item',
	operating: 'Operating',
	investing: 'Investing',
	financing: 'Financing',
	disclosureEvaluationConclusion: 'Disclosure misstatement details and authoritative guidance reference',
	attributes: 'Attributes',
	filterMyReview: 'Reviewed by me',
	filterCommunicated: 'Clearly trivial',
	filterNotCommunicated: 'Not communicated',
	filterCommunicatedUncorrected: 'Misstatements',
	filterCommunicatedCorrected: 'Communicate',
	filterRelatedDeficiency: 'Related deficiency',
	selectEntityToViewDetails: 'Select an entity to view details',
	noRelatedDeficiencyTooltip: 'No related deficiency',
	reviewedBy: 'Reviewed by me on',
	notReviewed: 'Not reviewed by me',
	notCommunicated: 'Not communicated',
	clearlyTrivial: 'Clearly trivial',
	excludeFromCommunication: 'Exclude from communication',
	cyBadge: 'CY',
	pyBadge: 'PY',
	cyPyBadge: 'CY PY',
	cyBadgeTooltip: 'Current period',
	cyWithTurnaroundBadgeTooltip: 'Current period with turnaround',
	pyBadgeTooltip: 'Prior period',
	pyPeriodEntry: 'Prior period entry',
	showDeletedMisstatements: 'Show deleted misstatements',
	singleDeletedPriorPeriodMisstatementTitle: 'There is {0} misstatement rolled forward from the prior year which has been deleted',
	multipleDeletedPriorPeriodMisstatementTitle: 'There are {0} misstatements rolled forward from the prior year which have been deleted',
	deletedPriorPeriodMisstatement: "Review the deleted prior period misstatement(s) by selecting 'Show deleted misstatements'. Misstatement(s) can be restored if desired.",
	turnaroundLabel: 'Turnaround effect on current period income Debit / (Credit)',
	turnaroundAmount: 'Turnaround amount',
	myReviewFilters: [
		{
			value: 0,
			label: labels.yes
		},
		{
			value: 1,
			label: labels.no
		}
	],
	communicatedFilters: [
		{
			value: 0,
			label: labels.yes
		},
		{
			value: 1,
			label: labels.no
		}
	],
	communicatedFiltersUncorrected: [
		{
			value: 1,
			label: 'Accumulated'
		},
		{
			value: 0,
			label: 'Clearly trivial'
		}
	],
	relatedDeficiencyFilters: [
		{
			value: 0,
			label: labels.yes
		},
		{
			value: 1,
			label: labels.no
		}
	],
	edit: 'Edit',
	showValidations: 'Show only misstatements with validations',
	noValidResultsFound: 'No results found',
	showNoResultCheckCorrected: 'No results found. Please adjust filters or check corrected tab for any remaining validations.',
	showNoResultCheckUncorrected: 'No results found. Please adjust filters or check uncorrected tab for any remaining validations.'
};

const misstatementDetailsNatureTypeLabels = {
	factual: 'Factual',
	projected: 'Projected',
	judgemental: 'Judgmental',
	notSelected: 'Type not selected'
};

const misstatementAccountGroupSelectionLabels = {
	currentAssets: 'Current assets',
	nonCurrentAssets: 'Noncurrent assets',
	currentLiabilities: 'Current liabilities',
	nonCurrentLiabilities: 'Noncurrent liabilities',
	equity: 'Equity',
	preTaxIncomeLoss: 'Pretax income',
	incomeTaxExpenseBenefit: 'Income tax',
	otherComprehensiveIncome: 'Other comprehensive income'
};

export const MisstatementDetails = {
	title: 'Misstatement details',
	modalCancelTitle: 'Close',
	editModal: {
		title: 'Edit misstatement',
		description: `Edit misstatement details below and select '{0}' to finish.`,
		indexLabel: 'Misstatement index (required)',
		descriptionLabel: 'Misstatement description (required)',
		required: 'Required',
		save: 'Save',
		cancel: 'Cancel',
		cancelTooltip: 'Cancel',
		characters: 'characters',
		of: 'of'
	},
	header: {
		period: 'Period',
		periodRequired: 'Period (required)',
		type: 'Effect on',
		misstatementIndex: 'Index (required)',
		description: 'Description (required)',
		multiEntity: 'Reporting entity',
		multiEntityEdit: 'Reporting entity (required)',
		groupComponent: 'Identified by',
		groupComponentEdit: 'Identified by (required)',
		groupComponents: 'Group components',
		primaryTeam: 'Primary Team',
		noResultsFound: 'No results found',
		myReview: 'Reviewed by me',
		natureNotSelected: 'Type not selected',
		notSelected: 'Not selected',
		edit: 'Edit',
		copyMisstatementLink: 'Copy misstatement link',
		urlCopied: 'URL copied successfully',
		reviewedByMe: 'Reviewed by me',
		notReviewedByMe: 'Not reviewed by me',
		reviewedOn: 'Reviewed by me on {date}',
		incomeStatementBalanceSheet: 'Income, OCI or balance sheet',
		delete: 'Delete misstatement',
		deleteButtonLabel: 'Delete',
		cancelButtonLabel: 'Cancel',
		moreOptions: 'More options',
	},
	currentPeriod: {
		fsli: 'FSLI',
		accountGroup: 'Financial statement subtotal',
		statementOfCashflowsLineItem: 'Statement of cash flows line item',
		cashFlowActivity: 'Cash flow activity',
		financialStatementLineItem: 'Financial statement line item',
		cashFlowOperating: 'Operating',
		cashFlowInvesting: 'Investing',
		cashFlowFinancing: 'Financing',
		periodLabel: 'Current period',
		currencyLabelPrefix: 'Currency',
		currencyNotSelected: 'Not selected',
		currencySelectRelatedEntity: 'Select related entity to edit currency.',
		taxRateLabelPrefix: 'Tax rate',
		taxRateNotSelected: 'Not selected',
		taxRateNotSelectedTooltip: 'To set the tax rate, go to \'Financial statement amounts\' view.',
		taxRateNotSelectedTooltipMultiEntity: 'To set the tax rate, go to \'Financial statement amounts\' view for the related entity.',
		taxRateSelectRelatedEntity: 'Select related entity to edit tax rate.',
		debit: 'Debit',
		credit: 'Credit',
		increase: 'Increase',
		decrease: 'Decrease',
		taxable: 'Taxable',
		addLine: 'Add line',
		saveAndClose: 'Save & close',
		selectLabel: 'Select',
		enterPlaceholder: 'Enter',
		totalsLabel: 'Totals',
		totalLabel: 'Total',
		entryLabel: 'Entry',
		editEntryTooltip: 'Edit entry',
		emptyEntryMessage: 'Entry incomplete. Click {here} to get started.',
		emptyEntryLinkText: 'here',
		entriesNeedToBalance: 'Entries need to balance',
		incompleteEntryMessage: 'Incomplete entry. Complete all required inputs and try again.',
		unbalancedEntryMessage: 'The entry is unbalanced. Edit the debit and credits or add lines to balance the entry.',
		unbalancedCashFlowEntryMessage: 'The entry is unbalanced. Edit the increases and decreases or add lines to balance the entry.',
		unbalancedViewWarningMessage: 'Entry is unbalanced. Click edit to adjust the entry.',
		misstatementIncomplete: "The misstatement entry is incomplete. Click {0} to edit.",
		misstatementDetailsIncomplete: 'Misstatement details are incomplete. Click {0} to edit.',
		priorPeriodMisstatementIncomplete: 'Prior period misstatement details are incomplete. Click {0} to edit.',
		deleteLineTooltip: 'Delete line',
		priorYearAdjustmentActionTooltip: 'This adjustment was rolled forward from the prior year. Action cannot be taken.',
		maxLineReachedTooltip: 'Maximum of 100 lines reached.',
		taxableDisabledTooltip:
			'When a misstatement affects the "Income tax" financial statement subtotal, the entry must be entered without tax effect. If a tax effect is required, manually enter the tax effect by adding a line item affecting the "Income tax" financial statement subtotal.',
		statusOptions: [
			{ value: 'uncorrected', label: 'Uncorrected' },
			{ value: 'corrected', label: 'Corrected' }
		],
		misstatementStatusOptions: [
			{ value: 1, label: 'New' },
			{ value: 2, label: 'Recurring' },
			{ value: 3, label: 'New' },
			{ value: 4, label: 'Rolled forward' },
			{ value: 5, label: 'Updated' }
		],
		accountGroupOptions: createMisstatementAccountGroupOptionResourceMapping(misstatementAccountGroupSelectionLabels),
		natureOptions: createMisstatementNatureOptionResourceMapping(misstatementDetailsNatureTypeLabels)
	},
	periodTypeLabels: {
		currentPeriod: 'Current period',
		comparativePeriod: 'Prior period',
		secondComparativePeriod: 'Second Comparative Period'
	},
	misstatementTypeLabels: {
		...misstatementDetailsNatureTypeLabels,
		reclassification: 'Reclassification',
		clientAdjustment: 'Client adjustment',
		manualTopUpAdjustment: 'Manual top-up adjustment'
	},
	parentMisstatementTypeLabels: {
		hasEffectOnIncome: 'Has effect on income',
		doesNotHaveEffectOnIncome: 'Does not have an effect on income',
		cashFlow: 'Cash flow',
		disclosure: 'Disclosure'
	},
	expansionCards: {
		sectionLabel: 'Misstatement impact',
		netEffectLabel: 'Net effect\nDebit / (Credit)',
		netEffectEditLabel: 'Net effect will be calculated automatically',
		currentPeriodIncomeLabel: 'Effect on current period\nincome\nDebit / (Credit)',
		currentPeriodIncomeEditLabel: 'Effect on current period income will be calculated automatically',
		priorPeriodIncomeLabel: 'Turnaround effect on current period income\nDebit / (Credit)',
		priorPeriodIncomeEditLabel: 'Turnaround will be automatically calculated',
		turnaroundIncomeLabel: 'Turnaround effect on current period income\nDebit / (Credit)',
		turnaroundIncomeEditLabel: 'Turnaround will be automatically calculated'
	},
	priorPeriod: {
		sectionLabel: 'Prior period',
		description:
			'Enter the entry as it should have been recorded in the prior period. The turnaround amount will be automatically calculated.',
		periodLabel: 'Prior period',
		relatePriorPeriodMisstatement: 'Relate prior period misstatement',
		emptyStateMessage: 'No prior period misstatement. Click {relatePriorPeriodMisstatement} to relate a misstatement.',
		unbalancedViewWarningMessage: 'Entry is unbalanced. Open prior period misstatement to adjust the entry.',
		confirmChangesTitle: 'Confirm changes',
		confirmChangesDescription:
			'Selecting this option will unrelate all prior period misstatements. This may impact your documentation. Do you want to continue?',
		periodChangeConfirmChangesDescription:
			'Changing the period will unrelate prior period adjustment entries. This action cannot be undone. Do you want to continue?',
		continueButtonLabel: 'Continue',
		cancelButtonLabel: 'Cancel',
		columnDisplayName: 'Prior period misstatements',
		disabledRelateTooltip: 'Already related to other current period misstatement',
		relateModalGenericErrorMessage: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
		judgemental: {
			tooltipLabel: 'Reversal of judgmental misstatements',
			tooltipDescription:
				'Judgmental misstatements existing at the end of the period generally turn around in the current period, except when experience in the current period indicates that management\'s estimation assumptions in the prior period were correct or within a reasonable range and ours were not.',
			atlasGuidanceLabel: 'MISSTATE 1.2',
			atlasGuidanceUrl: 'https://live.atlas.ey.com/#document/2532266534606/',
			priorAdjustmentGuidanceTooltip: 'Guidance'
		},
		entryGuidance: {
			label: 'Guidance',
			newComparativeDescription:
				'In the current period, we accumulate prior period uncorrected misstatements that have an effect on income, irrespective of whether the misstatement exists in the current period.',
			judgementalDescription:
				"Judgmental misstatements existing at the end of the prior period turn around in the current period, except when experience in the current period indicates that management's estimate in the prior period was correct and ours was not.\nThe turnaround amount is automatically calculated. When applicable, we update the prior period misstatement to reflect the amount that turns around in the current period.",
			factualProjectedDescription:
				'Uncorrected factual and projected misstatements from the prior period turn around in the current period.\nThe turnaround amount is automatically calculated.'
		}
	},
	supportingWorkpapers: {
		sectionLabel: 'Supporting evidence',
		addEvidence: 'Add evidence',
		newEvidence: 'New evidence',
		relateEvidence: 'Relate evidence',
		emptyStateMessage: 'Add supporting evidence by clicking on {newEvidence} or {relateEvidence}.',
		columnName: 'Name',
		columnNotes: 'Notes',
		columnSignoffs: 'Sign-offs',
		removeFromMisstatement: 'Remove from misstatement',
		removeSuccess: 'Document removed from misstatement successfully',
		removeError: 'Failed to remove document from misstatement',
		concurrencyError: 'The action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.',
		removing: 'Removing...',
		relateEvidenceModalInstructional: 'Add or remove documents related to this misstatement.',
		newEvidenceTaskModalInstructional: 'New documents must be related to at least one task. Select a task that this document should be added to as evidence.',
		showOnlyRelated: 'Show only related'
	},
	communicationDecision: {
		sectionLabel: 'Communication',
		description: 'Did we conclude the corrected misstatement should be communicated with those charged with governance?',
		excludeFromCommunication: 'Communicate:',
		onLabel: 'Yes',
		offLabel: 'No',
		rationaleLabel: 'Rationale for not communicating the corrected misstatement (required)',
		rationalePlaceholder: 'Enter',
		emptyRationaleWarning: 'Corrected misstatements not communicated to those charged with governance require a rationale.',
		emptySaveDescription:
			'You have not entered any value. This will turn on the communicate option and the misstatement will be included in communications. Do you want to continue?',
		toggleOffDescription: 'Selecting this option will remove the rationale. This may impact your documentation. Do you want to continue?',
		confirmChangesTitle: 'Confirm changes',
		guidanceTooltip: 'Guidance',
		guidanceTooltipLabel: 'Guidance',
		atlasGuidanceLabel: 'COMMS 2.13.2',
		atlasGuidanceUrl: 'https://live.atlas.ey.com/#document/2532256877722/',
		guidanceTooltipDescription:
			'We communicate corrected misstatements that have an effect on income or OCI exceeding TE, and other misstatements that, based on our professional judgment, merit the attention of those charged with governance.',
		editRationale: 'Edit rationale',
		continue: 'Continue',
		cancel: 'Cancel'
	},
	clearlyTrivial: {
		sectionLabel: 'Is the misstatement clearly trivial?',
		excludeFromCommunication: 'Clearly trivial:',
		onLabel: 'Yes',
		offLabel: 'No',
		rationaleLabel: 'Rationale for concluding the misstatement is clearly trivial (required)',
		rationalePlaceholder: 'Enter',
		emptyRationaleWarning: 'Designating a misstatement as clearly trivial removes it from the accumulation of misstatements. A rationale is required.',
		emptySaveDescription:
			'You have not entered a rationale. The misstatement will not be designated as clearly trivial. Do you want to continue?',
		toggleOffDescription: 'Deselecting this option will remove the clearly trivial rationale. This may impact your documentation. Do you want to continue?',
		confirmChangesTitle: 'Confirm changes',
		guidanceTooltip: 'Guidance',
		guidanceTooltipLabel: 'Guidance',
		atlasGuidanceLabel: 'MISSTATE 1.1',
		atlasGuidanceUrl: 'https://live.atlas.ey.com/#document/2532266534606/',
		guidanceTooltipDescription:
			'Misstatements greater than the SAD nominal amount are generally more than clearly trivial. For misstatements that do not have an effect on income or OCI, we use professional judgment to determine whether misstatements are clearly trivial and therefore do not merit the attention of those charged with governance. We consider quantitative and qualitative factors to determine whether identified misstatements that do not have an effect on income or OCI, either individually or when aggregated with other misstatements, are clearly trivial. When there is any uncertainty about whether one or more items are clearly trivial, the misstatement is considered not to be clearly trivial.',
		editRationale: 'Edit rationale',
		continue: 'Continue',
		cancel: 'Cancel'
	},
	evaluationRationale: {
		sectionLabel: 'Misstatement evaluation',
		fieldLabel: 'Disclosure misstatement details and authoritative guidance reference (required)',
		placeholder: 'Enter',
		warningMessage: 'All disclosure misstatements must have additional details provided.',
		emptyStateMessage: 'Disclosure misstatement details and authoritative guidance reference are incomplete.<br />Click {here} to enter response.',
		concurrencyError: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.'
	},
	relatedAccounts: {
		sectionLabel: 'Related account',
		relateAccount: 'Relate account',
		emptyStateMessage: 'No accounts are related to this misstatement. Click {relateAccount} to relate an account.',
		relateModalTitle: 'Relate account',
		relateModalDescription: 'Add or remove accounts related to this misstatement.',
		misstatementLabel: 'Misstatement:',
		showOnlyRelated: 'Show only related',
		searchPlaceholder: 'Search',
		clearHoverText: 'Clear',
		closeLabel: 'Close',
		noResults: 'No results found',
		accountsListLabel: 'Accounts',
		accountCountSingular: '1 account',
		accountCountPlural: '{0} accounts',
		addedLabel: 'Added',
		relateErrorMessage: 'This action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.'
	},
	deficiencies: {
		sectionHeaderLabel: 'Deficiencies',
		description: 'Is the misstatement indicative of a control deficiency?',
		warningDescription:
			'Relate a deficiency or select "No, the misstatement is not indicative of a control deficiency", and document the rationale.',
		noDeficienciesIdentified: 'No, the misstatement is not indicative of a control deficiency.',
		addDeficiency: 'New deficiency',
		relateDeficiencies: 'Relate deficiencies',
		relatedDeficienciesHeader: 'Related deficiencies',
		noRelatedDeficiencies: 'No related deficiencies. Click {relateDeficiencies} to relate an existing deficiency or {addDeficiency} to create a new one.',
		rationaleLabel: 'Rationale for concluding the misstatement is not indicative of a control deficiency (required)',
		enterPlaceholder: 'Enter',
		save: 'Save',
		cancel: 'Cancel',
		editRationale: 'Edit rationale',
		confirmChanges: 'Confirm changes',
		continue: 'Continue',
		emptySaveDescription:
			"Saving an empty value will remove the 'No deficiency' designation, which may impact your audit documentation. Do you want to continue?",
		deselectRationale: 'Deselecting this option will remove rationale. Do you want to continue?',
		relateModalTitle: 'Relate deficiencies',
		relateModalDescription: 'Add or remove deficiencies related to this misstatement.',
		misstatementLabel: 'Misstatement:',
		showOnlyRelated: 'Show only related',
		searchPlaceholder: 'Search',
		clearHoverText: 'Clear',
		closeLabel: 'Close',
		noResults: 'No results found',
		deficienciesListLabel: 'Deficiencies',
		deficiencyCountSingular: '1 deficiency',
		deficiencyCountPlural: '{0} deficiencies',
		addedLabel: 'Added',
		relateErrorMessage: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	}
};

//for SAD final balances modal
export const SadImpactSummary = {
	tableHeader: 'Misstatement impact summary',
	goToSourceLabel: 'To view or change SAD Final balances, click',
	finalBalancesModal: {
		sadFinalBalancesLabel: 'Financial statement amounts',
		sadFinalBalancesDescription: 'Input the tax rate, currency and final financial statement amounts below and select <b class=\'motif-body1-default-bold\'>\'Save and close\'</b> to finish.',
		sadFinalBalTaxRateLabel: 'Tax rate',
		sadFinalBalTaxRatePlaceholder: 'Tax rate',
		sadFinalBalTaxRateTooltip: 'Enter the current year marginal tax rate. This rate will be used to calculate the tax effect of misstatements.',
		sadFinalBalCurrencyLabel: 'Currency',
		sadFinalBalCurrencyPlaceholder: 'Currency',
		sadFinalBalCurrencyTooltip: 'Provide the reporting currency code for the entity.',
		sadFinalBalCurrencyTaxPlaceholder: 'Enter',
	},
	finalBalancesModalSection: {
		//sub-section labels
		sadFinalBalFinancialSectionLabel: 'Financial statements',
		sadFinalBalanceAmount: 'Debit / (Credit)',
		sadCashFlowFinalBalanceAmount: 'Increase / (Decrease)',
		sadFinalBalanceAmountPlaceholder: 'Enter amount',
		sadFinalBalFinancialValidationWarn: 'Incomplete',

		// for Income Statement
		sadIncomeStatementHeader: 'Income statement and OCI',
		sadIncStateProfitLoss: 'Pretax income',
		sadIncomeTaxExpense: 'Income tax',
		sadOtherComprehensiveIncome: 'Other comprehensive income',

		// for Balance Sheet
		sadBalanceSheetHeader: 'Balance sheet',
		sadBalSheetCurrentAssets: 'Current assets',
		sadBalSheetNonCurrentAssets: 'Noncurrent assets',
		sadBalSheetCurrentLiabilities: 'Current liabilities',
		sadBalSheetNonCurrentLiabilities: 'Noncurrent liabilities',
		sadBalSheetEquity: 'Equity',
		sadBalSheetValidationWarn: 'Balance sheet does not balance',

		// for Cash Flow Statement
		sadCashFlowStatementHeader: 'Statement of cash flows',
		sadCashFlowOperating: 'Operating',
		sadCashFlowInvesting: 'Investing',
		sadCashFlowFinancing: 'Financing',
	},
	incomeStatementTab: {
		pretaxIncomeExpense: 'Pretax income',
		taxEffectOfMisstatement: 'Tax effect of misstatements',
		incomeTaxBenefitExpense: 'Misstatements in income tax',
		totalIncomeTax: 'Total income tax',
		incomeExpenseAfterTax: 'Net income',
		otherComprehensiveIncome: 'Other comprehensive income',
	},
	financialStatementsTable: {
		financialStatementAmount: 'Financial statement amount',
		uncorrectedMisstatementEffect: 'Effect of uncorrected misstatements',
		beforeTurnaround: 'Before turnaround',
		afterTurnaround: 'After turnaround',
		exceedsPm: 'Exceeds PM',
		exceedsUmt: 'Exceeds UMT'
	},
	sadImpactSummaryTabs: {
		incomeStatement: 'Income statement and OCI',
		balanceSheet: 'Balance sheet',
		statementOfCashFlows: 'Statement of cash flows',
		lineItem: 'Effect on FSLI',
		clearlyTrivial: 'Clearly trivial',
		notCommunicated: 'Not communicated'
	},
	lineItemStatementTable: {
		accountGroup: 'Financial statement subtotal',
		incomeStatement: 'Income statement and OCI',
		incomeStatementTableHeader: 'Income statement and OCI',
		balanceSheet: 'Balance sheet',
		statementOfCashFlows: 'Statement of cash flows',
		financialStatementLineItem: 'Financial statement line item',
		beforeTurnaround: 'Before turnaround',
		afterTurnaround: 'After turnaround',
		uncorrectedMisstatement: 'Effect of uncorrected misstatements',
		uncorrectedMisstatementBeforeTax: 'Effect of uncorrected misstatements',
		cashFlowActivity: 'Cash flow activity',
		statementOfCashFlowsLineItem: 'Statement of cash flows line item',
	}
};

export const sadFinancialItemsEnums = {
	20: 'Pretax income',
	21: 'Misstatements in income tax',
	11: 'Other comprehensive income',
	2: 'Current assets',
	3: 'Noncurrent assets',
	5: 'Current liabilities',
	6: 'Noncurrent liabilities',
	7: 'Equity',
	23: 'Operating',
	24: 'Investing',
	25: 'Financing'
};

export const AccountOverviewLabels = {
	relevantAssertions: 'Relevant assertions',
	estimateLabel: 'Estimate',
	accountBalance: 'Account balance',
	higherROMMs: 'Higher ROMMs',
	romms: 'ROMMs',
	designation: 'Designation',
	hyphen: '-',
	multiple: 'Multiple',
	trialBalanceName: 'Display the trial balance name',
	knowledgeAccount: 'Knowledge account'
};

export const DeficiencyDocuments = {
	sectionLabel: 'Evidence',
	addDocuments: 'Add documents',
	addDocumentsLink: 'Drag and drop one or more documents or click <span>{addDocument}</span>',
	columnName: 'Name',
	columnNotes: 'Notes',
	columnSignoffs: 'Sign-offs',
	removeFromDeficiency: 'Remove from deficiency',
	columnRelatedTasks: 'Related tasks',
	relateDocument: 'Relate document',
	concurrencyError: 'The action could not be completed. Refresh the page and try again. Contact the Help Desk if the error persists.'
};

export const DeficiencyRelatedDeficiencies = {
	deficiencies: labels.deficiencies,
	signoffs: labels.signoffs,
	noResultsFound: 'No deficiencies are related. Click {0} or {1} to create and/or relate deficiencies.',
	relateLinkLabel: labels.relateDeficiencyModalTitle,
	relateLinkTitle: labels.relateDeficiencyModalTitle,
	relateButtonLabel: labels.relateDeficiencyModalTitle,
	relateButtonTitle: labels.relateDeficiencyModalTitle,
	addLinkLabel: 'Add deficiency',
	addLinkTitle: 'Add deficiencies',
	unrelatedImpactedTitleSingular: 'There is {0} control or ITGC identified as impacted by this deficiency, for which an additional deficiency has not yet been related.',
	unrelatedImpactedTitlePlural: 'There are {0} controls or ITGCs identified as impacted by this deficiency, for which an additional deficiency has not yet been related.',
	unrelatedImpactedDescription: "Add a deficiency for impacted controls by clicking 'Add deficiency'. To relate an existing deficiency, click 'Relate deficiencies'.",
	relateModalErrorMessage: 'The action could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.'
};

export const DeficiencyParentDeficiencies = {
	deficiencies: labels.deficiencies,
	signoffs: labels.signoffs,
	comments: labels.comments,
	noResultsFound: labels.noResultFoundPlaceholder,
	relateLinkLabel: labels.relateDeficiencyModalTitle,
	relateLinkTitle: labels.relateDeficiencyModalTitle,
	relateButtonLabel: labels.relateDeficiencyModalTitle,
	relateButtonTitle: labels.relateDeficiencyModalTitle
};

export const AddDeficiency = {
	AddDeficiency: 'Add deficiency',
	deficiency: labels.deficiency,
	itgcs: 'ITGCs',
	itgc: 'ITGC',
	control: 'control',
	controls: 'controls',
	controlLabel: 'Control',
	controlsTabLabel: 'Controls',
	noResultsLabelForItgcs: 'No impacted ITGCs with unrelated deficiencies',
	noResultsLabelForControls: 'No impacted controls with unrelated deficiencies',
	description: "The following controls are impacted by this deficiency but do not have a specific deficiency related. To create a related deficiency, select at least one control and click 'Add deficiency'.",
	nextClick: "Next: Add deficiency",
	selectionRequired: "Select at least one control or ITGC",
	onDisableTitle: "Deficiency cannot be related to both controls and ITGCs",
	controlWithoutRelatedDeficiency: "Controls without a related deficiency",
};

export const NotImpactedControlsRelateModal = {
	title: 'Select controls not impacted',
	deficiency: 'Deficiency',
	itgcs: 'ITGCs',
	itgc: 'ITGC',
	control: 'control',
	controls: 'controls',
	controlLabel: 'Control',
	businessProcessControls: 'Controls',
	lockedCompensating: 'This is also a compensating control. To un-select this record, first remove it as a compensating control.',
	lockedInvalid: `To un-select this record, close this modal and click on 'Show unrelated controls' in the banner displayed`
};

export const DeficiencyChildDeficiencies = {
	deficiencies: labels.deficiencies,
	signoffs: labels.signoffs,
	comments: labels.comments,
	noResultsFound: labels.noResultFoundPlaceholder,
	relateLinkLabel: labels.relateDeficiencyModalTitle,
	relateLinkTitle: labels.relateDeficiencyModalTitle,
	relateButtonLabel: labels.relateDeficiencyModalTitle,
	relateButtonTitle: labels.relateDeficiencyModalTitle
};

export const deficiencyChildDeficiencies = {
	deficiency: labels.deficiency,
	deficiencies: labels.deficiencies,
	relateDeficiencies: 'Relate deficiencies',
	allDeficiencies: 'All deficiencies',
	relatedToImpactedControls: 'Business process deficiencies',
	relatedToImpactedITGCs: 'IT process deficiencies',
}

export const accountMetricsLabels = {
	accountsWithControls: 'Accounts with {0} controls',
	ineffectiveControlDesign: 'Accounts with ineffective control design',
	ineffectiveControlOperation: 'Accounts with ineffective control operation',
	controlDeficiencies: 'Accounts with control deficiencies',
	rommsHeader: 'ROMMs',
	noResultsFound: 'No results found',
	assertions: 'Assertions'
};

export const scSummaryMetrics302Labels = {
	accounts: 'Accounts',
	accountsWithSubstantiveAloneNotSufficientROMMs: 'Accounts with ROMMs where substantive procedures alone are not sufficient',
	accountsWithoutROMMsWithJournalEntryConsiderations: 'Accounts without ROMMs with journal entry considerations',
	accountsWithROMMsWithRelatedPartyTransactions: 'Accounts with ROMMs with related party transactions',
	accountsWithROMMsWithSignificantOrUnusualTransactions: 'Accounts with ROMMs with significant unusual transactions',
	srfr: 'SR/FR',
	relatedEntities: 'Related Entities',
	substantiveAloneNotSufficient: 'Substantive alone is not sufficient',
	journalEntryConsiderations: 'Journal entry considerations',
	relatedPartyTransactions: 'Related party transactions',
	significantUnusualTransactions: 'Significant unusual transactions',
	specialCircumstances: 'Special circumstances',
	rommsThatRequireControls: 'ROMMs that require controls',
	instructionalText: 'Select the checkboxes to define ROMMs that require controls',
	noRommsFound: 'No ROMMs found.',
};

export const socdSummaryMetrics298Labels = {
	signOffView: 'Sign-off view',
	deficiencies: 'Deficiencies',
	controlDeficiencies: 'Business process deficiencies',
	itControlDeficiencies: 'IT process deficiencies',
	significantOrMaterialWeakness: 'Significant deficiencies',
	unremediatedDeficiencies: 'Unremediated deficiencies',
};

export const socdQuickFilters298Labels = {
	showOnly: 'Show only',
	compensated: 'Compensated',
	immaterial: 'Immaterial',
	otherConsiderations: 'Other considerations',
	changeToCRAFS: 'Change to CRA',
	unmitigatedITRisksFSA: 'Unmitigated IT risks (FSA)'
};

export const socdAggregationByAccount299Labels = {
	noResultsFound: 'No accounts with more than one unremediated deficiency identified.',
	deficienciesLabel: 'Deficiencies',
	deficiencyNameColumn: 'Deficiency',
	assertionsColumn: 'Assertions',
	compensatedColumn: 'Compensated',
	conclusionColumn: 'Conclusion',
	accountsFilterLabel: 'Accounts',
	selectAll: 'Select all',
	allAccounts: 'All accounts',
	selected: 'selected'
};

export const socdAggregationByICCContainer300Labels = {
	noResultsFound: 'No results found',
	noDeficienciesImpactThisInternalControlComponent: 'No deficiencies impact this internal control component',
	noUnremediatedDeficiencies: 'No unremediated deficiencies related to this Internal Control Component',
	deficiencyName: 'Deficiency',
	recurring: 'Recurring',
	cosoPrinciples: 'COSO 2013 principles',
	deficiencyIn: 'Type',
	compensatingControls: 'Compensated',
	conclusion: 'Conclusion',
	cosoPrinciplesPopoutTitle: 'COSO principles',
	yes: 'Yes',
	no: 'No',
	deficiencies: 'Deficiencies'
};

export const iccClassTypeNames = {
	1: 'Control environment',
	2: 'Risk assessment process',
	3: 'Control activities',
	4: 'Information and communication',
	5: 'Monitoring'
};

export const cosoPrincipleNames = {
	1: '1. Demonstrate commitment to integrity and ethical values',
	2: '2. Ensure that board exercises oversight responsibility',
	3: '3. Establish structures, reporting lines, authorities and responsibilities',
	4: '4. Demonstrate commitment to a competent workforce',
	5: '5. Hold people accountable',
	6: '6. Specify appropriate objectives',
	7: '7. Identify and analyze risks',
	8: '8. Evaluate fraud risks',
	9: '9. Identify and analyze changes that could significantly affect internal controls',
	10: '10. Select and develop control activities that mitigate risks',
	11: '11. Select and develop technology controls',
	12: '12. Deploy control activities through policies and procedures',
	13: '13. Use relevant, quality information to support the internal control function',
	14: '14. Communicate internal control information internally',
	15: '15. Communicate internal control information externally',
	16: '16. Perform ongoing or periodic evaluations of internal controls (or a combination of the two)',
	17: '17. Communicate internal control deficiencies'
};

export const deficiencyTypeNames = {
	1: 'Operation',
	2: 'Design',
	3: 'Design and operation',
	4: 'Uncategorized'
};

export const InvalidControlsModal = {
	title: 'Unrelated controls',
	description: `The following controls and ITGCs are marked as "not impacted" but are no longer supported by the deficient ITGC(s). To remove a control or ITGC from the list of "not impacted" controls, select a record and click 'Remove'.`,
	businessProcessControls: 'Controls',
	controlLabel: 'Control',
	crossDisableTooltip: 'Cannot select both business process controls and ITGCs at the same time',
	selectionRequired: 'Select at least one control or ITGC',
	bannerTitleSingular: 'There is {0} control listed below that is no longer supported by the deficient ITGC(s).',
	bannerTitlePlural: 'There are {0} controls listed below that are no longer supported by the deficient ITGC(s).',
	bannerDescription: 'Click on \'Show unrelated controls\' to review and remove them from the list below.',
	bannerButtonLabel: 'Show unrelated controls',
	errorToast: 'At least one record must be selected for removal'
};

export const manageControlStep332Labels = {
	newDesignAttribute: 'New design attribute',
	noDesignAttributesCreated: 'No Design attributes have been created. Click New design attribute to get started.',
	procedures: 'Procedures',
	viewDetails: 'View details',
	fromKnowledge: 'From knowledge',
	deleteDesignAttribute: 'Delete design attribute',
	deleteDesignAttributeConfirmation: 'Are you sure you want to delete this design attribute? All existing relationships and associated documentation may be impacted or removed. This action cannot be undone.',
	deleteDesignAttributeConcurrencyError: 'The selected design attribute has been deleted. Close this modal to see the updated list.',
	newControlStepModalTitle: 'New design attribute',
	controlStepModalDescription: "Enter the new design attribute details below and select <span class='save-close'>'Save and close'</span> to finish. To create another design attribute, select <span class='save-create-another'>'Save and create another'</span>.",
	controlStepNameLabel: 'Design attribute name (required)',
	controlStepNamePlaceholder: 'Enter design attribute name (required)',
	controlStepNameMaxLength: 'Maximum 1000 characters allowed',
	displayOrderLabel: 'Display order',
	addAsLastStepLabel: 'Add as last design attribute?',
	displayBeforeLabel: 'Display before',
	displayAfterLabel: 'Display after',
	selectControlStepPlaceholder: 'Select design attribute',
	firstItemToBeCreatedLabel: 'First item to be created',
	filterYes: 'Yes',
	filterNo: 'No',
	saveAndClose: 'Save and close',
	saveAndCreateAnother: 'Save and create another',
	cancel: 'Cancel',
	required: 'Required',
	controlStepCreatedSuccess: 'Successfully created new design attribute',
	editControlStepModalTitle: 'Edit design attribute',
	editControlStepModalDescription: 'Edit the design attribute details below and select <b>\'Save\'</b> to finish.',
	changeDisplayOrderLabel: 'Change display order?',
	save: 'Save'
};

export const controlDesignSummary335Labels = {
	viewByAccount: 'View by accounts',
	viewByControl: 'View by controls',
	signOffView: 'Sign-off view',
	noControlsFound: 'No controls found',
	noSignOffResultsFound: 'No results found',
	totalColumnHeader: 'Total',
	selectedForTestingColumnHeader: 'Selected for testing',
	accountsWithControlsTileLabel: 'accounts with {0} controls',
	exportLabel: 'Export',
	controlsRelatedToAccountsTileLabel: 'controls related to {0} accounts',
	controlsRelatedToAccountTileLabel: 'controls related to {0} account',
	controlTypeTileHeader: 'Control type',
	otherConsiderationsHeader: 'Other considerations',
	higherRiskColumnHeader: 'Higher risk',
	diConclusionColumnHeader: 'D&I - Conclusion',
	higherRiskTileLabel: 'Controls set as Higher Risk',
	ineffectiveDiTileLabel: 'Controls with ineffective D&I',
	controlsWithDeficienciesTileLabel: 'Controls with deficiencies',
	mrcsTileLabel: 'MRCs',
	totalAccountsTileLabel: 'Total accounts',
	accountsWithHigherRiskControlTileLabel: 'Accounts with Control set as Higher Risk',
	accountsWithIneffectiveDiTileLabel: 'Accounts with controls with ineffective D&I',
	accountsWithDeficienciesTileLabel: 'Accounts with deficiencies',
	accountsWithMrcsTileLabel: 'Accounts with MRCs',
	controlSummaryTypeLabel: 'Type',
	controlSummaryFrequencyLabel: 'Frequency',
	controlSummaryTestingApproachLabel: 'Testing approach',
	controlSummaryControlRiskLabel: 'Control risk',
	controlSummaryDesignConclusionLabel: 'D&I - conclusion',
	controlSummaryTestingApproachEffectivenessLabel: 'Design, implementation and operating effectiveness',
	controlSummaryTestingApproachImplementationLabel: 'Design and implementation',
	controlSummaryControlRiskHigherLabel: 'Higher',
	controlSummaryControlRiskLowerLabel: 'Lower',
	controlSummaryControlTypeDisplay: {
		1: {label: 'ITAC', tooltip: 'IT application control'},
		2: {label: 'ITDM', tooltip: 'IT dependent manual'},
		3: {label: 'Manual', tooltip: 'Manual prevent'},
		4: {label: 'Manual', tooltip: 'Manual detect'}
	},
	editControlLabel: 'Edit control',
	controlSummaryGuidedWorkflowLabel: 'Guided workflow',
	controlSummaryGuidedWorkflowNoRecordsFound: 'No records found',
	relatedDeficienciesTitle: 'Related deficiencies',
	relatedDeficienciesDeficiencyLabel: 'Deficiency',
	relatedDeficienciesTypeLabel: 'Type',
	relatedDeficienciesRemediatedLabel: 'Remediated',
	relatedDeficienciesNoResultsFound: 'No related deficiencies found',
	relatedDeficienciesGoToSourceLabel: 'To manage deficiencies from this engagement, click',
	relatedDeficienciesGoToSourceLinkText: 'here'
};

// Shared by the Audit Plan Summary V2 bodies 356 and 357. Column headers live here instead of in
// `labels` because `labels.higherROMMs` is 'All Higher ROMMs' and is still consumed by the V1 bodies 241/242.
export const auditPlanSummaryV2Labels = {
	higherROMMsColumnHeader: 'Higher ROMMs',
	timingColumnHeader: 'Timing',
	interimBadge: 'Interim',
	yearEndBadge: 'Year end',
	interimTestingDateTooltip: 'Interim testing date: {0}',
	pspsGroupHeader: 'PSPs',
	amendedColumnHeader: 'Amended'
};

export const itControlDesignSummary324Labels = {
	itgcsTileLabel: 'ITGCs',
	drawerIconTooltip: 'ITGC',
	noITGCsAvailable: 'No ITGCs available',
	noResultsFound: 'No results found',
	itgcHeader: 'ITGC',
	subCategoryHeader: 'Sub-Category',
	frequencyHeader: 'Frequency',
	designHeader: 'Design',
	operationHeader: 'Operation',
	testingHeader: 'Testing',
	notTested: 'Not tested',
	effective: 'Effective',
	ineffective: 'Ineffective',
	notSelected: 'Not selected',
	otherConsiderationsHeader: 'Other considerations',
	itgcWithDesignDeficiencies: 'ITGC with design deficiencies',
	itgcIssuesDidNotRiseDeficiency: 'ITGC with issues noted that did not rise to a deficiency',
	commonITGCs: 'Common ITGCs',
	itgcWithAutomatedComponents: 'ITGCs with automated components',
	signOffView: 'Sign-off view',
	exportLabel: 'Export',
	showOnly: 'Show only',
	performedByOthers: 'ITGCs with procedures performed by others',
	newlyImplemented: 'Newly implemented ITGCs',
	decommissioned: 'Decommissioned ITGCs',
	otherConsiderations: 'Other considerations',
	relatedDeficiencies: 'Deficiencies',
	deficiencyNameHeader: 'Deficiencies',
	deficiencyTypeHeader: 'Type',
	recurringHeader: 'Recurring',
	remediatedHeader: 'Remediated',
	relatedTechnologies: 'Technologies',
	technologyNameHeader: 'Technologies',
	technologyTypeHeader: 'Type',
	technologyRelevanceHeader: 'Relevance',
	technologyTypeApplicationTool: 'Application/Tool',
	technologyTypeDatabase: 'Database',
	technologyTypeOperatingSystem: 'Operating system',
	technologyTypeNetwork: 'Network',
	technologyRelevanceRelevant: 'Relevant',
	technologyRelevanceNotRelevant: 'Not Relevant'
};

export const itControlOperationSummary325Labels = {
	itgcsTileLabel: '{0} ITGCs',
	noResultsFound: 'No results found',
	noItgcsAvailable: 'No ITGCs available',
	itgcHeader: 'ITGC',
	tocPeriodHeader: 'TOC period',
	frequencyHeader: 'Frequency',
	populationHeader: 'Population',
	sampleHeader: 'Sample',
	updateStrategyHeader: 'Update strategy',
	operationHeader: 'Operation',
	notTested: 'Not tested',
	effective: 'Effective',
	ineffective: 'Ineffective',
	notSelected: 'Not selected'
};

export const milestonesLabels = {
	1: 'Scope',
	2: 'Strategy',
	3: 'Walkthroughs',
	4: 'Interim control testing',
	5: 'Interim substantive testing',
	6: 'Walkthroughs (year-end processes)',
	7: 'Year-end control testing',
	8: 'Year-end substantive testing',
	9: 'Conclusion',
	10: 'Not applicable',
	11: 'Execution',
	12: 'Scope and strategy quality activities',
	13: 'Other scope and strategy',
	14: 'CRA',
	15: 'Identify and assess risk',
	16: 'Design response to risk',
	17: 'Post-interim project management'
};

export const controlManageConfigurationsAndMasterDataLabels = {
	addDataElement: 'Add data element',
	dataElement: 'Data element',
	fromKnowledge: 'From knowledge',
	keyConfigurations: 'Key configurations',
	masterData: 'Master data'
};
